
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("ecd4d", function(module, exports) {
$parcel$export(module.exports, "computed", () => (parcelRequire("TusQn")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("TusQn")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("TusQn")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("TusQn")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("TusQn")).createElementVNode);
$parcel$export(module.exports, "createStaticVNode", () => (parcelRequire("TusQn")).createStaticVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("TusQn")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("TusQn")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("TusQn")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("TusQn")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("TusQn")).getCurrentInstance);
$parcel$export(module.exports, "h", () => (parcelRequire("TusQn")).h);
$parcel$export(module.exports, "hasInjectionContext", () => (parcelRequire("TusQn")).hasInjectionContext);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("TusQn")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("TusQn")).inject);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("01W3b")).isReactive);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("01W3b")).markRaw);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("TusQn")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "onActivated", () => (parcelRequire("TusQn")).onActivated);
$parcel$export(module.exports, "onDeactivated", () => (parcelRequire("TusQn")).onDeactivated);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("TusQn")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("TusQn")).onUnmounted);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("TusQn")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("TusQn")).provide);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("TusQn")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("TusQn")).renderSlot);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("TusQn")).resolveComponent);
$parcel$export(module.exports, "resolveDirective", () => (parcelRequire("TusQn")).resolveDirective);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("01W3b")).shallowReactive);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "watch", () => (parcelRequire("TusQn")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("TusQn")).watchEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("TusQn")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("TusQn")).withDirectives);
$parcel$export(module.exports, "createApp", () => (parcelRequire("eeJ70")).createApp);
$parcel$export(module.exports, "Transition", () => (parcelRequire("eeJ70")).Transition);
$parcel$export(module.exports, "useCssVars", () => (parcelRequire("eeJ70")).useCssVars);
$parcel$export(module.exports, "vModelText", () => (parcelRequire("eeJ70")).vModelText);
$parcel$export(module.exports, "vShow", () => (parcelRequire("eeJ70")).vShow);
$parcel$export(module.exports, "withModifiers", () => (parcelRequire("eeJ70")).withModifiers);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("01W3b")).effectScope);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("01W3b")).getCurrentScope);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("01W3b")).onScopeDispose);
$parcel$export(module.exports, "toRef", () => (parcelRequire("01W3b")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("01W3b")).toRefs);
$parcel$export(module.exports, "unref", () => (parcelRequire("01W3b")).unref);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8POXm")).toDisplayString);
/**
* vue v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $TusQn = parcelRequire("TusQn");parcelRequire("eeJ70");parcelRequire("01W3b");parcelRequire("8POXm");
function $a55c527d369bf9c1$var$initDev() {
    (0, $TusQn.initCustomFormatter)();
}
const $a55c527d369bf9c1$export$ef7acd7185315e22 = ()=>{};

});
parcelRegister("TusQn", function(module, exports) {

$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $0a6cc4ba868319ae$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $0a6cc4ba868319ae$export$bdd553fddd433dcb);
$parcel$export(module.exports, "queuePostFlushCb", () => $0a6cc4ba868319ae$export$59536a0199721cab);
$parcel$export(module.exports, "Fragment", () => $0a6cc4ba868319ae$export$ffb0004e005737fa);
$parcel$export(module.exports, "Static", () => $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "withCtx", () => $0a6cc4ba868319ae$export$694b237e827a3d23);
$parcel$export(module.exports, "withDirectives", () => $0a6cc4ba868319ae$export$49729353e7c1e6c5);
$parcel$export(module.exports, "useTransitionState", () => $0a6cc4ba868319ae$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $0a6cc4ba868319ae$export$6d1641039221b5cb);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => $0a6cc4ba868319ae$export$b876c99684f8cf3b);
$parcel$export(module.exports, "getCurrentInstance", () => $0a6cc4ba868319ae$export$f13e630aa3915748);
$parcel$export(module.exports, "getTransitionRawChildren", () => $0a6cc4ba868319ae$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "resolveTransitionHooks", () => $0a6cc4ba868319ae$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $0a6cc4ba868319ae$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $0a6cc4ba868319ae$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "defineComponent", () => $0a6cc4ba868319ae$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "createVNode", () => $0a6cc4ba868319ae$export$bf5c4cf060303d58);
$parcel$export(module.exports, "createTextVNode", () => $0a6cc4ba868319ae$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "watch", () => $0a6cc4ba868319ae$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "onUpdated", () => $0a6cc4ba868319ae$export$5876c47052fb88b1);
$parcel$export(module.exports, "onActivated", () => $0a6cc4ba868319ae$export$ba52d824b95a2154);
$parcel$export(module.exports, "onDeactivated", () => $0a6cc4ba868319ae$export$bf1440eeaf5fa709);
$parcel$export(module.exports, "onUnmounted", () => $0a6cc4ba868319ae$export$13348a43ccacfe58);
$parcel$export(module.exports, "onBeforeUpdate", () => $0a6cc4ba868319ae$export$ab91988a13872e4c);
$parcel$export(module.exports, "resolveComponent", () => $0a6cc4ba868319ae$export$681d65eec9d1d1e8);
$parcel$export(module.exports, "resolveDirective", () => $0a6cc4ba868319ae$export$a1989e995cd481be);
$parcel$export(module.exports, "renderList", () => $0a6cc4ba868319ae$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "renderSlot", () => $0a6cc4ba868319ae$export$4abee4c34694ada1);
$parcel$export(module.exports, "openBlock", () => $0a6cc4ba868319ae$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "createBlock", () => $0a6cc4ba868319ae$export$9f2dfe8048dfb22b);
$parcel$export(module.exports, "computed", () => $0a6cc4ba868319ae$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "provide", () => $0a6cc4ba868319ae$export$abe1e183e22e10ad);
$parcel$export(module.exports, "inject", () => $0a6cc4ba868319ae$export$a976684a0efeb93f);
$parcel$export(module.exports, "hasInjectionContext", () => $0a6cc4ba868319ae$export$caf6761f24fc571a);
$parcel$export(module.exports, "createRenderer", () => $0a6cc4ba868319ae$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $0a6cc4ba868319ae$export$200524cf0d997ff0);
$parcel$export(module.exports, "watchEffect", () => $0a6cc4ba868319ae$export$ede35fc0e5500309);
$parcel$export(module.exports, "createElementBlock", () => $0a6cc4ba868319ae$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $0a6cc4ba868319ae$export$42098e0eaa15c48e);
$parcel$export(module.exports, "createStaticVNode", () => $0a6cc4ba868319ae$export$33a9f6dd2840e6bb);
$parcel$export(module.exports, "createCommentVNode", () => $0a6cc4ba868319ae$export$49553837c7236d3c);
$parcel$export(module.exports, "isRuntimeOnly", () => $0a6cc4ba868319ae$export$c93a9c496c5211fa);
$parcel$export(module.exports, "h", () => $0a6cc4ba868319ae$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $0a6cc4ba868319ae$export$aed4979be6a60047);
$parcel$export(module.exports, "warn", () => $0a6cc4ba868319ae$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("01W3b")).isReactive);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("01W3b")).markRaw);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("01W3b")).shallowReactive);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8POXm")).camelize);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
/**
* @vue/runtime-core v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $01W3b = parcelRequire("01W3b");

var $8POXm = parcelRequire("8POXm");
const $0a6cc4ba868319ae$var$stack = [];
function $0a6cc4ba868319ae$var$pushWarningContext(vnode) {
    $0a6cc4ba868319ae$var$stack.push(vnode);
}
function $0a6cc4ba868319ae$var$popWarningContext() {
    $0a6cc4ba868319ae$var$stack.pop();
}
let $0a6cc4ba868319ae$var$isWarning = false;
function $0a6cc4ba868319ae$var$warn$1(msg, ...args) {
    if ($0a6cc4ba868319ae$var$isWarning) return;
    $0a6cc4ba868319ae$var$isWarning = true;
    (0, $01W3b.pauseTracking)();
    const instance = $0a6cc4ba868319ae$var$stack.length ? $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $0a6cc4ba868319ae$var$getComponentTrace();
    if (appWarnHandler) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$0a6cc4ba868319ae$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$0a6cc4ba868319ae$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $01W3b.resetTracking)();
    $0a6cc4ba868319ae$var$isWarning = false;
}
function $0a6cc4ba868319ae$var$getComponentTrace() {
    let currentVNode = $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $0a6cc4ba868319ae$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$0a6cc4ba868319ae$var$formatTraceEntry(entry));
    });
    return logs;
}
function $0a6cc4ba868319ae$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$0a6cc4ba868319ae$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$0a6cc4ba868319ae$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $0a6cc4ba868319ae$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$0a6cc4ba868319ae$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $0a6cc4ba868319ae$var$formatProp(key, value, raw) {
    if ((0, $8POXm.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $01W3b.isRef)(value)) {
        value = $0a6cc4ba868319ae$var$formatProp(key, (0, $01W3b.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $8POXm.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $01W3b.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $0a6cc4ba868319ae$export$dfbcecb440255e4a(val, type) {
    return;
}
const $0a6cc4ba868319ae$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
const $0a6cc4ba868319ae$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update",
    [16]: "app unmount cleanup function"
};
function $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $0a6cc4ba868319ae$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $8POXm.isFunction)(fn)) {
        const res = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $8POXm.isPromise)(res)) res.catch((err)=>{
            $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $8POXm.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($0a6cc4ba868319ae$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler: errorHandler, throwUnhandledErrorInProduction: throwUnhandledErrorInProduction } = instance && instance.appContext.config || (0, $8POXm.EMPTY_OBJ);
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$b22fcaf88446e9bf(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $01W3b.resetTracking)();
            return;
        }
    }
    $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    if (throwInProd) throw err;
    else console.error(err);
}
const $0a6cc4ba868319ae$var$queue = [];
let $0a6cc4ba868319ae$var$flushIndex = -1;
const $0a6cc4ba868319ae$var$pendingPostFlushCbs = [];
let $0a6cc4ba868319ae$var$activePostFlushCbs = null;
let $0a6cc4ba868319ae$var$postFlushIndex = 0;
const $0a6cc4ba868319ae$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $0a6cc4ba868319ae$var$currentFlushPromise = null;
const $0a6cc4ba868319ae$var$RECURSION_LIMIT = 100;
function $0a6cc4ba868319ae$export$bdd553fddd433dcb(fn) {
    const p = $0a6cc4ba868319ae$var$currentFlushPromise || $0a6cc4ba868319ae$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $0a6cc4ba868319ae$var$findInsertionIndex(id) {
    let start = $0a6cc4ba868319ae$var$flushIndex + 1;
    let end = $0a6cc4ba868319ae$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $0a6cc4ba868319ae$var$queue[middle];
        const middleJobId = $0a6cc4ba868319ae$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $0a6cc4ba868319ae$var$queueJob(job) {
    if (!(job.flags & 1)) {
        const jobId = $0a6cc4ba868319ae$var$getId(job);
        const lastJob = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$queue.length - 1];
        if (!lastJob || // fast path when the job id is larger than the tail
        !(job.flags & 2) && jobId >= $0a6cc4ba868319ae$var$getId(lastJob)) $0a6cc4ba868319ae$var$queue.push(job);
        else $0a6cc4ba868319ae$var$queue.splice($0a6cc4ba868319ae$var$findInsertionIndex(jobId), 0, job);
        job.flags |= 1;
        $0a6cc4ba868319ae$var$queueFlush();
    }
}
function $0a6cc4ba868319ae$var$queueFlush() {
    if (!$0a6cc4ba868319ae$var$currentFlushPromise) $0a6cc4ba868319ae$var$currentFlushPromise = $0a6cc4ba868319ae$var$resolvedPromise.then($0a6cc4ba868319ae$var$flushJobs);
}
function $0a6cc4ba868319ae$export$59536a0199721cab(cb) {
    if (!(0, $8POXm.isArray)(cb)) {
        if ($0a6cc4ba868319ae$var$activePostFlushCbs && cb.id === -1) $0a6cc4ba868319ae$var$activePostFlushCbs.splice($0a6cc4ba868319ae$var$postFlushIndex + 1, 0, cb);
        else if (!(cb.flags & 1)) {
            $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(cb);
            cb.flags |= 1;
        }
    } else $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(...cb);
    $0a6cc4ba868319ae$var$queueFlush();
}
function $0a6cc4ba868319ae$var$flushPreFlushCbs(instance, seen, i = $0a6cc4ba868319ae$var$flushIndex + 1) {
    for(; i < $0a6cc4ba868319ae$var$queue.length; i++){
        const cb = $0a6cc4ba868319ae$var$queue[i];
        if (cb && cb.flags & 2) {
            if (instance && cb.id !== instance.uid) continue;
            $0a6cc4ba868319ae$var$queue.splice(i, 1);
            i--;
            if (cb.flags & 4) cb.flags &= -2;
            cb();
            if (!(cb.flags & 4)) cb.flags &= -2;
        }
    }
}
function $0a6cc4ba868319ae$var$flushPostFlushCbs(seen) {
    if ($0a6cc4ba868319ae$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($0a6cc4ba868319ae$var$pendingPostFlushCbs)
        ].sort((a, b)=>$0a6cc4ba868319ae$var$getId(a) - $0a6cc4ba868319ae$var$getId(b));
        $0a6cc4ba868319ae$var$pendingPostFlushCbs.length = 0;
        if ($0a6cc4ba868319ae$var$activePostFlushCbs) {
            $0a6cc4ba868319ae$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $0a6cc4ba868319ae$var$activePostFlushCbs = deduped;
        for($0a6cc4ba868319ae$var$postFlushIndex = 0; $0a6cc4ba868319ae$var$postFlushIndex < $0a6cc4ba868319ae$var$activePostFlushCbs.length; $0a6cc4ba868319ae$var$postFlushIndex++){
            const cb = $0a6cc4ba868319ae$var$activePostFlushCbs[$0a6cc4ba868319ae$var$postFlushIndex];
            if (cb.flags & 4) cb.flags &= -2;
            if (!(cb.flags & 8)) cb();
            cb.flags &= -2;
        }
        $0a6cc4ba868319ae$var$activePostFlushCbs = null;
        $0a6cc4ba868319ae$var$postFlushIndex = 0;
    }
}
const $0a6cc4ba868319ae$var$getId = (job)=>job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function $0a6cc4ba868319ae$var$flushJobs(seen) {
    const check = (0, $8POXm.NOOP);
    try {
        for($0a6cc4ba868319ae$var$flushIndex = 0; $0a6cc4ba868319ae$var$flushIndex < $0a6cc4ba868319ae$var$queue.length; $0a6cc4ba868319ae$var$flushIndex++){
            const job = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$flushIndex];
            if (job && !(job.flags & 8)) {
                if (job.flags & 4) job.flags &= -2;
                $0a6cc4ba868319ae$export$b22fcaf88446e9bf(job, job.i, job.i ? 15 : 14);
                if (!(job.flags & 4)) job.flags &= -2;
            }
        }
    } finally{
        for(; $0a6cc4ba868319ae$var$flushIndex < $0a6cc4ba868319ae$var$queue.length; $0a6cc4ba868319ae$var$flushIndex++){
            const job = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$flushIndex];
            if (job) job.flags &= -2;
        }
        $0a6cc4ba868319ae$var$flushIndex = -1;
        $0a6cc4ba868319ae$var$queue.length = 0;
        $0a6cc4ba868319ae$var$flushPostFlushCbs(seen);
        $0a6cc4ba868319ae$var$currentFlushPromise = null;
        if ($0a6cc4ba868319ae$var$queue.length || $0a6cc4ba868319ae$var$pendingPostFlushCbs.length) $0a6cc4ba868319ae$var$flushJobs(seen);
    }
}
function $0a6cc4ba868319ae$var$checkRecursiveUpdates(seen, fn) {
    const count = seen.get(fn) || 0;
    if (count > $0a6cc4ba868319ae$var$RECURSION_LIMIT) {
        const instance = fn.i;
        const componentName = instance && $0a6cc4ba868319ae$var$getComponentName(instance.type);
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
let $0a6cc4ba868319ae$var$isHmrUpdating = false;
const $0a6cc4ba868319ae$var$hmrDirtyComponents = /* @__PURE__ */ new Map();
const $0a6cc4ba868319ae$var$map = /* @__PURE__ */ new Map();
function $0a6cc4ba868319ae$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) {
        $0a6cc4ba868319ae$var$createRecord(id, instance.type);
        record = $0a6cc4ba868319ae$var$map.get(id);
    }
    record.instances.add(instance);
}
function $0a6cc4ba868319ae$var$unregisterHMR(instance) {
    $0a6cc4ba868319ae$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $0a6cc4ba868319ae$var$createRecord(id, initialDef) {
    if ($0a6cc4ba868319ae$var$map.has(id)) return false;
    $0a6cc4ba868319ae$var$map.set(id, {
        initialDef: $0a6cc4ba868319ae$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $0a6cc4ba868319ae$var$normalizeClassComponent(component) {
    return $0a6cc4ba868319ae$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $0a6cc4ba868319ae$var$rerender(id, newRender) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $0a6cc4ba868319ae$var$isHmrUpdating = true;
        instance.update();
        $0a6cc4ba868319ae$var$isHmrUpdating = false;
    });
}
function $0a6cc4ba868319ae$var$reload(id, newComp) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    newComp = $0a6cc4ba868319ae$var$normalizeClassComponent(newComp);
    $0a6cc4ba868319ae$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for(let i = 0; i < instances.length; i++){
        const instance = instances[i];
        const oldComp = $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type);
        let dirtyInstances = $0a6cc4ba868319ae$var$hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp);
            $0a6cc4ba868319ae$var$hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances.delete(instance);
        } else if (instance.parent) $0a6cc4ba868319ae$var$queueJob(()=>{
            $0a6cc4ba868319ae$var$isHmrUpdating = true;
            instance.parent.update();
            $0a6cc4ba868319ae$var$isHmrUpdating = false;
            dirtyInstances.delete(instance);
        });
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
    }
    $0a6cc4ba868319ae$export$59536a0199721cab(()=>{
        $0a6cc4ba868319ae$var$hmrDirtyComponents.clear();
    });
}
function $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp) {
    (0, $8POXm.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $0a6cc4ba868319ae$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $0a6cc4ba868319ae$var$devtools$1;
let $0a6cc4ba868319ae$var$buffer = [];
let $0a6cc4ba868319ae$var$devtoolsNotInstalled = false;
function $0a6cc4ba868319ae$var$emit$1(event, ...args) {
    if ($0a6cc4ba868319ae$var$devtools$1) $0a6cc4ba868319ae$var$devtools$1.emit(event, ...args);
    else if (!$0a6cc4ba868319ae$var$devtoolsNotInstalled) $0a6cc4ba868319ae$var$buffer.push({
        event: event,
        args: args
    });
}
function $0a6cc4ba868319ae$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $0a6cc4ba868319ae$var$devtools$1 = hook;
    if ($0a6cc4ba868319ae$var$devtools$1) {
        $0a6cc4ba868319ae$var$devtools$1.enabled = true;
        $0a6cc4ba868319ae$var$buffer.forEach(({ event: event, args: args })=>$0a6cc4ba868319ae$var$devtools$1.emit(event, ...args));
        $0a6cc4ba868319ae$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $0a6cc4ba868319ae$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$0a6cc4ba868319ae$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
                $0a6cc4ba868319ae$var$buffer = [];
            }
        }, 3e3);
    } else {
        $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
        $0a6cc4ba868319ae$var$buffer = [];
    }
}
function $0a6cc4ba868319ae$var$devtoolsInitApp(app, version) {
    $0a6cc4ba868319ae$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $0a6cc4ba868319ae$export$ffb0004e005737fa,
        Text: $0a6cc4ba868319ae$export$5f1af8db9871e1d6,
        Comment: $0a6cc4ba868319ae$export$4d299b491347818a,
        Static: $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6
    });
}
function $0a6cc4ba868319ae$var$devtoolsUnmountApp(app) {
    $0a6cc4ba868319ae$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $0a6cc4ba868319ae$var$devtoolsComponentAdded = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentUpdated = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $0a6cc4ba868319ae$var$_devtoolsComponentRemoved = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentRemoved = (component)=>{
    if ($0a6cc4ba868319ae$var$devtools$1 && typeof $0a6cc4ba868319ae$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$0a6cc4ba868319ae$var$devtools$1.cleanupBuffer(component)) $0a6cc4ba868319ae$var$_devtoolsComponentRemoved(component);
};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $0a6cc4ba868319ae$var$devtoolsPerfStart = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $0a6cc4ba868319ae$var$devtoolsPerfEnd = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $0a6cc4ba868319ae$var$devtoolsComponentEmit(component, event, params) {
    $0a6cc4ba868319ae$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
let $0a6cc4ba868319ae$var$currentRenderingInstance = null;
let $0a6cc4ba868319ae$var$currentScopeId = null;
function $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance) {
    const prev = $0a6cc4ba868319ae$var$currentRenderingInstance;
    $0a6cc4ba868319ae$var$currentRenderingInstance = instance;
    $0a6cc4ba868319ae$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $0a6cc4ba868319ae$export$ac020265ca2cc4cd(id) {
    $0a6cc4ba868319ae$var$currentScopeId = id;
}
function $0a6cc4ba868319ae$export$f2dc6805dc11834e() {
    $0a6cc4ba868319ae$var$currentScopeId = null;
}
const $0a6cc4ba868319ae$export$15ba313e13f3dd04 = (_id)=>$0a6cc4ba868319ae$export$694b237e827a3d23;
function $0a6cc4ba868319ae$export$694b237e827a3d23(fn, ctx = $0a6cc4ba868319ae$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(-1);
        const prevInstance = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function $0a6cc4ba868319ae$var$validateDirectiveName(name) {
    if ((0, $8POXm.isBuiltInDirective)(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $0a6cc4ba868319ae$export$49729353e7c1e6c5(vnode, directives) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance === null) return vnode;
    const instance = $0a6cc4ba868319ae$var$getComponentPublicInstance($0a6cc4ba868319ae$var$currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $8POXm.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $8POXm.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, $01W3b.traverse)(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $01W3b.resetTracking)();
        }
    }
}
const $0a6cc4ba868319ae$var$TeleportEndKey = Symbol("_vte");
const $0a6cc4ba868319ae$var$isTeleport = (type)=>type.__isTeleport;
const $0a6cc4ba868319ae$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $0a6cc4ba868319ae$var$isTeleportDeferred = (props)=>props && (props.defer || props.defer === "");
const $0a6cc4ba868319ae$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $0a6cc4ba868319ae$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $0a6cc4ba868319ae$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $8POXm.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
const $0a6cc4ba868319ae$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) {
                    if (parentComponent && parentComponent.isCE) parentComponent.ce._teleportTarget = container2;
                    mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                }
            };
            const mountToTarget = ()=>{
                const target = n2.target = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
                const targetAnchor = $0a6cc4ba868319ae$var$prepareAnchor(target, n2, createText, insert);
                if (target) {
                    if (namespace !== "svg" && $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
                    else if (namespace !== "mathml" && $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
                    if (!disabled) {
                        mount(target, targetAnchor);
                        $0a6cc4ba868319ae$var$updateCssVars(n2, false);
                    }
                }
            };
            if (disabled) {
                mount(container, mainAnchor);
                $0a6cc4ba868319ae$var$updateCssVars(n2, true);
            }
            if ($0a6cc4ba868319ae$var$isTeleportDeferred(n2.props)) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                mountToTarget();
                n2.el.__isMounted = true;
            }, parentSuspense);
            else mountToTarget();
        } else {
            if ($0a6cc4ba868319ae$var$isTeleportDeferred(n2.props) && !n1.el.__isMounted) {
                $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                    $0a6cc4ba868319ae$var$TeleportImpl.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                    delete n1.el.__isMounted;
                }, parentSuspense);
                return;
            }
            n2.el = n1.el;
            n2.targetStart = n1.targetStart;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $0a6cc4ba868319ae$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
            $0a6cc4ba868319ae$var$updateCssVars(n2, disabled);
        }
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetStart: targetStart, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            const shouldRemove = doRemove || !$0a6cc4ba868319ae$var$isTeleportDisabled(props);
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: $0a6cc4ba868319ae$var$moveTeleport,
    hydrate: $0a6cc4ba868319ae$var$hydrateTeleport
};
function $0a6cc4ba868319ae$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $0a6cc4ba868319ae$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $0a6cc4ba868319ae$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector, insert: insert, createText: createText } }, hydrateChildren) {
    const target = vnode.target = $0a6cc4ba868319ae$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(vnode.props);
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetStart = targetNode;
                vnode.targetAnchor = targetNode && nextSibling(targetNode);
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    if (targetAnchor && targetAnchor.nodeType === 8) {
                        if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                        else if (targetAnchor.data === "teleport anchor") {
                            vnode.targetAnchor = targetAnchor;
                            target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                            break;
                        }
                    }
                    targetAnchor = nextSibling(targetAnchor);
                }
                if (!vnode.targetAnchor) $0a6cc4ba868319ae$var$prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $0a6cc4ba868319ae$var$updateCssVars(vnode, disabled);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $0a6cc4ba868319ae$export$76d55a0304a371f4 = $0a6cc4ba868319ae$var$TeleportImpl;
function $0a6cc4ba868319ae$var$updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function $0a6cc4ba868319ae$var$prepareAnchor(target, vnode, createText, insert) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[$0a6cc4ba868319ae$var$TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target);
        insert(targetAnchor, target);
    }
    return targetAnchor;
}
const $0a6cc4ba868319ae$var$leaveCbKey = Symbol("_leaveCb");
const $0a6cc4ba868319ae$var$enterCbKey = Symbol("_enterCb");
function $0a6cc4ba868319ae$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $0a6cc4ba868319ae$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $0a6cc4ba868319ae$var$TransitionHookValidator = [
    Function,
    Array
];
const $0a6cc4ba868319ae$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnterCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeaveCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppearCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator
};
const $0a6cc4ba868319ae$var$recursiveGetSubtree = (instance)=>{
    const subTree = instance.subTree;
    return subTree.component ? $0a6cc4ba868319ae$var$recursiveGetSubtree(subTree.component) : subTree;
};
const $0a6cc4ba868319ae$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $0a6cc4ba868319ae$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const state = $0a6cc4ba868319ae$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $0a6cc4ba868319ae$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            const child = $0a6cc4ba868319ae$var$findNonCommentChild(children);
            const rawProps = (0, $01W3b.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            const innerChild = $0a6cc4ba868319ae$var$getInnerChild$1(child);
            if (!innerChild) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            let enterHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            (hooks)=>enterHooks = hooks);
            if (innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) $0a6cc4ba868319ae$export$7770a22486565649(innerChild, enterHooks);
            let oldInnerChild = instance.subTree && $0a6cc4ba868319ae$var$getInnerChild$1(instance.subTree);
            if (oldInnerChild && oldInnerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a && !$0a6cc4ba868319ae$var$isSameVNodeType(innerChild, oldInnerChild) && $0a6cc4ba868319ae$var$recursiveGetSubtree(instance).type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                let leavingHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $0a6cc4ba868319ae$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (!(instance.job.flags & 8)) instance.update();
                        delete leavingHooks.afterLeave;
                        oldInnerChild = void 0;
                    };
                    return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$0a6cc4ba868319ae$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                    enterHooks.delayedLeave = ()=>{
                        delayedLeave();
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                };
                else oldInnerChild = void 0;
            } else if (oldInnerChild) oldInnerChild = void 0;
            return child;
        };
    }
};
function $0a6cc4ba868319ae$var$findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
        let hasFound = false;
        for (const c of children)if (c.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
            child = c;
            hasFound = true;
            break;
        }
    }
    return child;
}
const $0a6cc4ba868319ae$export$abd95b5f5e8a8837 = $0a6cc4ba868319ae$var$BaseTransitionImpl;
function $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $0a6cc4ba868319ae$export$76ac1779589cd824(vnode, props, state, instance, postClone) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $8POXm.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$0a6cc4ba868319ae$var$leaveCbKey]) el[$0a6cc4ba868319ae$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $0a6cc4ba868319ae$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]) leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el[$0a6cc4ba868319ae$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$0a6cc4ba868319ae$var$enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$0a6cc4ba868319ae$var$enterCbKey]) el[$0a6cc4ba868319ae$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el[$0a6cc4ba868319ae$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            const hooks2 = $0a6cc4ba868319ae$export$76ac1779589cd824(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function $0a6cc4ba868319ae$var$emptyPlaceholder(vnode) {
    if ($0a6cc4ba868319ae$var$isKeepAlive(vnode)) {
        vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $0a6cc4ba868319ae$var$getInnerChild$1(vnode) {
    if (!$0a6cc4ba868319ae$var$isKeepAlive(vnode)) {
        if ($0a6cc4ba868319ae$var$isTeleport(vnode.type) && vnode.children) return $0a6cc4ba868319ae$var$findNonCommentChild(vnode.children);
        return vnode;
    }
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $8POXm.isFunction)(children.default)) return children.default();
    }
}
function $0a6cc4ba868319ae$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        $0a6cc4ba868319ae$export$7770a22486565649(vnode.component.subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $0a6cc4ba868319ae$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($0a6cc4ba868319ae$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $0a6cc4ba868319ae$export$4d299b491347818a) ret.push(key != null ? $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $8POXm.isFunction)(options) ? // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $8POXm.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
function $0a6cc4ba868319ae$export$f680877a34711e37() {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    return "";
}
function $0a6cc4ba868319ae$var$markAsyncBoundary(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
const $0a6cc4ba868319ae$var$knownTemplateRefs = /* @__PURE__ */ new WeakSet();
function $0a6cc4ba868319ae$export$83a5dbc1f35517ca(key) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    const r = (0, $01W3b.shallowRef)(null);
    if (i) {
        const refs = i.refs === (0, $8POXm.EMPTY_OBJ) ? i.refs = {} : i.refs;
        let desc;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: ()=>r.value,
            set: (val)=>r.value = val
        });
    }
    const ret = r;
    return ret;
}
function $0a6cc4ba868319ae$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $8POXm.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$0a6cc4ba868319ae$var$setRef(r, oldRawRef && ((0, $8POXm.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) && !isUnmount) {
        if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) $0a6cc4ba868319ae$var$setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
        return;
    }
    const refValue = vnode.shapeFlag & 4 ? $0a6cc4ba868319ae$var$getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $8POXm.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = (0, $01W3b.toRaw)(setupState);
    const canSetSetupRef = setupState === (0, $8POXm.EMPTY_OBJ) ? ()=>false : (key)=>{
        return (0, $8POXm.hasOwn)(rawSetupState, key);
    };
    if (oldRef != null && oldRef !== ref) {
        if ((0, $8POXm.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, $01W3b.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $8POXm.isFunction)(ref)) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $8POXm.isString)(ref);
        const _isRef = (0, $01W3b.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $8POXm.isArray)(existing) && (0, $8POXm.remove)(existing, refValue);
                    else {
                        if (!(0, $8POXm.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                $0a6cc4ba868319ae$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $0a6cc4ba868319ae$var$hasLoggedMismatchError = false;
const $0a6cc4ba868319ae$var$logMismatchError = ()=>{
    if ($0a6cc4ba868319ae$var$hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    $0a6cc4ba868319ae$var$hasLoggedMismatchError = true;
};
const $0a6cc4ba868319ae$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $0a6cc4ba868319ae$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $0a6cc4ba868319ae$var$getContainerType = (container)=>{
    if (container.nodeType !== 1) return void 0;
    if ($0a6cc4ba868319ae$var$isSVGContainer(container)) return "svg";
    if ($0a6cc4ba868319ae$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $0a6cc4ba868319ae$var$isComment = (node)=>node.nodeType === 8;
function $0a6cc4ba868319ae$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        $0a6cc4ba868319ae$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $0a6cc4ba868319ae$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $8POXm.def)(node, "__vnode", vnode, true);
            (0, $8POXm.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        $0a6cc4ba868319ae$var$logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($0a6cc4ba868319ae$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), optimized);
                    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) && !vnode.type.__asyncResolved) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $0a6cc4ba868319ae$export$22f9b5ffd89dac9("") : $0a6cc4ba868319ae$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $0a6cc4ba868319ae$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(null, // no need check parentSuspense in hydration
                transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) transition.beforeEnter(content);
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    if (!$0a6cc4ba868319ae$var$isMismatchAllowed(el, 1 /* CHILDREN */ )) {
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                            $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                            hasWarned = true;
                        }
                        $0a6cc4ba868319ae$var$logMismatchError();
                    }
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                let clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                if (el.textContent !== clientText) {
                    if (!$0a6cc4ba868319ae$var$isMismatchAllowed(el, 0 /* TEXT */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${el.textContent}
  - expected on client: ${vnode.children}`);
                        $0a6cc4ba868319ae$var$logMismatchError();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & 48) {
                    const isCustomElement = el.tagName.includes("-");
                    for(const key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                        // as it could have mutated the DOM in any possible way
                        !(dirs && dirs.some((d)=>d.dir.created)) && $0a6cc4ba868319ae$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $0a6cc4ba868319ae$var$logMismatchError();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $8POXm.isOn)(key) && !(0, $8POXm.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                        key[0] === "." || isCustomElement) patchProp(el, key, null, props[key], void 0, parentComponent);
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, $01W3b.isReactive)(props.style)) for(const key in props.style)props.style[key];
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $0a6cc4ba868319ae$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            const isText = vnode.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && $0a6cc4ba868319ae$var$normalizeVNode(children[i + 1]).type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!$0a6cc4ba868319ae$var$isMismatchAllowed(container, 1 /* CHILDREN */ )) {
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                        $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                        hasWarned = true;
                    }
                    $0a6cc4ba868319ae$var$logMismatchError();
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $0a6cc4ba868319ae$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $0a6cc4ba868319ae$var$logMismatchError();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        if (!$0a6cc4ba868319ae$var$isMismatchAllowed(node.parentElement, 1 /* CHILDREN */ )) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 ? `(text)` : $0a6cc4ba868319ae$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
            $0a6cc4ba868319ae$var$logMismatchError();
        }
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
        if (parentComponent) {
            parentComponent.vnode.el = vnode.el;
            $0a6cc4ba868319ae$var$updateHOCHostEl(parentComponent, vnode.el);
        }
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $0a6cc4ba868319ae$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function $0a6cc4ba868319ae$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        actual = el.getAttribute("class");
        expected = (0, $8POXm.normalizeClass)(clientValue);
        if (!$0a6cc4ba868319ae$var$isSetEqual($0a6cc4ba868319ae$var$toClassSet(actual || ""), $0a6cc4ba868319ae$var$toClassSet(expected))) {
            mismatchType = 2 /* CLASS */ ;
            mismatchKey = `class`;
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $8POXm.isString)(clientValue) ? clientValue : (0, $8POXm.stringifyStyle)((0, $8POXm.normalizeStyle)(clientValue));
        const actualMap = $0a6cc4ba868319ae$var$toStyleMap(actual);
        const expectedMap = $0a6cc4ba868319ae$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) $0a6cc4ba868319ae$var$resolveCssVars(instance, vnode, expectedMap);
        if (!$0a6cc4ba868319ae$var$isMapEqual(actualMap, expectedMap)) {
            mismatchType = 3 /* STYLE */ ;
            mismatchKey = "style";
        }
    } else if (el instanceof SVGElement && (0, $8POXm.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $8POXm.isBooleanAttr)(key) || (0, $8POXm.isKnownHtmlAttr)(key))) {
        if ((0, $8POXm.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $8POXm.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $8POXm.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = 4 /* ATTRIBUTE */ ;
            mismatchKey = key;
        }
    }
    if (mismatchType != null && !$0a6cc4ba868319ae$var$isMismatchAllowed(el, mismatchType)) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${$0a6cc4ba868319ae$var$MismatchTypeString[mismatchType]} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $0a6cc4ba868319ae$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $0a6cc4ba868319ae$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $0a6cc4ba868319ae$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $0a6cc4ba868319ae$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
function $0a6cc4ba868319ae$var$resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === $0a6cc4ba868319ae$export$ffb0004e005737fa && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars)expectedMap.set(`--${(0, $8POXm.getEscapedCssVarName)(key, false)}`, String(cssVars[key]));
    }
    if (vnode === root && instance.parent) $0a6cc4ba868319ae$var$resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
const $0a6cc4ba868319ae$var$allowMismatchAttr = "data-allow-mismatch";
const $0a6cc4ba868319ae$var$MismatchTypeString = {
    [0 /* TEXT */ ]: "text",
    [1 /* CHILDREN */ ]: "children",
    [2 /* CLASS */ ]: "class",
    [3 /* STYLE */ ]: "style",
    [4 /* ATTRIBUTE */ ]: "attribute"
};
function $0a6cc4ba868319ae$var$isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 /* TEXT */  || allowedType === 1 /* CHILDREN */ ) while(el && !el.hasAttribute($0a6cc4ba868319ae$var$allowMismatchAttr))el = el.parentElement;
    const allowedAttr = el && el.getAttribute($0a6cc4ba868319ae$var$allowMismatchAttr);
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        const list = allowedAttr.split(",");
        if (allowedType === 0 /* TEXT */  && list.includes("children")) return true;
        return allowedAttr.split(",").includes($0a6cc4ba868319ae$var$MismatchTypeString[allowedType]);
    }
}
const $0a6cc4ba868319ae$var$requestIdleCallback = (0, $8POXm.getGlobalThis)().requestIdleCallback || ((cb)=>setTimeout(cb, 1));
const $0a6cc4ba868319ae$var$cancelIdleCallback = (0, $8POXm.getGlobalThis)().cancelIdleCallback || ((id)=>clearTimeout(id));
const $0a6cc4ba868319ae$export$8bfca283fd254627 = (timeout = 1e4)=>(hydrate)=>{
        const id = $0a6cc4ba868319ae$var$requestIdleCallback(hydrate, {
            timeout: timeout
        });
        return ()=>$0a6cc4ba868319ae$var$cancelIdleCallback(id);
    };
function $0a6cc4ba868319ae$var$elementIsVisibleInViewport(el) {
    const { top: top, left: left, bottom: bottom, right: right } = el.getBoundingClientRect();
    const { innerHeight: innerHeight, innerWidth: innerWidth } = window;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
const $0a6cc4ba868319ae$export$2b04cd335e660930 = (opts)=>(hydrate, forEach)=>{
        const ob = new IntersectionObserver((entries)=>{
            for (const e of entries){
                if (!e.isIntersecting) continue;
                ob.disconnect();
                hydrate();
                break;
            }
        }, opts);
        forEach((el)=>{
            if (!(el instanceof Element)) return;
            if ($0a6cc4ba868319ae$var$elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            ob.observe(el);
        });
        return ()=>ob.disconnect();
    };
const $0a6cc4ba868319ae$export$804dbb6002787b74 = (query)=>(hydrate)=>{
        if (query) {
            const mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return ()=>mql.removeEventListener("change", hydrate);
            }
        }
    };
const $0a6cc4ba868319ae$export$288f5a9b4248e114 = (interactions = [])=>(hydrate, forEach)=>{
        if ((0, $8POXm.isString)(interactions)) interactions = [
            interactions
        ];
        let hasHydrated = false;
        const doHydrate = (e)=>{
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        const teardown = ()=>{
            forEach((el)=>{
                for (const i of interactions)el.removeEventListener(i, doHydrate);
            });
        };
        forEach((el)=>{
            for (const i of interactions)el.addEventListener(i, doHydrate, {
                once: true
            });
        });
        return teardown;
    };
function $0a6cc4ba868319ae$var$forEachElement(node, cb) {
    if ($0a6cc4ba868319ae$var$isComment(node) && node.data === "[") {
        let depth = 1;
        let next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                const result = cb(next);
                if (result === false) break;
            } else if ($0a6cc4ba868319ae$var$isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
const $0a6cc4ba868319ae$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$d75d499b4c16cf21(source) {
    if ((0, $8POXm.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, hydrate: hydrateStrategy, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $0a6cc4ba868319ae$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate (el, instance, hydrate) {
            const doHydrate = hydrateStrategy ? ()=>{
                const teardown = hydrateStrategy(hydrate, (cb)=>$0a6cc4ba868319ae$var$forEachElement(el, cb));
                if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
            } : hydrate;
            if (resolvedComp) doHydrate();
            else load().then(()=>!instance.isUnmounted && doHydrate());
        },
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $0a6cc4ba868319ae$var$currentInstance;
            $0a6cc4ba868319ae$var$markAsyncBoundary(instance);
            if (resolvedComp) return ()=>$0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $0a6cc4ba868319ae$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$0a6cc4ba868319ae$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $01W3b.ref)(false);
            const error = (0, $01W3b.ref)();
            const delayed = (0, $01W3b.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $0a6cc4ba868319ae$var$isKeepAlive(instance.parent.vnode)) instance.parent.update();
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $0a6cc4ba868319ae$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $0a6cc4ba868319ae$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $0a6cc4ba868319ae$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $8POXm.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            $0a6cc4ba868319ae$var$invalidateMount(instance2.m);
            $0a6cc4ba868319ae$var$invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $8POXm.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $0a6cc4ba868319ae$var$getComponentName(vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !$0a6cc4ba868319ae$var$isSameVNodeType(cached, current))) unmount(cached);
            else if (current) $0a6cc4ba868319ae$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $0a6cc4ba868319ae$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$0a6cc4ba868319ae$var$matches(include, name));
            exclude && pruneCache((name)=>!$0a6cc4ba868319ae$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if ($0a6cc4ba868319ae$var$isSuspense(instance.subTree.type)) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                    cache.set(pendingCacheKey, $0a6cc4ba868319ae$var$getInnerChild(instance.subTree));
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, $0a6cc4ba868319ae$var$getInnerChild(instance.subTree));
            }
        };
        $0a6cc4ba868319ae$export$6d1641039221b5cb(cacheSubtree);
        $0a6cc4ba868319ae$export$5876c47052fb88b1(cacheSubtree);
        $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $0a6cc4ba868319ae$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $0a6cc4ba868319ae$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $0a6cc4ba868319ae$var$getInnerChild(rawVNode);
            if (vnode.type === $0a6cc4ba868319ae$export$4d299b491347818a) {
                current = null;
                return vnode;
            }
            const comp = vnode.type;
            const name = $0a6cc4ba868319ae$var$getComponentName($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$0a6cc4ba868319ae$var$matches(include, name)) || exclude && name && $0a6cc4ba868319ae$var$matches(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $0a6cc4ba868319ae$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $0a6cc4ba868319ae$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $0a6cc4ba868319ae$export$70eb8a58709972df = $0a6cc4ba868319ae$var$KeepAliveImpl;
function $0a6cc4ba868319ae$var$matches(pattern, name) {
    if ((0, $8POXm.isArray)(pattern)) return pattern.some((p)=>$0a6cc4ba868319ae$var$matches(p, name));
    else if ((0, $8POXm.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $8POXm.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    return false;
}
function $0a6cc4ba868319ae$export$ba52d824b95a2154(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "a", target);
}
function $0a6cc4ba868319ae$export$bf1440eeaf5fa709(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "da", target);
}
function $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, type, target = $0a6cc4ba868319ae$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $0a6cc4ba868319ae$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($0a6cc4ba868319ae$var$isKeepAlive(current.parent.vnode)) $0a6cc4ba868319ae$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $0a6cc4ba868319ae$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $0a6cc4ba868319ae$var$injectHook(type, hook, keepAliveRoot, true);
    $0a6cc4ba868319ae$export$13348a43ccacfe58(()=>{
        (0, $8POXm.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $0a6cc4ba868319ae$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $0a6cc4ba868319ae$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $0a6cc4ba868319ae$var$injectHook(type, hook, target = $0a6cc4ba868319ae$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            (0, $01W3b.pauseTracking)();
            const reset = $0a6cc4ba868319ae$var$setCurrentInstance(target);
            const res = $0a6cc4ba868319ae$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $01W3b.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $0a6cc4ba868319ae$var$createHook = (lifecycle)=>(hook, target = $0a6cc4ba868319ae$var$currentInstance)=>{
        if (!$0a6cc4ba868319ae$var$isInSSRComponentSetup || lifecycle === "sp") $0a6cc4ba868319ae$var$injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const $0a6cc4ba868319ae$export$23b7aeb0d671f804 = $0a6cc4ba868319ae$var$createHook("bm");
const $0a6cc4ba868319ae$export$6d1641039221b5cb = $0a6cc4ba868319ae$var$createHook("m");
const $0a6cc4ba868319ae$export$ab91988a13872e4c = $0a6cc4ba868319ae$var$createHook("bu");
const $0a6cc4ba868319ae$export$5876c47052fb88b1 = $0a6cc4ba868319ae$var$createHook("u");
const $0a6cc4ba868319ae$export$40c420df62d2614 = $0a6cc4ba868319ae$var$createHook("bum");
const $0a6cc4ba868319ae$export$13348a43ccacfe58 = $0a6cc4ba868319ae$var$createHook("um");
const $0a6cc4ba868319ae$export$ebf0c601f267bceb = $0a6cc4ba868319ae$var$createHook("sp");
const $0a6cc4ba868319ae$export$898295a813d662eb = $0a6cc4ba868319ae$var$createHook("rtg");
const $0a6cc4ba868319ae$export$2b41f4235363e921 = $0a6cc4ba868319ae$var$createHook("rtc");
function $0a6cc4ba868319ae$export$6a3a15856e50ad19(hook, target = $0a6cc4ba868319ae$var$currentInstance) {
    $0a6cc4ba868319ae$var$injectHook("ec", hook, target);
}
const $0a6cc4ba868319ae$var$COMPONENTS = "components";
const $0a6cc4ba868319ae$var$DIRECTIVES = "directives";
function $0a6cc4ba868319ae$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $0a6cc4ba868319ae$export$b44c564a05ca975(component) {
    if ((0, $8POXm.isString)(component)) return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, component, false) || component;
    else return component || $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT;
}
function $0a6cc4ba868319ae$export$a1989e995cd481be(name) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$DIRECTIVES, name);
}
function $0a6cc4ba868319ae$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $0a6cc4ba868319ae$var$currentRenderingInstance || $0a6cc4ba868319ae$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $0a6cc4ba868319ae$var$COMPONENTS) {
            const selfName = $0a6cc4ba868319ae$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $8POXm.camelize)(name) || selfName === (0, $8POXm.capitalize)((0, $8POXm.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $0a6cc4ba868319ae$var$resolve(instance[type] || Component[type], name) || // global registration
        $0a6cc4ba868319ae$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $0a6cc4ba868319ae$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $8POXm.camelize)(name)] || registry[(0, $8POXm.capitalize)((0, $8POXm.camelize)(name))]);
}
function $0a6cc4ba868319ae$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = (0, $8POXm.isArray)(source);
    if (sourceIsArray || (0, $8POXm.isString)(source)) {
        const sourceIsReactiveArray = sourceIsArray && (0, $01W3b.isReactive)(source);
        let needsWrap = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, $01W3b.isShallow)(source);
            source = (0, $01W3b.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? (0, $01W3b.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $8POXm.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $0a6cc4ba868319ae$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $8POXm.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $0a6cc4ba868319ae$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance.ce || $0a6cc4ba868319ae$var$currentRenderingInstance.parent && $0a6cc4ba868319ae$var$isAsyncWrapper($0a6cc4ba868319ae$var$currentRenderingInstance.parent) && $0a6cc4ba868319ae$var$currentRenderingInstance.parent.ce) {
        if (name !== "default") props.name = name;
        return $0a6cc4ba868319ae$export$e7eaa45e502fe5cc(), $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$ffb0004e005737fa, null, [
            $0a6cc4ba868319ae$export$bf5c4cf060303d58("slot", props, fallback && fallback())
        ], 64);
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $0a6cc4ba868319ae$var$ensureValidVNode(slot(props));
    const slotKey = props.key || // slot content array of a dynamic conditional slot may have a branch
    // key attached in the `createSlots` helper, respect that
    validSlotContent && validSlotContent.key;
    const rendered = $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$ffb0004e005737fa, {
        key: (slotKey && !(0, $8POXm.isSymbol)(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
        (!validSlotContent && fallback ? "_fb" : "")
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $0a6cc4ba868319ae$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(child)) return true;
        if (child.type === $0a6cc4ba868319ae$export$4d299b491347818a) return false;
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa && !$0a6cc4ba868319ae$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $0a6cc4ba868319ae$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $8POXm.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $0a6cc4ba868319ae$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($0a6cc4ba868319ae$var$isStatefulComponent(i)) return $0a6cc4ba868319ae$var$getComponentPublicInstance(i);
    return $0a6cc4ba868319ae$var$getPublicInstance(i.parent);
};
const $0a6cc4ba868319ae$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.parent),
    $root: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.root),
    $host: (i)=>i.ce,
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            $0a6cc4ba868319ae$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $0a6cc4ba868319ae$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$instanceWatch.bind(i) : (0, $8POXm.NOOP)
});
const $0a6cc4ba868319ae$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $0a6cc4ba868319ae$var$hasSetupBinding = (state, key)=>state !== (0, $8POXm.EMPTY_OBJ) && !state.__isScriptSetup && (0, $8POXm.hasOwn)(state, key);
const $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $8POXm.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $0a6cc4ba868319ae$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $0a6cc4ba868319ae$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $01W3b.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $8POXm.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $8POXm.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key) || $0a6cc4ba868319ae$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $8POXm.hasOwn)(normalizedProps, key) || (0, $8POXm.hasOwn)(ctx, key) || (0, $8POXm.hasOwn)($0a6cc4ba868319ae$var$publicPropertiesMap, key) || (0, $8POXm.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $8POXm.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $0a6cc4ba868319ae$var$target;
const $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $8POXm.extend)({}, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $8POXm.isGloballyAllowed)(key);
        return has;
    }
});
function $0a6cc4ba868319ae$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($0a6cc4ba868319ae$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$0a6cc4ba868319ae$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $8POXm.NOOP)
        });
    });
    return target;
}
function $0a6cc4ba868319ae$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $8POXm.NOOP)
        });
    });
}
function $0a6cc4ba868319ae$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $01W3b.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($0a6cc4ba868319ae$var$isReservedPrefix(key[0])) {
                $0a6cc4ba868319ae$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $8POXm.NOOP)
            });
        }
    });
}
const $0a6cc4ba868319ae$var$warnRuntimeUsage = (method)=>$0a6cc4ba868319ae$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $0a6cc4ba868319ae$export$80b33eababae110e() {
    return null;
}
function $0a6cc4ba868319ae$export$51ecece22fc17ddc() {
    return null;
}
function $0a6cc4ba868319ae$export$da25b65ca24b518a(exposed) {}
function $0a6cc4ba868319ae$export$77e79129327f3d0d(options) {}
function $0a6cc4ba868319ae$export$1b3acd4bb805b712() {
    return null;
}
function $0a6cc4ba868319ae$export$acd55aa037e791bb() {}
function $0a6cc4ba868319ae$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $0a6cc4ba868319ae$export$9203a8e84125433c() {
    return $0a6cc4ba868319ae$var$getContext().slots;
}
function $0a6cc4ba868319ae$export$75e29435042cd2ea() {
    return $0a6cc4ba868319ae$var$getContext().attrs;
}
function $0a6cc4ba868319ae$var$getContext() {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $0a6cc4ba868319ae$var$createSetupContext(i));
}
function $0a6cc4ba868319ae$var$normalizePropsOrEmits(props) {
    return (0, $8POXm.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $0a6cc4ba868319ae$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $0a6cc4ba868319ae$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $0a6cc4ba868319ae$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $8POXm.isArray)(a) && (0, $8POXm.isArray)(b)) return a.concat(b);
    return (0, $8POXm.extend)({}, $0a6cc4ba868319ae$var$normalizePropsOrEmits(a), $0a6cc4ba868319ae$var$normalizePropsOrEmits(b));
}
function $0a6cc4ba868319ae$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $0a6cc4ba868319ae$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $0a6cc4ba868319ae$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $0a6cc4ba868319ae$var$unsetCurrentInstance();
    if ((0, $8POXm.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $0a6cc4ba868319ae$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$0a6cc4ba868319ae$var$setCurrentInstance(ctx)
    ];
}
function $0a6cc4ba868319ae$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $0a6cc4ba868319ae$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $0a6cc4ba868319ae$var$shouldCacheAccess = true;
function $0a6cc4ba868319ae$var$applyOptions(instance) {
    const options = $0a6cc4ba868319ae$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $0a6cc4ba868319ae$var$shouldCacheAccess = false;
    if (options.beforeCreate) $0a6cc4ba868319ae$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $8POXm.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $8POXm.isObject)(data)) ;
        else instance.data = (0, $01W3b.reactive)(data);
    }
    $0a6cc4ba868319ae$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $8POXm.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $8POXm.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $8POXm.NOOP);
        const set = !(0, $8POXm.isFunction)(opt) && (0, $8POXm.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $8POXm.NOOP);
        const c = $0a6cc4ba868319ae$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$0a6cc4ba868319ae$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $8POXm.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $0a6cc4ba868319ae$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $8POXm.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($0a6cc4ba868319ae$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($0a6cc4ba868319ae$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($0a6cc4ba868319ae$export$5876c47052fb88b1, updated);
    registerLifecycleHook($0a6cc4ba868319ae$export$ba52d824b95a2154, activated);
    registerLifecycleHook($0a6cc4ba868319ae$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($0a6cc4ba868319ae$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($0a6cc4ba868319ae$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($0a6cc4ba868319ae$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($0a6cc4ba868319ae$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($0a6cc4ba868319ae$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $8POXm.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $8POXm.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) $0a6cc4ba868319ae$var$markAsyncBoundary(instance);
}
function $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $8POXm.NOOP)) {
    if ((0, $8POXm.isArray)(injectOptions)) injectOptions = $0a6cc4ba868319ae$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $8POXm.isObject)(opt)) {
            if ("default" in opt) injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key);
        } else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt);
        if ((0, $01W3b.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $0a6cc4ba868319ae$var$callHook(hook, instance, type) {
    $0a6cc4ba868319ae$export$dae85862a8d94378((0, $8POXm.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $0a6cc4ba868319ae$var$createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $8POXm.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $8POXm.isFunction)(raw)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $8POXm.isObject)(raw)) {
        if ((0, $8POXm.isArray)(raw)) raw.forEach((r)=>$0a6cc4ba868319ae$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $8POXm.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $0a6cc4ba868319ae$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $0a6cc4ba868319ae$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $8POXm.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $0a6cc4ba868319ae$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $0a6cc4ba868319ae$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $0a6cc4ba868319ae$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $0a6cc4ba868319ae$var$internalOptionMergeStrats = {
    data: $0a6cc4ba868319ae$var$mergeDataFn,
    props: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    emits: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $0a6cc4ba868319ae$var$mergeObjectOptions,
    computed: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $0a6cc4ba868319ae$var$mergeAsArray,
    created: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeMount: $0a6cc4ba868319ae$var$mergeAsArray,
    mounted: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUpdate: $0a6cc4ba868319ae$var$mergeAsArray,
    updated: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeDestroy: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUnmount: $0a6cc4ba868319ae$var$mergeAsArray,
    destroyed: $0a6cc4ba868319ae$var$mergeAsArray,
    unmounted: $0a6cc4ba868319ae$var$mergeAsArray,
    activated: $0a6cc4ba868319ae$var$mergeAsArray,
    deactivated: $0a6cc4ba868319ae$var$mergeAsArray,
    errorCaptured: $0a6cc4ba868319ae$var$mergeAsArray,
    serverPrefetch: $0a6cc4ba868319ae$var$mergeAsArray,
    // assets
    components: $0a6cc4ba868319ae$var$mergeObjectOptions,
    directives: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // watch
    watch: $0a6cc4ba868319ae$var$mergeWatchOptions,
    // provide / inject
    provide: $0a6cc4ba868319ae$var$mergeDataFn,
    inject: $0a6cc4ba868319ae$var$mergeInject
};
function $0a6cc4ba868319ae$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $8POXm.extend)((0, $8POXm.isFunction)(to) ? to.call(this, this) : to, (0, $8POXm.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $0a6cc4ba868319ae$var$mergeInject(to, from) {
    return $0a6cc4ba868319ae$var$mergeObjectOptions($0a6cc4ba868319ae$var$normalizeInject(to), $0a6cc4ba868319ae$var$normalizeInject(from));
}
function $0a6cc4ba868319ae$var$normalizeInject(raw) {
    if ((0, $8POXm.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $0a6cc4ba868319ae$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $0a6cc4ba868319ae$var$mergeObjectOptions(to, from) {
    return to ? (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $8POXm.isArray)(to) && (0, $8POXm.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), $0a6cc4ba868319ae$var$normalizePropsOrEmits(to), $0a6cc4ba868319ae$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $0a6cc4ba868319ae$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $0a6cc4ba868319ae$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $0a6cc4ba868319ae$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $8POXm.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $0a6cc4ba868319ae$var$uid$1 = 0;
function $0a6cc4ba868319ae$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $8POXm.isFunction)(rootComponent)) rootComponent = (0, $8POXm.extend)({}, rootComponent);
        if (rootProps != null && !(0, $8POXm.isObject)(rootProps)) rootProps = null;
        const context = $0a6cc4ba868319ae$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        const pluginCleanupFns = [];
        let isMounted = false;
        const app = context.app = {
            _uid: $0a6cc4ba868319ae$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $0a6cc4ba868319ae$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $8POXm.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $8POXm.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = app._ceVNode || $0a6cc4ba868319ae$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $0a6cc4ba868319ae$var$devtoolsInitApp(app, $0a6cc4ba868319ae$export$83d89fbfd8236492);
                    }
                    return $0a6cc4ba868319ae$var$getComponentPublicInstance(vnode.component);
                }
            },
            onUnmount (cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount () {
                if (isMounted) {
                    $0a6cc4ba868319ae$export$dae85862a8d94378(pluginCleanupFns, app._instance, 16);
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $0a6cc4ba868319ae$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $0a6cc4ba868319ae$var$currentApp;
                $0a6cc4ba868319ae$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $0a6cc4ba868319ae$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $0a6cc4ba868319ae$var$currentApp = null;
function $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, value) {
    if (!$0a6cc4ba868319ae$var$currentInstance) ;
    else {
        let provides = $0a6cc4ba868319ae$var$currentInstance.provides;
        const parentProvides = $0a6cc4ba868319ae$var$currentInstance.parent && $0a6cc4ba868319ae$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $0a6cc4ba868319ae$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $0a6cc4ba868319ae$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
    if (instance || $0a6cc4ba868319ae$var$currentApp) {
        const provides = $0a6cc4ba868319ae$var$currentApp ? $0a6cc4ba868319ae$var$currentApp._context.provides : instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $8POXm.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $0a6cc4ba868319ae$export$caf6761f24fc571a() {
    return !!($0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance || $0a6cc4ba868319ae$var$currentApp);
}
const $0a6cc4ba868319ae$var$internalObjectProto = {};
const $0a6cc4ba868319ae$var$createInternalObject = ()=>Object.create($0a6cc4ba868319ae$var$internalObjectProto);
const $0a6cc4ba868319ae$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $0a6cc4ba868319ae$var$internalObjectProto;
function $0a6cc4ba868319ae$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $0a6cc4ba868319ae$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $01W3b.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $0a6cc4ba868319ae$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $0a6cc4ba868319ae$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $01W3b.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $8POXm.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $8POXm.camelize)(key);
                        props[camelizedKey] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $8POXm.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $8POXm.hyphenate)(key)) === key || !(0, $8POXm.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $8POXm.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $01W3b.trigger)(instance.attrs, "set", "");
}
function $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $8POXm.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $8POXm.hasOwn)(options, camelKey = (0, $8POXm.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $01W3b.toRaw)(props);
        const castValues = rawCastValues || (0, $8POXm.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $8POXm.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $0a6cc4ba868319ae$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $8POXm.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $8POXm.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $8POXm.hyphenate)(key))) value = true;
        }
    }
    return value;
}
const $0a6cc4ba868319ae$var$mixinPropsCache = /* @__PURE__ */ new WeakMap();
function $0a6cc4ba868319ae$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $0a6cc4ba868319ae$var$mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $0a6cc4ba868319ae$var$normalizePropsOptions(raw2, appContext, true);
            (0, $8POXm.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, (0, $8POXm.EMPTY_ARR));
        return 0, $8POXm.EMPTY_ARR;
    }
    if ((0, $8POXm.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $8POXm.camelize)(raw[i]);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $8POXm.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $8POXm.camelize)(key);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt) ? {
                type: opt
            } : (0, $8POXm.extend)({}, opt);
            const propType = prop.type;
            let shouldCast = false;
            let shouldCastTrue = true;
            if ((0, $8POXm.isArray)(propType)) for(let index = 0; index < propType.length; ++index){
                const type = propType[index];
                const typeName = (0, $8POXm.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, $8POXm.isFunction)(propType) && propType.name === "Boolean";
            prop[0 /* shouldCast */ ] = shouldCast;
            prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
            if (shouldCast || (0, $8POXm.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $0a6cc4ba868319ae$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $8POXm.isReservedProp)(key)) return true;
    return false;
}
function $0a6cc4ba868319ae$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $0a6cc4ba868319ae$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $01W3b.toRaw)(props);
    const options = instance.propsOptions[0];
    const camelizePropsKey = Object.keys(rawProps).map((key)=>(0, $8POXm.camelize)(key));
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $0a6cc4ba868319ae$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !camelizePropsKey.includes(key));
    }
}
function $0a6cc4ba868319ae$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $0a6cc4ba868319ae$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $8POXm.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $0a6cc4ba868319ae$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $0a6cc4ba868319ae$var$warn$1($0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $0a6cc4ba868319ae$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $0a6cc4ba868319ae$var$isSimpleType = /* @__PURE__ */ (0, $8POXm.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $0a6cc4ba868319ae$var$assertType(value, type) {
    let valid;
    const expectedType = $0a6cc4ba868319ae$var$getType(type);
    if (expectedType === "null") valid = value === null;
    else if ($0a6cc4ba868319ae$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $8POXm.isObject)(value);
    else if (expectedType === "Array") valid = (0, $8POXm.isArray)(value);
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $8POXm.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $8POXm.toRawType)(value);
    const expectedValue = $0a6cc4ba868319ae$var$styleValue(value, expectedType);
    const receivedValue = $0a6cc4ba868319ae$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $0a6cc4ba868319ae$var$isExplicable(expectedType) && !$0a6cc4ba868319ae$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($0a6cc4ba868319ae$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $0a6cc4ba868319ae$var$styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $0a6cc4ba868319ae$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $0a6cc4ba868319ae$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $0a6cc4ba868319ae$var$isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const $0a6cc4ba868319ae$var$normalizeSlotValue = (value)=>(0, $8POXm.isArray)(value) ? value.map($0a6cc4ba868319ae$var$normalizeVNode) : [
        $0a6cc4ba868319ae$var$normalizeVNode(value)
    ];
const $0a6cc4ba868319ae$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $0a6cc4ba868319ae$export$694b237e827a3d23((...args)=>{
        return $0a6cc4ba868319ae$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $0a6cc4ba868319ae$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($0a6cc4ba868319ae$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $8POXm.isFunction)(value)) slots[key] = $0a6cc4ba868319ae$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $0a6cc4ba868319ae$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $0a6cc4ba868319ae$var$assignSlots = (slots, children, optimized)=>{
    for(const key in children)if (optimized || key !== "_") slots[key] = children[key];
};
const $0a6cc4ba868319ae$var$initSlots = (instance, children, optimized)=>{
    const slots = instance.slots = $0a6cc4ba868319ae$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            $0a6cc4ba868319ae$var$assignSlots(slots, children, optimized);
            if (optimized) (0, $8POXm.def)(slots, "_", type, true);
        } else $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
    } else if (children) $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
};
const $0a6cc4ba868319ae$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $8POXm.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else $0a6cc4ba868319ae$var$assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$0a6cc4ba868319ae$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
let $0a6cc4ba868319ae$var$supported;
let $0a6cc4ba868319ae$var$perf;
function $0a6cc4ba868319ae$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) $0a6cc4ba868319ae$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfStart(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $0a6cc4ba868319ae$var$perf.mark(endTag);
        $0a6cc4ba868319ae$var$perf.measure(`<${$0a6cc4ba868319ae$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(startTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfEnd(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$isSupported() {
    if ($0a6cc4ba868319ae$var$supported !== void 0) return $0a6cc4ba868319ae$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $0a6cc4ba868319ae$var$supported = true;
        $0a6cc4ba868319ae$var$perf = window.performance;
    } else $0a6cc4ba868319ae$var$supported = false;
    return $0a6cc4ba868319ae$var$supported;
}
function $0a6cc4ba868319ae$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $0a6cc4ba868319ae$var$queuePostRenderEffect = $0a6cc4ba868319ae$var$queueEffectWithSuspense;
function $0a6cc4ba868319ae$export$53ae2f996c64e9a(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options);
}
function $0a6cc4ba868319ae$export$200524cf0d997ff0(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options, $0a6cc4ba868319ae$var$createHydrationFunctions);
}
function $0a6cc4ba868319ae$var$baseCreateRenderer(options, createHydrationFns) {
    $0a6cc4ba868319ae$var$initFeatureFlags();
    const target = (0, $8POXm.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $8POXm.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $0a6cc4ba868319ae$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $8POXm.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $8POXm.def)(el, "__vnode", vnode, true);
            (0, $8POXm.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree || $0a6cc4ba868319ae$var$isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(children[i]) : $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $8POXm.EMPTY_OBJ);
        const newProps = n2.props || (0, $8POXm.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, true);
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $0a6cc4ba868319ae$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$0a6cc4ba868319ae$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $8POXm.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $8POXm.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(const key in newProps){
                if ((0, $8POXm.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $0a6cc4ba868319ae$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($0a6cc4ba868319ae$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $0a6cc4ba868319ae$var$setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($0a6cc4ba868319ae$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent, root: root, type: type } = instance;
                const isAsyncWrapperVNode = $0a6cc4ba868319ae$var$isAsyncWrapper(initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (bm) (0, $8POXm.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce) root.ce._injectChildStyle(type);
                    const subTree = instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $0a6cc4ba868319ae$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $0a6cc4ba868319ae$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $0a6cc4ba868319ae$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            if (!instance.isUnmounted) componentUpdateFn();
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $8POXm.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                const nextTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $0a6cc4ba868319ae$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $0a6cc4ba868319ae$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(instance);
            }
        };
        instance.scope.on();
        const effect = instance.effect = new (0, $01W3b.ReactiveEffect)(componentUpdateFn);
        instance.scope.off();
        const update = instance.update = effect.run.bind(effect);
        const job = instance.job = effect.runIfDirty.bind(effect);
        job.i = instance;
        job.id = instance.uid;
        effect.scheduler = ()=>$0a6cc4ba868319ae$var$queueJob(job);
        $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $0a6cc4ba868319ae$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $0a6cc4ba868319ae$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $01W3b.pauseTracking)();
        $0a6cc4ba868319ae$var$flushPreFlushCbs(instance);
        (0, $01W3b.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $8POXm.EMPTY_ARR);
        c2 = c2 || (0, $8POXm.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[e2]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[e2]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $0a6cc4ba868319ae$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $0a6cc4ba868319ae$var$getSequence(newIndexToOldIndexMap) : (0, $8POXm.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs, cacheIndex: cacheIndex } = vnode;
        if (patchFlag === -2) optimized = false;
        if (ref != null) $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode, true);
        if (cacheIndex != null) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$0a6cc4ba868319ae$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $0a6cc4ba868319ae$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, job: job, subTree: subTree, um: um, m: m, a: a } = instance;
        $0a6cc4ba868319ae$var$invalidateMount(m);
        $0a6cc4ba868319ae$var$invalidateMount(a);
        if (bum) (0, $8POXm.invokeArrayFns)(bum);
        scope.stop();
        if (job) {
            job.flags |= 8;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $0a6cc4ba868319ae$var$queuePostRenderEffect(um, parentSuspense);
        $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        const el = hostNextSibling(vnode.anchor || vnode.el);
        const teleportEnd = el && el[$0a6cc4ba868319ae$var$TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        container._vnode = vnode;
        if (!isFlushing) {
            isFlushing = true;
            $0a6cc4ba868319ae$var$flushPreFlushCbs();
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            isFlushing = false;
        }
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $0a6cc4ba868319ae$var$createAppAPI(render, hydrate)
    };
}
function $0a6cc4ba868319ae$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $0a6cc4ba868319ae$var$toggleRecurse({ effect: effect, job: job }, allowed) {
    if (allowed) {
        effect.flags |= 32;
        job.flags |= 4;
    } else {
        effect.flags &= -33;
        job.flags &= -5;
    }
}
function $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $8POXm.isArray)(ch1) && (0, $8POXm.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $0a6cc4ba868319ae$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) $0a6cc4ba868319ae$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6) c2.el = c1.el;
    }
}
function $0a6cc4ba868319ae$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
function $0a6cc4ba868319ae$var$invalidateMount(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].flags |= 8;
}
const $0a6cc4ba868319ae$export$f2549a27e18acf2d = Symbol.for("v-scx");
const $0a6cc4ba868319ae$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $0a6cc4ba868319ae$export$a976684a0efeb93f($0a6cc4ba868319ae$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $0a6cc4ba868319ae$export$ede35fc0e5500309(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, options);
}
function $0a6cc4ba868319ae$export$b7f27ea67102d543(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $0a6cc4ba868319ae$export$2035654f31b0e555(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "sync"
    });
}
function $0a6cc4ba868319ae$export$3db5d71bdb2d5499(source, cb, options) {
    return $0a6cc4ba868319ae$var$doWatch(source, cb, options);
}
function $0a6cc4ba868319ae$var$doWatch(source, cb, options = (0, $8POXm.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, flush: flush, once: once } = options;
    const baseWatchOptions = (0, $8POXm.extend)({}, options);
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if ($0a6cc4ba868319ae$var$isInSSRComponentSetup) {
        if (flush === "sync") {
            const ctx = $0a6cc4ba868319ae$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            const watchStopHandle = ()=>{};
            watchStopHandle.stop = (0, $8POXm.NOOP);
            watchStopHandle.resume = (0, $8POXm.NOOP);
            watchStopHandle.pause = (0, $8POXm.NOOP);
            return watchStopHandle;
        }
    }
    const instance = $0a6cc4ba868319ae$var$currentInstance;
    baseWatchOptions.call = (fn, type, args)=>$0a6cc4ba868319ae$export$dae85862a8d94378(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") baseWatchOptions.scheduler = (job)=>{
        $0a6cc4ba868319ae$var$queuePostRenderEffect(job, instance && instance.suspense);
    };
    else if (flush !== "sync") {
        isPre = true;
        baseWatchOptions.scheduler = (job, isFirstRun)=>{
            if (isFirstRun) job();
            else $0a6cc4ba868319ae$var$queueJob(job);
        };
    }
    baseWatchOptions.augmentJob = (job)=>{
        if (cb) job.flags |= 4;
        if (isPre) {
            job.flags |= 2;
            if (instance) {
                job.id = instance.uid;
                job.i = instance;
            }
        }
    };
    const watchHandle = (0, $01W3b.watch)(source, cb, baseWatchOptions);
    if ($0a6cc4ba868319ae$var$isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(watchHandle);
        else if (runsImmediately) watchHandle();
    }
    return watchHandle;
}
function $0a6cc4ba868319ae$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $8POXm.isString)(source) ? source.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $8POXm.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(this);
    const res = $0a6cc4ba868319ae$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $0a6cc4ba868319ae$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $0a6cc4ba868319ae$export$fb78bd113157f1a1(props, name, options = (0, $8POXm.EMPTY_OBJ)) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    const camelizedName = (0, $8POXm.camelize)(name);
    const hyphenatedName = (0, $8POXm.hyphenate)(name);
    const modifiers = $0a6cc4ba868319ae$var$getModelModifiers(props, camelizedName);
    const res = (0, $01W3b.customRef)((track, trigger)=>{
        let localValue;
        let prevSetValue = (0, $8POXm.EMPTY_OBJ);
        let prevEmittedValue;
        $0a6cc4ba868319ae$export$2035654f31b0e555(()=>{
            const propValue = props[camelizedName];
            if ((0, $8POXm.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const emittedValue = options.set ? options.set(value) : value;
                if (!(0, $8POXm.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasChanged)(value, prevSetValue))) return;
                const rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps))) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, emittedValue);
                if ((0, $8POXm.hasChanged)(value, emittedValue) && (0, $8POXm.hasChanged)(value, prevSetValue) && !(0, $8POXm.hasChanged)(emittedValue, prevEmittedValue)) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, $8POXm.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
const $0a6cc4ba868319ae$var$getModelModifiers = (props, modelName)=>{
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${(0, $8POXm.camelize)(modelName)}Modifiers`] || props[`${(0, $8POXm.hyphenate)(modelName)}Modifiers`];
};
function $0a6cc4ba868319ae$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $8POXm.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modifiers = isModelListener && $0a6cc4ba868319ae$var$getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map((a)=>(0, $8POXm.isString)(a) ? a.trim() : a);
        if (modifiers.number) args = rawArgs.map((0, $8POXm.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $8POXm.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.hyphenate)(event))];
    if (handler) $0a6cc4ba868319ae$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $0a6cc4ba868319ae$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $0a6cc4ba868319ae$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $0a6cc4ba868319ae$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $8POXm.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $8POXm.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $8POXm.extend)(normalized, raw);
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $0a6cc4ba868319ae$var$isEmitListener(options, key) {
    if (!options || !(0, $8POXm.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $8POXm.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $8POXm.hasOwn)(options, (0, $8POXm.hyphenate)(key)) || (0, $8POXm.hasOwn)(options, key);
}
let $0a6cc4ba868319ae$var$accessedAttrs = false;
function $0a6cc4ba868319ae$var$markAttrsAccessed() {
    $0a6cc4ba868319ae$var$accessedAttrs = true;
}
function $0a6cc4ba868319ae$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $0a6cc4ba868319ae$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $0a6cc4ba868319ae$var$blockStack.length = 0;
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 1);
        result = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $8POXm.isModelListener))) fallthroughAttrs = $0a6cc4ba868319ae$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) $0a6cc4ba868319ae$export$7770a22486565649(root, vnode.transition);
    result = root;
    $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prev);
    return result;
}
const $0a6cc4ba868319ae$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $0a6cc4ba868319ae$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $0a6cc4ba868319ae$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $0a6cc4ba868319ae$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($0a6cc4ba868319ae$export$3868d13f8734ae81(child)) {
            if (child.type !== $0a6cc4ba868319ae$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $0a6cc4ba868319ae$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $8POXm.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $8POXm.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $0a6cc4ba868319ae$export$4d299b491347818a;
};
function $0a6cc4ba868319ae$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$0a6cc4ba868319ae$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$0a6cc4ba868319ae$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) root.el = vnode.el;
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
}
const $0a6cc4ba868319ae$var$isSuspense = (type)=>type.__isSuspense;
let $0a6cc4ba868319ae$var$suspenseId = 0;
const $0a6cc4ba868319ae$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $0a6cc4ba868319ae$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $0a6cc4ba868319ae$var$hydrateSuspense,
    normalize: $0a6cc4ba868319ae$var$normalizeSuspenseChildren
};
const $0a6cc4ba868319ae$export$74bf444e3cd11ea5 = $0a6cc4ba868319ae$var$SuspenseImpl;
function $0a6cc4ba868319ae$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $8POXm.isFunction)(eventListener)) eventListener();
}
function $0a6cc4ba868319ae$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onPending");
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($0a6cc4ba868319ae$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, newBranch);
    } else {
        $0a6cc4ba868319ae$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $0a6cc4ba868319ae$var$hasWarned = false;
function $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $8POXm.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $0a6cc4ba868319ae$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2 } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        $0a6cc4ba868319ae$export$59536a0199721cab(effects);
                    }
                };
                if (activeBranch) {
                    if (parentNode(activeBranch.el) === container2) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            $0a6cc4ba868319ae$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $0a6cc4ba868319ae$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $0a6cc4ba868319ae$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect, optimized2) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $0a6cc4ba868319ae$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized2);
                if (placeholder) remove(placeholder);
                $0a6cc4ba868319ae$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $0a6cc4ba868319ae$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $0a6cc4ba868319ae$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $0a6cc4ba868319ae$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $0a6cc4ba868319ae$var$normalizeSuspenseSlot(children.fallback) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
}
function $0a6cc4ba868319ae$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $8POXm.isFunction)(s)) {
        const trackBlock = $0a6cc4ba868319ae$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $0a6cc4ba868319ae$var$currentBlock;
            $0a6cc4ba868319ae$var$closeBlock();
        }
    }
    if ((0, $8POXm.isArray)(s)) {
        const singleChild = $0a6cc4ba868319ae$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $0a6cc4ba868319ae$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $0a6cc4ba868319ae$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $8POXm.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $0a6cc4ba868319ae$export$59536a0199721cab(fn);
}
function $0a6cc4ba868319ae$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $0a6cc4ba868319ae$var$updateHOCHostEl(parentComponent, el);
    }
}
function $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const $0a6cc4ba868319ae$export$ffb0004e005737fa = Symbol.for("v-fgt");
const $0a6cc4ba868319ae$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
const $0a6cc4ba868319ae$export$4d299b491347818a = Symbol.for("v-cmt");
const $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
const $0a6cc4ba868319ae$var$blockStack = [];
let $0a6cc4ba868319ae$var$currentBlock = null;
function $0a6cc4ba868319ae$export$e7eaa45e502fe5cc(disableTracking = false) {
    $0a6cc4ba868319ae$var$blockStack.push($0a6cc4ba868319ae$var$currentBlock = disableTracking ? null : []);
}
function $0a6cc4ba868319ae$var$closeBlock() {
    $0a6cc4ba868319ae$var$blockStack.pop();
    $0a6cc4ba868319ae$var$currentBlock = $0a6cc4ba868319ae$var$blockStack[$0a6cc4ba868319ae$var$blockStack.length - 1] || null;
}
let $0a6cc4ba868319ae$var$isBlockTreeEnabled = 1;
function $0a6cc4ba868319ae$export$c20bee82f26f1e27(value, inVOnce = false) {
    $0a6cc4ba868319ae$var$isBlockTreeEnabled += value;
    if (value < 0 && $0a6cc4ba868319ae$var$currentBlock && inVOnce) $0a6cc4ba868319ae$var$currentBlock.hasOnce = true;
}
function $0a6cc4ba868319ae$var$setupBlock(vnode) {
    vnode.dynamicChildren = $0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 ? $0a6cc4ba868319ae$var$currentBlock || (0, $8POXm.EMPTY_ARR) : null;
    $0a6cc4ba868319ae$var$closeBlock();
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
function $0a6cc4ba868319ae$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $0a6cc4ba868319ae$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $0a6cc4ba868319ae$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $0a6cc4ba868319ae$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $0a6cc4ba868319ae$var$vnodeArgsTransformer;
function $0a6cc4ba868319ae$export$83beccd3afeeb809(transformer) {
    $0a6cc4ba868319ae$var$vnodeArgsTransformer = transformer;
}
const $0a6cc4ba868319ae$var$createVNodeWithArgsTransform = (...args)=>{
    return $0a6cc4ba868319ae$var$_createVNode(...$0a6cc4ba868319ae$var$vnodeArgsTransformer ? $0a6cc4ba868319ae$var$vnodeArgsTransformer(args, $0a6cc4ba868319ae$var$currentRenderingInstance) : args);
};
const $0a6cc4ba868319ae$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $0a6cc4ba868319ae$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $8POXm.isString)(ref) || (0, $01W3b.isRef)(ref) || (0, $8POXm.isFunction)(ref) ? {
        i: $0a6cc4ba868319ae$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $0a6cc4ba868319ae$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $0a6cc4ba868319ae$var$normalizeKey(props),
        ref: props && $0a6cc4ba868319ae$var$normalizeRef(props),
        scopeId: $0a6cc4ba868319ae$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $0a6cc4ba868319ae$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $8POXm.isString)(children) ? 8 : 16;
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $0a6cc4ba868319ae$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
const $0a6cc4ba868319ae$export$bf5c4cf060303d58 = $0a6cc4ba868319ae$var$_createVNode;
function $0a6cc4ba868319ae$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT) type = $0a6cc4ba868319ae$export$4d299b491347818a;
    if ($0a6cc4ba868319ae$export$3868d13f8734ae81(type)) {
        const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $0a6cc4ba868319ae$var$normalizeChildren(cloned, children);
        if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && !isBlockNode && $0a6cc4ba868319ae$var$currentBlock) {
            if (cloned.shapeFlag & 6) $0a6cc4ba868319ae$var$currentBlock[$0a6cc4ba868319ae$var$currentBlock.indexOf(type)] = cloned;
            else $0a6cc4ba868319ae$var$currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if ($0a6cc4ba868319ae$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $8POXm.isString)(klass)) props.class = (0, $8POXm.normalizeClass)(klass);
        if ((0, $8POXm.isObject)(style)) {
            if ((0, $01W3b.isProxy)(style) && !(0, $8POXm.isArray)(style)) style = (0, $8POXm.extend)({}, style);
            props.style = (0, $8POXm.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $8POXm.isString)(type) ? 1 : $0a6cc4ba868319ae$var$isSuspense(type) ? 128 : $0a6cc4ba868319ae$var$isTeleport(type) ? 64 : (0, $8POXm.isObject)(type) ? 4 : (0, $8POXm.isFunction)(type) ? 2 : 0;
    return $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $01W3b.isProxy)(props) || $0a6cc4ba868319ae$var$isInternalObject(props) ? (0, $8POXm.extend)({}, props) : props;
}
function $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $0a6cc4ba868319ae$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $0a6cc4ba868319ae$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $8POXm.isArray)(ref) ? ref.concat($0a6cc4ba868319ae$var$normalizeRef(extraProps)) : [
            ref,
            $0a6cc4ba868319ae$var$normalizeRef(extraProps)
        ] : $0a6cc4ba868319ae$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $0a6cc4ba868319ae$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) $0a6cc4ba868319ae$export$7770a22486565649(cloned, transition.clone(cloned));
    return cloned;
}
function $0a6cc4ba868319ae$var$deepCloneVNode(vnode) {
    const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $8POXm.isArray)(vnode.children)) cloned.children = vnode.children.map($0a6cc4ba868319ae$var$deepCloneVNode);
    return cloned;
}
function $0a6cc4ba868319ae$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, text, flag);
}
function $0a6cc4ba868319ae$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $0a6cc4ba868319ae$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($0a6cc4ba868319ae$export$e7eaa45e502fe5cc(), $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$4d299b491347818a, null, text)) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a, null, text);
}
function $0a6cc4ba868319ae$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    else if ((0, $8POXm.isArray)(child)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if ($0a6cc4ba868319ae$export$3868d13f8734ae81(child)) return $0a6cc4ba868319ae$var$cloneIfMounted(child);
    else return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, String(child));
}
function $0a6cc4ba868319ae$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child);
}
function $0a6cc4ba868319ae$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $8POXm.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $0a6cc4ba868319ae$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$0a6cc4ba868319ae$var$isInternalObject(children)) children._ctx = $0a6cc4ba868319ae$var$currentRenderingInstance;
            else if (slotFlag === 3 && $0a6cc4ba868319ae$var$currentRenderingInstance) {
                if ($0a6cc4ba868319ae$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $8POXm.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $0a6cc4ba868319ae$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $0a6cc4ba868319ae$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $8POXm.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $8POXm.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $8POXm.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $8POXm.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $0a6cc4ba868319ae$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $0a6cc4ba868319ae$var$emptyAppContext = $0a6cc4ba868319ae$var$createAppContext();
let $0a6cc4ba868319ae$var$uid = 0;
function $0a6cc4ba868319ae$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $0a6cc4ba868319ae$var$emptyAppContext;
    const instance = {
        uid: $0a6cc4ba868319ae$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        job: null,
        scope: new (0, $01W3b.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $0a6cc4ba868319ae$var$normalizePropsOptions(type, appContext),
        emitsOptions: $0a6cc4ba868319ae$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $8POXm.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $8POXm.EMPTY_OBJ),
        data: (0, $8POXm.EMPTY_OBJ),
        props: (0, $8POXm.EMPTY_OBJ),
        attrs: (0, $8POXm.EMPTY_OBJ),
        slots: (0, $8POXm.EMPTY_OBJ),
        refs: (0, $8POXm.EMPTY_OBJ),
        setupState: (0, $8POXm.EMPTY_OBJ),
        setupContext: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $0a6cc4ba868319ae$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $0a6cc4ba868319ae$var$currentInstance = null;
const $0a6cc4ba868319ae$export$f13e630aa3915748 = ()=>$0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
let $0a6cc4ba868319ae$var$internalSetCurrentInstance;
let $0a6cc4ba868319ae$var$setInSSRSetupState;
{
    const g = (0, $8POXm.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $0a6cc4ba868319ae$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$currentInstance = v1);
    $0a6cc4ba868319ae$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$isInSSRComponentSetup = v1);
}const $0a6cc4ba868319ae$var$setCurrentInstance = (instance)=>{
    const prev = $0a6cc4ba868319ae$var$currentInstance;
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $0a6cc4ba868319ae$var$internalSetCurrentInstance(prev);
    };
};
const $0a6cc4ba868319ae$var$unsetCurrentInstance = ()=>{
    $0a6cc4ba868319ae$var$currentInstance && $0a6cc4ba868319ae$var$currentInstance.scope.off();
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(null);
};
const $0a6cc4ba868319ae$var$isBuiltInTag = /* @__PURE__ */ (0, $8POXm.makeMap)("slot,component");
function $0a6cc4ba868319ae$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($0a6cc4ba868319ae$var$isBuiltInTag(name) || isNativeTag(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $0a6cc4ba868319ae$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $0a6cc4ba868319ae$var$isInSSRComponentSetup = false;
function $0a6cc4ba868319ae$var$setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $0a6cc4ba868319ae$var$isStatefulComponent(instance);
    $0a6cc4ba868319ae$var$initProps(instance, props, isStateful, isSSR);
    $0a6cc4ba868319ae$var$initSlots(instance, children, optimized);
    const setupResult = isStateful ? $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(false);
    return setupResult;
}
function $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        (0, $01W3b.pauseTracking)();
        const setupContext = instance.setupContext = setup.length > 1 ? $0a6cc4ba868319ae$var$createSetupContext(instance) : null;
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        const setupResult = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        const isAsyncSetup = (0, $8POXm.isPromise)(setupResult);
        (0, $01W3b.resetTracking)();
        reset();
        if ((isAsyncSetup || instance.sp) && !$0a6cc4ba868319ae$var$isAsyncWrapper(instance)) $0a6cc4ba868319ae$var$markAsyncBoundary(instance);
        if (isAsyncSetup) {
            setupResult.then($0a6cc4ba868319ae$var$unsetCurrentInstance, $0a6cc4ba868319ae$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $0a6cc4ba868319ae$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR);
    } else $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
function $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $8POXm.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $8POXm.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $01W3b.proxyRefs)(setupResult);
    }
    $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
let $0a6cc4ba868319ae$var$compile;
let $0a6cc4ba868319ae$var$installWithProxy;
function $0a6cc4ba868319ae$export$667bb5a67822b941(_compile) {
    $0a6cc4ba868319ae$var$compile = _compile;
    $0a6cc4ba868319ae$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $0a6cc4ba868319ae$export$c93a9c496c5211fa = ()=>!$0a6cc4ba868319ae$var$compile;
function $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $0a6cc4ba868319ae$var$compile && !Component.render) {
            const template = Component.template || __VUE_OPTIONS_API__ && $0a6cc4ba868319ae$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $8POXm.extend)((0, $8POXm.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $0a6cc4ba868319ae$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $8POXm.NOOP);
        if ($0a6cc4ba868319ae$var$installWithProxy) $0a6cc4ba868319ae$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        (0, $01W3b.pauseTracking)();
        try {
            $0a6cc4ba868319ae$var$applyOptions(instance);
        } finally{
            (0, $01W3b.resetTracking)();
            reset();
        }
    }
}
const $0a6cc4ba868319ae$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $01W3b.track)(target, "get", "");
        return target[key];
    }
};
function $0a6cc4ba868319ae$var$getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get (target, key) {
            (0, $01W3b.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function $0a6cc4ba868319ae$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $0a6cc4ba868319ae$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $0a6cc4ba868319ae$var$getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $01W3b.proxyRefs)((0, $01W3b.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $0a6cc4ba868319ae$var$publicPropertiesMap) return $0a6cc4ba868319ae$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $0a6cc4ba868319ae$var$publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const $0a6cc4ba868319ae$var$classifyRE = /(?:^|[-_])(\w)/g;
const $0a6cc4ba868319ae$var$classify = (str)=>str.replace($0a6cc4ba868319ae$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $0a6cc4ba868319ae$var$getComponentName(Component, includeInferred = true) {
    return (0, $8POXm.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $0a6cc4ba868319ae$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $0a6cc4ba868319ae$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $0a6cc4ba868319ae$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $0a6cc4ba868319ae$var$isClassComponent(value) {
    return (0, $8POXm.isFunction)(value) && "__vccOpts" in value;
}
const $0a6cc4ba868319ae$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $01W3b.computed)(getterOrOptions, debugOptions, $0a6cc4ba868319ae$var$isInSSRComponentSetup);
    return c;
};
function $0a6cc4ba868319ae$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $8POXm.isObject)(propsOrChildren) && !(0, $8POXm.isArray)(propsOrChildren)) {
            if ($0a6cc4ba868319ae$export$3868d13f8734ae81(propsOrChildren)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $0a6cc4ba868319ae$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
function $0a6cc4ba868319ae$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $01W3b.toRaw)(instance.props)));
        if (instance.setupState !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $01W3b.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $8POXm.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $8POXm.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $01W3b.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $8POXm.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $8POXm.isArray)(opts) && opts.includes(key) || (0, $8POXm.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $01W3b.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $0a6cc4ba868319ae$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $8POXm.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(cached);
    return true;
}
const $0a6cc4ba868319ae$export$83d89fbfd8236492 = "3.5.13";
const $0a6cc4ba868319ae$export$c106dd0671a0fc2d = (0, $8POXm.NOOP);
const $0a6cc4ba868319ae$export$795e0ad4a0e2ed30 = $0a6cc4ba868319ae$var$ErrorTypeStrings$1;
const $0a6cc4ba868319ae$export$6922d3b3a607469e = $0a6cc4ba868319ae$var$devtools$1;
const $0a6cc4ba868319ae$export$b0c258b32c26c785 = $0a6cc4ba868319ae$var$setDevtoolsHook$1;
const $0a6cc4ba868319ae$var$_ssrUtils = {
    createComponentInstance: $0a6cc4ba868319ae$var$createComponentInstance,
    setupComponent: $0a6cc4ba868319ae$var$setupComponent,
    renderComponentRoot: $0a6cc4ba868319ae$var$renderComponentRoot,
    setCurrentRenderingInstance: $0a6cc4ba868319ae$var$setCurrentRenderingInstance,
    isVNode: $0a6cc4ba868319ae$export$3868d13f8734ae81,
    normalizeVNode: $0a6cc4ba868319ae$var$normalizeVNode,
    getComponentPublicInstance: $0a6cc4ba868319ae$var$getComponentPublicInstance,
    ensureValidVNode: $0a6cc4ba868319ae$var$ensureValidVNode,
    pushWarningContext: $0a6cc4ba868319ae$var$pushWarningContext,
    popWarningContext: $0a6cc4ba868319ae$var$popWarningContext
};
const $0a6cc4ba868319ae$export$a9679033567b336d = $0a6cc4ba868319ae$var$_ssrUtils;
const $0a6cc4ba868319ae$export$83cf26e06ea620e1 = null;
const $0a6cc4ba868319ae$export$dc678eddf276286e = null;
const $0a6cc4ba868319ae$export$22072a82865312f6 = null;

});
parcelRegister("01W3b", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $005d1fb7704e278c$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "effectScope", () => $005d1fb7704e278c$export$7056603ea81600be);
$parcel$export(module.exports, "getCurrentScope", () => $005d1fb7704e278c$export$c7be4b0125a10cba);
$parcel$export(module.exports, "onScopeDispose", () => $005d1fb7704e278c$export$a780418acd4762da);
$parcel$export(module.exports, "ReactiveEffect", () => $005d1fb7704e278c$export$28352bb4dd362521);
$parcel$export(module.exports, "pauseTracking", () => $005d1fb7704e278c$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $005d1fb7704e278c$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $005d1fb7704e278c$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $005d1fb7704e278c$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $005d1fb7704e278c$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isShallow", () => $005d1fb7704e278c$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "toReactive", () => $005d1fb7704e278c$export$45c769cf449a508c);
$parcel$export(module.exports, "shallowReadArray", () => $005d1fb7704e278c$export$5eb48af14254449e);
$parcel$export(module.exports, "isProxy", () => $005d1fb7704e278c$export$5f3ca29d057519b3);
$parcel$export(module.exports, "isRef", () => $005d1fb7704e278c$export$4f9f5282de18fc69);
$parcel$export(module.exports, "reactive", () => $005d1fb7704e278c$export$90a44edba14e47be);
$parcel$export(module.exports, "shallowReactive", () => $005d1fb7704e278c$export$8d81cefd22d22260);
$parcel$export(module.exports, "isReactive", () => $005d1fb7704e278c$export$352205f445242f02);
$parcel$export(module.exports, "markRaw", () => $005d1fb7704e278c$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "ref", () => $005d1fb7704e278c$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "shallowRef", () => $005d1fb7704e278c$export$9b7bc5fe3b17c8b3);
$parcel$export(module.exports, "unref", () => $005d1fb7704e278c$export$a239a76781616204);
$parcel$export(module.exports, "proxyRefs", () => $005d1fb7704e278c$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "customRef", () => $005d1fb7704e278c$export$a20c2dd6199824cb);
$parcel$export(module.exports, "toRefs", () => $005d1fb7704e278c$export$2e9533675e5e70e0);
$parcel$export(module.exports, "toRef", () => $005d1fb7704e278c$export$1f60508e4f47b4b7);
$parcel$export(module.exports, "computed", () => $005d1fb7704e278c$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "watch", () => $005d1fb7704e278c$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "traverse", () => $005d1fb7704e278c$export$df3f009e3d155b20);
/**
* @vue/reactivity v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $8POXm = parcelRequire("8POXm");
function $005d1fb7704e278c$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $005d1fb7704e278c$var$activeEffectScope;
class $005d1fb7704e278c$export$1168ed9dbc71ddbd {
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this._isPaused = false;
        this.parent = $005d1fb7704e278c$var$activeEffectScope;
        if (!detached && $005d1fb7704e278c$var$activeEffectScope) this.index = ($005d1fb7704e278c$var$activeEffectScope.scopes || ($005d1fb7704e278c$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    pause() {
        if (this._active) {
            this._isPaused = true;
            let i, l;
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].pause();
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].pause();
        }
    }
    /**
   * Resumes the effect scope, including all child scopes and effects.
   */ resume() {
        if (this._active) {
            if (this._isPaused) {
                this._isPaused = false;
                let i, l;
                if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].resume();
                for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].resume();
            }
        }
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $005d1fb7704e278c$var$activeEffectScope;
            try {
                $005d1fb7704e278c$var$activeEffectScope = this;
                return fn();
            } finally{
                $005d1fb7704e278c$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        $005d1fb7704e278c$var$activeEffectScope = this;
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        $005d1fb7704e278c$var$activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this._active) {
            this._active = false;
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            this.effects.length = 0;
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            this.cleanups.length = 0;
            if (this.scopes) {
                for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
                this.scopes.length = 0;
            }
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
        }
    }
}
function $005d1fb7704e278c$export$7056603ea81600be(detached) {
    return new $005d1fb7704e278c$export$1168ed9dbc71ddbd(detached);
}
function $005d1fb7704e278c$export$c7be4b0125a10cba() {
    return $005d1fb7704e278c$var$activeEffectScope;
}
function $005d1fb7704e278c$export$a780418acd4762da(fn, failSilently = false) {
    if ($005d1fb7704e278c$var$activeEffectScope) $005d1fb7704e278c$var$activeEffectScope.cleanups.push(fn);
}
let $005d1fb7704e278c$var$activeSub;
const $005d1fb7704e278c$export$37ee493b2f34ee54 = {
    "ACTIVE": 1,
    "1": "ACTIVE",
    "RUNNING": 2,
    "2": "RUNNING",
    "TRACKING": 4,
    "4": "TRACKING",
    "NOTIFIED": 8,
    "8": "NOTIFIED",
    "DIRTY": 16,
    "16": "DIRTY",
    "ALLOW_RECURSE": 32,
    "32": "ALLOW_RECURSE",
    "PAUSED": 64,
    "64": "PAUSED"
};
const $005d1fb7704e278c$var$pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class $005d1fb7704e278c$export$28352bb4dd362521 {
    constructor(fn){
        this.fn = fn;
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 5;
        /**
     * @internal
     */ this.next = void 0;
        /**
     * @internal
     */ this.cleanup = void 0;
        this.scheduler = void 0;
        if ($005d1fb7704e278c$var$activeEffectScope && $005d1fb7704e278c$var$activeEffectScope.active) $005d1fb7704e278c$var$activeEffectScope.effects.push(this);
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if ($005d1fb7704e278c$var$pausedQueueEffects.has(this)) {
                $005d1fb7704e278c$var$pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) $005d1fb7704e278c$var$batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        $005d1fb7704e278c$var$cleanupEffect(this);
        $005d1fb7704e278c$var$prepareDeps(this);
        const prevEffect = $005d1fb7704e278c$var$activeSub;
        const prevShouldTrack = $005d1fb7704e278c$var$shouldTrack;
        $005d1fb7704e278c$var$activeSub = this;
        $005d1fb7704e278c$var$shouldTrack = true;
        try {
            return this.fn();
        } finally{
            $005d1fb7704e278c$var$cleanupDeps(this);
            $005d1fb7704e278c$var$activeSub = prevEffect;
            $005d1fb7704e278c$var$shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)$005d1fb7704e278c$var$removeSub(link);
            this.deps = this.depsTail = void 0;
            $005d1fb7704e278c$var$cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) $005d1fb7704e278c$var$pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if ($005d1fb7704e278c$var$isDirty(this)) this.run();
    }
    get dirty() {
        return $005d1fb7704e278c$var$isDirty(this);
    }
}
let $005d1fb7704e278c$var$batchDepth = 0;
let $005d1fb7704e278c$var$batchedSub;
let $005d1fb7704e278c$var$batchedComputed;
function $005d1fb7704e278c$var$batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = $005d1fb7704e278c$var$batchedComputed;
        $005d1fb7704e278c$var$batchedComputed = sub;
        return;
    }
    sub.next = $005d1fb7704e278c$var$batchedSub;
    $005d1fb7704e278c$var$batchedSub = sub;
}
function $005d1fb7704e278c$var$startBatch() {
    $005d1fb7704e278c$var$batchDepth++;
}
function $005d1fb7704e278c$var$endBatch() {
    if (--$005d1fb7704e278c$var$batchDepth > 0) return;
    if ($005d1fb7704e278c$var$batchedComputed) {
        let e = $005d1fb7704e278c$var$batchedComputed;
        $005d1fb7704e278c$var$batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error;
    while($005d1fb7704e278c$var$batchedSub){
        let e = $005d1fb7704e278c$var$batchedSub;
        $005d1fb7704e278c$var$batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error) error = err;
            }
            e = next;
        }
    }
    if (error) throw error;
}
function $005d1fb7704e278c$var$prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function $005d1fb7704e278c$var$cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            $005d1fb7704e278c$var$removeSub(link);
            $005d1fb7704e278c$var$removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function $005d1fb7704e278c$var$isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && ($005d1fb7704e278c$var$refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function $005d1fb7704e278c$var$refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === $005d1fb7704e278c$var$globalVersion) return;
    computed.globalVersion = $005d1fb7704e278c$var$globalVersion;
    const dep = computed.dep;
    computed.flags |= 2;
    if (dep.version > 0 && !computed.isSSR && computed.deps && !$005d1fb7704e278c$var$isDirty(computed)) {
        computed.flags &= -3;
        return;
    }
    const prevSub = $005d1fb7704e278c$var$activeSub;
    const prevShouldTrack = $005d1fb7704e278c$var$shouldTrack;
    $005d1fb7704e278c$var$activeSub = computed;
    $005d1fb7704e278c$var$shouldTrack = true;
    try {
        $005d1fb7704e278c$var$prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || (0, $8POXm.hasChanged)(value, computed._value)) {
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        $005d1fb7704e278c$var$activeSub = prevSub;
        $005d1fb7704e278c$var$shouldTrack = prevShouldTrack;
        $005d1fb7704e278c$var$cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function $005d1fb7704e278c$var$removeSub(link, soft = false) {
    const { dep: dep, prevSub: prevSub, nextSub: nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)$005d1fb7704e278c$var$removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function $005d1fb7704e278c$var$removeDep(link) {
    const { prevDep: prevDep, nextDep: nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function $005d1fb7704e278c$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $005d1fb7704e278c$export$28352bb4dd362521) fn = fn.effect.fn;
    const e = new $005d1fb7704e278c$export$28352bb4dd362521(fn);
    if (options) (0, $8POXm.extend)(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function $005d1fb7704e278c$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $005d1fb7704e278c$var$shouldTrack = true;
const $005d1fb7704e278c$var$trackStack = [];
function $005d1fb7704e278c$export$938a971395fef855() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = false;
}
function $005d1fb7704e278c$export$1f8ffc6fd33b1d16() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = true;
}
function $005d1fb7704e278c$export$c39176b1babaa8b8() {
    const last = $005d1fb7704e278c$var$trackStack.pop();
    $005d1fb7704e278c$var$shouldTrack = last === void 0 ? true : last;
}
function $005d1fb7704e278c$export$92b6a62b33d94031(fn, failSilently = false) {
    if ($005d1fb7704e278c$var$activeSub instanceof $005d1fb7704e278c$export$28352bb4dd362521) $005d1fb7704e278c$var$activeSub.cleanup = fn;
}
function $005d1fb7704e278c$var$cleanupEffect(e) {
    const { cleanup: cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = $005d1fb7704e278c$var$activeSub;
        $005d1fb7704e278c$var$activeSub = void 0;
        try {
            cleanup();
        } finally{
            $005d1fb7704e278c$var$activeSub = prevSub;
        }
    }
}
let $005d1fb7704e278c$var$globalVersion = 0;
class $005d1fb7704e278c$var$Link {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
}
class $005d1fb7704e278c$var$Dep {
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        /**
     * Link between this dep and the current active effect
     */ this.activeLink = void 0;
        /**
     * Doubly linked list representing the subscribing effects (tail)
     */ this.subs = void 0;
        /**
     * For object property deps cleanup
     */ this.map = void 0;
        this.key = void 0;
        /**
     * Subscriber counter
     */ this.sc = 0;
    }
    track(debugInfo) {
        if (!$005d1fb7704e278c$var$activeSub || !$005d1fb7704e278c$var$shouldTrack || $005d1fb7704e278c$var$activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== $005d1fb7704e278c$var$activeSub) {
            link = this.activeLink = new $005d1fb7704e278c$var$Link($005d1fb7704e278c$var$activeSub, this);
            if (!$005d1fb7704e278c$var$activeSub.deps) $005d1fb7704e278c$var$activeSub.deps = $005d1fb7704e278c$var$activeSub.depsTail = link;
            else {
                link.prevDep = $005d1fb7704e278c$var$activeSub.depsTail;
                $005d1fb7704e278c$var$activeSub.depsTail.nextDep = link;
                $005d1fb7704e278c$var$activeSub.depsTail = link;
            }
            $005d1fb7704e278c$var$addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = $005d1fb7704e278c$var$activeSub.depsTail;
                link.nextDep = void 0;
                $005d1fb7704e278c$var$activeSub.depsTail.nextDep = link;
                $005d1fb7704e278c$var$activeSub.depsTail = link;
                if ($005d1fb7704e278c$var$activeSub.deps === link) $005d1fb7704e278c$var$activeSub.deps = next;
            }
        }
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        $005d1fb7704e278c$var$globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        $005d1fb7704e278c$var$startBatch();
        try {
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            $005d1fb7704e278c$var$endBatch();
        }
    }
}
function $005d1fb7704e278c$var$addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)$005d1fb7704e278c$var$addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        link.dep.subs = link;
    }
}
const $005d1fb7704e278c$var$targetMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$export$3c41b1a4e06acc14 = Symbol("");
const $005d1fb7704e278c$export$49093fa1cddcb78d = Symbol("");
const $005d1fb7704e278c$export$4f926f0baab682cd = Symbol("");
function $005d1fb7704e278c$export$6b2a7d5132615086(target, type, key) {
    if ($005d1fb7704e278c$var$shouldTrack && $005d1fb7704e278c$var$activeSub) {
        let depsMap = $005d1fb7704e278c$var$targetMap.get(target);
        if (!depsMap) $005d1fb7704e278c$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new $005d1fb7704e278c$var$Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track();
    }
}
function $005d1fb7704e278c$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $005d1fb7704e278c$var$targetMap.get(target);
    if (!depsMap) {
        $005d1fb7704e278c$var$globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger();
    };
    $005d1fb7704e278c$var$startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = (0, $8POXm.isArray)(target);
        const isArrayIndex = targetIsArray && (0, $8POXm.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === $005d1fb7704e278c$export$4f926f0baab682cd || !(0, $8POXm.isSymbol)(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get($005d1fb7704e278c$export$4f926f0baab682cd));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                        if ((0, $8POXm.isMap)(target)) run(depsMap.get($005d1fb7704e278c$export$49093fa1cddcb78d));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                        if ((0, $8POXm.isMap)(target)) run(depsMap.get($005d1fb7704e278c$export$49093fa1cddcb78d));
                    }
                    break;
                case "set":
                    if ((0, $8POXm.isMap)(target)) run(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                    break;
            }
        }
    }
    $005d1fb7704e278c$var$endBatch();
}
function $005d1fb7704e278c$var$getDepFromReactive(object, key) {
    const depMap = $005d1fb7704e278c$var$targetMap.get(object);
    return depMap && depMap.get(key);
}
function $005d1fb7704e278c$export$1544eab4943788e4(array) {
    const raw = $005d1fb7704e278c$export$ab18938b9fc5f28e(array);
    if (raw === array) return raw;
    $005d1fb7704e278c$export$6b2a7d5132615086(raw, "iterate", $005d1fb7704e278c$export$4f926f0baab682cd);
    return $005d1fb7704e278c$export$7f3fe6025abfa26e(array) ? raw : raw.map($005d1fb7704e278c$export$45c769cf449a508c);
}
function $005d1fb7704e278c$export$5eb48af14254449e(arr) {
    $005d1fb7704e278c$export$6b2a7d5132615086(arr = $005d1fb7704e278c$export$ab18938b9fc5f28e(arr), "iterate", $005d1fb7704e278c$export$4f926f0baab682cd);
    return arr;
}
const $005d1fb7704e278c$var$arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return $005d1fb7704e278c$var$iterator(this, Symbol.iterator, $005d1fb7704e278c$export$45c769cf449a508c);
    },
    concat (...args) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).concat(...args.map((x)=>(0, $8POXm.isArray)(x) ? $005d1fb7704e278c$export$1544eab4943788e4(x) : x));
    },
    entries () {
        return $005d1fb7704e278c$var$iterator(this, "entries", (value)=>{
            value[1] = $005d1fb7704e278c$export$45c769cf449a508c(value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "filter", fn, thisArg, (v)=>v.map($005d1fb7704e278c$export$45c769cf449a508c), arguments);
    },
    find (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "find", fn, thisArg, $005d1fb7704e278c$export$45c769cf449a508c, arguments);
    },
    findIndex (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "findLast", fn, thisArg, $005d1fb7704e278c$export$45c769cf449a508c, arguments);
    },
    findLastIndex (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return $005d1fb7704e278c$var$searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return $005d1fb7704e278c$var$searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimisation required
    lastIndexOf (...args) {
        return $005d1fb7704e278c$var$searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return $005d1fb7704e278c$var$noTracking(this, "pop");
    },
    push (...args) {
        return $005d1fb7704e278c$var$noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return $005d1fb7704e278c$var$reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return $005d1fb7704e278c$var$reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return $005d1fb7704e278c$var$noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return $005d1fb7704e278c$var$noTracking(this, "splice", args);
    },
    toReversed () {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).toReversed();
    },
    toSorted (comparer) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).toSpliced(...args);
    },
    unshift (...args) {
        return $005d1fb7704e278c$var$noTracking(this, "unshift", args);
    },
    values () {
        return $005d1fb7704e278c$var$iterator(this, "values", $005d1fb7704e278c$export$45c769cf449a508c);
    }
};
function $005d1fb7704e278c$var$iterator(self, method, wrapValue) {
    const arr = $005d1fb7704e278c$export$5eb48af14254449e(self);
    const iter = arr[method]();
    if (arr !== self && !$005d1fb7704e278c$export$7f3fe6025abfa26e(self)) {
        iter._next = iter.next;
        iter.next = ()=>{
            const result = iter._next();
            if (result.value) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
const $005d1fb7704e278c$var$arrayProto = Array.prototype;
function $005d1fb7704e278c$var$apply(self, method, fn, thisArg, wrappedRetFn, args) {
    const arr = $005d1fb7704e278c$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$005d1fb7704e278c$export$7f3fe6025abfa26e(self);
    const methodFn = arr[method];
    if (methodFn !== $005d1fb7704e278c$var$arrayProto[method]) {
        const result2 = methodFn.apply(self, args);
        return needsWrap ? $005d1fb7704e278c$export$45c769cf449a508c(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, $005d1fb7704e278c$export$45c769cf449a508c(item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function $005d1fb7704e278c$var$reduce(self, method, fn, args) {
    const arr = $005d1fb7704e278c$export$5eb48af14254449e(self);
    let wrappedFn = fn;
    if (arr !== self) {
        if (!$005d1fb7704e278c$export$7f3fe6025abfa26e(self)) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, $005d1fb7704e278c$export$45c769cf449a508c(item), index, self);
        };
        else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    return arr[method](wrappedFn, ...args);
}
function $005d1fb7704e278c$var$searchProxy(self, method, args) {
    const arr = $005d1fb7704e278c$export$ab18938b9fc5f28e(self);
    $005d1fb7704e278c$export$6b2a7d5132615086(arr, "iterate", $005d1fb7704e278c$export$4f926f0baab682cd);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && $005d1fb7704e278c$export$5f3ca29d057519b3(args[0])) {
        args[0] = $005d1fb7704e278c$export$ab18938b9fc5f28e(args[0]);
        return arr[method](...args);
    }
    return res;
}
function $005d1fb7704e278c$var$noTracking(self, method, args = []) {
    $005d1fb7704e278c$export$938a971395fef855();
    $005d1fb7704e278c$var$startBatch();
    const res = $005d1fb7704e278c$export$ab18938b9fc5f28e(self)[method].apply(self, args);
    $005d1fb7704e278c$var$endBatch();
    $005d1fb7704e278c$export$c39176b1babaa8b8();
    return res;
}
const $005d1fb7704e278c$var$isNonTrackableKeys = /* @__PURE__ */ (0, $8POXm.makeMap)(`__proto__,__v_isRef,__isVue`);
const $005d1fb7704e278c$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $8POXm.isSymbol)));
function $005d1fb7704e278c$var$hasOwnProperty(key) {
    if (!(0, $8POXm.isSymbol)(key)) key = String(key);
    const obj = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    $005d1fb7704e278c$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        if (key === "__v_skip") return target["__v_skip"];
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $005d1fb7704e278c$var$shallowReadonlyMap : $005d1fb7704e278c$var$readonlyMap : isShallow2 ? $005d1fb7704e278c$var$shallowReactiveMap : $005d1fb7704e278c$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $8POXm.isArray)(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = $005d1fb7704e278c$var$arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return $005d1fb7704e278c$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        $005d1fb7704e278c$export$4f9f5282de18fc69(target) ? target : receiver);
        if ((0, $8POXm.isSymbol)(key) ? $005d1fb7704e278c$var$builtInSymbols.has(key) : $005d1fb7704e278c$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $005d1fb7704e278c$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(res)) return targetIsArray && (0, $8POXm.isIntegerKey)(key) ? res : res.value;
        if ((0, $8POXm.isObject)(res)) return isReadonly2 ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(res) : $005d1fb7704e278c$export$90a44edba14e47be(res);
        return res;
    }
}
class $005d1fb7704e278c$var$MutableReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        if (!this._isShallow) {
            const isOldValueReadonly = $005d1fb7704e278c$export$92d09b48637741e7(oldValue);
            if (!$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) {
                oldValue = $005d1fb7704e278c$export$ab18938b9fc5f28e(oldValue);
                value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $8POXm.isArray)(target) && $005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return false;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = (0, $8POXm.isArray)(target) && (0, $8POXm.isIntegerKey)(key) ? Number(key) < target.length : (0, $8POXm.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, $005d1fb7704e278c$export$4f9f5282de18fc69(target) ? target : receiver);
        if (target === $005d1fb7704e278c$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $8POXm.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $8POXm.isSymbol)(key) || !$005d1fb7704e278c$var$builtInSymbols.has(key)) $005d1fb7704e278c$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $005d1fb7704e278c$export$6b2a7d5132615086(target, "iterate", (0, $8POXm.isArray)(target) ? "length" : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $005d1fb7704e278c$var$ReadonlyReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $005d1fb7704e278c$var$mutableHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler();
const $005d1fb7704e278c$var$readonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler();
const $005d1fb7704e278c$var$shallowReactiveHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler(true);
const $005d1fb7704e278c$var$shallowReadonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler(true);
const $005d1fb7704e278c$var$toShallow = (value)=>value;
const $005d1fb7704e278c$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $005d1fb7704e278c$var$createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $8POXm.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? $005d1fb7704e278c$var$toShallow : isReadonly2 ? $005d1fb7704e278c$export$4a78e7a2a4fb689f : $005d1fb7704e278c$export$45c769cf449a508c;
        !isReadonly2 && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $005d1fb7704e278c$export$49093fa1cddcb78d : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $005d1fb7704e278c$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $005d1fb7704e278c$var$createInstrumentations(readonly, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
            const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $8POXm.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", key);
                $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", rawKey);
            }
            const { has: has } = $005d1fb7704e278c$var$getProto(rawTarget);
            const wrap = shallow ? $005d1fb7704e278c$var$toShallow : readonly ? $005d1fb7704e278c$export$4a78e7a2a4fb689f : $005d1fb7704e278c$export$45c769cf449a508c;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly && $005d1fb7704e278c$export$6b2a7d5132615086($005d1fb7704e278c$export$ab18938b9fc5f28e(target), "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
            return Reflect.get(target, "size", target);
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
            const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $8POXm.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", key);
                $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
            const wrap = shallow ? $005d1fb7704e278c$var$toShallow : readonly ? $005d1fb7704e278c$export$4a78e7a2a4fb689f : $005d1fb7704e278c$export$45c769cf449a508c;
            !readonly && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, $8POXm.extend)(instrumentations, readonly ? {
        add: $005d1fb7704e278c$var$createReadonlyMethod("add"),
        set: $005d1fb7704e278c$var$createReadonlyMethod("set"),
        delete: $005d1fb7704e278c$var$createReadonlyMethod("delete"),
        clear: $005d1fb7704e278c$var$createReadonlyMethod("clear")
    } : {
        add (value) {
            if (!shallow && !$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const proto = $005d1fb7704e278c$var$getProto(target);
            const hadKey = proto.has.call(target, value);
            if (!hadKey) {
                target.add(value);
                $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", value, value);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $005d1fb7704e278c$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $005d1fb7704e278c$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get ? get.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const hadItems = target.size !== 0;
            const oldTarget = void 0;
            const result = target.clear();
            if (hadItems) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = $005d1fb7704e278c$var$createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function $005d1fb7704e278c$var$createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = $005d1fb7704e278c$var$createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $8POXm.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $005d1fb7704e278c$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, false)
};
const $005d1fb7704e278c$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, true)
};
const $005d1fb7704e278c$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, false)
};
const $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, true)
};
function $005d1fb7704e278c$var$checkIdentityKeys(target, has, key) {
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, $8POXm.toRawType)(target);
        $005d1fb7704e278c$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $005d1fb7704e278c$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $005d1fb7704e278c$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $005d1fb7704e278c$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $005d1fb7704e278c$var$targetTypeMap((0, $8POXm.toRawType)(value));
}
function $005d1fb7704e278c$export$90a44edba14e47be(target) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(target)) return target;
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$mutableHandlers, $005d1fb7704e278c$var$mutableCollectionHandlers, $005d1fb7704e278c$var$reactiveMap);
}
function $005d1fb7704e278c$export$8d81cefd22d22260(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$shallowReactiveHandlers, $005d1fb7704e278c$var$shallowCollectionHandlers, $005d1fb7704e278c$var$shallowReactiveMap);
}
function $005d1fb7704e278c$export$6ec456bd5b7b3c51(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$readonlyHandlers, $005d1fb7704e278c$var$readonlyCollectionHandlers, $005d1fb7704e278c$var$readonlyMap);
}
function $005d1fb7704e278c$export$7c4b5f2b50f09f6b(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$shallowReadonlyHandlers, $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers, $005d1fb7704e278c$var$shallowReadonlyMap);
}
function $005d1fb7704e278c$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $8POXm.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $005d1fb7704e278c$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $005d1fb7704e278c$export$352205f445242f02(value) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(value)) return $005d1fb7704e278c$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $005d1fb7704e278c$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $005d1fb7704e278c$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
function $005d1fb7704e278c$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
function $005d1fb7704e278c$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? $005d1fb7704e278c$export$ab18938b9fc5f28e(raw) : observed;
}
function $005d1fb7704e278c$export$995ab8b13ad7a9d0(value) {
    if (!(0, $8POXm.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, $8POXm.def)(value, "__v_skip", true);
    return value;
}
const $005d1fb7704e278c$export$45c769cf449a508c = (value)=>(0, $8POXm.isObject)(value) ? $005d1fb7704e278c$export$90a44edba14e47be(value) : value;
const $005d1fb7704e278c$export$4a78e7a2a4fb689f = (value)=>(0, $8POXm.isObject)(value) ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(value) : value;
function $005d1fb7704e278c$export$4f9f5282de18fc69(r) {
    return r ? r["__v_isRef"] === true : false;
}
function $005d1fb7704e278c$export$eff4d24c3ff7876e(value) {
    return $005d1fb7704e278c$var$createRef(value, false);
}
function $005d1fb7704e278c$export$9b7bc5fe3b17c8b3(value) {
    return $005d1fb7704e278c$var$createRef(value, true);
}
function $005d1fb7704e278c$var$createRef(rawValue, shallow) {
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $005d1fb7704e278c$var$RefImpl(rawValue, shallow);
}
class $005d1fb7704e278c$var$RefImpl {
    constructor(value, isShallow2){
        this.dep = new $005d1fb7704e278c$var$Dep();
        this["__v_isRef"] = true;
        this["__v_isShallow"] = false;
        this._rawValue = isShallow2 ? value : $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
        this._value = isShallow2 ? value : $005d1fb7704e278c$export$45c769cf449a508c(value);
        this["__v_isShallow"] = isShallow2;
    }
    get value() {
        this.dep.track();
        return this._value;
    }
    set value(newValue) {
        const oldValue = this._rawValue;
        const useDirectValue = this["__v_isShallow"] || $005d1fb7704e278c$export$7f3fe6025abfa26e(newValue) || $005d1fb7704e278c$export$92d09b48637741e7(newValue);
        newValue = useDirectValue ? newValue : $005d1fb7704e278c$export$ab18938b9fc5f28e(newValue);
        if ((0, $8POXm.hasChanged)(newValue, oldValue)) {
            this._rawValue = newValue;
            this._value = useDirectValue ? newValue : $005d1fb7704e278c$export$45c769cf449a508c(newValue);
            this.dep.trigger();
        }
    }
}
function $005d1fb7704e278c$export$f402f86588575ccc(ref2) {
    if (ref2.dep) ref2.dep.trigger();
}
function $005d1fb7704e278c$export$a239a76781616204(ref2) {
    return $005d1fb7704e278c$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $005d1fb7704e278c$export$30bdcc2218aa9458(source) {
    return (0, $8POXm.isFunction)(source) ? source() : $005d1fb7704e278c$export$a239a76781616204(source);
}
const $005d1fb7704e278c$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>key === "__v_raw" ? target : $005d1fb7704e278c$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $005d1fb7704e278c$export$f353fd1b97db3fa0(objectWithRefs) {
    return $005d1fb7704e278c$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $005d1fb7704e278c$var$shallowUnwrapHandlers);
}
class $005d1fb7704e278c$var$CustomRefImpl {
    constructor(factory){
        this["__v_isRef"] = true;
        this._value = void 0;
        const dep = this.dep = new $005d1fb7704e278c$var$Dep();
        const { get: get, set: set } = factory(dep.track.bind(dep), dep.trigger.bind(dep));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._value = this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $005d1fb7704e278c$export$a20c2dd6199824cb(factory) {
    return new $005d1fb7704e278c$var$CustomRefImpl(factory);
}
function $005d1fb7704e278c$export$2e9533675e5e70e0(object) {
    const ret = (0, $8POXm.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $005d1fb7704e278c$var$propertyToRef(object, key);
    return ret;
}
class $005d1fb7704e278c$var$ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
    }
    get value() {
        const val = this._object[this._key];
        return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return $005d1fb7704e278c$var$getDepFromReactive($005d1fb7704e278c$export$ab18938b9fc5f28e(this._object), this._key);
    }
}
class $005d1fb7704e278c$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    get value() {
        return this._value = this._getter();
    }
}
function $005d1fb7704e278c$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $8POXm.isFunction)(source)) return new $005d1fb7704e278c$var$GetterRefImpl(source);
    else if ((0, $8POXm.isObject)(source) && arguments.length > 1) return $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue);
    else return $005d1fb7704e278c$export$eff4d24c3ff7876e(source);
}
function $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return $005d1fb7704e278c$export$4f9f5282de18fc69(val) ? val : new $005d1fb7704e278c$var$ObjectRefImpl(source, key, defaultValue);
}
class $005d1fb7704e278c$var$ComputedRefImpl {
    constructor(fn, setter, isSSR){
        this.fn = fn;
        this.setter = setter;
        /**
     * @internal
     */ this._value = void 0;
        /**
     * @internal
     */ this.dep = new $005d1fb7704e278c$var$Dep(this);
        /**
     * @internal
     */ this.__v_isRef = true;
        // TODO isolatedDeclarations "__v_isReadonly"
        // A computed is also a subscriber that tracks other deps
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 16;
        /**
     * @internal
     */ this.globalVersion = $005d1fb7704e278c$var$globalVersion - 1;
        /**
     * @internal
     */ this.next = void 0;
        // for backwards compat
        this.effect = this;
        this["__v_isReadonly"] = !setter;
        this.isSSR = isSSR;
    }
    /**
   * @internal
   */ notify() {
        this.flags |= 16;
        if (!(this.flags & 8) && // avoid infinite self recursion
        $005d1fb7704e278c$var$activeSub !== this) {
            $005d1fb7704e278c$var$batch(this, true);
            return true;
        }
    }
    get value() {
        const link = this.dep.track();
        $005d1fb7704e278c$var$refreshComputed(this);
        if (link) link.version = this.dep.version;
        return this._value;
    }
    set value(newValue) {
        if (this.setter) this.setter(newValue);
    }
}
function $005d1fb7704e278c$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if ((0, $8POXm.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $005d1fb7704e278c$var$ComputedRefImpl(getter, setter, isSSR);
    return cRef;
}
const $005d1fb7704e278c$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $005d1fb7704e278c$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $005d1fb7704e278c$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw",
    "IS_REF": "__v_isRef"
};
const $005d1fb7704e278c$export$c54ef203cb79e75f = {
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP"
};
const $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE = {};
const $005d1fb7704e278c$var$cleanupMap = /* @__PURE__ */ new WeakMap();
let $005d1fb7704e278c$var$activeWatcher = void 0;
function $005d1fb7704e278c$export$2532f7acfca7c82d() {
    return $005d1fb7704e278c$var$activeWatcher;
}
function $005d1fb7704e278c$export$8ddeeb083684a9d0(cleanupFn, failSilently = false, owner = $005d1fb7704e278c$var$activeWatcher) {
    if (owner) {
        let cleanups = $005d1fb7704e278c$var$cleanupMap.get(owner);
        if (!cleanups) $005d1fb7704e278c$var$cleanupMap.set(owner, cleanups = []);
        cleanups.push(cleanupFn);
    }
}
function $005d1fb7704e278c$export$3db5d71bdb2d5499(source, cb, options = (0, $8POXm.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, once: once, scheduler: scheduler, augmentJob: augmentJob, call: call } = options;
    const warnInvalidSource = (s)=>{
        (options.onWarn || $005d1fb7704e278c$var$warn)(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const reactiveGetter = (source2)=>{
        if (deep) return source2;
        if ($005d1fb7704e278c$export$7f3fe6025abfa26e(source2) || deep === false || deep === 0) return $005d1fb7704e278c$export$df3f009e3d155b20(source2, 1);
        return $005d1fb7704e278c$export$df3f009e3d155b20(source2);
    };
    let effect;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(source)) {
        getter = ()=>source.value;
        forceTrigger = $005d1fb7704e278c$export$7f3fe6025abfa26e(source);
    } else if ($005d1fb7704e278c$export$352205f445242f02(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $8POXm.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>$005d1fb7704e278c$export$352205f445242f02(s) || $005d1fb7704e278c$export$7f3fe6025abfa26e(s));
        getter = ()=>source.map((s)=>{
                if ($005d1fb7704e278c$export$4f9f5282de18fc69(s)) return s.value;
                else if ($005d1fb7704e278c$export$352205f445242f02(s)) return reactiveGetter(s);
                else if ((0, $8POXm.isFunction)(s)) return call ? call(s, 2) : s();
            });
    } else if ((0, $8POXm.isFunction)(source)) {
        if (cb) getter = call ? ()=>call(source, 2) : source;
        else getter = ()=>{
            if (cleanup) {
                $005d1fb7704e278c$export$938a971395fef855();
                try {
                    cleanup();
                } finally{
                    $005d1fb7704e278c$export$c39176b1babaa8b8();
                }
            }
            const currentEffect = $005d1fb7704e278c$var$activeWatcher;
            $005d1fb7704e278c$var$activeWatcher = effect;
            try {
                return call ? call(source, 3, [
                    boundCleanup
                ]) : source(boundCleanup);
            } finally{
                $005d1fb7704e278c$var$activeWatcher = currentEffect;
            }
        };
    } else getter = (0, $8POXm.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        const depth = deep === true ? Infinity : deep;
        getter = ()=>$005d1fb7704e278c$export$df3f009e3d155b20(baseGetter(), depth);
    }
    const scope = $005d1fb7704e278c$export$c7be4b0125a10cba();
    const watchHandle = ()=>{
        effect.stop();
        if (scope && scope.active) (0, $8POXm.remove)(scope.effects, effect);
    };
    if (once && cb) {
        const _cb = cb;
        cb = (...args)=>{
            _cb(...args);
            watchHandle();
        };
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($005d1fb7704e278c$var$INITIAL_WATCHER_VALUE) : $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun)=>{
        if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v, i)=>(0, $8POXm.hasChanged)(v, oldValue[i])) : (0, $8POXm.hasChanged)(newValue, oldValue))) {
                if (cleanup) cleanup();
                const currentWatcher = $005d1fb7704e278c$var$activeWatcher;
                $005d1fb7704e278c$var$activeWatcher = effect;
                try {
                    const args = [
                        newValue,
                        // pass undefined as the old value when it's changed for the first time
                        oldValue === $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                        boundCleanup
                    ];
                    call ? call(cb, 3, args) : // @ts-expect-error
                    cb(...args);
                    oldValue = newValue;
                } finally{
                    $005d1fb7704e278c$var$activeWatcher = currentWatcher;
                }
            }
        } else effect.run();
    };
    if (augmentJob) augmentJob(job);
    effect = new $005d1fb7704e278c$export$28352bb4dd362521(getter);
    effect.scheduler = scheduler ? ()=>scheduler(job, false) : job;
    boundCleanup = (fn)=>$005d1fb7704e278c$export$8ddeeb083684a9d0(fn, false, effect);
    cleanup = effect.onStop = ()=>{
        const cleanups = $005d1fb7704e278c$var$cleanupMap.get(effect);
        if (cleanups) {
            if (call) call(cleanups, 4);
            else for (const cleanup2 of cleanups)cleanup2();
            $005d1fb7704e278c$var$cleanupMap.delete(effect);
        }
    };
    if (cb) {
        if (immediate) job(true);
        else oldValue = effect.run();
    } else if (scheduler) scheduler(job.bind(null, true), true);
    else effect.run();
    watchHandle.pause = effect.pause.bind(effect);
    watchHandle.resume = effect.resume.bind(effect);
    watchHandle.stop = watchHandle;
    return watchHandle;
}
function $005d1fb7704e278c$export$df3f009e3d155b20(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $8POXm.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    depth--;
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(value)) $005d1fb7704e278c$export$df3f009e3d155b20(value.value, depth, seen);
    else if ((0, $8POXm.isArray)(value)) for(let i = 0; i < value.length; i++)$005d1fb7704e278c$export$df3f009e3d155b20(value[i], depth, seen);
    else if ((0, $8POXm.isSet)(value) || (0, $8POXm.isMap)(value)) value.forEach((v)=>{
        $005d1fb7704e278c$export$df3f009e3d155b20(v, depth, seen);
    });
    else if ((0, $8POXm.isPlainObject)(value)) {
        for(const key in value)$005d1fb7704e278c$export$df3f009e3d155b20(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) $005d1fb7704e278c$export$df3f009e3d155b20(value[key], depth, seen);
    }
    return value;
}

});
parcelRegister("8POXm", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $66ea9d0aaa418c4d$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $66ea9d0aaa418c4d$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $66ea9d0aaa418c4d$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $66ea9d0aaa418c4d$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $66ea9d0aaa418c4d$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $66ea9d0aaa418c4d$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $66ea9d0aaa418c4d$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $66ea9d0aaa418c4d$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $66ea9d0aaa418c4d$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $66ea9d0aaa418c4d$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $66ea9d0aaa418c4d$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $66ea9d0aaa418c4d$export$6750766a7c7ec627);
$parcel$export(module.exports, "isRegExp", () => $66ea9d0aaa418c4d$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $66ea9d0aaa418c4d$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $66ea9d0aaa418c4d$export$844ec244b1367d54);
$parcel$export(module.exports, "isSymbol", () => $66ea9d0aaa418c4d$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $66ea9d0aaa418c4d$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isPlainObject", () => $66ea9d0aaa418c4d$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isIntegerKey", () => $66ea9d0aaa418c4d$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "isReservedProp", () => $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $66ea9d0aaa418c4d$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $66ea9d0aaa418c4d$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $66ea9d0aaa418c4d$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $66ea9d0aaa418c4d$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $66ea9d0aaa418c4d$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $66ea9d0aaa418c4d$export$8afb76124cf08683);
$parcel$export(module.exports, "looseToNumber", () => $66ea9d0aaa418c4d$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "isGloballyAllowed", () => $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf);
$parcel$export(module.exports, "normalizeStyle", () => $66ea9d0aaa418c4d$export$8756898546458274);
$parcel$export(module.exports, "stringifyStyle", () => $66ea9d0aaa418c4d$export$9466a5a0ee6f1479);
$parcel$export(module.exports, "normalizeClass", () => $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "isHTMLTag", () => $66ea9d0aaa418c4d$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $66ea9d0aaa418c4d$export$6328ce7565ea1049);
$parcel$export(module.exports, "isMathMLTag", () => $66ea9d0aaa418c4d$export$4a46ca4c5be17b20);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $66ea9d0aaa418c4d$export$d186f5eb2e810715);
$parcel$export(module.exports, "isBooleanAttr", () => $66ea9d0aaa418c4d$export$f763ba3b84e9cd8c);
$parcel$export(module.exports, "includeBooleanAttr", () => $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "isKnownHtmlAttr", () => $66ea9d0aaa418c4d$export$f7e7a1cc7da8d5e9);
$parcel$export(module.exports, "isKnownSvgAttr", () => $66ea9d0aaa418c4d$export$80da416f43933831);
$parcel$export(module.exports, "isRenderableAttrValue", () => $66ea9d0aaa418c4d$export$921dd2acf0d386a3);
$parcel$export(module.exports, "getEscapedCssVarName", () => $66ea9d0aaa418c4d$export$ad9a320bfb7ba440);
$parcel$export(module.exports, "looseEqual", () => $66ea9d0aaa418c4d$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $66ea9d0aaa418c4d$export$42912a80cedb8bd4);
$parcel$export(module.exports, "toDisplayString", () => $66ea9d0aaa418c4d$export$b5b1545233b45293);
/**
* @vue/shared v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $66ea9d0aaa418c4d$export$b41394a5437791c8(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const $66ea9d0aaa418c4d$export$cf583d23ab39677c = {};
const $66ea9d0aaa418c4d$export$6bd8558f433f1cc1 = [];
const $66ea9d0aaa418c4d$export$5702a91a6f42969f = ()=>{};
const $66ea9d0aaa418c4d$export$c01351c0af048e39 = ()=>false;
const $66ea9d0aaa418c4d$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $66ea9d0aaa418c4d$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $66ea9d0aaa418c4d$export$8b58be045bf06082 = Object.assign;
const $66ea9d0aaa418c4d$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $66ea9d0aaa418c4d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3 = (val, key)=>$66ea9d0aaa418c4d$var$hasOwnProperty.call(val, key);
const $66ea9d0aaa418c4d$export$43bee75e5e14138e = Array.isArray;
const $66ea9d0aaa418c4d$export$5c90113a285f2241 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Map]";
const $66ea9d0aaa418c4d$export$6750766a7c7ec627 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Set]";
const $66ea9d0aaa418c4d$export$871608497c498473 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Date]";
const $66ea9d0aaa418c4d$export$49841c62b9eff15 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object RegExp]";
const $66ea9d0aaa418c4d$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $66ea9d0aaa418c4d$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $66ea9d0aaa418c4d$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $66ea9d0aaa418c4d$export$4369c812aac99591 = (val)=>{
    return ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) || $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val)) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.then) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.catch);
};
const $66ea9d0aaa418c4d$export$830c053460e5ddf6 = Object.prototype.toString;
const $66ea9d0aaa418c4d$export$1dccc787cc36538b = (value)=>$66ea9d0aaa418c4d$export$830c053460e5ddf6.call(value);
const $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5 = (value)=>{
    return $66ea9d0aaa418c4d$export$1dccc787cc36538b(value).slice(8, -1);
};
const $66ea9d0aaa418c4d$export$53b83ca8eaab0383 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Object]";
const $66ea9d0aaa418c4d$export$e2a2b93446ec9fe = (key)=>$66ea9d0aaa418c4d$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $66ea9d0aaa418c4d$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $66ea9d0aaa418c4d$var$camelizeRE = /-(\w)/g;
const $66ea9d0aaa418c4d$export$161d051f5dd25de7 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.replace($66ea9d0aaa418c4d$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $66ea9d0aaa418c4d$var$hyphenateRE = /\B([A-Z])/g;
const $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>str.replace($66ea9d0aaa418c4d$var$hyphenateRE, "-$1").toLowerCase());
const $66ea9d0aaa418c4d$export$9a00dee1beb8f576 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $66ea9d0aaa418c4d$export$8c022799eeaaefcd = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    const s = str ? `on${$66ea9d0aaa418c4d$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $66ea9d0aaa418c4d$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $66ea9d0aaa418c4d$export$39951422d618a9d3 = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const $66ea9d0aaa418c4d$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $66ea9d0aaa418c4d$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $66ea9d0aaa418c4d$var$_globalThis;
const $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14 = ()=>{
    return $66ea9d0aaa418c4d$var$_globalThis || ($66ea9d0aaa418c4d$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $66ea9d0aaa418c4d$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $66ea9d0aaa418c4d$export$53d5e12f9a1d3cde(name) {
    return $66ea9d0aaa418c4d$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function $66ea9d0aaa418c4d$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
const $66ea9d0aaa418c4d$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $66ea9d0aaa418c4d$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $66ea9d0aaa418c4d$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $66ea9d0aaa418c4d$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $66ea9d0aaa418c4d$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $66ea9d0aaa418c4d$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$GLOBALS_ALLOWED);
const $66ea9d0aaa418c4d$export$d6571a1911e4f27e = $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf;
const $66ea9d0aaa418c4d$var$range = 2;
function $66ea9d0aaa418c4d$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $66ea9d0aaa418c4d$var$range; j <= i + $66ea9d0aaa418c4d$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $66ea9d0aaa418c4d$export$8756898546458274(value) {
    if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $66ea9d0aaa418c4d$export$844ec244b1367d54(item) ? $66ea9d0aaa418c4d$export$76a205ce979d066a(item) : $66ea9d0aaa418c4d$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) return value;
}
const $66ea9d0aaa418c4d$var$listDelimiterRE = /;(?![^(]*\))/g;
const $66ea9d0aaa418c4d$var$propertyDelimiterRE = /:([^]+)/;
const $66ea9d0aaa418c4d$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $66ea9d0aaa418c4d$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($66ea9d0aaa418c4d$var$styleCommentRE, "").split($66ea9d0aaa418c4d$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($66ea9d0aaa418c4d$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $66ea9d0aaa418c4d$export$9466a5a0ee6f1479(styles) {
    if (!styles) return "";
    if ($66ea9d0aaa418c4d$export$844ec244b1367d54(styles)) return styles;
    let ret = "";
    for(const key in styles){
        const value = styles[key];
        if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value)) res = value;
    else if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $66ea9d0aaa418c4d$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$66ea9d0aaa418c4d$export$844ec244b1367d54(klass)) props.class = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $66ea9d0aaa418c4d$export$8756898546458274(style);
    return props;
}
const $66ea9d0aaa418c4d$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $66ea9d0aaa418c4d$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $66ea9d0aaa418c4d$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $66ea9d0aaa418c4d$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $66ea9d0aaa418c4d$export$1ccf854a0984f890 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$HTML_TAGS);
const $66ea9d0aaa418c4d$export$6328ce7565ea1049 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$SVG_TAGS);
const $66ea9d0aaa418c4d$export$4a46ca4c5be17b20 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$MATH_TAGS);
const $66ea9d0aaa418c4d$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$VOID_TAGS);
const $66ea9d0aaa418c4d$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $66ea9d0aaa418c4d$export$d186f5eb2e810715 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs);
const $66ea9d0aaa418c4d$export$f763ba3b84e9cd8c = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $66ea9d0aaa418c4d$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $66ea9d0aaa418c4d$var$attrValidationCache = {};
function $66ea9d0aaa418c4d$export$d55ef77660f30d12(name) {
    if ($66ea9d0aaa418c4d$var$attrValidationCache.hasOwnProperty(name)) return $66ea9d0aaa418c4d$var$attrValidationCache[name];
    const isUnsafe = $66ea9d0aaa418c4d$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $66ea9d0aaa418c4d$var$attrValidationCache[name] = !isUnsafe;
}
const $66ea9d0aaa418c4d$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $66ea9d0aaa418c4d$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $66ea9d0aaa418c4d$export$80da416f43933831 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $66ea9d0aaa418c4d$export$fc0748a8e0014066 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns`);
function $66ea9d0aaa418c4d$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $66ea9d0aaa418c4d$var$escapeRE = /["'&<>]/;
function $66ea9d0aaa418c4d$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $66ea9d0aaa418c4d$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $66ea9d0aaa418c4d$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $66ea9d0aaa418c4d$export$7b105034a53bde5f(src) {
    return src.replace($66ea9d0aaa418c4d$var$commentStripRE, "");
}
const $66ea9d0aaa418c4d$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $66ea9d0aaa418c4d$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($66ea9d0aaa418c4d$export$9320a7246b331080, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $66ea9d0aaa418c4d$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $66ea9d0aaa418c4d$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $66ea9d0aaa418c4d$export$871608497c498473(a);
    let bValidType = $66ea9d0aaa418c4d$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(a);
    bValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(a);
    bValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) : false;
    aValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(a);
    bValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$66ea9d0aaa418c4d$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $66ea9d0aaa418c4d$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$66ea9d0aaa418c4d$export$ae8015769846262c(item, val));
}
const $66ea9d0aaa418c4d$var$isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const $66ea9d0aaa418c4d$export$b5b1545233b45293 = (val)=>{
    return $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? val : val == null ? "" : $66ea9d0aaa418c4d$export$43bee75e5e14138e(val) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && (val.toString === $66ea9d0aaa418c4d$export$830c053460e5ddf6 || !$66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.toString)) ? $66ea9d0aaa418c4d$var$isRef(val) ? $66ea9d0aaa418c4d$export$b5b1545233b45293(val.value) : JSON.stringify(val, $66ea9d0aaa418c4d$var$replacer, 2) : String(val);
};
const $66ea9d0aaa418c4d$var$replacer = (_key, val)=>{
    if ($66ea9d0aaa418c4d$var$isRef(val)) return $66ea9d0aaa418c4d$var$replacer(_key, val.value);
    else if ($66ea9d0aaa418c4d$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$66ea9d0aaa418c4d$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($66ea9d0aaa418c4d$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$66ea9d0aaa418c4d$var$stringifySymbol(v))
    };
    else if ($66ea9d0aaa418c4d$export$a244864fd9645c7f(val)) return $66ea9d0aaa418c4d$var$stringifySymbol(val);
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && !$66ea9d0aaa418c4d$export$43bee75e5e14138e(val) && !$66ea9d0aaa418c4d$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $66ea9d0aaa418c4d$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $66ea9d0aaa418c4d$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};

});



parcelRegister("eeJ70", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", () => (parcelRequire("TusQn")).BaseTransition);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => (parcelRequire("TusQn")).BaseTransitionPropsValidators);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => (parcelRequire("TusQn")).callWithAsyncErrorHandling);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8POXm")).camelize);
$parcel$export(module.exports, "computed", () => (parcelRequire("TusQn")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("TusQn")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("TusQn")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("TusQn")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("TusQn")).createElementVNode);
$parcel$export(module.exports, "createHydrationRenderer", () => (parcelRequire("TusQn")).createHydrationRenderer);
$parcel$export(module.exports, "createRenderer", () => (parcelRequire("TusQn")).createRenderer);
$parcel$export(module.exports, "createStaticVNode", () => (parcelRequire("TusQn")).createStaticVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("TusQn")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("TusQn")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("TusQn")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("TusQn")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("TusQn")).getCurrentInstance);
$parcel$export(module.exports, "getTransitionRawChildren", () => (parcelRequire("TusQn")).getTransitionRawChildren);
$parcel$export(module.exports, "h", () => (parcelRequire("TusQn")).h);
$parcel$export(module.exports, "hasInjectionContext", () => (parcelRequire("TusQn")).hasInjectionContext);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("TusQn")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("TusQn")).inject);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("01W3b")).isReactive);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "isRuntimeOnly", () => (parcelRequire("TusQn")).isRuntimeOnly);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("01W3b")).markRaw);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("TusQn")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "onActivated", () => (parcelRequire("TusQn")).onActivated);
$parcel$export(module.exports, "onBeforeUpdate", () => (parcelRequire("TusQn")).onBeforeUpdate);
$parcel$export(module.exports, "onDeactivated", () => (parcelRequire("TusQn")).onDeactivated);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("TusQn")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("TusQn")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("TusQn")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("TusQn")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("TusQn")).provide);
$parcel$export(module.exports, "queuePostFlushCb", () => (parcelRequire("TusQn")).queuePostFlushCb);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("TusQn")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("TusQn")).renderSlot);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("TusQn")).resolveComponent);
$parcel$export(module.exports, "resolveDirective", () => (parcelRequire("TusQn")).resolveDirective);
$parcel$export(module.exports, "resolveTransitionHooks", () => (parcelRequire("TusQn")).resolveTransitionHooks);
$parcel$export(module.exports, "setTransitionHooks", () => (parcelRequire("TusQn")).setTransitionHooks);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("01W3b")).shallowReactive);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "Static", () => (parcelRequire("TusQn")).Static);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "useTransitionState", () => (parcelRequire("TusQn")).useTransitionState);
$parcel$export(module.exports, "warn", () => (parcelRequire("TusQn")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("TusQn")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("TusQn")).watchEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("TusQn")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("TusQn")).withDirectives);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("01W3b")).effectScope);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("01W3b")).getCurrentScope);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("01W3b")).onScopeDispose);
$parcel$export(module.exports, "toRef", () => (parcelRequire("01W3b")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("01W3b")).toRefs);
$parcel$export(module.exports, "unref", () => (parcelRequire("01W3b")).unref);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8POXm")).toDisplayString);

$parcel$export(module.exports, "Transition", () => $a5d55dc64ccb07cf$export$be58926105124dd4);
$parcel$export(module.exports, "vShow", () => $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1);
$parcel$export(module.exports, "useCssVars", () => $a5d55dc64ccb07cf$export$ef28b76f07940108);
$parcel$export(module.exports, "createApp", () => $a5d55dc64ccb07cf$export$4e373c34abfa8c68);
$parcel$export(module.exports, "vModelText", () => $a5d55dc64ccb07cf$export$f1f88689f5728478);
$parcel$export(module.exports, "withModifiers", () => $a5d55dc64ccb07cf$export$26bd3b8e29e6f273);
/**
* @vue/runtime-dom v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");
var $01W3b = parcelRequire("01W3b");parcelRequire("8POXm");

var $8POXm = parcelRequire("8POXm");
let $a5d55dc64ccb07cf$var$policy = void 0;
const $a5d55dc64ccb07cf$var$tt = typeof window !== "undefined" && window.trustedTypes;
if ($a5d55dc64ccb07cf$var$tt) try {
    $a5d55dc64ccb07cf$var$policy = /* @__PURE__ */ $a5d55dc64ccb07cf$var$tt.createPolicy("vue", {
        createHTML: (val)=>val
    });
} catch (e) {}
const $a5d55dc64ccb07cf$var$unsafeToTrustedHTML = $a5d55dc64ccb07cf$var$policy ? (val)=>$a5d55dc64ccb07cf$var$policy.createHTML(val) : (val)=>val;
const $a5d55dc64ccb07cf$var$svgNS = "http://www.w3.org/2000/svg";
const $a5d55dc64ccb07cf$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $a5d55dc64ccb07cf$var$doc = typeof document !== "undefined" ? document : null;
const $a5d55dc64ccb07cf$var$templateContainer = $a5d55dc64ccb07cf$var$doc && /* @__PURE__ */ $a5d55dc64ccb07cf$var$doc.createElement("template");
const $a5d55dc64ccb07cf$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$svgNS, tag) : namespace === "mathml" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$mathmlNS, tag) : is ? $a5d55dc64ccb07cf$var$doc.createElement(tag, {
            is: is
        }) : $a5d55dc64ccb07cf$var$doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$a5d55dc64ccb07cf$var$doc.createTextNode(text),
    createComment: (text)=>$a5d55dc64ccb07cf$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$a5d55dc64ccb07cf$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $a5d55dc64ccb07cf$var$templateContainer.innerHTML = $a5d55dc64ccb07cf$var$unsafeToTrustedHTML(namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content);
            const template = $a5d55dc64ccb07cf$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $a5d55dc64ccb07cf$var$TRANSITION = "transition";
const $a5d55dc64ccb07cf$var$ANIMATION = "animation";
const $a5d55dc64ccb07cf$var$vtcKey = Symbol("_vtc");
const $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $a5d55dc64ccb07cf$var$TransitionPropsValidators = /* @__PURE__ */ (0, $8POXm.extend)({}, (0, $TusQn.BaseTransitionPropsValidators), $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators);
const $a5d55dc64ccb07cf$var$decorate$1 = (t)=>{
    t.displayName = "Transition";
    t.props = $a5d55dc64ccb07cf$var$TransitionPropsValidators;
    return t;
};
const $a5d55dc64ccb07cf$export$be58926105124dd4 = /* @__PURE__ */ $a5d55dc64ccb07cf$var$decorate$1((props, { slots: slots })=>(0, $TusQn.h)((0, $TusQn.BaseTransition), $a5d55dc64ccb07cf$var$resolveTransitionProps(props), slots));
const $a5d55dc64ccb07cf$var$callHook = (hook, args = [])=>{
    if ((0, $8POXm.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $a5d55dc64ccb07cf$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $8POXm.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $a5d55dc64ccb07cf$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done, isCancelled)=>{
        el._enterCancelled = isCancelled;
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $a5d55dc64ccb07cf$var$callHook(hook, [
                el,
                resolve
            ]);
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(hook)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $8POXm.extend)(baseProps, {
        onBeforeEnter (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeEnter, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeAppear, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveFromClass);
            if (!el._enterCancelled) {
                $a5d55dc64ccb07cf$var$forceReflow();
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveActiveClass);
            } else {
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveActiveClass);
                $a5d55dc64ccb07cf$var$forceReflow();
            }
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(onLeave)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $a5d55dc64ccb07cf$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false, void 0, true);
            $a5d55dc64ccb07cf$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true, void 0, true);
            $a5d55dc64ccb07cf$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $a5d55dc64ccb07cf$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $a5d55dc64ccb07cf$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $8POXm.isObject)(duration)) return [
        $a5d55dc64ccb07cf$var$NumberOf(duration.enter),
        $a5d55dc64ccb07cf$var$NumberOf(duration.leave)
    ];
    else {
        const n = $a5d55dc64ccb07cf$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $a5d55dc64ccb07cf$var$NumberOf(val) {
    const res = (0, $8POXm.toNumber)(val);
    return res;
}
function $a5d55dc64ccb07cf$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$a5d55dc64ccb07cf$var$vtcKey] || (el[$a5d55dc64ccb07cf$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $a5d55dc64ccb07cf$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$a5d55dc64ccb07cf$var$vtcKey] = void 0;
    }
}
function $a5d55dc64ccb07cf$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $a5d55dc64ccb07cf$var$endId = 0;
function $a5d55dc64ccb07cf$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$a5d55dc64ccb07cf$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Duration`);
    const transitionTimeout = $a5d55dc64ccb07cf$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Duration`);
    const animationTimeout = $a5d55dc64ccb07cf$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $a5d55dc64ccb07cf$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $a5d55dc64ccb07cf$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $a5d55dc64ccb07cf$var$TRANSITION : $a5d55dc64ccb07cf$var$ANIMATION : null;
        propCount = type ? type === $a5d55dc64ccb07cf$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $a5d55dc64ccb07cf$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $a5d55dc64ccb07cf$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$a5d55dc64ccb07cf$var$toMs(d) + $a5d55dc64ccb07cf$var$toMs(delays[i])));
}
function $a5d55dc64ccb07cf$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $a5d55dc64ccb07cf$var$forceReflow() {
    return document.body.offsetHeight;
}
function $a5d55dc64ccb07cf$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $a5d55dc64ccb07cf$var$vShowOriginalDisplay = Symbol("_vod");
const $a5d55dc64ccb07cf$var$vShowHidden = Symbol("_vsh");
const $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $a5d55dc64ccb07cf$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $a5d55dc64ccb07cf$var$setDisplay(el, false);
            });
        } else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setDisplay(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setDisplay(el, value) {
    el.style.display = value ? el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] : "none";
    el[$a5d55dc64ccb07cf$var$vShowHidden] = !value;
}
function $a5d55dc64ccb07cf$var$initVShowForSSR() {
    $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $a5d55dc64ccb07cf$var$CSS_VAR_TEXT = Symbol("");
function $a5d55dc64ccb07cf$export$ef28b76f07940108(getter) {
    const instance = (0, $TusQn.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$a5d55dc64ccb07cf$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        if (instance.ce) $a5d55dc64ccb07cf$var$setVarsOnNode(instance.ce, vars);
        else $a5d55dc64ccb07cf$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $TusQn.onBeforeUpdate)(()=>{
        (0, $TusQn.queuePostFlushCb)(setVars);
    });
    (0, $TusQn.onMounted)(()=>{
        (0, $TusQn.watch)(setVars, (0, $8POXm.NOOP), {
            flush: "post"
        });
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $TusQn.onUnmounted)(()=>ob.disconnect());
    });
}
function $a5d55dc64ccb07cf$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $a5d55dc64ccb07cf$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $a5d55dc64ccb07cf$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $TusQn.Fragment)) vnode.children.forEach((c)=>$a5d55dc64ccb07cf$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $TusQn.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            style.setProperty(`--${key}`, vars[key]);
            cssText += `--${key}: ${vars[key]};`;
        }
        style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT] = cssText;
    }
}
const $a5d55dc64ccb07cf$var$displayRE = /(^|;)\s*display\s*:/;
function $a5d55dc64ccb07cf$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $8POXm.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $8POXm.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            $a5d55dc64ccb07cf$var$setStyle(style, key, next[key]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $a5d55dc64ccb07cf$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($a5d55dc64ccb07cf$var$vShowOriginalDisplay in el) {
        el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$a5d55dc64ccb07cf$var$vShowHidden]) style.display = "none";
    }
}
const $a5d55dc64ccb07cf$var$semicolonRE = /[^\\];\s*$/;
const $a5d55dc64ccb07cf$var$importantRE = /\s*!important$/;
function $a5d55dc64ccb07cf$var$setStyle(style, name, val) {
    if ((0, $8POXm.isArray)(val)) val.forEach((v)=>$a5d55dc64ccb07cf$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $a5d55dc64ccb07cf$var$autoPrefix(style, name);
            if ($a5d55dc64ccb07cf$var$importantRE.test(val)) style.setProperty((0, $8POXm.hyphenate)(prefixed), val.replace($a5d55dc64ccb07cf$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $a5d55dc64ccb07cf$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $a5d55dc64ccb07cf$var$prefixCache = {};
function $a5d55dc64ccb07cf$var$autoPrefix(style, rawName) {
    const cached = $a5d55dc64ccb07cf$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $8POXm.camelize)(rawName);
    if (name !== "filter" && name in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = name;
    name = (0, $8POXm.capitalize)(name);
    for(let i = 0; i < $a5d55dc64ccb07cf$var$prefixes.length; i++){
        const prefixed = $a5d55dc64ccb07cf$var$prefixes[i] + name;
        if (prefixed in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $a5d55dc64ccb07cf$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $a5d55dc64ccb07cf$var$patchAttr(el, key, value, isSVG, instance, isBoolean = (0, $8POXm.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, $8POXm.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, $8POXm.isSymbol)(value) ? String(value) : value);
}
function $a5d55dc64ccb07cf$var$patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? $a5d55dc64ccb07cf$var$unsafeToTrustedHTML(value) : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $8POXm.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
function $a5d55dc64ccb07cf$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $a5d55dc64ccb07cf$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $a5d55dc64ccb07cf$var$veiKey = Symbol("_vei");
function $a5d55dc64ccb07cf$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$a5d55dc64ccb07cf$var$veiKey] || (el[$a5d55dc64ccb07cf$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $a5d55dc64ccb07cf$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $a5d55dc64ccb07cf$var$createInvoker(nextValue, instance);
            $a5d55dc64ccb07cf$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $a5d55dc64ccb07cf$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $a5d55dc64ccb07cf$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $a5d55dc64ccb07cf$var$parseName(name) {
    let options;
    if ($a5d55dc64ccb07cf$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($a5d55dc64ccb07cf$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $8POXm.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $a5d55dc64ccb07cf$var$cachedNow = 0;
const $a5d55dc64ccb07cf$var$p = /* @__PURE__ */ Promise.resolve();
const $a5d55dc64ccb07cf$var$getNow = ()=>$a5d55dc64ccb07cf$var$cachedNow || ($a5d55dc64ccb07cf$var$p.then(()=>$a5d55dc64ccb07cf$var$cachedNow = 0), $a5d55dc64ccb07cf$var$cachedNow = Date.now());
function $a5d55dc64ccb07cf$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $TusQn.callWithAsyncErrorHandling)($a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $a5d55dc64ccb07cf$var$getNow();
    return invoker;
}
function $a5d55dc64ccb07cf$var$sanitizeEventValue(value, propName) {
    if ((0, $8POXm.isFunction)(value) || (0, $8POXm.isArray)(value)) return value;
    (0, $TusQn.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $8POXm.NOOP;
}
function $a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, value) {
    if ((0, $8POXm.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $a5d55dc64ccb07cf$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $a5d55dc64ccb07cf$var$patchProp = (el, key, prevValue, nextValue, namespace, parentComponent)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $a5d55dc64ccb07cf$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $a5d55dc64ccb07cf$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $8POXm.isOn)(key)) {
        if (!(0, $8POXm.isModelListener)(key)) $a5d55dc64ccb07cf$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, nextValue, isSVG)) {
        $a5d55dc64ccb07cf$var$patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) $a5d55dc64ccb07cf$var$patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (// #11081 force set props for possible async custom element
    el._isVueCE && (/[A-Z]/.test(key) || !(0, $8POXm.isString)(nextValue))) $a5d55dc64ccb07cf$var$patchDOMProp(el, (0, $8POXm.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $a5d55dc64ccb07cf$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $8POXm.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $8POXm.isString)(value)) return false;
    return key in el;
}
const $a5d55dc64ccb07cf$var$REMOVAL = {};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, extraOptions, _createApp) {
    const Comp = (0, $TusQn.defineComponent)(options, extraOptions);
    if ((0, $8POXm.isPlainObject)(Comp)) (0, $8POXm.extend)(Comp, extraOptions);
    class VueCustomElement extends $a5d55dc64ccb07cf$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, _createApp);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
/*! #__NO_SIDE_EFFECTS__ */ const $a5d55dc64ccb07cf$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options, extraOptions)=>{
    return /* @__PURE__ */ $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, extraOptions, $a5d55dc64ccb07cf$export$35800275c0037383);
};
const $a5d55dc64ccb07cf$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $a5d55dc64ccb07cf$export$b337c1a55163dbe3 extends $a5d55dc64ccb07cf$var$BaseClass {
    constructor(_def, _props = {}, _createApp = $a5d55dc64ccb07cf$export$4e373c34abfa8c68){
        super();
        this._def = _def;
        this._props = _props;
        this._createApp = _createApp;
        this._isVueCE = true;
        /**
     * @internal
     */ this._instance = null;
        /**
     * @internal
     */ this._app = null;
        /**
     * @internal
     */ this._nonce = this._def.nonce;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        this._styleChildren = /* @__PURE__ */ new WeakSet();
        this._ob = null;
        if (this.shadowRoot && _createApp !== $a5d55dc64ccb07cf$export$4e373c34abfa8c68) this._root = this.shadowRoot;
        else if (_def.shadowRoot !== false) {
            this.attachShadow({
                mode: "open"
            });
            this._root = this.shadowRoot;
        } else this._root = this;
        if (!this._def.__asyncLoader) this._resolveProps(this._def);
    }
    connectedCallback() {
        if (!this.isConnected) return;
        if (!this.shadowRoot) this._parseSlots();
        this._connected = true;
        let parent = this;
        while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $a5d55dc64ccb07cf$export$b337c1a55163dbe3) {
            this._parent = parent;
            break;
        }
        if (!this._instance) {
            if (this._resolved) {
                this._setParent();
                this._update();
            } else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(()=>{
                this._pendingResolve = void 0;
                this._resolveDef();
            });
            else this._resolveDef();
        }
    }
    _setParent(parent = this._parent) {
        if (parent) {
            this._instance.parent = parent._instance;
            this._instance.provides = parent._instance.provides;
        }
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $TusQn.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                this._app && this._app.unmount();
                if (this._instance) this._instance.ce = void 0;
                this._app = this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        if (this._pendingResolve) return;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        });
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            this._resolved = true;
            this._pendingResolve = void 0;
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $8POXm.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $8POXm.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $8POXm.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            if (isAsync) this._resolveProps(def);
            if (this.shadowRoot) this._applyStyles(styles);
            this._mount(def);
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) this._pendingResolve = asyncDef().then((def)=>resolve(this._def = def, true));
        else resolve(this._def);
    }
    _mount(def) {
        if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
        this._app = this._createApp(def);
        if (def.configureApp) def.configureApp(this._app);
        this._app._ceVNode = this._createVNode();
        this._app.mount(this._root);
        const exposed = this._instance && this._instance.exposed;
        if (!exposed) return;
        for(const key in exposed)if (!(0, $8POXm.hasOwn)(this, key)) Object.defineProperty(this, key, {
            // unwrap ref to be consistent with public instance behavior
            get: ()=>(0, $01W3b.unref)(exposed[key])
        });
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $8POXm.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
        for (const key of declaredPropKeys.map((0, $8POXm.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val, true, true);
            }
        });
    }
    _setAttr(key) {
        if (key.startsWith("data-v-")) return;
        const has = this.hasAttribute(key);
        let value = has ? this.getAttribute(key) : $a5d55dc64ccb07cf$var$REMOVAL;
        const camelKey = (0, $8POXm.camelize)(key);
        if (has && this._numberProps && this._numberProps[camelKey]) value = (0, $8POXm.toNumber)(value);
        this._setProp(camelKey, value, false, true);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
        if (val !== this._props[key]) {
            if (val === $a5d55dc64ccb07cf$var$REMOVAL) delete this._props[key];
            else {
                this._props[key] = val;
                if (key === "key" && this._app) this._app._ceVNode.key = val;
            }
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                const ob = this._ob;
                ob && ob.disconnect();
                if (val === true) this.setAttribute((0, $8POXm.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $8POXm.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $8POXm.hyphenate)(key));
                ob && ob.observe(this, {
                    attributes: true
                });
            }
        }
    }
    _update() {
        $a5d55dc64ccb07cf$export$b3890eb0ae9dca99(this._createVNode(), this._root);
    }
    _createVNode() {
        const baseProps = {};
        if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
        const vnode = (0, $TusQn.createVNode)(this._def, (0, $8POXm.extend)(baseProps, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.ce = this;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, (0, $8POXm.isPlainObject)(args[0]) ? (0, $8POXm.extend)({
                    detail: args
                }, args[0]) : {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $8POXm.hyphenate)(event) !== event) dispatch((0, $8POXm.hyphenate)(event), args);
            };
            this._setParent();
        };
        return vnode;
    }
    _applyStyles(styles, owner) {
        if (!styles) return;
        if (owner) {
            if (owner === this._def || this._styleChildren.has(owner)) return;
            this._styleChildren.add(owner);
        }
        const nonce = this._nonce;
        for(let i = styles.length - 1; i >= 0; i--){
            const s = document.createElement("style");
            if (nonce) s.setAttribute("nonce", nonce);
            s.textContent = styles[i];
            this.shadowRoot.prepend(s);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _parseSlots() {
        const slots = this._slots = {};
        let n;
        while(n = this.firstChild){
            const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
            (slots[slotName] || (slots[slotName] = [])).push(n);
            this.removeChild(n);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _renderSlots() {
        const outlets = (this._teleportTarget || this).querySelectorAll("slot");
        const scopeId = this._instance.type.__scopeId;
        for(let i = 0; i < outlets.length; i++){
            const o = outlets[i];
            const slotName = o.getAttribute("name") || "default";
            const content = this._slots[slotName];
            const parent = o.parentNode;
            if (content) for (const n of content){
                if (scopeId && n.nodeType === 1) {
                    const id = scopeId + "-s";
                    const walker = document.createTreeWalker(n, 1);
                    n.setAttribute(id, "");
                    let child;
                    while(child = walker.nextNode())child.setAttribute(id, "");
                }
                parent.insertBefore(n, o);
            }
            else while(o.firstChild)parent.insertBefore(o.firstChild, o);
            parent.removeChild(o);
        }
    }
    /**
   * @internal
   */ _injectChildStyle(comp) {
        this._applyStyles(comp.styles, comp);
    }
    /**
   * @internal
   */ _removeChildStyle(comp) {
        var s;
    }
}
function $a5d55dc64ccb07cf$export$da5acfe93a94e37d(caller) {
    const instance = (0, $TusQn.getCurrentInstance)();
    const el = instance && instance.ce;
    if (el) return el;
    else if (false) {
        if (!instance) (0, $TusQn.warn)(`${caller || "useHost"} called without an active component instance.`);
        else (0, $TusQn.warn)(`${caller || "useHost"} can only be used in components defined via defineCustomElement.`);
    }
    return null;
}
function $a5d55dc64ccb07cf$export$64d45095031fa749() {
    const el = $a5d55dc64ccb07cf$export$da5acfe93a94e37d();
    return el && el.shadowRoot;
}
function $a5d55dc64ccb07cf$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $TusQn.getCurrentInstance)();
        if (!instance) return 0, $8POXm.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $8POXm.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $8POXm.EMPTY_OBJ;
        return mod;
    }
}
const $a5d55dc64ccb07cf$var$positionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$moveCbKey = Symbol("_moveCb");
const $a5d55dc64ccb07cf$var$enterCbKey = Symbol("_enterCb");
const $a5d55dc64ccb07cf$var$decorate = (t)=>{
    delete t.props.mode;
    return t;
};
const $a5d55dc64ccb07cf$var$TransitionGroupImpl = /* @__PURE__ */ $a5d55dc64ccb07cf$var$decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $8POXm.extend)({}, $a5d55dc64ccb07cf$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $TusQn.getCurrentInstance)();
        const state = (0, $TusQn.useTransitionState)();
        let prevChildren;
        let children;
        (0, $TusQn.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$a5d55dc64ccb07cf$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            prevChildren.forEach($a5d55dc64ccb07cf$var$callPendingCbs);
            prevChildren.forEach($a5d55dc64ccb07cf$var$recordPosition);
            const movedChildren = prevChildren.filter($a5d55dc64ccb07cf$var$applyTranslation);
            $a5d55dc64ccb07cf$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $a5d55dc64ccb07cf$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$a5d55dc64ccb07cf$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[$a5d55dc64ccb07cf$var$moveCbKey] = null;
                        $a5d55dc64ccb07cf$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, $01W3b.toRaw)(props);
            const cssTransitionProps = $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $TusQn.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $a5d55dc64ccb07cf$var$positionMap.set(child, child.el.getBoundingClientRect());
                }
            }
            children = slots.default ? (0, $TusQn.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, $TusQn.createVNode)(tag, null, children);
        };
    }
});
const $a5d55dc64ccb07cf$export$19ffa8f511f7bc2e = $a5d55dc64ccb07cf$var$TransitionGroupImpl;
function $a5d55dc64ccb07cf$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$a5d55dc64ccb07cf$var$moveCbKey]) el[$a5d55dc64ccb07cf$var$moveCbKey]();
    if (el[$a5d55dc64ccb07cf$var$enterCbKey]) el[$a5d55dc64ccb07cf$var$enterCbKey]();
}
function $a5d55dc64ccb07cf$var$recordPosition(c) {
    $a5d55dc64ccb07cf$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $a5d55dc64ccb07cf$var$applyTranslation(c) {
    const oldPos = $a5d55dc64ccb07cf$var$positionMap.get(c);
    const newPos = $a5d55dc64ccb07cf$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $a5d55dc64ccb07cf$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $a5d55dc64ccb07cf$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $a5d55dc64ccb07cf$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $8POXm.isArray)(fn) ? (value)=>(0, $8POXm.invokeArrayFns)(fn, value) : fn;
};
function $a5d55dc64ccb07cf$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $a5d55dc64ccb07cf$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $a5d55dc64ccb07cf$var$assignKey = Symbol("_assign");
const $a5d55dc64ccb07cf$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $a5d55dc64ccb07cf$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $8POXm.looseToNumber)(domValue);
            el[$a5d55dc64ccb07cf$var$assignKey](domValue);
        });
        if (trim) $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionstart", $a5d55dc64ccb07cf$var$onCompositionStart);
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionend", $a5d55dc64ccb07cf$var$onCompositionEnd);
            $a5d55dc64ccb07cf$var$addEventListener(el, "change", $a5d55dc64ccb07cf$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, oldValue: oldValue, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $8POXm.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $a5d55dc64ccb07cf$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $a5d55dc64ccb07cf$var$getValue(el);
            const checked = el.checked;
            const assign = el[$a5d55dc64ccb07cf$var$assignKey];
            if ((0, $8POXm.isArray)(modelValue)) {
                const index = (0, $8POXm.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $8POXm.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($a5d55dc64ccb07cf$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $a5d55dc64ccb07cf$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$setChecked(el, binding, vnode);
    }
};
function $a5d55dc64ccb07cf$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    let checked;
    if ((0, $8POXm.isArray)(value)) checked = (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $8POXm.isSet)(value)) checked = value.has(vnode.props.value);
    else {
        if (value === oldValue) return;
        checked = (0, $8POXm.looseEqual)(value, $a5d55dc64ccb07cf$var$getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
}
const $a5d55dc64ccb07cf$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el[$a5d55dc64ccb07cf$var$assignKey]($a5d55dc64ccb07cf$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
    }
};
const $a5d55dc64ccb07cf$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $8POXm.isSet)(value);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $8POXm.looseToNumber)($a5d55dc64ccb07cf$var$getValue(o)) : $a5d55dc64ccb07cf$var$getValue(o));
            el[$a5d55dc64ccb07cf$var$assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $TusQn.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        if (!el._assigning) $a5d55dc64ccb07cf$var$setSelected(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $8POXm.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $8POXm.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $a5d55dc64ccb07cf$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $8POXm.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $8POXm.looseEqual)($a5d55dc64ccb07cf$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $a5d55dc64ccb07cf$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $a5d55dc64ccb07cf$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $a5d55dc64ccb07cf$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $a5d55dc64ccb07cf$export$87d227567b51ca39;
        case "TEXTAREA":
            return $a5d55dc64ccb07cf$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $a5d55dc64ccb07cf$export$8847c2e532b35714;
                case "radio":
                    return $a5d55dc64ccb07cf$export$b4356c59b38b7aa9;
                default:
                    return $a5d55dc64ccb07cf$export$f1f88689f5728478;
            }
    }
}
function $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $a5d55dc64ccb07cf$var$initVModelForSSR() {
    $a5d55dc64ccb07cf$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $a5d55dc64ccb07cf$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $8POXm.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $8POXm.isArray)(value)) {
            if (vnode.props && (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $8POXm.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $a5d55dc64ccb07cf$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $a5d55dc64ccb07cf$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$a5d55dc64ccb07cf$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $a5d55dc64ccb07cf$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $a5d55dc64ccb07cf$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $a5d55dc64ccb07cf$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $a5d55dc64ccb07cf$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $8POXm.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $a5d55dc64ccb07cf$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $a5d55dc64ccb07cf$var$rendererOptions = /* @__PURE__ */ (0, $8POXm.extend)({
    patchProp: $a5d55dc64ccb07cf$var$patchProp
}, $a5d55dc64ccb07cf$var$nodeOps);
let $a5d55dc64ccb07cf$var$renderer;
let $a5d55dc64ccb07cf$var$enabledHydration = false;
function $a5d55dc64ccb07cf$var$ensureRenderer() {
    return $a5d55dc64ccb07cf$var$renderer || ($a5d55dc64ccb07cf$var$renderer = (0, $TusQn.createRenderer)($a5d55dc64ccb07cf$var$rendererOptions));
}
function $a5d55dc64ccb07cf$var$ensureHydrationRenderer() {
    $a5d55dc64ccb07cf$var$renderer = $a5d55dc64ccb07cf$var$enabledHydration ? $a5d55dc64ccb07cf$var$renderer : (0, $TusQn.createHydrationRenderer)($a5d55dc64ccb07cf$var$rendererOptions);
    $a5d55dc64ccb07cf$var$enabledHydration = true;
    return $a5d55dc64ccb07cf$var$renderer;
}
const $a5d55dc64ccb07cf$export$b3890eb0ae9dca99 = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureRenderer().render(...args);
};
const $a5d55dc64ccb07cf$export$fa8d919ba61d84db = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureHydrationRenderer().hydrate(...args);
};
const $a5d55dc64ccb07cf$export$4e373c34abfa8c68 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $8POXm.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        const proxy = mount(container, false, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $a5d55dc64ccb07cf$export$35800275c0037383 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
    };
    return app;
};
function $a5d55dc64ccb07cf$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $a5d55dc64ccb07cf$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $8POXm.isHTMLTag)(tag) || (0, $8POXm.isSVGTag)(tag) || (0, $8POXm.isMathMLTag)(tag),
        writable: false
    });
}
function $a5d55dc64ccb07cf$var$injectCompilerOptionsCheck(app) {
    if ((0, $TusQn.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $TusQn.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $TusQn.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $TusQn.warn)(msg);
            }
        });
    }
}
function $a5d55dc64ccb07cf$var$normalizeContainer(container) {
    if ((0, $8POXm.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = false;
const $a5d55dc64ccb07cf$export$800b28255aa678d9 = ()=>{
    if (!$a5d55dc64ccb07cf$var$ssrDirectiveInitialized) {
        $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = true;
        $a5d55dc64ccb07cf$var$initVModelForSSR();
        $a5d55dc64ccb07cf$var$initVShowForSSR();
    }
};

});


parcelRegister("73mM4", function(module, exports) {

$parcel$export(module.exports, "createWebHistory", () => $a809ac530d32f081$export$7b4942f78e7b8a49);
$parcel$export(module.exports, "onBeforeRouteLeave", () => $a809ac530d32f081$export$d7fcdd004b009a9e);
$parcel$export(module.exports, "createRouter", () => $a809ac530d32f081$export$baddd0131ee8c05b);
$parcel$export(module.exports, "useRouter", () => $a809ac530d32f081$export$9a302a45f65d0572);
/*!
  * vue-router v4.5.0
  * (c) 2024 Eduardo San Martin Morote
  * @license MIT
  */ parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $j6G8F = parcelRequire("j6G8F");
const $a809ac530d32f081$var$isBrowser = typeof document !== 'undefined';
/**
 * Allows differentiating lazy components from functional components and vue-class-component
 * @internal
 *
 * @param component
 */ function $a809ac530d32f081$var$isRouteComponent(component) {
    return typeof component === 'object' || 'displayName' in component || 'props' in component || '__vccOpts' in component;
}
function $a809ac530d32f081$var$isESModule(obj) {
    return obj.__esModule || obj[Symbol.toStringTag] === 'Module' || // support CF with dynamic imports that do not
    // add the Module string tag
    obj.default && $a809ac530d32f081$var$isRouteComponent(obj.default);
}
const $a809ac530d32f081$var$assign = Object.assign;
function $a809ac530d32f081$var$applyToParams(fn, params) {
    const newParams = {};
    for(const key in params){
        const value = params[key];
        newParams[key] = $a809ac530d32f081$var$isArray(value) ? value.map(fn) : fn(value);
    }
    return newParams;
}
const $a809ac530d32f081$var$noop = ()=>{};
/**
 * Typesafe alternative to Array.isArray
 * https://github.com/microsoft/TypeScript/pull/48228
 */ const $a809ac530d32f081$var$isArray = Array.isArray;
function $a809ac530d32f081$var$warn(msg) {
    // avoid using ...args as it breaks in older Edge builds
    const args = Array.from(arguments).slice(1);
    console.warn.apply(console, [
        '[Vue Router warn]: ' + msg
    ].concat(args));
}
/**
 * Encoding Rules (␣ = Space)
 * - Path: ␣ " < > # ? { }
 * - Query: ␣ " < > # & =
 * - Hash: ␣ " < > `
 *
 * On top of that, the RFC3986 (https://tools.ietf.org/html/rfc3986#section-2.2)
 * defines some extra characters to be encoded. Most browsers do not encode them
 * in encodeURI https://github.com/whatwg/url/issues/369, so it may be safer to
 * also encode `!'()*`. Leaving un-encoded only ASCII alphanumeric(`a-zA-Z0-9`)
 * plus `-._~`. This extra safety should be applied to query by patching the
 * string returned by encodeURIComponent encodeURI also encodes `[\]^`. `\`
 * should be encoded to avoid ambiguity. Browsers (IE, FF, C) transform a `\`
 * into a `/` if directly typed in. The _backtick_ (`````) should also be
 * encoded everywhere because some browsers like FF encode it when directly
 * written while others don't. Safari and IE don't encode ``"<>{}``` in hash.
 */ // const EXTRA_RESERVED_RE = /[!'()*]/g
// const encodeReservedReplacer = (c: string) => '%' + c.charCodeAt(0).toString(16)
const $a809ac530d32f081$var$HASH_RE = /#/g; // %23
const $a809ac530d32f081$var$AMPERSAND_RE = /&/g; // %26
const $a809ac530d32f081$var$SLASH_RE = /\//g; // %2F
const $a809ac530d32f081$var$EQUAL_RE = /=/g; // %3D
const $a809ac530d32f081$var$IM_RE = /\?/g; // %3F
const $a809ac530d32f081$var$PLUS_RE = /\+/g; // %2B
/**
 * NOTE: It's not clear to me if we should encode the + symbol in queries, it
 * seems to be less flexible than not doing so and I can't find out the legacy
 * systems requiring this for regular requests like text/html. In the standard,
 * the encoding of the plus character is only mentioned for
 * application/x-www-form-urlencoded
 * (https://url.spec.whatwg.org/#urlencoded-parsing) and most browsers seems lo
 * leave the plus character as is in queries. To be more flexible, we allow the
 * plus character on the query, but it can also be manually encoded by the user.
 *
 * Resources:
 * - https://url.spec.whatwg.org/#urlencoded-parsing
 * - https://stackoverflow.com/questions/1634271/url-encoding-the-space-character-or-20
 */ const $a809ac530d32f081$var$ENC_BRACKET_OPEN_RE = /%5B/g; // [
const $a809ac530d32f081$var$ENC_BRACKET_CLOSE_RE = /%5D/g; // ]
const $a809ac530d32f081$var$ENC_CARET_RE = /%5E/g; // ^
const $a809ac530d32f081$var$ENC_BACKTICK_RE = /%60/g; // `
const $a809ac530d32f081$var$ENC_CURLY_OPEN_RE = /%7B/g; // {
const $a809ac530d32f081$var$ENC_PIPE_RE = /%7C/g; // |
const $a809ac530d32f081$var$ENC_CURLY_CLOSE_RE = /%7D/g; // }
const $a809ac530d32f081$var$ENC_SPACE_RE = /%20/g; // }
/**
 * Encode characters that need to be encoded on the path, search and hash
 * sections of the URL.
 *
 * @internal
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$commonEncode(text) {
    return encodeURI('' + text).replace($a809ac530d32f081$var$ENC_PIPE_RE, '|').replace($a809ac530d32f081$var$ENC_BRACKET_OPEN_RE, '[').replace($a809ac530d32f081$var$ENC_BRACKET_CLOSE_RE, ']');
}
/**
 * Encode characters that need to be encoded on the hash section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodeHash(text) {
    return $a809ac530d32f081$var$commonEncode(text).replace($a809ac530d32f081$var$ENC_CURLY_OPEN_RE, '{').replace($a809ac530d32f081$var$ENC_CURLY_CLOSE_RE, '}').replace($a809ac530d32f081$var$ENC_CARET_RE, '^');
}
/**
 * Encode characters that need to be encoded query values on the query
 * section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodeQueryValue(text) {
    return $a809ac530d32f081$var$commonEncode(text)// Encode the space as +, encode the + to differentiate it from the space
    .replace($a809ac530d32f081$var$PLUS_RE, '%2B').replace($a809ac530d32f081$var$ENC_SPACE_RE, '+').replace($a809ac530d32f081$var$HASH_RE, '%23').replace($a809ac530d32f081$var$AMPERSAND_RE, '%26').replace($a809ac530d32f081$var$ENC_BACKTICK_RE, '`').replace($a809ac530d32f081$var$ENC_CURLY_OPEN_RE, '{').replace($a809ac530d32f081$var$ENC_CURLY_CLOSE_RE, '}').replace($a809ac530d32f081$var$ENC_CARET_RE, '^');
}
/**
 * Like `encodeQueryValue` but also encodes the `=` character.
 *
 * @param text - string to encode
 */ function $a809ac530d32f081$var$encodeQueryKey(text) {
    return $a809ac530d32f081$var$encodeQueryValue(text).replace($a809ac530d32f081$var$EQUAL_RE, '%3D');
}
/**
 * Encode characters that need to be encoded on the path section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodePath(text) {
    return $a809ac530d32f081$var$commonEncode(text).replace($a809ac530d32f081$var$HASH_RE, '%23').replace($a809ac530d32f081$var$IM_RE, '%3F');
}
/**
 * Encode characters that need to be encoded on the path section of the URL as a
 * param. This function encodes everything {@link encodePath} does plus the
 * slash (`/`) character. If `text` is `null` or `undefined`, returns an empty
 * string instead.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodeParam(text) {
    return text == null ? '' : $a809ac530d32f081$var$encodePath(text).replace($a809ac530d32f081$var$SLASH_RE, '%2F');
}
/**
 * Decode text using `decodeURIComponent`. Returns the original text if it
 * fails.
 *
 * @param text - string to decode
 * @returns decoded string
 */ function $a809ac530d32f081$var$decode(text) {
    try {
        return decodeURIComponent('' + text);
    } catch (err) {}
    return '' + text;
}
const $a809ac530d32f081$var$TRAILING_SLASH_RE = /\/$/;
const $a809ac530d32f081$var$removeTrailingSlash = (path)=>path.replace($a809ac530d32f081$var$TRAILING_SLASH_RE, '');
/**
 * Transforms a URI into a normalized history location
 *
 * @param parseQuery
 * @param location - URI to normalize
 * @param currentLocation - current absolute location. Allows resolving relative
 * paths. Must start with `/`. Defaults to `/`
 * @returns a normalized history location
 */ function $a809ac530d32f081$var$parseURL(parseQuery, location1, currentLocation = '/') {
    let path, query = {}, searchString = '', hash = '';
    // Could use URL and URLSearchParams but IE 11 doesn't support it
    // TODO: move to new URL()
    const hashPos = location1.indexOf('#');
    let searchPos = location1.indexOf('?');
    // the hash appears before the search, so it's not part of the search string
    if (hashPos < searchPos && hashPos >= 0) searchPos = -1;
    if (searchPos > -1) {
        path = location1.slice(0, searchPos);
        searchString = location1.slice(searchPos + 1, hashPos > -1 ? hashPos : location1.length);
        query = parseQuery(searchString);
    }
    if (hashPos > -1) {
        path = path || location1.slice(0, hashPos);
        // keep the # character
        hash = location1.slice(hashPos, location1.length);
    }
    // no search and no query
    path = $a809ac530d32f081$var$resolveRelativePath(path != null ? path : location1, currentLocation);
    // empty path means a relative query or hash `?foo=f`, `#thing`
    return {
        fullPath: path + (searchString && '?') + searchString + hash,
        path: path,
        query: query,
        hash: $a809ac530d32f081$var$decode(hash)
    };
}
/**
 * Stringifies a URL object
 *
 * @param stringifyQuery
 * @param location
 */ function $a809ac530d32f081$var$stringifyURL(stringifyQuery, location1) {
    const query = location1.query ? stringifyQuery(location1.query) : '';
    return location1.path + (query && '?') + query + (location1.hash || '');
}
/**
 * Strips off the base from the beginning of a location.pathname in a non-case-sensitive way.
 *
 * @param pathname - location.pathname
 * @param base - base to strip off
 */ function $a809ac530d32f081$var$stripBase(pathname, base) {
    // no base or base is not found at the beginning
    if (!base || !pathname.toLowerCase().startsWith(base.toLowerCase())) return pathname;
    return pathname.slice(base.length) || '/';
}
/**
 * Checks if two RouteLocation are equal. This means that both locations are
 * pointing towards the same {@link RouteRecord} and that all `params`, `query`
 * parameters and `hash` are the same
 *
 * @param stringifyQuery - A function that takes a query object of type LocationQueryRaw and returns a string representation of it.
 * @param a - first {@link RouteLocation}
 * @param b - second {@link RouteLocation}
 */ function $a809ac530d32f081$var$isSameRouteLocation(stringifyQuery, a, b) {
    const aLastIndex = a.matched.length - 1;
    const bLastIndex = b.matched.length - 1;
    return aLastIndex > -1 && aLastIndex === bLastIndex && $a809ac530d32f081$var$isSameRouteRecord(a.matched[aLastIndex], b.matched[bLastIndex]) && $a809ac530d32f081$var$isSameRouteLocationParams(a.params, b.params) && stringifyQuery(a.query) === stringifyQuery(b.query) && a.hash === b.hash;
}
/**
 * Check if two `RouteRecords` are equal. Takes into account aliases: they are
 * considered equal to the `RouteRecord` they are aliasing.
 *
 * @param a - first {@link RouteRecord}
 * @param b - second {@link RouteRecord}
 */ function $a809ac530d32f081$var$isSameRouteRecord(a, b) {
    // since the original record has an undefined value for aliasOf
    // but all aliases point to the original record, this will always compare
    // the original record
    return (a.aliasOf || a) === (b.aliasOf || b);
}
function $a809ac530d32f081$var$isSameRouteLocationParams(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (!$a809ac530d32f081$var$isSameRouteLocationParamsValue(a[key], b[key])) return false;
    }
    return true;
}
function $a809ac530d32f081$var$isSameRouteLocationParamsValue(a, b) {
    return $a809ac530d32f081$var$isArray(a) ? $a809ac530d32f081$var$isEquivalentArray(a, b) : $a809ac530d32f081$var$isArray(b) ? $a809ac530d32f081$var$isEquivalentArray(b, a) : a === b;
}
/**
 * Check if two arrays are the same or if an array with one single entry is the
 * same as another primitive value. Used to check query and parameters
 *
 * @param a - array of values
 * @param b - array of values or a single value
 */ function $a809ac530d32f081$var$isEquivalentArray(a, b) {
    return $a809ac530d32f081$var$isArray(b) ? a.length === b.length && a.every((value, i)=>value === b[i]) : a.length === 1 && a[0] === b;
}
/**
 * Resolves a relative path that starts with `.`.
 *
 * @param to - path location we are resolving
 * @param from - currentLocation.path, should start with `/`
 */ function $a809ac530d32f081$var$resolveRelativePath(to, from) {
    if (to.startsWith('/')) return to;
    if (!to) return from;
    const fromSegments = from.split('/');
    const toSegments = to.split('/');
    const lastToSegment = toSegments[toSegments.length - 1];
    // make . and ./ the same (../ === .., ../../ === ../..)
    // this is the same behavior as new URL()
    if (lastToSegment === '..' || lastToSegment === '.') toSegments.push('');
    let position = fromSegments.length - 1;
    let toPosition;
    let segment;
    for(toPosition = 0; toPosition < toSegments.length; toPosition++){
        segment = toSegments[toPosition];
        // we stay on the same position
        if (segment === '.') continue;
        // go up in the from array
        if (segment === '..') // we can't go below zero, but we still need to increment toPosition
        {
            if (position > 1) position--;
        } else break;
    }
    return fromSegments.slice(0, position).join('/') + '/' + toSegments.slice(toPosition).join('/');
}
/**
 * Initial route location where the router is. Can be used in navigation guards
 * to differentiate the initial navigation.
 *
 * @example
 * ```js
 * import { START_LOCATION } from 'vue-router'
 *
 * router.beforeEach((to, from) => {
 *   if (from === START_LOCATION) {
 *     // initial navigation
 *   }
 * })
 * ```
 */ const $a809ac530d32f081$export$e44be9a9779c480b = {
    path: '/',
    // TODO: could we use a symbol in the future?
    name: undefined,
    params: {},
    query: {},
    hash: '',
    fullPath: '/',
    matched: [],
    meta: {},
    redirectedFrom: undefined
};
var $a809ac530d32f081$var$NavigationType;
(function(NavigationType) {
    NavigationType["pop"] = "pop";
    NavigationType["push"] = "push";
})($a809ac530d32f081$var$NavigationType || ($a809ac530d32f081$var$NavigationType = {}));
var $a809ac530d32f081$var$NavigationDirection;
(function(NavigationDirection) {
    NavigationDirection["back"] = "back";
    NavigationDirection["forward"] = "forward";
    NavigationDirection["unknown"] = "";
})($a809ac530d32f081$var$NavigationDirection || ($a809ac530d32f081$var$NavigationDirection = {}));
/**
 * Starting location for Histories
 */ const $a809ac530d32f081$var$START = '';
// Generic utils
/**
 * Normalizes a base by removing any trailing slash and reading the base tag if
 * present.
 *
 * @param base - base to normalize
 */ function $a809ac530d32f081$var$normalizeBase(base) {
    if (!base) {
        if ($a809ac530d32f081$var$isBrowser) {
            // respect <base> tag
            const baseEl = document.querySelector('base');
            base = baseEl && baseEl.getAttribute('href') || '/';
            // strip full URL origin
            base = base.replace(/^\w+:\/\/[^\/]+/, '');
        } else base = '/';
    }
    // ensure leading slash when it was removed by the regex above avoid leading
    // slash with hash because the file could be read from the disk like file://
    // and the leading slash would cause problems
    if (base[0] !== '/' && base[0] !== '#') base = '/' + base;
    // remove the trailing slash so all other method can just do `base + fullPath`
    // to build an href
    return $a809ac530d32f081$var$removeTrailingSlash(base);
}
// remove any character before the hash
const $a809ac530d32f081$var$BEFORE_HASH_RE = /^[^#]+#/;
function $a809ac530d32f081$var$createHref(base, location1) {
    return base.replace($a809ac530d32f081$var$BEFORE_HASH_RE, '#') + location1;
}
function $a809ac530d32f081$var$getElementPosition(el, offset) {
    const docRect = document.documentElement.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    return {
        behavior: offset.behavior,
        left: elRect.left - docRect.left - (offset.left || 0),
        top: elRect.top - docRect.top - (offset.top || 0)
    };
}
const $a809ac530d32f081$var$computeScrollPosition = ()=>({
        left: window.scrollX,
        top: window.scrollY
    });
function $a809ac530d32f081$var$scrollToPosition(position) {
    let scrollToOptions;
    if ('el' in position) {
        const positionEl = position.el;
        const isIdSelector = typeof positionEl === 'string' && positionEl.startsWith('#');
        var err;
        const el = typeof positionEl === 'string' ? isIdSelector ? document.getElementById(positionEl.slice(1)) : document.querySelector(positionEl) : positionEl;
        if (!el) return;
        scrollToOptions = $a809ac530d32f081$var$getElementPosition(el, position);
    } else scrollToOptions = position;
    if ('scrollBehavior' in document.documentElement.style) window.scrollTo(scrollToOptions);
    else window.scrollTo(scrollToOptions.left != null ? scrollToOptions.left : window.scrollX, scrollToOptions.top != null ? scrollToOptions.top : window.scrollY);
}
function $a809ac530d32f081$var$getScrollKey(path, delta) {
    const position = history.state ? history.state.position - delta : -1;
    return position + path;
}
const $a809ac530d32f081$var$scrollPositions = new Map();
function $a809ac530d32f081$var$saveScrollPosition(key, scrollPosition) {
    $a809ac530d32f081$var$scrollPositions.set(key, scrollPosition);
}
function $a809ac530d32f081$var$getSavedScrollPosition(key) {
    const scroll = $a809ac530d32f081$var$scrollPositions.get(key);
    // consume it so it's not used again
    $a809ac530d32f081$var$scrollPositions.delete(key);
    return scroll;
}
// TODO: RFC about how to save scroll position
/**
 * ScrollBehavior instance used by the router to compute and restore the scroll
 * position when navigating.
 */ // export interface ScrollHandler<ScrollPositionEntry extends HistoryStateValue, ScrollPosition extends ScrollPositionEntry> {
//   // returns a scroll position that can be saved in history
//   compute(): ScrollPositionEntry
//   // can take an extended ScrollPositionEntry
//   scroll(position: ScrollPosition): void
// }
// export const scrollHandler: ScrollHandler<ScrollPosition> = {
//   compute: computeScroll,
//   scroll: scrollToPosition,
// }
let $a809ac530d32f081$var$createBaseLocation = ()=>location.protocol + '//' + location.host;
/**
 * Creates a normalized history location from a window.location object
 * @param base - The base path
 * @param location - The window.location object
 */ function $a809ac530d32f081$var$createCurrentLocation(base, location1) {
    const { pathname: pathname, search: search, hash: hash } = location1;
    // allows hash bases like #, /#, #/, #!, #!/, /#!/, or even /folder#end
    const hashPos = base.indexOf('#');
    if (hashPos > -1) {
        let slicePos = hash.includes(base.slice(hashPos)) ? base.slice(hashPos).length : 1;
        let pathFromHash = hash.slice(slicePos);
        // prepend the starting slash to hash so the url starts with /#
        if (pathFromHash[0] !== '/') pathFromHash = '/' + pathFromHash;
        return $a809ac530d32f081$var$stripBase(pathFromHash, '');
    }
    const path = $a809ac530d32f081$var$stripBase(pathname, base);
    return path + search + hash;
}
function $a809ac530d32f081$var$useHistoryListeners(base, historyState, currentLocation, replace) {
    let listeners = [];
    let teardowns = [];
    // TODO: should it be a stack? a Dict. Check if the popstate listener
    // can trigger twice
    let pauseState = null;
    const popStateHandler = ({ state: state })=>{
        const to = $a809ac530d32f081$var$createCurrentLocation(base, location);
        const from = currentLocation.value;
        const fromState = historyState.value;
        let delta = 0;
        if (state) {
            currentLocation.value = to;
            historyState.value = state;
            // ignore the popstate and reset the pauseState
            if (pauseState && pauseState === from) {
                pauseState = null;
                return;
            }
            delta = fromState ? state.position - fromState.position : 0;
        } else replace(to);
        // Here we could also revert the navigation by calling history.go(-delta)
        // this listener will have to be adapted to not trigger again and to wait for the url
        // to be updated before triggering the listeners. Some kind of validation function would also
        // need to be passed to the listeners so the navigation can be accepted
        // call all listeners
        listeners.forEach((listener)=>{
            listener(currentLocation.value, from, {
                delta: delta,
                type: $a809ac530d32f081$var$NavigationType.pop,
                direction: delta ? delta > 0 ? $a809ac530d32f081$var$NavigationDirection.forward : $a809ac530d32f081$var$NavigationDirection.back : $a809ac530d32f081$var$NavigationDirection.unknown
            });
        });
    };
    function pauseListeners() {
        pauseState = currentLocation.value;
    }
    function listen(callback) {
        // set up the listener and prepare teardown callbacks
        listeners.push(callback);
        const teardown = ()=>{
            const index = listeners.indexOf(callback);
            if (index > -1) listeners.splice(index, 1);
        };
        teardowns.push(teardown);
        return teardown;
    }
    function beforeUnloadListener() {
        const { history: history1 } = window;
        if (!history1.state) return;
        history1.replaceState($a809ac530d32f081$var$assign({}, history1.state, {
            scroll: $a809ac530d32f081$var$computeScrollPosition()
        }), '');
    }
    function destroy() {
        for (const teardown of teardowns)teardown();
        teardowns = [];
        window.removeEventListener('popstate', popStateHandler);
        window.removeEventListener('beforeunload', beforeUnloadListener);
    }
    // set up the listeners and prepare teardown callbacks
    window.addEventListener('popstate', popStateHandler);
    // TODO: could we use 'pagehide' or 'visibilitychange' instead?
    // https://developer.chrome.com/blog/page-lifecycle-api/
    window.addEventListener('beforeunload', beforeUnloadListener, {
        passive: true
    });
    return {
        pauseListeners: pauseListeners,
        listen: listen,
        destroy: destroy
    };
}
/**
 * Creates a state object
 */ function $a809ac530d32f081$var$buildState(back, current, forward, replaced = false, computeScroll = false) {
    return {
        back: back,
        current: current,
        forward: forward,
        replaced: replaced,
        position: window.history.length,
        scroll: computeScroll ? $a809ac530d32f081$var$computeScrollPosition() : null
    };
}
function $a809ac530d32f081$var$useHistoryStateNavigation(base) {
    const { history: history1, location: location1 } = window;
    // private variables
    const currentLocation = {
        value: $a809ac530d32f081$var$createCurrentLocation(base, location1)
    };
    const historyState = {
        value: history1.state
    };
    // build current history entry as this is a fresh navigation
    if (!historyState.value) changeLocation(currentLocation.value, {
        back: null,
        current: currentLocation.value,
        forward: null,
        // the length is off by one, we need to decrease it
        position: history1.length - 1,
        replaced: true,
        // don't add a scroll as the user may have an anchor, and we want
        // scrollBehavior to be triggered without a saved position
        scroll: null
    }, true);
    function changeLocation(to, state, replace) {
        /**
         * if a base tag is provided, and we are on a normal domain, we have to
         * respect the provided `base` attribute because pushState() will use it and
         * potentially erase anything before the `#` like at
         * https://github.com/vuejs/router/issues/685 where a base of
         * `/folder/#` but a base of `/` would erase the `/folder/` section. If
         * there is no host, the `<base>` tag makes no sense and if there isn't a
         * base tag we can just use everything after the `#`.
         */ const hashIndex = base.indexOf('#');
        const url = hashIndex > -1 ? (location1.host && document.querySelector('base') ? base : base.slice(hashIndex)) + to : $a809ac530d32f081$var$createBaseLocation() + base + to;
        try {
            // BROWSER QUIRK
            // NOTE: Safari throws a SecurityError when calling this function 100 times in 30 seconds
            history1[replace ? 'replaceState' : 'pushState'](state, '', url);
            historyState.value = state;
        } catch (err) {
            console.error(err);
            // Force the navigation, this also resets the call count
            location1[replace ? 'replace' : 'assign'](url);
        }
    }
    function replace(to, data) {
        const state = $a809ac530d32f081$var$assign({}, history1.state, $a809ac530d32f081$var$buildState(historyState.value.back, // keep back and forward entries but override current position
        to, historyState.value.forward, true), data, {
            position: historyState.value.position
        });
        changeLocation(to, state, true);
        currentLocation.value = to;
    }
    function push(to, data) {
        // Add to current entry the information of where we are going
        // as well as saving the current position
        const currentState = $a809ac530d32f081$var$assign({}, // use current history state to gracefully handle a wrong call to
        // history.replaceState
        // https://github.com/vuejs/router/issues/366
        historyState.value, history1.state, {
            forward: to,
            scroll: $a809ac530d32f081$var$computeScrollPosition()
        });
        changeLocation(currentState.current, currentState, true);
        const state = $a809ac530d32f081$var$assign({}, $a809ac530d32f081$var$buildState(currentLocation.value, to, null), {
            position: currentState.position + 1
        }, data);
        changeLocation(to, state, false);
        currentLocation.value = to;
    }
    return {
        location: currentLocation,
        state: historyState,
        push: push,
        replace: replace
    };
}
/**
 * Creates an HTML5 history. Most common history for single page applications.
 *
 * @param base -
 */ function $a809ac530d32f081$export$7b4942f78e7b8a49(base) {
    base = $a809ac530d32f081$var$normalizeBase(base);
    const historyNavigation = $a809ac530d32f081$var$useHistoryStateNavigation(base);
    const historyListeners = $a809ac530d32f081$var$useHistoryListeners(base, historyNavigation.state, historyNavigation.location, historyNavigation.replace);
    function go(delta, triggerListeners = true) {
        if (!triggerListeners) historyListeners.pauseListeners();
        history.go(delta);
    }
    const routerHistory = $a809ac530d32f081$var$assign({
        // it's overridden right after
        location: '',
        base: base,
        go: go,
        createHref: $a809ac530d32f081$var$createHref.bind(null, base)
    }, historyNavigation, historyListeners);
    Object.defineProperty(routerHistory, 'location', {
        enumerable: true,
        get: ()=>historyNavigation.location.value
    });
    Object.defineProperty(routerHistory, 'state', {
        enumerable: true,
        get: ()=>historyNavigation.state.value
    });
    return routerHistory;
}
/**
 * Creates an in-memory based history. The main purpose of this history is to handle SSR. It starts in a special location that is nowhere.
 * It's up to the user to replace that location with the starter location by either calling `router.push` or `router.replace`.
 *
 * @param base - Base applied to all urls, defaults to '/'
 * @returns a history object that can be passed to the router constructor
 */ function $a809ac530d32f081$export$2b76ad033c6e6d08(base = '') {
    let listeners = [];
    let queue = [
        $a809ac530d32f081$var$START
    ];
    let position = 0;
    base = $a809ac530d32f081$var$normalizeBase(base);
    function setLocation(location1) {
        position++;
        if (position !== queue.length) // we are in the middle, we remove everything from here in the queue
        queue.splice(position);
        queue.push(location1);
    }
    function triggerListeners(to, from, { direction: direction, delta: delta }) {
        const info = {
            direction: direction,
            delta: delta,
            type: $a809ac530d32f081$var$NavigationType.pop
        };
        for (const callback of listeners)callback(to, from, info);
    }
    const routerHistory = {
        // rewritten by Object.defineProperty
        location: $a809ac530d32f081$var$START,
        // TODO: should be kept in queue
        state: {},
        base: base,
        createHref: $a809ac530d32f081$var$createHref.bind(null, base),
        replace (to) {
            // remove current entry and decrement position
            queue.splice(position--, 1);
            setLocation(to);
        },
        push (to, data) {
            setLocation(to);
        },
        listen (callback) {
            listeners.push(callback);
            return ()=>{
                const index = listeners.indexOf(callback);
                if (index > -1) listeners.splice(index, 1);
            };
        },
        destroy () {
            listeners = [];
            queue = [
                $a809ac530d32f081$var$START
            ];
            position = 0;
        },
        go (delta, shouldTrigger = true) {
            const from = this.location;
            const direction = // we are considering delta === 0 going forward, but in abstract mode
            // using 0 for the delta doesn't make sense like it does in html5 where
            // it reloads the page
            delta < 0 ? $a809ac530d32f081$var$NavigationDirection.back : $a809ac530d32f081$var$NavigationDirection.forward;
            position = Math.max(0, Math.min(position + delta, queue.length - 1));
            if (shouldTrigger) triggerListeners(this.location, from, {
                direction: direction,
                delta: delta
            });
        }
    };
    Object.defineProperty(routerHistory, 'location', {
        enumerable: true,
        get: ()=>queue[position]
    });
    return routerHistory;
}
/**
 * Creates a hash history. Useful for web applications with no host (e.g. `file://`) or when configuring a server to
 * handle any URL is not possible.
 *
 * @param base - optional base to provide. Defaults to `location.pathname + location.search` If there is a `<base>` tag
 * in the `head`, its value will be ignored in favor of this parameter **but note it affects all the history.pushState()
 * calls**, meaning that if you use a `<base>` tag, it's `href` value **has to match this parameter** (ignoring anything
 * after the `#`).
 *
 * @example
 * ```js
 * // at https://example.com/folder
 * createWebHashHistory() // gives a url of `https://example.com/folder#`
 * createWebHashHistory('/folder/') // gives a url of `https://example.com/folder/#`
 * // if the `#` is provided in the base, it won't be added by `createWebHashHistory`
 * createWebHashHistory('/folder/#/app/') // gives a url of `https://example.com/folder/#/app/`
 * // you should avoid doing this because it changes the original url and breaks copying urls
 * createWebHashHistory('/other-folder/') // gives a url of `https://example.com/other-folder/#`
 *
 * // at file:///usr/etc/folder/index.html
 * // for locations with no `host`, the base is ignored
 * createWebHashHistory('/iAmIgnored') // gives a url of `file:///usr/etc/folder/index.html#`
 * ```
 */ function $a809ac530d32f081$export$542bc3a76486c94d(base) {
    // Make sure this implementation is fine in terms of encoding, specially for IE11
    // for `file://`, directly use the pathname and ignore the base
    // location.pathname contains an initial `/` even at the root: `https://example.com`
    base = location.host ? base || location.pathname + location.search : '';
    // allow the user to provide a `#` in the middle: `/base/#/app`
    if (!base.includes('#')) base += '#';
    return $a809ac530d32f081$export$7b4942f78e7b8a49(base);
}
function $a809ac530d32f081$var$isRouteLocation(route) {
    return typeof route === 'string' || route && typeof route === 'object';
}
function $a809ac530d32f081$var$isRouteName(name) {
    return typeof name === 'string' || typeof name === 'symbol';
}
const $a809ac530d32f081$var$NavigationFailureSymbol = Symbol('');
/**
 * Enumeration with all possible types for navigation failures. Can be passed to
 * {@link isNavigationFailure} to check for specific failures.
 */ var $a809ac530d32f081$export$35710516f95d6a57;
(function(NavigationFailureType) {
    /**
     * An aborted navigation is a navigation that failed because a navigation
     * guard returned `false` or called `next(false)`
     */ NavigationFailureType[NavigationFailureType["aborted"] = 4] = "aborted";
    /**
     * A cancelled navigation is a navigation that failed because a more recent
     * navigation finished started (not necessarily finished).
     */ NavigationFailureType[NavigationFailureType["cancelled"] = 8] = "cancelled";
    /**
     * A duplicated navigation is a navigation that failed because it was
     * initiated while already being at the exact same location.
     */ NavigationFailureType[NavigationFailureType["duplicated"] = 16] = "duplicated";
})($a809ac530d32f081$export$35710516f95d6a57 || ($a809ac530d32f081$export$35710516f95d6a57 = {}));
// DEV only debug messages
const $a809ac530d32f081$var$ErrorTypeMessages = {
    [1 /* ErrorTypes.MATCHER_NOT_FOUND */ ] ({ location: location1, currentLocation: currentLocation }) {
        return `No match for\n ${JSON.stringify(location1)}${currentLocation ? '\nwhile being at\n' + JSON.stringify(currentLocation) : ''}`;
    },
    [2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ ] ({ from: from, to: to }) {
        return `Redirected from "${from.fullPath}" to "${$a809ac530d32f081$var$stringifyRoute(to)}" via a navigation guard.`;
    },
    [4 /* ErrorTypes.NAVIGATION_ABORTED */ ] ({ from: from, to: to }) {
        return `Navigation aborted from "${from.fullPath}" to "${to.fullPath}" via a navigation guard.`;
    },
    [8 /* ErrorTypes.NAVIGATION_CANCELLED */ ] ({ from: from, to: to }) {
        return `Navigation cancelled from "${from.fullPath}" to "${to.fullPath}" with a new navigation.`;
    },
    [16 /* ErrorTypes.NAVIGATION_DUPLICATED */ ] ({ from: from, to: to }) {
        return `Avoided redundant navigation to current location: "${from.fullPath}".`;
    }
};
/**
 * Creates a typed NavigationFailure object.
 * @internal
 * @param type - NavigationFailureType
 * @param params - { from, to }
 */ function $a809ac530d32f081$var$createRouterError(type, params) {
    return $a809ac530d32f081$var$assign(new Error(), {
        type: type,
        [$a809ac530d32f081$var$NavigationFailureSymbol]: true
    }, params);
}
function $a809ac530d32f081$export$873de56207a30e5a(error, type) {
    return error instanceof Error && $a809ac530d32f081$var$NavigationFailureSymbol in error && (type == null || !!(error.type & type));
}
const $a809ac530d32f081$var$propertiesToLog = [
    'params',
    'query',
    'hash'
];
function $a809ac530d32f081$var$stringifyRoute(to) {
    if (typeof to === 'string') return to;
    if (to.path != null) return to.path;
    const location1 = {};
    for (const key of $a809ac530d32f081$var$propertiesToLog)if (key in to) location1[key] = to[key];
    return JSON.stringify(location1, null, 2);
}
// default pattern for a param: non-greedy everything but /
const $a809ac530d32f081$var$BASE_PARAM_PATTERN = '[^/]+?';
const $a809ac530d32f081$var$BASE_PATH_PARSER_OPTIONS = {
    sensitive: false,
    strict: false,
    start: true,
    end: true
};
// Special Regex characters that must be escaped in static tokens
const $a809ac530d32f081$var$REGEX_CHARS_RE = /[.+*?^${}()[\]/\\]/g;
/**
 * Creates a path parser from an array of Segments (a segment is an array of Tokens)
 *
 * @param segments - array of segments returned by tokenizePath
 * @param extraOptions - optional options for the regexp
 * @returns a PathParser
 */ function $a809ac530d32f081$var$tokensToParser(segments, extraOptions) {
    const options = $a809ac530d32f081$var$assign({}, $a809ac530d32f081$var$BASE_PATH_PARSER_OPTIONS, extraOptions);
    // the amount of scores is the same as the length of segments except for the root segment "/"
    const score = [];
    // the regexp as a string
    let pattern = options.start ? '^' : '';
    // extracted keys
    const keys = [];
    for (const segment of segments){
        // the root segment needs special treatment
        const segmentScores = segment.length ? [] : [
            90 /* PathScore.Root */ 
        ];
        // allow trailing slash
        if (options.strict && !segment.length) pattern += '/';
        for(let tokenIndex = 0; tokenIndex < segment.length; tokenIndex++){
            const token = segment[tokenIndex];
            // resets the score if we are inside a sub-segment /:a-other-:b
            let subSegmentScore = 40 /* PathScore.Segment */  + (options.sensitive ? 0.25 /* PathScore.BonusCaseSensitive */  : 0);
            if (token.type === 0 /* TokenType.Static */ ) {
                // prepend the slash if we are starting a new segment
                if (!tokenIndex) pattern += '/';
                pattern += token.value.replace($a809ac530d32f081$var$REGEX_CHARS_RE, '\\$&');
                subSegmentScore += 40 /* PathScore.Static */ ;
            } else if (token.type === 1 /* TokenType.Param */ ) {
                const { value: value, repeatable: repeatable, optional: optional, regexp: regexp } = token;
                keys.push({
                    name: value,
                    repeatable: repeatable,
                    optional: optional
                });
                const re = regexp ? regexp : $a809ac530d32f081$var$BASE_PARAM_PATTERN;
                // the user provided a custom regexp /:id(\\d+)
                if (re !== $a809ac530d32f081$var$BASE_PARAM_PATTERN) {
                    subSegmentScore += 10 /* PathScore.BonusCustomRegExp */ ;
                    // make sure the regexp is valid before using it
                    try {
                        new RegExp(`(${re})`);
                    } catch (err) {
                        throw new Error(`Invalid custom RegExp for param "${value}" (${re}): ` + err.message);
                    }
                }
                // when we repeat we must take care of the repeating leading slash
                let subPattern = repeatable ? `((?:${re})(?:/(?:${re}))*)` : `(${re})`;
                // prepend the slash if we are starting a new segment
                if (!tokenIndex) subPattern = // avoid an optional / if there are more segments e.g. /:p?-static
                // or /:p?-:p2
                optional && segment.length < 2 ? `(?:/${subPattern})` : '/' + subPattern;
                if (optional) subPattern += '?';
                pattern += subPattern;
                subSegmentScore += 20 /* PathScore.Dynamic */ ;
                if (optional) subSegmentScore += -8 /* PathScore.BonusOptional */ ;
                if (repeatable) subSegmentScore += -20 /* PathScore.BonusRepeatable */ ;
                if (re === '.*') subSegmentScore += -50 /* PathScore.BonusWildcard */ ;
            }
            segmentScores.push(subSegmentScore);
        }
        // an empty array like /home/ -> [[{home}], []]
        // if (!segment.length) pattern += '/'
        score.push(segmentScores);
    }
    // only apply the strict bonus to the last score
    if (options.strict && options.end) {
        const i = score.length - 1;
        score[i][score[i].length - 1] += 0.7000000000000001 /* PathScore.BonusStrict */ ;
    }
    // TODO: dev only warn double trailing slash
    if (!options.strict) pattern += '/?';
    if (options.end) pattern += '$';
    else if (options.strict && !pattern.endsWith('/')) pattern += '(?:/|$)';
    const re = new RegExp(pattern, options.sensitive ? '' : 'i');
    function parse(path) {
        const match = path.match(re);
        const params = {};
        if (!match) return null;
        for(let i = 1; i < match.length; i++){
            const value = match[i] || '';
            const key = keys[i - 1];
            params[key.name] = value && key.repeatable ? value.split('/') : value;
        }
        return params;
    }
    function stringify(params) {
        let path = '';
        // for optional parameters to allow to be empty
        let avoidDuplicatedSlash = false;
        for (const segment of segments){
            if (!avoidDuplicatedSlash || !path.endsWith('/')) path += '/';
            avoidDuplicatedSlash = false;
            for (const token of segment){
                if (token.type === 0 /* TokenType.Static */ ) path += token.value;
                else if (token.type === 1 /* TokenType.Param */ ) {
                    const { value: value, repeatable: repeatable, optional: optional } = token;
                    const param = value in params ? params[value] : '';
                    if ($a809ac530d32f081$var$isArray(param) && !repeatable) throw new Error(`Provided param "${value}" is an array but it is not repeatable (* or + modifiers)`);
                    const text = $a809ac530d32f081$var$isArray(param) ? param.join('/') : param;
                    if (!text) {
                        if (optional) // if we have more than one optional param like /:a?-static we don't need to care about the optional param
                        {
                            if (segment.length < 2) {
                                // remove the last slash as we could be at the end
                                if (path.endsWith('/')) path = path.slice(0, -1);
                                else avoidDuplicatedSlash = true;
                            }
                        } else throw new Error(`Missing required param "${value}"`);
                    }
                    path += text;
                }
            }
        }
        // avoid empty path when we have multiple optional params
        return path || '/';
    }
    return {
        re: re,
        score: score,
        keys: keys,
        parse: parse,
        stringify: stringify
    };
}
/**
 * Compares an array of numbers as used in PathParser.score and returns a
 * number. This function can be used to `sort` an array
 *
 * @param a - first array of numbers
 * @param b - second array of numbers
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 * should be sorted first
 */ function $a809ac530d32f081$var$compareScoreArray(a, b) {
    let i = 0;
    while(i < a.length && i < b.length){
        const diff = b[i] - a[i];
        // only keep going if diff === 0
        if (diff) return diff;
        i++;
    }
    // if the last subsegment was Static, the shorter segments should be sorted first
    // otherwise sort the longest segment first
    if (a.length < b.length) return a.length === 1 && a[0] === 80 /* PathScore.Segment */  ? -1 : 1;
    else if (a.length > b.length) return b.length === 1 && b[0] === 80 /* PathScore.Segment */  ? 1 : -1;
    return 0;
}
/**
 * Compare function that can be used with `sort` to sort an array of PathParser
 *
 * @param a - first PathParser
 * @param b - second PathParser
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 */ function $a809ac530d32f081$var$comparePathParserScore(a, b) {
    let i = 0;
    const aScore = a.score;
    const bScore = b.score;
    while(i < aScore.length && i < bScore.length){
        const comp = $a809ac530d32f081$var$compareScoreArray(aScore[i], bScore[i]);
        // do not return if both are equal
        if (comp) return comp;
        i++;
    }
    if (Math.abs(bScore.length - aScore.length) === 1) {
        if ($a809ac530d32f081$var$isLastScoreNegative(aScore)) return 1;
        if ($a809ac530d32f081$var$isLastScoreNegative(bScore)) return -1;
    }
    // if a and b share the same score entries but b has more, sort b first
    return bScore.length - aScore.length;
// this is the ternary version
// return aScore.length < bScore.length
//   ? 1
//   : aScore.length > bScore.length
//   ? -1
//   : 0
}
/**
 * This allows detecting splats at the end of a path: /home/:id(.*)*
 *
 * @param score - score to check
 * @returns true if the last entry is negative
 */ function $a809ac530d32f081$var$isLastScoreNegative(score) {
    const last = score[score.length - 1];
    return score.length > 0 && last[last.length - 1] < 0;
}
const $a809ac530d32f081$var$ROOT_TOKEN = {
    type: 0 /* TokenType.Static */ ,
    value: ''
};
const $a809ac530d32f081$var$VALID_PARAM_RE = /[a-zA-Z0-9_]/;
// After some profiling, the cache seems to be unnecessary because tokenizePath
// (the slowest part of adding a route) is very fast
// const tokenCache = new Map<string, Token[][]>()
function $a809ac530d32f081$var$tokenizePath(path) {
    if (!path) return [
        []
    ];
    if (path === '/') return [
        [
            $a809ac530d32f081$var$ROOT_TOKEN
        ]
    ];
    if (!path.startsWith('/')) throw new Error(`Invalid path "${path}"`);
    // if (tokenCache.has(path)) return tokenCache.get(path)!
    function crash(message) {
        throw new Error(`ERR (${state})/"${buffer}": ${message}`);
    }
    let state = 0 /* TokenizerState.Static */ ;
    let previousState = state;
    const tokens = [];
    // the segment will always be valid because we get into the initial state
    // with the leading /
    let segment;
    function finalizeSegment() {
        if (segment) tokens.push(segment);
        segment = [];
    }
    // index on the path
    let i = 0;
    // char at index
    let char;
    // buffer of the value read
    let buffer = '';
    // custom regexp for a param
    let customRe = '';
    function consumeBuffer() {
        if (!buffer) return;
        if (state === 0 /* TokenizerState.Static */ ) segment.push({
            type: 0 /* TokenType.Static */ ,
            value: buffer
        });
        else if (state === 1 /* TokenizerState.Param */  || state === 2 /* TokenizerState.ParamRegExp */  || state === 3 /* TokenizerState.ParamRegExpEnd */ ) {
            if (segment.length > 1 && (char === '*' || char === '+')) crash(`A repeatable param (${buffer}) must be alone in its segment. eg: '/:ids+.`);
            segment.push({
                type: 1 /* TokenType.Param */ ,
                value: buffer,
                regexp: customRe,
                repeatable: char === '*' || char === '+',
                optional: char === '*' || char === '?'
            });
        } else crash('Invalid state to consume buffer');
        buffer = '';
    }
    function addCharToBuffer() {
        buffer += char;
    }
    while(i < path.length){
        char = path[i++];
        if (char === '\\' && state !== 2 /* TokenizerState.ParamRegExp */ ) {
            previousState = state;
            state = 4 /* TokenizerState.EscapeNext */ ;
            continue;
        }
        switch(state){
            case 0 /* TokenizerState.Static */ :
                if (char === '/') {
                    if (buffer) consumeBuffer();
                    finalizeSegment();
                } else if (char === ':') {
                    consumeBuffer();
                    state = 1 /* TokenizerState.Param */ ;
                } else addCharToBuffer();
                break;
            case 4 /* TokenizerState.EscapeNext */ :
                addCharToBuffer();
                state = previousState;
                break;
            case 1 /* TokenizerState.Param */ :
                if (char === '(') state = 2 /* TokenizerState.ParamRegExp */ ;
                else if ($a809ac530d32f081$var$VALID_PARAM_RE.test(char)) addCharToBuffer();
                else {
                    consumeBuffer();
                    state = 0 /* TokenizerState.Static */ ;
                    // go back one character if we were not modifying
                    if (char !== '*' && char !== '?' && char !== '+') i--;
                }
                break;
            case 2 /* TokenizerState.ParamRegExp */ :
                // TODO: is it worth handling nested regexp? like :p(?:prefix_([^/]+)_suffix)
                // it already works by escaping the closing )
                // https://paths.esm.dev/?p=AAMeJbiAwQEcDKbAoAAkP60PG2R6QAvgNaA6AFACM2ABuQBB#
                // is this really something people need since you can also write
                // /prefix_:p()_suffix
                if (char === ')') {
                    // handle the escaped )
                    if (customRe[customRe.length - 1] == '\\') customRe = customRe.slice(0, -1) + char;
                    else state = 3 /* TokenizerState.ParamRegExpEnd */ ;
                } else customRe += char;
                break;
            case 3 /* TokenizerState.ParamRegExpEnd */ :
                // same as finalizing a param
                consumeBuffer();
                state = 0 /* TokenizerState.Static */ ;
                // go back one character if we were not modifying
                if (char !== '*' && char !== '?' && char !== '+') i--;
                customRe = '';
                break;
            default:
                crash('Unknown state');
                break;
        }
    }
    if (state === 2 /* TokenizerState.ParamRegExp */ ) crash(`Unfinished custom RegExp for param "${buffer}"`);
    consumeBuffer();
    finalizeSegment();
    // tokenCache.set(path, tokens)
    return tokens;
}
function $a809ac530d32f081$var$createRouteRecordMatcher(record, parent, options) {
    const parser = $a809ac530d32f081$var$tokensToParser($a809ac530d32f081$var$tokenizePath(record.path), options);
    const matcher = $a809ac530d32f081$var$assign(parser, {
        record: record,
        parent: parent,
        // these needs to be populated by the parent
        children: [],
        alias: []
    });
    if (parent) // both are aliases or both are not aliases
    // we don't want to mix them because the order is used when
    // passing originalRecord in Matcher.addRoute
    {
        if (!matcher.record.aliasOf === !parent.record.aliasOf) parent.children.push(matcher);
    }
    return matcher;
}
/**
 * Creates a Router Matcher.
 *
 * @internal
 * @param routes - array of initial routes
 * @param globalOptions - global route options
 */ function $a809ac530d32f081$export$36302c85fdcc95a8(routes, globalOptions) {
    // normalized ordered array of matchers
    const matchers = [];
    const matcherMap = new Map();
    globalOptions = $a809ac530d32f081$var$mergeOptions({
        strict: false,
        end: true,
        sensitive: false
    }, globalOptions);
    function getRecordMatcher(name) {
        return matcherMap.get(name);
    }
    function addRoute(record, parent, originalRecord) {
        // used later on to remove by name
        const isRootAdd = !originalRecord;
        const mainNormalizedRecord = $a809ac530d32f081$var$normalizeRouteRecord(record);
        // we might be the child of an alias
        mainNormalizedRecord.aliasOf = originalRecord && originalRecord.record;
        const options = $a809ac530d32f081$var$mergeOptions(globalOptions, record);
        // generate an array of records to correctly handle aliases
        const normalizedRecords = [
            mainNormalizedRecord
        ];
        if ('alias' in record) {
            const aliases = typeof record.alias === 'string' ? [
                record.alias
            ] : record.alias;
            for (const alias of aliases)normalizedRecords.push(// we need to normalize again to ensure the `mods` property
            // being non enumerable
            $a809ac530d32f081$var$normalizeRouteRecord($a809ac530d32f081$var$assign({}, mainNormalizedRecord, {
                // this allows us to hold a copy of the `components` option
                // so that async components cache is hold on the original record
                components: originalRecord ? originalRecord.record.components : mainNormalizedRecord.components,
                path: alias,
                // we might be the child of an alias
                aliasOf: originalRecord ? originalRecord.record : mainNormalizedRecord
            })));
        }
        let matcher;
        let originalMatcher;
        for (const normalizedRecord of normalizedRecords){
            const { path: path } = normalizedRecord;
            // Build up the path for nested routes if the child isn't an absolute
            // route. Only add the / delimiter if the child path isn't empty and if the
            // parent path doesn't have a trailing slash
            if (parent && path[0] !== '/') {
                const parentPath = parent.record.path;
                const connectingSlash = parentPath[parentPath.length - 1] === '/' ? '' : '/';
                normalizedRecord.path = parent.record.path + (path && connectingSlash + path);
            }
            // create the object beforehand, so it can be passed to children
            matcher = $a809ac530d32f081$var$createRouteRecordMatcher(normalizedRecord, parent, options);
            // if we are an alias we must tell the original record that we exist,
            // so we can be removed
            if (originalRecord) originalRecord.alias.push(matcher);
            else {
                // otherwise, the first record is the original and others are aliases
                originalMatcher = originalMatcher || matcher;
                if (originalMatcher !== matcher) originalMatcher.alias.push(matcher);
                // remove the route if named and only for the top record (avoid in nested calls)
                // this works because the original record is the first one
                if (isRootAdd && record.name && !$a809ac530d32f081$var$isAliasRecord(matcher)) removeRoute(record.name);
            }
            // Avoid adding a record that doesn't display anything. This allows passing through records without a component to
            // not be reached and pass through the catch all route
            if ($a809ac530d32f081$var$isMatchable(matcher)) insertMatcher(matcher);
            if (mainNormalizedRecord.children) {
                const children = mainNormalizedRecord.children;
                for(let i = 0; i < children.length; i++)addRoute(children[i], matcher, originalRecord && originalRecord.children[i]);
            }
            // if there was no original record, then the first one was not an alias and all
            // other aliases (if any) need to reference this record when adding children
            originalRecord = originalRecord || matcher;
        // TODO: add normalized records for more flexibility
        // if (parent && isAliasRecord(originalRecord)) {
        //   parent.children.push(originalRecord)
        // }
        }
        return originalMatcher ? ()=>{
            // since other matchers are aliases, they should be removed by the original matcher
            removeRoute(originalMatcher);
        } : $a809ac530d32f081$var$noop;
    }
    function removeRoute(matcherRef) {
        if ($a809ac530d32f081$var$isRouteName(matcherRef)) {
            const matcher = matcherMap.get(matcherRef);
            if (matcher) {
                matcherMap.delete(matcherRef);
                matchers.splice(matchers.indexOf(matcher), 1);
                matcher.children.forEach(removeRoute);
                matcher.alias.forEach(removeRoute);
            }
        } else {
            const index = matchers.indexOf(matcherRef);
            if (index > -1) {
                matchers.splice(index, 1);
                if (matcherRef.record.name) matcherMap.delete(matcherRef.record.name);
                matcherRef.children.forEach(removeRoute);
                matcherRef.alias.forEach(removeRoute);
            }
        }
    }
    function getRoutes() {
        return matchers;
    }
    function insertMatcher(matcher) {
        const index = $a809ac530d32f081$var$findInsertionIndex(matcher, matchers);
        matchers.splice(index, 0, matcher);
        // only add the original record to the name map
        if (matcher.record.name && !$a809ac530d32f081$var$isAliasRecord(matcher)) matcherMap.set(matcher.record.name, matcher);
    }
    function resolve(location1, currentLocation) {
        let matcher;
        let params = {};
        let path;
        let name;
        if ('name' in location1 && location1.name) {
            matcher = matcherMap.get(location1.name);
            if (!matcher) throw $a809ac530d32f081$var$createRouterError(1 /* ErrorTypes.MATCHER_NOT_FOUND */ , {
                location: location1
            });
            name = matcher.record.name;
            params = $a809ac530d32f081$var$assign(// paramsFromLocation is a new object
            $a809ac530d32f081$var$paramsFromLocation(currentLocation.params, // only keep params that exist in the resolved location
            // only keep optional params coming from a parent record
            matcher.keys.filter((k)=>!k.optional).concat(matcher.parent ? matcher.parent.keys.filter((k)=>k.optional) : []).map((k)=>k.name)), // discard any existing params in the current location that do not exist here
            // #1497 this ensures better active/exact matching
            location1.params && $a809ac530d32f081$var$paramsFromLocation(location1.params, matcher.keys.map((k)=>k.name)));
            // throws if cannot be stringified
            path = matcher.stringify(params);
        } else if (location1.path != null) {
            // no need to resolve the path with the matcher as it was provided
            // this also allows the user to control the encoding
            path = location1.path;
            matcher = matchers.find((m)=>m.re.test(path));
            // matcher should have a value after the loop
            if (matcher) {
                // we know the matcher works because we tested the regexp
                params = matcher.parse(path);
                name = matcher.record.name;
            }
        // location is a relative path
        } else {
            // match by name or path of current route
            matcher = currentLocation.name ? matcherMap.get(currentLocation.name) : matchers.find((m)=>m.re.test(currentLocation.path));
            if (!matcher) throw $a809ac530d32f081$var$createRouterError(1 /* ErrorTypes.MATCHER_NOT_FOUND */ , {
                location: location1,
                currentLocation: currentLocation
            });
            name = matcher.record.name;
            // since we are navigating to the same location, we don't need to pick the
            // params like when `name` is provided
            params = $a809ac530d32f081$var$assign({}, currentLocation.params, location1.params);
            path = matcher.stringify(params);
        }
        const matched = [];
        let parentMatcher = matcher;
        while(parentMatcher){
            // reversed order so parents are at the beginning
            matched.unshift(parentMatcher.record);
            parentMatcher = parentMatcher.parent;
        }
        return {
            name: name,
            path: path,
            params: params,
            matched: matched,
            meta: $a809ac530d32f081$var$mergeMetaFields(matched)
        };
    }
    // add initial routes
    routes.forEach((route)=>addRoute(route));
    function clearRoutes() {
        matchers.length = 0;
        matcherMap.clear();
    }
    return {
        addRoute: addRoute,
        resolve: resolve,
        removeRoute: removeRoute,
        clearRoutes: clearRoutes,
        getRoutes: getRoutes,
        getRecordMatcher: getRecordMatcher
    };
}
function $a809ac530d32f081$var$paramsFromLocation(params, keys) {
    const newParams = {};
    for (const key of keys)if (key in params) newParams[key] = params[key];
    return newParams;
}
/**
 * Normalizes a RouteRecordRaw. Creates a copy
 *
 * @param record
 * @returns the normalized version
 */ function $a809ac530d32f081$var$normalizeRouteRecord(record) {
    const normalized = {
        path: record.path,
        redirect: record.redirect,
        name: record.name,
        meta: record.meta || {},
        aliasOf: record.aliasOf,
        beforeEnter: record.beforeEnter,
        props: $a809ac530d32f081$var$normalizeRecordProps(record),
        children: record.children || [],
        instances: {},
        leaveGuards: new Set(),
        updateGuards: new Set(),
        enterCallbacks: {},
        // must be declared afterwards
        // mods: {},
        components: 'components' in record ? record.components || null : record.component && {
            default: record.component
        }
    };
    // mods contain modules and shouldn't be copied,
    // logged or anything. It's just used for internal
    // advanced use cases like data loaders
    Object.defineProperty(normalized, 'mods', {
        value: {}
    });
    return normalized;
}
/**
 * Normalize the optional `props` in a record to always be an object similar to
 * components. Also accept a boolean for components.
 * @param record
 */ function $a809ac530d32f081$var$normalizeRecordProps(record) {
    const propsObject = {};
    // props does not exist on redirect records, but we can set false directly
    const props = record.props || false;
    if ('component' in record) propsObject.default = props;
    else // NOTE: we could also allow a function to be applied to every component.
    // Would need user feedback for use cases
    for(const name in record.components)propsObject[name] = typeof props === 'object' ? props[name] : props;
    return propsObject;
}
/**
 * Checks if a record or any of its parent is an alias
 * @param record
 */ function $a809ac530d32f081$var$isAliasRecord(record) {
    while(record){
        if (record.record.aliasOf) return true;
        record = record.parent;
    }
    return false;
}
/**
 * Merge meta fields of an array of records
 *
 * @param matched - array of matched records
 */ function $a809ac530d32f081$var$mergeMetaFields(matched) {
    return matched.reduce((meta, record)=>$a809ac530d32f081$var$assign(meta, record.meta), {});
}
function $a809ac530d32f081$var$mergeOptions(defaults, partialOptions) {
    const options = {};
    for(const key in defaults)options[key] = key in partialOptions ? partialOptions[key] : defaults[key];
    return options;
}
function $a809ac530d32f081$var$isSameParam(a, b) {
    return a.name === b.name && a.optional === b.optional && a.repeatable === b.repeatable;
}
/**
 * Check if a path and its alias have the same required params
 *
 * @param a - original record
 * @param b - alias record
 */ function $a809ac530d32f081$var$checkSameParams(a, b) {
    for (const key of a.keys){
        if (!key.optional && !b.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return $a809ac530d32f081$var$warn(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    }
    for (const key of b.keys){
        if (!key.optional && !a.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return $a809ac530d32f081$var$warn(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    }
}
/**
 * A route with a name and a child with an empty path without a name should warn when adding the route
 *
 * @param mainNormalizedRecord - RouteRecordNormalized
 * @param parent - RouteRecordMatcher
 */ function $a809ac530d32f081$var$checkChildMissingNameWithEmptyPath(mainNormalizedRecord, parent) {
    if (parent && parent.record.name && !mainNormalizedRecord.name && !mainNormalizedRecord.path) $a809ac530d32f081$var$warn(`The route named "${String(parent.record.name)}" has a child without a name and an empty path. Using that name won't render the empty path child so you probably want to move the name to the child instead. If this is intentional, add a name to the child route to remove the warning.`);
}
function $a809ac530d32f081$var$checkSameNameAsAncestor(record, parent) {
    for(let ancestor = parent; ancestor; ancestor = ancestor.parent){
        if (ancestor.record.name === record.name) throw new Error(`A route named "${String(record.name)}" has been added as a ${parent === ancestor ? 'child' : 'descendant'} of a route with the same name. Route names must be unique and a nested route cannot use the same name as an ancestor.`);
    }
}
function $a809ac530d32f081$var$checkMissingParamsInAbsolutePath(record, parent) {
    for (const key of parent.keys){
        if (!record.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return $a809ac530d32f081$var$warn(`Absolute path "${record.record.path}" must have the exact same param named "${key.name}" as its parent "${parent.record.path}".`);
    }
}
/**
 * Performs a binary search to find the correct insertion index for a new matcher.
 *
 * Matchers are primarily sorted by their score. If scores are tied then we also consider parent/child relationships,
 * with descendants coming before ancestors. If there's still a tie, new routes are inserted after existing routes.
 *
 * @param matcher - new matcher to be inserted
 * @param matchers - existing matchers
 */ function $a809ac530d32f081$var$findInsertionIndex(matcher, matchers) {
    // First phase: binary search based on score
    let lower = 0;
    let upper = matchers.length;
    while(lower !== upper){
        const mid = lower + upper >> 1;
        const sortOrder = $a809ac530d32f081$var$comparePathParserScore(matcher, matchers[mid]);
        if (sortOrder < 0) upper = mid;
        else lower = mid + 1;
    }
    // Second phase: check for an ancestor with the same score
    const insertionAncestor = $a809ac530d32f081$var$getInsertionAncestor(matcher);
    if (insertionAncestor) upper = matchers.lastIndexOf(insertionAncestor, upper - 1);
    return upper;
}
function $a809ac530d32f081$var$getInsertionAncestor(matcher) {
    let ancestor = matcher;
    while(ancestor = ancestor.parent){
        if ($a809ac530d32f081$var$isMatchable(ancestor) && $a809ac530d32f081$var$comparePathParserScore(matcher, ancestor) === 0) return ancestor;
    }
    return;
}
/**
 * Checks if a matcher can be reachable. This means if it's possible to reach it as a route. For example, routes without
 * a component, or name, or redirect, are just used to group other routes.
 * @param matcher
 * @param matcher.record record of the matcher
 * @returns
 */ function $a809ac530d32f081$var$isMatchable({ record: record }) {
    return !!(record.name || record.components && Object.keys(record.components).length || record.redirect);
}
/**
 * Transforms a queryString into a {@link LocationQuery} object. Accept both, a
 * version with the leading `?` and without Should work as URLSearchParams

 * @internal
 *
 * @param search - search string to parse
 * @returns a query object
 */ function $a809ac530d32f081$export$1e8473eaf75b0d10(search) {
    const query = {};
    // avoid creating an object with an empty key and empty value
    // because of split('&')
    if (search === '' || search === '?') return query;
    const hasLeadingIM = search[0] === '?';
    const searchParams = (hasLeadingIM ? search.slice(1) : search).split('&');
    for(let i = 0; i < searchParams.length; ++i){
        // pre decode the + into space
        const searchParam = searchParams[i].replace($a809ac530d32f081$var$PLUS_RE, ' ');
        // allow the = character
        const eqPos = searchParam.indexOf('=');
        const key = $a809ac530d32f081$var$decode(eqPos < 0 ? searchParam : searchParam.slice(0, eqPos));
        const value = eqPos < 0 ? null : $a809ac530d32f081$var$decode(searchParam.slice(eqPos + 1));
        if (key in query) {
            // an extra variable for ts types
            let currentValue = query[key];
            if (!$a809ac530d32f081$var$isArray(currentValue)) currentValue = query[key] = [
                currentValue
            ];
            currentValue.push(value);
        } else query[key] = value;
    }
    return query;
}
/**
 * Stringifies a {@link LocationQueryRaw} object. Like `URLSearchParams`, it
 * doesn't prepend a `?`
 *
 * @internal
 *
 * @param query - query object to stringify
 * @returns string version of the query without the leading `?`
 */ function $a809ac530d32f081$export$d33b45a8f796a30(query) {
    let search = '';
    for(let key in query){
        const value = query[key];
        key = $a809ac530d32f081$var$encodeQueryKey(key);
        if (value == null) {
            // only null adds the value
            if (value !== undefined) search += (search.length ? '&' : '') + key;
            continue;
        }
        // keep null values
        const values = $a809ac530d32f081$var$isArray(value) ? value.map((v)=>v && $a809ac530d32f081$var$encodeQueryValue(v)) : [
            value && $a809ac530d32f081$var$encodeQueryValue(value)
        ];
        values.forEach((value)=>{
            // skip undefined values in arrays as if they were not present
            // smaller code than using filter
            if (value !== undefined) {
                // only append & with non-empty search
                search += (search.length ? '&' : '') + key;
                if (value != null) search += '=' + value;
            }
        });
    }
    return search;
}
/**
 * Transforms a {@link LocationQueryRaw} into a {@link LocationQuery} by casting
 * numbers into strings, removing keys with an undefined value and replacing
 * undefined with null in arrays
 *
 * @param query - query object to normalize
 * @returns a normalized query object
 */ function $a809ac530d32f081$var$normalizeQuery(query) {
    const normalizedQuery = {};
    for(const key in query){
        const value = query[key];
        if (value !== undefined) normalizedQuery[key] = $a809ac530d32f081$var$isArray(value) ? value.map((v)=>v == null ? null : '' + v) : value == null ? value : '' + value;
    }
    return normalizedQuery;
}
/**
 * RouteRecord being rendered by the closest ancestor Router View. Used for
 * `onBeforeRouteUpdate` and `onBeforeRouteLeave`. rvlm stands for Router View
 * Location Matched
 *
 * @internal
 */ const $a809ac530d32f081$export$7f4879db1558672d = Symbol('');
/**
 * Allows overriding the router view depth to control which component in
 * `matched` is rendered. rvd stands for Router View Depth
 *
 * @internal
 */ const $a809ac530d32f081$export$9b3825c34ca1427a = Symbol('');
/**
 * Allows overriding the router instance returned by `useRouter` in tests. r
 * stands for router
 *
 * @internal
 */ const $a809ac530d32f081$export$b6c0da8b9dae491f = Symbol('');
/**
 * Allows overriding the current route returned by `useRoute` in tests. rl
 * stands for route location
 *
 * @internal
 */ const $a809ac530d32f081$export$3aca783e9a3e6e9e = Symbol('');
/**
 * Allows overriding the current route used by router-view. Internally this is
 * used when the `route` prop is passed.
 *
 * @internal
 */ const $a809ac530d32f081$export$54c8124bead129f8 = Symbol('');
/**
 * Create a list of callbacks that can be reset. Used to create before and after navigation guards list
 */ function $a809ac530d32f081$var$useCallbacks() {
    let handlers = [];
    function add(handler) {
        handlers.push(handler);
        return ()=>{
            const i = handlers.indexOf(handler);
            if (i > -1) handlers.splice(i, 1);
        };
    }
    function reset() {
        handlers = [];
    }
    return {
        add: add,
        list: ()=>handlers.slice(),
        reset: reset
    };
}
function $a809ac530d32f081$var$registerGuard(record, name, guard) {
    const removeFromList = ()=>{
        record[name].delete(guard);
    };
    (0, $TusQn.onUnmounted)(removeFromList);
    (0, $TusQn.onDeactivated)(removeFromList);
    (0, $TusQn.onActivated)(()=>{
        record[name].add(guard);
    });
    record[name].add(guard);
}
/**
 * Add a navigation guard that triggers whenever the component for the current
 * location is about to be left. Similar to {@link beforeRouteLeave} but can be
 * used in any component. The guard is removed when the component is unmounted.
 *
 * @param leaveGuard - {@link NavigationGuard}
 */ function $a809ac530d32f081$export$d7fcdd004b009a9e(leaveGuard) {
    const activeRecord = (0, $TusQn.inject)($a809ac530d32f081$export$7f4879db1558672d, // to avoid warning
    {}).value;
    if (!activeRecord) return;
    $a809ac530d32f081$var$registerGuard(activeRecord, 'leaveGuards', leaveGuard);
}
/**
 * Add a navigation guard that triggers whenever the current location is about
 * to be updated. Similar to {@link beforeRouteUpdate} but can be used in any
 * component. The guard is removed when the component is unmounted.
 *
 * @param updateGuard - {@link NavigationGuard}
 */ function $a809ac530d32f081$export$46b4cb99461f4cc7(updateGuard) {
    const activeRecord = (0, $TusQn.inject)($a809ac530d32f081$export$7f4879db1558672d, // to avoid warning
    {}).value;
    if (!activeRecord) return;
    $a809ac530d32f081$var$registerGuard(activeRecord, 'updateGuards', updateGuard);
}
function $a809ac530d32f081$var$guardToPromiseFn(guard, to, from, record, name, runWithContext = (fn)=>fn()) {
    // keep a reference to the enterCallbackArray to prevent pushing callbacks if a new navigation took place
    const enterCallbackArray = record && // name is defined if record is because of the function overload
    (record.enterCallbacks[name] = record.enterCallbacks[name] || []);
    return ()=>new Promise((resolve, reject)=>{
            const next = (valid)=>{
                if (valid === false) reject($a809ac530d32f081$var$createRouterError(4 /* ErrorTypes.NAVIGATION_ABORTED */ , {
                    from: from,
                    to: to
                }));
                else if (valid instanceof Error) reject(valid);
                else if ($a809ac530d32f081$var$isRouteLocation(valid)) reject($a809ac530d32f081$var$createRouterError(2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ , {
                    from: to,
                    to: valid
                }));
                else {
                    if (enterCallbackArray && // since enterCallbackArray is truthy, both record and name also are
                    record.enterCallbacks[name] === enterCallbackArray && typeof valid === 'function') enterCallbackArray.push(valid);
                    resolve();
                }
            };
            // wrapping with Promise.resolve allows it to work with both async and sync guards
            const guardReturn = runWithContext(()=>guard.call(record && record.instances[name], to, from, next));
            let guardCall = Promise.resolve(guardReturn);
            if (guard.length < 3) guardCall = guardCall.then(next);
            var resolvedValue;
            guardCall.catch((err)=>reject(err));
        });
}
function $a809ac530d32f081$var$canOnlyBeCalledOnce(next, to, from) {
    let called = 0;
    return function() {
        if (called++ === 1) $a809ac530d32f081$var$warn(`The "next" callback was called more than once in one navigation guard when going from "${from.fullPath}" to "${to.fullPath}". It should be called exactly one time in each navigation guard. This will fail in production.`);
        // @ts-expect-error: we put it in the original one because it's easier to check
        next._called = true;
        if (called === 1) next.apply(null, arguments);
    };
}
function $a809ac530d32f081$var$extractComponentsGuards(matched, guardType, to, from, runWithContext = (fn)=>fn()) {
    const guards = [];
    for (const record of matched)for(const name in record.components){
        let rawComponent = record.components[name];
        // skip update and leave guards if the route component is not mounted
        if (guardType !== 'beforeRouteEnter' && !record.instances[name]) continue;
        if ($a809ac530d32f081$var$isRouteComponent(rawComponent)) {
            // __vccOpts is added by vue-class-component and contain the regular options
            const options = rawComponent.__vccOpts || rawComponent;
            const guard = options[guardType];
            guard && guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from, record, name, runWithContext));
        } else {
            // start requesting the chunk already
            let componentPromise = rawComponent();
            guards.push(()=>componentPromise.then((resolved)=>{
                    if (!resolved) throw new Error(`Couldn't resolve component "${name}" at "${record.path}"`);
                    const resolvedComponent = $a809ac530d32f081$var$isESModule(resolved) ? resolved.default : resolved;
                    // keep the resolved module for plugins like data loaders
                    record.mods[name] = resolved;
                    // replace the function with the resolved component
                    // cannot be null or undefined because we went into the for loop
                    record.components[name] = resolvedComponent;
                    // __vccOpts is added by vue-class-component and contain the regular options
                    const options = resolvedComponent.__vccOpts || resolvedComponent;
                    const guard = options[guardType];
                    return guard && $a809ac530d32f081$var$guardToPromiseFn(guard, to, from, record, name, runWithContext)();
                }));
        }
    }
    return guards;
}
/**
 * Ensures a route is loaded, so it can be passed as o prop to `<RouterView>`.
 *
 * @param route - resolved route to load
 */ function $a809ac530d32f081$export$d092a02cbf0deea7(route) {
    return route.matched.every((record)=>record.redirect) ? Promise.reject(new Error('Cannot load a route that redirects.')) : Promise.all(route.matched.map((record)=>record.components && Promise.all(Object.keys(record.components).reduce((promises, name)=>{
            const rawComponent = record.components[name];
            if (typeof rawComponent === 'function' && !('displayName' in rawComponent)) promises.push(rawComponent().then((resolved)=>{
                if (!resolved) return Promise.reject(new Error(`Couldn't resolve component "${name}" at "${record.path}". Ensure you passed a function that returns a promise.`));
                const resolvedComponent = $a809ac530d32f081$var$isESModule(resolved) ? resolved.default : resolved;
                // keep the resolved module for plugins like data loaders
                record.mods[name] = resolved;
                // replace the function with the resolved component
                // cannot be null or undefined because we went into the for loop
                record.components[name] = resolvedComponent;
                return;
            }));
            return promises;
        }, [])))).then(()=>route);
}
// TODO: we could allow currentRoute as a prop to expose `isActive` and
// `isExactActive` behavior should go through an RFC
/**
 * Returns the internal behavior of a {@link RouterLink} without the rendering part.
 *
 * @param props - a `to` location and an optional `replace` flag
 */ function $a809ac530d32f081$export$dcf14c9974fe2767(props) {
    const router = (0, $TusQn.inject)($a809ac530d32f081$export$b6c0da8b9dae491f);
    const currentRoute = (0, $TusQn.inject)($a809ac530d32f081$export$3aca783e9a3e6e9e);
    let hasPrevious = false;
    let previousTo = null;
    const route = (0, $01W3b.computed)(()=>{
        const to = (0, $01W3b.unref)(props.to);
        return router.resolve(to);
    });
    const activeRecordIndex = (0, $01W3b.computed)(()=>{
        const { matched: matched } = route.value;
        const { length: length } = matched;
        const routeMatched = matched[length - 1];
        const currentMatched = currentRoute.matched;
        if (!routeMatched || !currentMatched.length) return -1;
        const index = currentMatched.findIndex($a809ac530d32f081$var$isSameRouteRecord.bind(null, routeMatched));
        if (index > -1) return index;
        // possible parent record
        const parentRecordPath = $a809ac530d32f081$var$getOriginalPath(matched[length - 2]);
        return(// we are dealing with nested routes
        length > 1 && // if the parent and matched route have the same path, this link is
        // referring to the empty child. Or we currently are on a different
        // child of the same parent
        $a809ac530d32f081$var$getOriginalPath(routeMatched) === parentRecordPath && // avoid comparing the child with its parent
        currentMatched[currentMatched.length - 1].path !== parentRecordPath ? currentMatched.findIndex($a809ac530d32f081$var$isSameRouteRecord.bind(null, matched[length - 2])) : index);
    });
    const isActive = (0, $01W3b.computed)(()=>activeRecordIndex.value > -1 && $a809ac530d32f081$var$includesParams(currentRoute.params, route.value.params));
    const isExactActive = (0, $01W3b.computed)(()=>activeRecordIndex.value > -1 && activeRecordIndex.value === currentRoute.matched.length - 1 && $a809ac530d32f081$var$isSameRouteLocationParams(currentRoute.params, route.value.params));
    function navigate(e = {}) {
        if ($a809ac530d32f081$var$guardEvent(e)) {
            const p = router[(0, $01W3b.unref)(props.replace) ? 'replace' : 'push']((0, $01W3b.unref)(props.to)).catch($a809ac530d32f081$var$noop);
            if (props.viewTransition && typeof document !== 'undefined' && 'startViewTransition' in document) document.startViewTransition(()=>p);
            return p;
        }
        return Promise.resolve();
    }
    // devtools only
    if (__VUE_PROD_DEVTOOLS__ && $a809ac530d32f081$var$isBrowser) {
        const instance = (0, $TusQn.getCurrentInstance)();
        if (instance) {
            const linkContextDevtools = {
                route: route.value,
                isActive: isActive.value,
                isExactActive: isExactActive.value,
                error: null
            };
            // @ts-expect-error: this is internal
            instance.__vrl_devtools = instance.__vrl_devtools || [];
            // @ts-expect-error: this is internal
            instance.__vrl_devtools.push(linkContextDevtools);
            (0, $TusQn.watchEffect)(()=>{
                linkContextDevtools.route = route.value;
                linkContextDevtools.isActive = isActive.value;
                linkContextDevtools.isExactActive = isExactActive.value;
                linkContextDevtools.error = $a809ac530d32f081$var$isRouteLocation((0, $01W3b.unref)(props.to)) ? null : 'Invalid "to" value';
            }, {
                flush: 'post'
            });
        }
    }
    /**
     * NOTE: update {@link _RouterLinkI}'s `$slots` type when updating this
     */ return {
        route: route,
        href: (0, $01W3b.computed)(()=>route.value.href),
        isActive: isActive,
        isExactActive: isExactActive,
        navigate: navigate
    };
}
function $a809ac530d32f081$var$preferSingleVNode(vnodes) {
    return vnodes.length === 1 ? vnodes[0] : vnodes;
}
const $a809ac530d32f081$var$RouterLinkImpl = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    name: 'RouterLink',
    compatConfig: {
        MODE: 3
    },
    props: {
        to: {
            type: [
                String,
                Object
            ],
            required: true
        },
        replace: Boolean,
        activeClass: String,
        // inactiveClass: String,
        exactActiveClass: String,
        custom: Boolean,
        ariaCurrentValue: {
            type: String,
            default: 'page'
        }
    },
    useLink: $a809ac530d32f081$export$dcf14c9974fe2767,
    setup (props, { slots: slots }) {
        const link = (0, $01W3b.reactive)($a809ac530d32f081$export$dcf14c9974fe2767(props));
        const { options: options } = (0, $TusQn.inject)($a809ac530d32f081$export$b6c0da8b9dae491f);
        const elClass = (0, $01W3b.computed)(()=>({
                [$a809ac530d32f081$var$getLinkClass(props.activeClass, options.linkActiveClass, 'router-link-active')]: link.isActive,
                // [getLinkClass(
                //   props.inactiveClass,
                //   options.linkInactiveClass,
                //   'router-link-inactive'
                // )]: !link.isExactActive,
                [$a809ac530d32f081$var$getLinkClass(props.exactActiveClass, options.linkExactActiveClass, 'router-link-exact-active')]: link.isExactActive
            }));
        return ()=>{
            const children = slots.default && $a809ac530d32f081$var$preferSingleVNode(slots.default(link));
            return props.custom ? children : (0, $TusQn.h)('a', {
                'aria-current': link.isExactActive ? props.ariaCurrentValue : null,
                href: link.href,
                // this would override user added attrs but Vue will still add
                // the listener, so we end up triggering both
                onClick: link.navigate,
                class: elClass.value
            }, children);
        };
    }
});
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to render a link that triggers a navigation on click.
 */ const $a809ac530d32f081$export$fce709ebdac448ed = $a809ac530d32f081$var$RouterLinkImpl;
function $a809ac530d32f081$var$guardEvent(e) {
    // don't redirect with control keys
    if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;
    // don't redirect when preventDefault called
    if (e.defaultPrevented) return;
    // don't redirect on right click
    if (e.button !== undefined && e.button !== 0) return;
    // don't redirect if `target="_blank"`
    // @ts-expect-error getAttribute does exist
    if (e.currentTarget && e.currentTarget.getAttribute) {
        // @ts-expect-error getAttribute exists
        const target = e.currentTarget.getAttribute('target');
        if (/\b_blank\b/i.test(target)) return;
    }
    // this may be a Weex event which doesn't have this method
    if (e.preventDefault) e.preventDefault();
    return true;
}
function $a809ac530d32f081$var$includesParams(outer, inner) {
    for(const key in inner){
        const innerValue = inner[key];
        const outerValue = outer[key];
        if (typeof innerValue === 'string') {
            if (innerValue !== outerValue) return false;
        } else {
            if (!$a809ac530d32f081$var$isArray(outerValue) || outerValue.length !== innerValue.length || innerValue.some((value, i)=>value !== outerValue[i])) return false;
        }
    }
    return true;
}
/**
 * Get the original path value of a record by following its aliasOf
 * @param record
 */ function $a809ac530d32f081$var$getOriginalPath(record) {
    return record ? record.aliasOf ? record.aliasOf.path : record.path : '';
}
/**
 * Utility class to get the active class based on defaults.
 * @param propClass
 * @param globalClass
 * @param defaultClass
 */ const $a809ac530d32f081$var$getLinkClass = (propClass, globalClass, defaultClass)=>propClass != null ? propClass : globalClass != null ? globalClass : defaultClass;
const $a809ac530d32f081$var$RouterViewImpl = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    name: 'RouterView',
    // #674 we manually inherit them
    inheritAttrs: false,
    props: {
        name: {
            type: String,
            default: 'default'
        },
        route: Object
    },
    // Better compat for @vue/compat users
    // https://github.com/vuejs/router/issues/1315
    compatConfig: {
        MODE: 3
    },
    setup (props, { attrs: attrs, slots: slots }) {
        const injectedRoute = (0, $TusQn.inject)($a809ac530d32f081$export$54c8124bead129f8);
        const routeToDisplay = (0, $01W3b.computed)(()=>props.route || injectedRoute.value);
        const injectedDepth = (0, $TusQn.inject)($a809ac530d32f081$export$9b3825c34ca1427a, 0);
        // The depth changes based on empty components option, which allows passthrough routes e.g. routes with children
        // that are used to reuse the `path` property
        const depth = (0, $01W3b.computed)(()=>{
            let initialDepth = (0, $01W3b.unref)(injectedDepth);
            const { matched: matched } = routeToDisplay.value;
            let matchedRoute;
            while((matchedRoute = matched[initialDepth]) && !matchedRoute.components)initialDepth++;
            return initialDepth;
        });
        const matchedRouteRef = (0, $01W3b.computed)(()=>routeToDisplay.value.matched[depth.value]);
        (0, $TusQn.provide)($a809ac530d32f081$export$9b3825c34ca1427a, (0, $01W3b.computed)(()=>depth.value + 1));
        (0, $TusQn.provide)($a809ac530d32f081$export$7f4879db1558672d, matchedRouteRef);
        (0, $TusQn.provide)($a809ac530d32f081$export$54c8124bead129f8, routeToDisplay);
        const viewRef = (0, $01W3b.ref)();
        // watch at the same time the component instance, the route record we are
        // rendering, and the name
        (0, $01W3b.watch)(()=>[
                viewRef.value,
                matchedRouteRef.value,
                props.name
            ], ([instance, to, name], [oldInstance, from, oldName])=>{
            // copy reused instances
            if (to) {
                // this will update the instance for new instances as well as reused
                // instances when navigating to a new route
                to.instances[name] = instance;
                // the component instance is reused for a different route or name, so
                // we copy any saved update or leave guards. With async setup, the
                // mounting component will mount before the matchedRoute changes,
                // making instance === oldInstance, so we check if guards have been
                // added before. This works because we remove guards when
                // unmounting/deactivating components
                if (from && from !== to && instance && instance === oldInstance) {
                    if (!to.leaveGuards.size) to.leaveGuards = from.leaveGuards;
                    if (!to.updateGuards.size) to.updateGuards = from.updateGuards;
                }
            }
            // trigger beforeRouteEnter next callbacks
            if (instance && to && // if there is no instance but to and from are the same this might be
            // the first visit
            (!from || !$a809ac530d32f081$var$isSameRouteRecord(to, from) || !oldInstance)) (to.enterCallbacks[name] || []).forEach((callback)=>callback(instance));
        }, {
            flush: 'post'
        });
        return ()=>{
            const route = routeToDisplay.value;
            // we need the value at the time we render because when we unmount, we
            // navigated to a different location so the value is different
            const currentName = props.name;
            const matchedRoute = matchedRouteRef.value;
            const ViewComponent = matchedRoute && matchedRoute.components[currentName];
            if (!ViewComponent) return $a809ac530d32f081$var$normalizeSlot(slots.default, {
                Component: ViewComponent,
                route: route
            });
            // props from route configuration
            const routePropsOption = matchedRoute.props[currentName];
            const routeProps = routePropsOption ? routePropsOption === true ? route.params : typeof routePropsOption === 'function' ? routePropsOption(route) : routePropsOption : null;
            const onVnodeUnmounted = (vnode)=>{
                // remove the instance reference to prevent leak
                if (vnode.component.isUnmounted) matchedRoute.instances[currentName] = null;
            };
            const component = (0, $TusQn.h)(ViewComponent, $a809ac530d32f081$var$assign({}, routeProps, attrs, {
                onVnodeUnmounted: onVnodeUnmounted,
                ref: viewRef
            }));
            if (__VUE_PROD_DEVTOOLS__ && $a809ac530d32f081$var$isBrowser && component.ref) {
                // TODO: can display if it's an alias, its props
                const info = {
                    depth: depth.value,
                    name: matchedRoute.name,
                    path: matchedRoute.path,
                    meta: matchedRoute.meta
                };
                const internalInstances = $a809ac530d32f081$var$isArray(component.ref) ? component.ref.map((r)=>r.i) : [
                    component.ref.i
                ];
                internalInstances.forEach((instance)=>{
                    // @ts-expect-error
                    instance.__vrv_devtools = info;
                });
            }
            return(// pass the vnode to the slot as a prop.
            // h and <component :is="..."> both accept vnodes
            $a809ac530d32f081$var$normalizeSlot(slots.default, {
                Component: component,
                route: route
            }) || component);
        };
    }
});
function $a809ac530d32f081$var$normalizeSlot(slot, data) {
    if (!slot) return null;
    const slotContent = slot(data);
    return slotContent.length === 1 ? slotContent[0] : slotContent;
}
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to display the current route the user is at.
 */ const $a809ac530d32f081$export$d941f00e9b9a537 = $a809ac530d32f081$var$RouterViewImpl;
// warn against deprecated usage with <transition> & <keep-alive>
// due to functional component being no longer eager in Vue 3
function $a809ac530d32f081$var$warnDeprecatedUsage() {
    const instance = (0, $TusQn.getCurrentInstance)();
    const parentName = instance.parent && instance.parent.type.name;
    const parentSubTreeType = instance.parent && instance.parent.subTree && instance.parent.subTree.type;
    if (parentName && (parentName === 'KeepAlive' || parentName.includes('Transition')) && typeof parentSubTreeType === 'object' && parentSubTreeType.name === 'RouterView') {
        const comp = parentName === 'KeepAlive' ? 'keep-alive' : 'transition';
        $a809ac530d32f081$var$warn(`<router-view> can no longer be used directly inside <transition> or <keep-alive>.\n` + `Use slot props instead:\n\n` + `<router-view v-slot="{ Component }">\n` + `  <${comp}>\n` + `    <component :is="Component" />\n` + `  </${comp}>\n` + `</router-view>`);
    }
}
/**
 * Copies a route location and removes any problematic properties that cannot be shown in devtools (e.g. Vue instances).
 *
 * @param routeLocation - routeLocation to format
 * @param tooltip - optional tooltip
 * @returns a copy of the routeLocation
 */ function $a809ac530d32f081$var$formatRouteLocation(routeLocation, tooltip) {
    const copy = $a809ac530d32f081$var$assign({}, routeLocation, {
        // remove variables that can contain vue instances
        matched: routeLocation.matched.map((matched)=>$a809ac530d32f081$var$omit(matched, [
                'instances',
                'children',
                'aliasOf'
            ]))
    });
    return {
        _custom: {
            type: null,
            readOnly: true,
            display: routeLocation.fullPath,
            tooltip: tooltip,
            value: copy
        }
    };
}
function $a809ac530d32f081$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
// to support multiple router instances
let $a809ac530d32f081$var$routerId = 0;
function $a809ac530d32f081$var$addDevtools(app, router, matcher) {
    // Take over router.beforeEach and afterEach
    // make sure we are not registering the devtool twice
    if (router.__hasDevtools) return;
    router.__hasDevtools = true;
    // increment to support multiple router instances
    const id = $a809ac530d32f081$var$routerId++;
    (0, $j6G8F.setupDevtoolsPlugin)({
        id: 'org.vuejs.router' + (id ? '.' + id : ''),
        label: 'Vue Router',
        packageName: 'vue-router',
        homepage: 'https://router.vuejs.org',
        logo: 'https://router.vuejs.org/logo.png',
        componentStateTypes: [
            'Routing'
        ],
        app: app
    }, (api)=>{
        if (typeof api.now !== 'function') console.warn('[Vue Router]: You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.');
        // display state added by the router
        api.on.inspectComponent((payload, ctx)=>{
            if (payload.instanceData) payload.instanceData.state.push({
                type: 'Routing',
                key: '$route',
                editable: false,
                value: $a809ac530d32f081$var$formatRouteLocation(router.currentRoute.value, 'Current Route')
            });
        });
        // mark router-link as active and display tags on router views
        api.on.visitComponentTree(({ treeNode: node, componentInstance: componentInstance })=>{
            if (componentInstance.__vrv_devtools) {
                const info = componentInstance.__vrv_devtools;
                node.tags.push({
                    label: (info.name ? `${info.name.toString()}: ` : '') + info.path,
                    textColor: 0,
                    tooltip: 'This component is rendered by &lt;router-view&gt;',
                    backgroundColor: $a809ac530d32f081$var$PINK_500
                });
            }
            // if multiple useLink are used
            if ($a809ac530d32f081$var$isArray(componentInstance.__vrl_devtools)) {
                componentInstance.__devtoolsApi = api;
                componentInstance.__vrl_devtools.forEach((devtoolsData)=>{
                    let label = devtoolsData.route.path;
                    let backgroundColor = $a809ac530d32f081$var$ORANGE_400;
                    let tooltip = '';
                    let textColor = 0;
                    if (devtoolsData.error) {
                        label = devtoolsData.error;
                        backgroundColor = $a809ac530d32f081$var$RED_100;
                        textColor = $a809ac530d32f081$var$RED_700;
                    } else if (devtoolsData.isExactActive) {
                        backgroundColor = $a809ac530d32f081$var$LIME_500;
                        tooltip = 'This is exactly active';
                    } else if (devtoolsData.isActive) {
                        backgroundColor = $a809ac530d32f081$var$BLUE_600;
                        tooltip = 'This link is active';
                    }
                    node.tags.push({
                        label: label,
                        textColor: textColor,
                        tooltip: tooltip,
                        backgroundColor: backgroundColor
                    });
                });
            }
        });
        (0, $01W3b.watch)(router.currentRoute, ()=>{
            // refresh active state
            refreshRoutesView();
            api.notifyComponentUpdate();
            api.sendInspectorTree(routerInspectorId);
            api.sendInspectorState(routerInspectorId);
        });
        const navigationsLayerId = 'router:navigations:' + id;
        api.addTimelineLayer({
            id: navigationsLayerId,
            label: `Router${id ? ' ' + id : ''} Navigations`,
            color: 0x40a8c4
        });
        // const errorsLayerId = 'router:errors'
        // api.addTimelineLayer({
        //   id: errorsLayerId,
        //   label: 'Router Errors',
        //   color: 0xea5455,
        // })
        router.onError((error, to)=>{
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: 'Error during Navigation',
                    subtitle: to.fullPath,
                    logType: 'error',
                    time: api.now(),
                    data: {
                        error: error
                    },
                    groupId: to.meta.__navigationId
                }
            });
        });
        // attached to `meta` and used to group events
        let navigationId = 0;
        router.beforeEach((to, from)=>{
            const data = {
                guard: $a809ac530d32f081$var$formatDisplay('beforeEach'),
                from: $a809ac530d32f081$var$formatRouteLocation(from, 'Current Location during this navigation'),
                to: $a809ac530d32f081$var$formatRouteLocation(to, 'Target location')
            };
            // Used to group navigations together, hide from devtools
            Object.defineProperty(to.meta, '__navigationId', {
                value: navigationId++
            });
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    time: api.now(),
                    title: 'Start of navigation',
                    subtitle: to.fullPath,
                    data: data,
                    groupId: to.meta.__navigationId
                }
            });
        });
        router.afterEach((to, from, failure)=>{
            const data = {
                guard: $a809ac530d32f081$var$formatDisplay('afterEach')
            };
            if (failure) {
                data.failure = {
                    _custom: {
                        type: Error,
                        readOnly: true,
                        display: failure ? failure.message : '',
                        tooltip: 'Navigation Failure',
                        value: failure
                    }
                };
                data.status = $a809ac530d32f081$var$formatDisplay("\u274C");
            } else data.status = $a809ac530d32f081$var$formatDisplay("\u2705");
            // we set here to have the right order
            data.from = $a809ac530d32f081$var$formatRouteLocation(from, 'Current Location during this navigation');
            data.to = $a809ac530d32f081$var$formatRouteLocation(to, 'Target location');
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: 'End of navigation',
                    subtitle: to.fullPath,
                    time: api.now(),
                    data: data,
                    logType: failure ? 'warning' : 'default',
                    groupId: to.meta.__navigationId
                }
            });
        });
        /**
         * Inspector of Existing routes
         */ const routerInspectorId = 'router-inspector:' + id;
        api.addInspector({
            id: routerInspectorId,
            label: 'Routes' + (id ? ' ' + id : ''),
            icon: 'book',
            treeFilterPlaceholder: 'Search routes'
        });
        function refreshRoutesView() {
            // the routes view isn't active
            if (!activeRoutesPayload) return;
            const payload = activeRoutesPayload;
            // children routes will appear as nested
            let routes = matcher.getRoutes().filter((route)=>!route.parent || // these routes have a parent with no component which will not appear in the view
                // therefore we still need to include them
                !route.parent.record.components);
            // reset match state to false
            routes.forEach($a809ac530d32f081$var$resetMatchStateOnRouteRecord);
            // apply a match state if there is a payload
            if (payload.filter) routes = routes.filter((route)=>// save matches state based on the payload
                $a809ac530d32f081$var$isRouteMatching(route, payload.filter.toLowerCase()));
            // mark active routes
            routes.forEach((route)=>$a809ac530d32f081$var$markRouteRecordActive(route, router.currentRoute.value));
            payload.rootNodes = routes.map($a809ac530d32f081$var$formatRouteRecordForInspector);
        }
        let activeRoutesPayload;
        api.on.getInspectorTree((payload)=>{
            activeRoutesPayload = payload;
            if (payload.app === app && payload.inspectorId === routerInspectorId) refreshRoutesView();
        });
        /**
         * Display information about the currently selected route record
         */ api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === routerInspectorId) {
                const routes = matcher.getRoutes();
                const route = routes.find((route)=>route.record.__vd_id === payload.nodeId);
                if (route) payload.state = {
                    options: $a809ac530d32f081$var$formatRouteRecordMatcherForStateInspector(route)
                };
            }
        });
        api.sendInspectorTree(routerInspectorId);
        api.sendInspectorState(routerInspectorId);
    });
}
function $a809ac530d32f081$var$modifierForKey(key) {
    if (key.optional) return key.repeatable ? '*' : '?';
    else return key.repeatable ? '+' : '';
}
function $a809ac530d32f081$var$formatRouteRecordMatcherForStateInspector(route) {
    const { record: record } = route;
    const fields = [
        {
            editable: false,
            key: 'path',
            value: record.path
        }
    ];
    if (record.name != null) fields.push({
        editable: false,
        key: 'name',
        value: record.name
    });
    fields.push({
        editable: false,
        key: 'regexp',
        value: route.re
    });
    if (route.keys.length) fields.push({
        editable: false,
        key: 'keys',
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.keys.map((key)=>`${key.name}${$a809ac530d32f081$var$modifierForKey(key)}`).join(' '),
                tooltip: 'Param keys',
                value: route.keys
            }
        }
    });
    if (record.redirect != null) fields.push({
        editable: false,
        key: 'redirect',
        value: record.redirect
    });
    if (route.alias.length) fields.push({
        editable: false,
        key: 'aliases',
        value: route.alias.map((alias)=>alias.record.path)
    });
    if (Object.keys(route.record.meta).length) fields.push({
        editable: false,
        key: 'meta',
        value: route.record.meta
    });
    fields.push({
        key: 'score',
        editable: false,
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.score.map((score)=>score.join(', ')).join(' | '),
                tooltip: 'Score used to sort routes',
                value: route.score
            }
        }
    });
    return fields;
}
/**
 * Extracted from tailwind palette
 */ const $a809ac530d32f081$var$PINK_500 = 0xec4899;
const $a809ac530d32f081$var$BLUE_600 = 0x2563eb;
const $a809ac530d32f081$var$LIME_500 = 0x84cc16;
const $a809ac530d32f081$var$CYAN_400 = 0x22d3ee;
const $a809ac530d32f081$var$ORANGE_400 = 0xfb923c;
// const GRAY_100 = 0xf4f4f5
const $a809ac530d32f081$var$DARK = 0x666666;
const $a809ac530d32f081$var$RED_100 = 0xfee2e2;
const $a809ac530d32f081$var$RED_700 = 0xb91c1c;
function $a809ac530d32f081$var$formatRouteRecordForInspector(route) {
    const tags = [];
    const { record: record } = route;
    if (record.name != null) tags.push({
        label: String(record.name),
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$CYAN_400
    });
    if (record.aliasOf) tags.push({
        label: 'alias',
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$ORANGE_400
    });
    if (route.__vd_match) tags.push({
        label: 'matches',
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$PINK_500
    });
    if (route.__vd_exactActive) tags.push({
        label: 'exact',
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$LIME_500
    });
    if (route.__vd_active) tags.push({
        label: 'active',
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$BLUE_600
    });
    if (record.redirect) tags.push({
        label: typeof record.redirect === 'string' ? `redirect: ${record.redirect}` : 'redirects',
        textColor: 0xffffff,
        backgroundColor: $a809ac530d32f081$var$DARK
    });
    // add an id to be able to select it. Using the `path` is not possible because
    // empty path children would collide with their parents
    let id = record.__vd_id;
    if (id == null) {
        id = String($a809ac530d32f081$var$routeRecordId++);
        record.__vd_id = id;
    }
    return {
        id: id,
        label: record.path,
        tags: tags,
        children: route.children.map($a809ac530d32f081$var$formatRouteRecordForInspector)
    };
}
//  incremental id for route records and inspector state
let $a809ac530d32f081$var$routeRecordId = 0;
const $a809ac530d32f081$var$EXTRACT_REGEXP_RE = /^\/(.*)\/([a-z]*)$/;
function $a809ac530d32f081$var$markRouteRecordActive(route, currentRoute) {
    // no route will be active if matched is empty
    // reset the matching state
    const isExactActive = currentRoute.matched.length && $a809ac530d32f081$var$isSameRouteRecord(currentRoute.matched[currentRoute.matched.length - 1], route.record);
    route.__vd_exactActive = route.__vd_active = isExactActive;
    if (!isExactActive) route.__vd_active = currentRoute.matched.some((match)=>$a809ac530d32f081$var$isSameRouteRecord(match, route.record));
    route.children.forEach((childRoute)=>$a809ac530d32f081$var$markRouteRecordActive(childRoute, currentRoute));
}
function $a809ac530d32f081$var$resetMatchStateOnRouteRecord(route) {
    route.__vd_match = false;
    route.children.forEach($a809ac530d32f081$var$resetMatchStateOnRouteRecord);
}
function $a809ac530d32f081$var$isRouteMatching(route, filter) {
    const found = String(route.re).match($a809ac530d32f081$var$EXTRACT_REGEXP_RE);
    route.__vd_match = false;
    if (!found || found.length < 3) return false;
    // use a regexp without $ at the end to match nested routes better
    const nonEndingRE = new RegExp(found[1].replace(/\$$/, ''), found[2]);
    if (nonEndingRE.test(filter)) {
        // mark children as matches
        route.children.forEach((child)=>$a809ac530d32f081$var$isRouteMatching(child, filter));
        // exception case: `/`
        if (route.record.path !== '/' || filter === '/') {
            route.__vd_match = route.re.test(filter);
            return true;
        }
        // hide the / route
        return false;
    }
    const path = route.record.path.toLowerCase();
    const decodedPath = $a809ac530d32f081$var$decode(path);
    // also allow partial matching on the path
    if (!filter.startsWith('/') && (decodedPath.includes(filter) || path.includes(filter))) return true;
    if (decodedPath.startsWith(filter) || path.startsWith(filter)) return true;
    if (route.record.name && String(route.record.name).includes(filter)) return true;
    return route.children.some((child)=>$a809ac530d32f081$var$isRouteMatching(child, filter));
}
function $a809ac530d32f081$var$omit(obj, keys) {
    const ret = {};
    for(const key in obj)if (!keys.includes(key)) // @ts-expect-error
    ret[key] = obj[key];
    return ret;
}
/**
 * Creates a Router instance that can be used by a Vue app.
 *
 * @param options - {@link RouterOptions}
 */ function $a809ac530d32f081$export$baddd0131ee8c05b(options) {
    const matcher = $a809ac530d32f081$export$36302c85fdcc95a8(options.routes, options);
    const parseQuery$1 = options.parseQuery || $a809ac530d32f081$export$1e8473eaf75b0d10;
    const stringifyQuery$1 = options.stringifyQuery || $a809ac530d32f081$export$d33b45a8f796a30;
    const routerHistory = options.history;
    const beforeGuards = $a809ac530d32f081$var$useCallbacks();
    const beforeResolveGuards = $a809ac530d32f081$var$useCallbacks();
    const afterGuards = $a809ac530d32f081$var$useCallbacks();
    const currentRoute = (0, $01W3b.shallowRef)($a809ac530d32f081$export$e44be9a9779c480b);
    let pendingLocation = $a809ac530d32f081$export$e44be9a9779c480b;
    // leave the scrollRestoration if no scrollBehavior is provided
    if ($a809ac530d32f081$var$isBrowser && options.scrollBehavior && 'scrollRestoration' in history) history.scrollRestoration = 'manual';
    const normalizeParams = $a809ac530d32f081$var$applyToParams.bind(null, (paramValue)=>'' + paramValue);
    const encodeParams = $a809ac530d32f081$var$applyToParams.bind(null, $a809ac530d32f081$var$encodeParam);
    const decodeParams = // @ts-expect-error: intentionally avoid the type check
    $a809ac530d32f081$var$applyToParams.bind(null, $a809ac530d32f081$var$decode);
    function addRoute(parentOrRoute, route) {
        let parent;
        let record;
        if ($a809ac530d32f081$var$isRouteName(parentOrRoute)) {
            parent = matcher.getRecordMatcher(parentOrRoute);
            record = route;
        } else record = parentOrRoute;
        return matcher.addRoute(record, parent);
    }
    function removeRoute(name) {
        const recordMatcher = matcher.getRecordMatcher(name);
        if (recordMatcher) matcher.removeRoute(recordMatcher);
    }
    function getRoutes() {
        return matcher.getRoutes().map((routeMatcher)=>routeMatcher.record);
    }
    function hasRoute(name) {
        return !!matcher.getRecordMatcher(name);
    }
    function resolve(rawLocation, currentLocation) {
        // const resolve: Router['resolve'] = (rawLocation: RouteLocationRaw, currentLocation) => {
        // const objectLocation = routerLocationAsObject(rawLocation)
        // we create a copy to modify it later
        currentLocation = $a809ac530d32f081$var$assign({}, currentLocation || currentRoute.value);
        if (typeof rawLocation === 'string') {
            const locationNormalized = $a809ac530d32f081$var$parseURL(parseQuery$1, rawLocation, currentLocation.path);
            const matchedRoute = matcher.resolve({
                path: locationNormalized.path
            }, currentLocation);
            const href = routerHistory.createHref(locationNormalized.fullPath);
            // locationNormalized is always a new object
            return $a809ac530d32f081$var$assign(locationNormalized, matchedRoute, {
                params: decodeParams(matchedRoute.params),
                hash: $a809ac530d32f081$var$decode(locationNormalized.hash),
                redirectedFrom: undefined,
                href: href
            });
        }
        let matcherLocation;
        // path could be relative in object as well
        if (rawLocation.path != null) matcherLocation = $a809ac530d32f081$var$assign({}, rawLocation, {
            path: $a809ac530d32f081$var$parseURL(parseQuery$1, rawLocation.path, currentLocation.path).path
        });
        else {
            // remove any nullish param
            const targetParams = $a809ac530d32f081$var$assign({}, rawLocation.params);
            for(const key in targetParams)if (targetParams[key] == null) delete targetParams[key];
            // pass encoded values to the matcher, so it can produce encoded path and fullPath
            matcherLocation = $a809ac530d32f081$var$assign({}, rawLocation, {
                params: encodeParams(targetParams)
            });
            // current location params are decoded, we need to encode them in case the
            // matcher merges the params
            currentLocation.params = encodeParams(currentLocation.params);
        }
        const matchedRoute = matcher.resolve(matcherLocation, currentLocation);
        const hash = rawLocation.hash || '';
        // the matcher might have merged current location params, so
        // we need to run the decoding again
        matchedRoute.params = normalizeParams(decodeParams(matchedRoute.params));
        const fullPath = $a809ac530d32f081$var$stringifyURL(stringifyQuery$1, $a809ac530d32f081$var$assign({}, rawLocation, {
            hash: $a809ac530d32f081$var$encodeHash(hash),
            path: matchedRoute.path
        }));
        const href = routerHistory.createHref(fullPath);
        return $a809ac530d32f081$var$assign({
            fullPath: fullPath,
            hash: // keep the hash encoded so fullPath is effectively path + encodedQuery +
            // hash
            hash,
            query: // if the user is using a custom query lib like qs, we might have
            // nested objects, so we keep the query as is, meaning it can contain
            // numbers at `$route.query`, but at the point, the user will have to
            // use their own type anyway.
            // https://github.com/vuejs/router/issues/328#issuecomment-649481567
            stringifyQuery$1 === $a809ac530d32f081$export$d33b45a8f796a30 ? $a809ac530d32f081$var$normalizeQuery(rawLocation.query) : rawLocation.query || {}
        }, matchedRoute, {
            redirectedFrom: undefined,
            href: href
        });
    }
    function locationAsObject(to) {
        return typeof to === 'string' ? $a809ac530d32f081$var$parseURL(parseQuery$1, to, currentRoute.value.path) : $a809ac530d32f081$var$assign({}, to);
    }
    function checkCanceledNavigation(to, from) {
        if (pendingLocation !== to) return $a809ac530d32f081$var$createRouterError(8 /* ErrorTypes.NAVIGATION_CANCELLED */ , {
            from: from,
            to: to
        });
    }
    function push(to) {
        return pushWithRedirect(to);
    }
    function replace(to) {
        return push($a809ac530d32f081$var$assign(locationAsObject(to), {
            replace: true
        }));
    }
    function handleRedirectRecord(to) {
        const lastMatched = to.matched[to.matched.length - 1];
        if (lastMatched && lastMatched.redirect) {
            const { redirect: redirect } = lastMatched;
            let newTargetLocation = typeof redirect === 'function' ? redirect(to) : redirect;
            if (typeof newTargetLocation === 'string') {
                newTargetLocation = newTargetLocation.includes('?') || newTargetLocation.includes('#') ? newTargetLocation = locationAsObject(newTargetLocation) : {
                    path: newTargetLocation
                };
                // @ts-expect-error: force empty params when a string is passed to let
                // the router parse them again
                newTargetLocation.params = {};
            }
            return $a809ac530d32f081$var$assign({
                query: to.query,
                hash: to.hash,
                // avoid transferring params if the redirect has a path
                params: newTargetLocation.path != null ? {} : to.params
            }, newTargetLocation);
        }
    }
    function pushWithRedirect(to, redirectedFrom) {
        const targetLocation = pendingLocation = resolve(to);
        const from = currentRoute.value;
        const data = to.state;
        const force = to.force;
        // to could be a string where `replace` is a function
        const replace = to.replace === true;
        const shouldRedirect = handleRedirectRecord(targetLocation);
        if (shouldRedirect) return pushWithRedirect($a809ac530d32f081$var$assign(locationAsObject(shouldRedirect), {
            state: typeof shouldRedirect === 'object' ? $a809ac530d32f081$var$assign({}, data, shouldRedirect.state) : data,
            force: force,
            replace: replace
        }), // keep original redirectedFrom if it exists
        redirectedFrom || targetLocation);
        // if it was a redirect we already called `pushWithRedirect` above
        const toLocation = targetLocation;
        toLocation.redirectedFrom = redirectedFrom;
        let failure;
        if (!force && $a809ac530d32f081$var$isSameRouteLocation(stringifyQuery$1, from, targetLocation)) {
            failure = $a809ac530d32f081$var$createRouterError(16 /* ErrorTypes.NAVIGATION_DUPLICATED */ , {
                to: toLocation,
                from: from
            });
            // trigger scroll to allow scrolling to the same anchor
            handleScroll(from, from, // this is a push, the only way for it to be triggered from a
            // history.listen is with a redirect, which makes it become a push
            true, // This cannot be the first navigation because the initial location
            // cannot be manually navigated to
            false);
        }
        return (failure ? Promise.resolve(failure) : navigate(toLocation, from)).catch((error)=>$a809ac530d32f081$export$873de56207a30e5a(error) ? $a809ac530d32f081$export$873de56207a30e5a(error, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ ) ? error : markAsReady(error) // also returns the error
             : triggerError(error, toLocation, from)).then((failure)=>{
            if (failure) {
                if ($a809ac530d32f081$export$873de56207a30e5a(failure, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ )) return pushWithRedirect(// keep options
                $a809ac530d32f081$var$assign({
                    replace: // preserve an existing replacement but allow the redirect to override it
                    replace
                }, locationAsObject(failure.to), {
                    state: typeof failure.to === 'object' ? $a809ac530d32f081$var$assign({}, data, failure.to.state) : data,
                    force: force
                }), // preserve the original redirectedFrom if any
                redirectedFrom || toLocation);
            } else // if we fail we don't finalize the navigation
            failure = finalizeNavigation(toLocation, from, true, replace, data);
            triggerAfterEach(toLocation, from, failure);
            return failure;
        });
    }
    /**
     * Helper to reject and skip all navigation guards if a new navigation happened
     * @param to
     * @param from
     */ function checkCanceledNavigationAndReject(to, from) {
        const error = checkCanceledNavigation(to, from);
        return error ? Promise.reject(error) : Promise.resolve();
    }
    function runWithContext(fn) {
        const app = installedApps.values().next().value;
        // support Vue < 3.3
        return app && typeof app.runWithContext === 'function' ? app.runWithContext(fn) : fn();
    }
    // TODO: refactor the whole before guards by internally using router.beforeEach
    function navigate(to, from) {
        let guards;
        const [leavingRecords, updatingRecords, enteringRecords] = $a809ac530d32f081$var$extractChangingRecords(to, from);
        // all components here have been resolved once because we are leaving
        guards = $a809ac530d32f081$var$extractComponentsGuards(leavingRecords.reverse(), 'beforeRouteLeave', to, from);
        // leavingRecords is already reversed
        for (const record of leavingRecords)record.leaveGuards.forEach((guard)=>{
            guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
        });
        const canceledNavigationCheck = checkCanceledNavigationAndReject.bind(null, to, from);
        guards.push(canceledNavigationCheck);
        // run the queue of per route beforeRouteLeave guards
        return runGuardQueue(guards).then(()=>{
            // check global guards beforeEach
            guards = [];
            for (const guard of beforeGuards.list())guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            // check in components beforeRouteUpdate
            guards = $a809ac530d32f081$var$extractComponentsGuards(updatingRecords, 'beforeRouteUpdate', to, from);
            for (const record of updatingRecords)record.updateGuards.forEach((guard)=>{
                guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
            });
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // check the route beforeEnter
            guards = [];
            for (const record of enteringRecords)// do not trigger beforeEnter on reused views
            if (record.beforeEnter) {
                if ($a809ac530d32f081$var$isArray(record.beforeEnter)) for (const beforeEnter of record.beforeEnter)guards.push($a809ac530d32f081$var$guardToPromiseFn(beforeEnter, to, from));
                else guards.push($a809ac530d32f081$var$guardToPromiseFn(record.beforeEnter, to, from));
            }
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // NOTE: at this point to.matched is normalized and does not contain any () => Promise<Component>
            // clear existing enterCallbacks, these are added by extractComponentsGuards
            to.matched.forEach((record)=>record.enterCallbacks = {});
            // check in-component beforeRouteEnter
            guards = $a809ac530d32f081$var$extractComponentsGuards(enteringRecords, 'beforeRouteEnter', to, from, runWithContext);
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // check global guards beforeResolve
            guards = [];
            for (const guard of beforeResolveGuards.list())guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        })// catch any navigation canceled
        .catch((err)=>$a809ac530d32f081$export$873de56207a30e5a(err, 8 /* ErrorTypes.NAVIGATION_CANCELLED */ ) ? err : Promise.reject(err));
    }
    function triggerAfterEach(to, from, failure) {
        // navigation is confirmed, call afterGuards
        // TODO: wrap with error handlers
        afterGuards.list().forEach((guard)=>runWithContext(()=>guard(to, from, failure)));
    }
    /**
     * - Cleans up any navigation guards
     * - Changes the url if necessary
     * - Calls the scrollBehavior
     */ function finalizeNavigation(toLocation, from, isPush, replace, data) {
        // a more recent navigation took place
        const error = checkCanceledNavigation(toLocation, from);
        if (error) return error;
        // only consider as push if it's not the first navigation
        const isFirstNavigation = from === $a809ac530d32f081$export$e44be9a9779c480b;
        const state = !$a809ac530d32f081$var$isBrowser ? {} : history.state;
        // change URL only if the user did a push/replace and if it's not the initial navigation because
        // it's just reflecting the url
        if (isPush) {
            // on the initial navigation, we want to reuse the scroll position from
            // history state if it exists
            if (replace || isFirstNavigation) routerHistory.replace(toLocation.fullPath, $a809ac530d32f081$var$assign({
                scroll: isFirstNavigation && state && state.scroll
            }, data));
            else routerHistory.push(toLocation.fullPath, data);
        }
        // accept current navigation
        currentRoute.value = toLocation;
        handleScroll(toLocation, from, isPush, isFirstNavigation);
        markAsReady();
    }
    let removeHistoryListener;
    // attach listener to history to trigger navigations
    function setupListeners() {
        // avoid setting up listeners twice due to an invalid first navigation
        if (removeHistoryListener) return;
        removeHistoryListener = routerHistory.listen((to, _from, info)=>{
            if (!router.listening) return;
            // cannot be a redirect route because it was in history
            const toLocation = resolve(to);
            // due to dynamic routing, and to hash history with manual navigation
            // (manually changing the url or calling history.hash = '#/somewhere'),
            // there could be a redirect record in history
            const shouldRedirect = handleRedirectRecord(toLocation);
            if (shouldRedirect) {
                pushWithRedirect($a809ac530d32f081$var$assign(shouldRedirect, {
                    replace: true,
                    force: true
                }), toLocation).catch($a809ac530d32f081$var$noop);
                return;
            }
            pendingLocation = toLocation;
            const from = currentRoute.value;
            // TODO: should be moved to web history?
            if ($a809ac530d32f081$var$isBrowser) $a809ac530d32f081$var$saveScrollPosition($a809ac530d32f081$var$getScrollKey(from.fullPath, info.delta), $a809ac530d32f081$var$computeScrollPosition());
            navigate(toLocation, from).catch((error)=>{
                if ($a809ac530d32f081$export$873de56207a30e5a(error, 12 /* ErrorTypes.NAVIGATION_CANCELLED */ )) return error;
                if ($a809ac530d32f081$export$873de56207a30e5a(error, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ )) {
                    // Here we could call if (info.delta) routerHistory.go(-info.delta,
                    // false) but this is bug prone as we have no way to wait the
                    // navigation to be finished before calling pushWithRedirect. Using
                    // a setTimeout of 16ms seems to work but there is no guarantee for
                    // it to work on every browser. So instead we do not restore the
                    // history entry and trigger a new navigation as requested by the
                    // navigation guard.
                    // the error is already handled by router.push we just want to avoid
                    // logging the error
                    pushWithRedirect($a809ac530d32f081$var$assign(locationAsObject(error.to), {
                        force: true
                    }), toLocation).then((failure)=>{
                        // manual change in hash history #916 ending up in the URL not
                        // changing, but it was changed by the manual url change, so we
                        // need to manually change it ourselves
                        if ($a809ac530d32f081$export$873de56207a30e5a(failure, 20 /* ErrorTypes.NAVIGATION_DUPLICATED */ ) && !info.delta && info.type === $a809ac530d32f081$var$NavigationType.pop) routerHistory.go(-1, false);
                    }).catch($a809ac530d32f081$var$noop);
                    // avoid the then branch
                    return Promise.reject();
                }
                // do not restore history on unknown direction
                if (info.delta) routerHistory.go(-info.delta, false);
                // unrecognized error, transfer to the global handler
                return triggerError(error, toLocation, from);
            }).then((failure)=>{
                failure = failure || finalizeNavigation(// after navigation, all matched components are resolved
                toLocation, from, false);
                // revert the navigation
                if (failure) {
                    if (info.delta && // a new navigation has been triggered, so we do not want to revert, that will change the current history
                    // entry while a different route is displayed
                    !$a809ac530d32f081$export$873de56207a30e5a(failure, 8 /* ErrorTypes.NAVIGATION_CANCELLED */ )) routerHistory.go(-info.delta, false);
                    else if (info.type === $a809ac530d32f081$var$NavigationType.pop && $a809ac530d32f081$export$873de56207a30e5a(failure, 20 /* ErrorTypes.NAVIGATION_DUPLICATED */ )) // manual change in hash history #916
                    // it's like a push but lacks the information of the direction
                    routerHistory.go(-1, false);
                }
                triggerAfterEach(toLocation, from, failure);
            })// avoid warnings in the console about uncaught rejections, they are logged by triggerErrors
            .catch($a809ac530d32f081$var$noop);
        });
    }
    // Initialization and Errors
    let readyHandlers = $a809ac530d32f081$var$useCallbacks();
    let errorListeners = $a809ac530d32f081$var$useCallbacks();
    let ready;
    /**
     * Trigger errorListeners added via onError and throws the error as well
     *
     * @param error - error to throw
     * @param to - location we were navigating to when the error happened
     * @param from - location we were navigating from when the error happened
     * @returns the error as a rejected promise
     */ function triggerError(error, to, from) {
        markAsReady(error);
        const list = errorListeners.list();
        if (list.length) list.forEach((handler)=>handler(error, to, from));
        else console.error(error);
        // reject the error no matter there were error listeners or not
        return Promise.reject(error);
    }
    function isReady() {
        if (ready && currentRoute.value !== $a809ac530d32f081$export$e44be9a9779c480b) return Promise.resolve();
        return new Promise((resolve, reject)=>{
            readyHandlers.add([
                resolve,
                reject
            ]);
        });
    }
    function markAsReady(err) {
        if (!ready) {
            // still not ready if an error happened
            ready = !err;
            setupListeners();
            readyHandlers.list().forEach(([resolve, reject])=>err ? reject(err) : resolve());
            readyHandlers.reset();
        }
        return err;
    }
    // Scroll behavior
    function handleScroll(to, from, isPush, isFirstNavigation) {
        const { scrollBehavior: scrollBehavior } = options;
        if (!$a809ac530d32f081$var$isBrowser || !scrollBehavior) return Promise.resolve();
        const scrollPosition = !isPush && $a809ac530d32f081$var$getSavedScrollPosition($a809ac530d32f081$var$getScrollKey(to.fullPath, 0)) || (isFirstNavigation || !isPush) && history.state && history.state.scroll || null;
        return (0, $TusQn.nextTick)().then(()=>scrollBehavior(to, from, scrollPosition)).then((position)=>position && $a809ac530d32f081$var$scrollToPosition(position)).catch((err)=>triggerError(err, to, from));
    }
    const go = (delta)=>routerHistory.go(delta);
    let started;
    const installedApps = new Set();
    const router = {
        currentRoute: currentRoute,
        listening: true,
        addRoute: addRoute,
        removeRoute: removeRoute,
        clearRoutes: matcher.clearRoutes,
        hasRoute: hasRoute,
        getRoutes: getRoutes,
        resolve: resolve,
        options: options,
        push: push,
        replace: replace,
        go: go,
        back: ()=>go(-1),
        forward: ()=>go(1),
        beforeEach: beforeGuards.add,
        beforeResolve: beforeResolveGuards.add,
        afterEach: afterGuards.add,
        onError: errorListeners.add,
        isReady: isReady,
        install (app) {
            const router = this;
            app.component('RouterLink', $a809ac530d32f081$export$fce709ebdac448ed);
            app.component('RouterView', $a809ac530d32f081$export$d941f00e9b9a537);
            app.config.globalProperties.$router = router;
            Object.defineProperty(app.config.globalProperties, '$route', {
                enumerable: true,
                get: ()=>(0, $01W3b.unref)(currentRoute)
            });
            // this initial navigation is only necessary on client, on server it doesn't
            // make sense because it will create an extra unnecessary navigation and could
            // lead to problems
            if ($a809ac530d32f081$var$isBrowser && // used for the initial navigation client side to avoid pushing
            // multiple times when the router is used in multiple apps
            !started && currentRoute.value === $a809ac530d32f081$export$e44be9a9779c480b) {
                // see above
                started = true;
                push(routerHistory.location).catch((err)=>{});
            }
            const reactiveRoute = {};
            for(const key in $a809ac530d32f081$export$e44be9a9779c480b)Object.defineProperty(reactiveRoute, key, {
                get: ()=>currentRoute.value[key],
                enumerable: true
            });
            app.provide($a809ac530d32f081$export$b6c0da8b9dae491f, router);
            app.provide($a809ac530d32f081$export$3aca783e9a3e6e9e, (0, $01W3b.shallowReactive)(reactiveRoute));
            app.provide($a809ac530d32f081$export$54c8124bead129f8, currentRoute);
            const unmountApp = app.unmount;
            installedApps.add(app);
            app.unmount = function() {
                installedApps.delete(app);
                // the router is not attached to an app anymore
                if (installedApps.size < 1) {
                    // invalidate the current navigation
                    pendingLocation = $a809ac530d32f081$export$e44be9a9779c480b;
                    removeHistoryListener && removeHistoryListener();
                    removeHistoryListener = null;
                    currentRoute.value = $a809ac530d32f081$export$e44be9a9779c480b;
                    started = false;
                    ready = false;
                }
                unmountApp();
            };
            // TODO: this probably needs to be updated so it can be used by vue-termui
            if (__VUE_PROD_DEVTOOLS__ && $a809ac530d32f081$var$isBrowser) $a809ac530d32f081$var$addDevtools(app, router, matcher);
        }
    };
    // TODO: type this as NavigationGuardReturn or similar instead of any
    function runGuardQueue(guards) {
        return guards.reduce((promise, guard)=>promise.then(()=>runWithContext(guard)), Promise.resolve());
    }
    return router;
}
function $a809ac530d32f081$var$extractChangingRecords(to, from) {
    const leavingRecords = [];
    const updatingRecords = [];
    const enteringRecords = [];
    const len = Math.max(from.matched.length, to.matched.length);
    for(let i = 0; i < len; i++){
        const recordFrom = from.matched[i];
        if (recordFrom) {
            if (to.matched.find((record)=>$a809ac530d32f081$var$isSameRouteRecord(record, recordFrom))) updatingRecords.push(recordFrom);
            else leavingRecords.push(recordFrom);
        }
        const recordTo = to.matched[i];
        if (recordTo) // the type doesn't matter because we are comparing per reference
        {
            if (!from.matched.find((record)=>$a809ac530d32f081$var$isSameRouteRecord(record, recordTo))) enteringRecords.push(recordTo);
        }
    }
    return [
        leavingRecords,
        updatingRecords,
        enteringRecords
    ];
}
/**
 * Returns the router instance. Equivalent to using `$router` inside
 * templates.
 */ function $a809ac530d32f081$export$9a302a45f65d0572() {
    return (0, $TusQn.inject)($a809ac530d32f081$export$b6c0da8b9dae491f);
}
/**
 * Returns the current route location. Equivalent to using `$route` inside
 * templates.
 */ function $a809ac530d32f081$export$3f79f0b98112cf57(_name) {
    return (0, $TusQn.inject)($a809ac530d32f081$export$3aca783e9a3e6e9e);
}

});
parcelRegister("j6G8F", function(module, exports) {

$parcel$export(module.exports, "setupDevtoolsPlugin", () => $de8f43bece76d38a$export$63b9a9bba9f20f3e);

var $jiSSU = parcelRequire("jiSSU");

var $7mHjb = parcelRequire("7mHjb");

var $83xTH = parcelRequire("83xTH");



function $de8f43bece76d38a$export$63b9a9bba9f20f3e(pluginDescriptor, setupFn) {
    const descriptor = pluginDescriptor;
    const target = (0, $jiSSU.getTarget)();
    const hook = (0, $jiSSU.getDevtoolsGlobalHook)();
    const enableProxy = (0, $jiSSU.isProxyAvailable) && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit((0, $7mHjb.HOOK_SETUP), pluginDescriptor, setupFn);
    else {
        const proxy = enableProxy ? new (0, $83xTH.ApiProxy)(descriptor, hook) : null;
        const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: descriptor,
            setupFn: setupFn,
            proxy: proxy
        });
        if (proxy) setupFn(proxy.proxiedTarget);
    }
}

});
parcelRegister("jiSSU", function(module, exports) {

$parcel$export(module.exports, "getDevtoolsGlobalHook", () => $e0da45b668fffb6e$export$5a2d366b2d9f38f6);
$parcel$export(module.exports, "getTarget", () => $e0da45b668fffb6e$export$c22522a4dfa48e9c);
$parcel$export(module.exports, "isProxyAvailable", () => $e0da45b668fffb6e$export$bc32a04c49ed7464);
function $e0da45b668fffb6e$export$5a2d366b2d9f38f6() {
    return $e0da45b668fffb6e$export$c22522a4dfa48e9c().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $e0da45b668fffb6e$export$c22522a4dfa48e9c() {
    // @ts-expect-error navigator and windows are not available in all environments
    return typeof navigator !== 'undefined' && typeof window !== 'undefined' ? window : typeof globalThis !== 'undefined' ? globalThis : {};
}
const $e0da45b668fffb6e$export$bc32a04c49ed7464 = typeof Proxy === 'function';

});

parcelRegister("7mHjb", function(module, exports) {

$parcel$export(module.exports, "HOOK_SETUP", () => $55cc2ea2e53f2ca6$export$b1499c3bd2a3f4df);
$parcel$export(module.exports, "HOOK_PLUGIN_SETTINGS_SET", () => $55cc2ea2e53f2ca6$export$a0897f44accbe922);
const $55cc2ea2e53f2ca6$export$b1499c3bd2a3f4df = 'devtools-plugin:setup';
const $55cc2ea2e53f2ca6$export$a0897f44accbe922 = 'plugin:settings:set';

});

parcelRegister("83xTH", function(module, exports) {

$parcel$export(module.exports, "ApiProxy", () => $5dd8e5d828be8ae1$export$5728f3776e9b2ac1);

var $7mHjb = parcelRequire("7mHjb");

var $2QQ8V = parcelRequire("2QQ8V");
class $5dd8e5d828be8ae1$export$5728f3776e9b2ac1 {
    constructor(plugin, hook){
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        const defaultSettings = {};
        if (plugin.settings) for(const id in plugin.settings){
            const item = plugin.settings[id];
            defaultSettings[id] = item.defaultValue;
        }
        const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
        let currentSettings = Object.assign({}, defaultSettings);
        try {
            const raw = localStorage.getItem(localSettingsSaveId);
            const data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        } catch (e) {
        // noop
        }
        this.fallbacks = {
            getSettings () {
                return currentSettings;
            },
            setSettings (value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                } catch (e) {
                // noop
                }
                currentSettings = value;
            },
            now () {
                return (0, $2QQ8V.now)();
            }
        };
        if (hook) hook.on((0, $7mHjb.HOOK_PLUGIN_SETTINGS_SET), (pluginId, value)=>{
            if (pluginId === this.plugin.id) this.fallbacks.setSettings(value);
        });
        this.proxiedOn = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target.on[prop];
                else return (...args)=>{
                    this.onQueue.push({
                        method: prop,
                        args: args
                    });
                };
            }
        });
        this.proxiedTarget = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target[prop];
                else if (prop === 'on') return this.proxiedOn;
                else if (Object.keys(this.fallbacks).includes(prop)) return (...args)=>{
                    this.targetQueue.push({
                        method: prop,
                        args: args,
                        resolve: ()=>{}
                    });
                    return this.fallbacks[prop](...args);
                };
                else return (...args)=>{
                    return new Promise((resolve)=>{
                        this.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: resolve
                        });
                    });
                };
            }
        });
    }
    async setRealTarget(target) {
        this.target = target;
        for (const item of this.onQueue)this.target.on[item.method](...item.args);
        for (const item of this.targetQueue)item.resolve(await this.target[item.method](...item.args));
    }
}

});
parcelRegister("2QQ8V", function(module, exports) {

$parcel$export(module.exports, "now", () => $2138e2947b5f69c4$export$461939dd4422153);
let $2138e2947b5f69c4$var$supported;
let $2138e2947b5f69c4$var$perf;
function $2138e2947b5f69c4$export$70d26280bc1ca547() {
    var _a;
    if ($2138e2947b5f69c4$var$supported !== undefined) return $2138e2947b5f69c4$var$supported;
    if (typeof window !== 'undefined' && window.performance) {
        $2138e2947b5f69c4$var$supported = true;
        $2138e2947b5f69c4$var$perf = window.performance;
    } else if (typeof globalThis !== 'undefined' && ((_a = globalThis.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
        $2138e2947b5f69c4$var$supported = true;
        $2138e2947b5f69c4$var$perf = globalThis.perf_hooks.performance;
    } else $2138e2947b5f69c4$var$supported = false;
    return $2138e2947b5f69c4$var$supported;
}
function $2138e2947b5f69c4$export$461939dd4422153() {
    return $2138e2947b5f69c4$export$70d26280bc1ca547() ? $2138e2947b5f69c4$var$perf.now() : Date.now();
}

});




parcelRegister("8qdaR", function(module, exports) {

$parcel$export(module.exports, "useGuestStore", () => $621af88cc6c59f3c$export$2f2a85a259009c86);

var $i0TKe = parcelRequire("i0TKe");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $6VOYw = parcelRequire("6VOYw");
const $621af88cc6c59f3c$export$2f2a85a259009c86 = (0, $i0TKe.defineStore)("guest", ()=>{
    // TODO: change this to an object
    const defaultGuest = {
        name: "",
        attending: "No",
        email: "",
        accommodations: "",
        transportation: "",
        diet: "",
        characterName: "",
        bio: "",
        characterAppearance: "",
        imageUrl: "",
        completedSurvey: false
    };
    const guest = (0, $01W3b.ref)(defaultGuest);
    const responses = (0, $01W3b.ref)([]);
    const loadGuest = ()=>{
        const storedGuest = localStorage.getItem("guest");
        if (storedGuest) {
            const parsedGuest = JSON.parse(storedGuest);
            guest.value = {
                ...parsedGuest
            };
        }
        // the csv might take a while to refresh... so this can cause old results to be loaded
        if (guest.value.email && responses.value.length > 0) {
            const submittedGuest = responses.value.find((sub)=>sub.email?.toLowerCase() === guest.value.email?.toLowerCase());
            if (submittedGuest) {
                guest.value = {
                    ...submittedGuest,
                    completedSurvey: true
                };
                // store the guest in local storage
                storeGuest();
            }
        }
    };
    const storeGuest = ()=>{
        localStorage.setItem("guest", JSON.stringify({
            ...guest.value,
            completedSurvey: guest.value.completedSurvey || false
        }));
    };
    const saveResult = ()=>{
        guest.value.completedSurvey = true;
        // store the result in local storage
        storeGuest();
        const formData = new FormData();
        formData.append("entry.884278233", guest.value.name);
        formData.append("entry.1136586200", guest.value.attending);
        formData.append("entry.262420987", guest.value.email);
        formData.append("entry.598567540", guest.value.accommodations);
        formData.append("entry.520854053", guest.value.transportation);
        formData.append("entry.340530196", guest.value.diet);
        formData.append("entry.987721675", guest.value.characterName);
        formData.append("entry.454363011", guest.value.bio);
        formData.append("entry.1840407414", guest.value.characterAppearance);
        formData.append("entry.200732033", guest.value.imageUrl);
        // push or replace this guest in the responses array
        const existingGuest = responses.value.find((g)=>g.email?.toLowerCase() === guest.value.email?.toLowerCase());
        if (existingGuest) {
            const index = responses.value.findIndex((g)=>g.email?.toLowerCase() === guest.value.email?.toLowerCase());
            responses.value[index] = {
                ...guest.value
            };
        } else responses.value.push({
            ...guest.value
        });
        return fetch("https://docs.google.com/forms/u/0/d/e/1FAIpQLSdcPMKofTNQsopjBtP_In6OVtL8Y5xtBlINkhf6opy9VjA2xg/formResponse", {
            method: "POST",
            mode: "no-cors",
            body: formData,
            headers: {
                "Content-Type": "application/json"
            }
        });
    };
    const loadResponses = async ()=>{
        // Add timestamp to prevent caching
        const timestamp = new Date().getTime();
        const csvUrl = `https://docs.google.com/spreadsheets/d/e/2PACX-1vTkYeyHOfPS6cKtIHjizEuJogvjzMWeHFHz9PhX42imBzN6FxE5F7Vk3zBcOn4Ki3i2q0JR2S-wGt8j/pub?gid=237881577&single=true&output=csv&_=${timestamp}`;
        try {
            responses.value = await (0, $6VOYw.CSVParser).parseGoogleSheet(csvUrl);
            console.log(responses.value);
        } catch (error) {
            console.error("Error fetching Google Sheets CSV:", error);
        }
    };
    const formattedPrompt = (name, description, random = false)=>{
        return `
    Name: ${name}, description: ${description}.
    `.replace(/\s+/g, ' ').trim();
    };
    const generateCharacterImage = async (name, description)=>{
        const prompt = formattedPrompt(name, description);
        const response = await fetch("https://ctij3gcjhb72ivmpw3al3nep6e0tzpiq.lambda-url.us-west-1.on.aws/", {
            method: "POST",
            body: JSON.stringify({
                stableDiffusion: "core",
                generateDetailedPrompt: false,
                email: guest.value.email,
                output_format: "png",
                prompt: prompt,
                negative_prompt: "worst quality, low quality, text, error, cropped, jpeg artifacts, signature, watermark, username, blurry, bad anatomy, bad hands, text, error, cropped, jpeg artifacts, signature, watermark, username, blurry, bad anatomy, bad hands",
                seed: 0,
                style_preset: 'pixel-art',
                steps: 30,
                samples: 3,
                cfg_scale: 8
            }),
            headers: {
                "Content-Type": "application/json"
            }
        });
        const data = await response.json();
        return data;
    };
    return {
        guest: guest,
        responses: responses,
        saveResult: saveResult,
        loadGuest: loadGuest,
        loadResponses: loadResponses,
        generateCharacterImage: generateCharacterImage
    };
});

});
parcelRegister("i0TKe", function(module, exports) {

$parcel$export(module.exports, "createPinia", () => $52e3354521f75c8c$export$4b9f6a0748623d44);
$parcel$export(module.exports, "defineStore", () => $52e3354521f75c8c$export$5061c4f75bbcb4a);
/*!
 * pinia v3.0.1
 * (c) 2025 Eduardo San Martin Morote
 * @license MIT
 */ parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $70eLC = parcelRequire("70eLC");
/**
 * setActivePinia must be called to handle SSR at the top of functions like
 * `fetch`, `setup`, `serverPrefetch` and others
 */ let $52e3354521f75c8c$var$activePinia;
/**
 * Sets or unsets the active pinia. Used in SSR and internally when calling
 * actions and getters
 *
 * @param pinia - Pinia instance
 */ // @ts-expect-error: cannot constrain the type of the return
const $52e3354521f75c8c$export$89ffb8149ccd46af = (pinia)=>$52e3354521f75c8c$var$activePinia = pinia;
/**
 * Get the currently active pinia if there is any.
 */ const $52e3354521f75c8c$export$d0cc41ca14a2d060 = ()=>(0, $TusQn.hasInjectionContext)() && (0, $TusQn.inject)($52e3354521f75c8c$var$piniaSymbol) || $52e3354521f75c8c$var$activePinia;
const $52e3354521f75c8c$var$piniaSymbol = /* istanbul ignore next */ Symbol();
function $52e3354521f75c8c$var$isPlainObject(// eslint-disable-next-line @typescript-eslint/no-explicit-any
o) {
    return o && typeof o === 'object' && Object.prototype.toString.call(o) === '[object Object]' && typeof o.toJSON !== 'function';
}
// type DeepReadonly<T> = { readonly [P in keyof T]: DeepReadonly<T[P]> }
// TODO: can we change these to numbers?
/**
 * Possible types for SubscriptionCallback
 */ var $52e3354521f75c8c$export$d97371ba8df8c539;
(function(MutationType) {
    /**
     * Direct mutation of the state:
     *
     * - `store.name = 'new name'`
     * - `store.$state.name = 'new name'`
     * - `store.list.push('new item')`
     */ MutationType["direct"] = "direct";
    /**
     * Mutated the state with `$patch` and an object
     *
     * - `store.$patch({ name: 'newName' })`
     */ MutationType["patchObject"] = "patch object";
    /**
     * Mutated the state with `$patch` and a function
     *
     * - `store.$patch(state => state.name = 'newName')`
     */ MutationType["patchFunction"] = "patch function";
// maybe reset? for $state = {} and $reset
})($52e3354521f75c8c$export$d97371ba8df8c539 || ($52e3354521f75c8c$export$d97371ba8df8c539 = {}));
const $52e3354521f75c8c$var$IS_CLIENT = typeof window !== 'undefined';
/*
 * FileSaver.js A saveAs() FileSaver implementation.
 *
 * Originally by Eli Grey, adapted as an ESM module by Eduardo San Martin
 * Morote.
 *
 * License : MIT
 */ // The one and only way of getting global scope in all environments
// https://stackoverflow.com/q/3277182/1008999
const $52e3354521f75c8c$var$_global = /*#__PURE__*/ (()=>typeof window === 'object' && window.window === window ? window : typeof self === 'object' && self.self === self ? self : typeof $parcel$global === 'object' && $parcel$global.global === $parcel$global ? $parcel$global : typeof globalThis === 'object' ? globalThis : {
        HTMLElement: null
    })();
function $52e3354521f75c8c$var$bom(blob, { autoBom: autoBom = false } = {}) {
    // prepend BOM for UTF-8 XML and text/* types (including HTML)
    // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
    if (autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) return new Blob([
        String.fromCharCode(0xfeff),
        blob
    ], {
        type: blob.type
    });
    return blob;
}
function $52e3354521f75c8c$var$download(url, name, opts) {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.onload = function() {
        $52e3354521f75c8c$var$saveAs(xhr.response, name, opts);
    };
    xhr.onerror = function() {
        console.error('could not download file');
    };
    xhr.send();
}
function $52e3354521f75c8c$var$corsEnabled(url) {
    const xhr = new XMLHttpRequest();
    // use sync to avoid popup blocker
    xhr.open('HEAD', url, false);
    try {
        xhr.send();
    } catch (e) {}
    return xhr.status >= 200 && xhr.status <= 299;
}
// `a.click()` doesn't work for all browsers (#465)
function $52e3354521f75c8c$var$click(node) {
    try {
        node.dispatchEvent(new MouseEvent('click'));
    } catch (e) {
        const evt = document.createEvent('MouseEvents');
        evt.initMouseEvent('click', true, true, window, 0, 0, 0, 80, 20, false, false, false, false, 0, null);
        node.dispatchEvent(evt);
    }
}
const $52e3354521f75c8c$var$_navigator = typeof navigator === 'object' ? navigator : {
    userAgent: ''
};
// Detect WebView inside a native macOS app by ruling out all browsers
// We just need to check for 'Safari' because all other browsers (besides Firefox) include that too
// https://www.whatismybrowser.com/guides/the-latest-user-agent/macos
const $52e3354521f75c8c$var$isMacOSWebView = /*#__PURE__*/ (()=>/Macintosh/.test($52e3354521f75c8c$var$_navigator.userAgent) && /AppleWebKit/.test($52e3354521f75c8c$var$_navigator.userAgent) && !/Safari/.test($52e3354521f75c8c$var$_navigator.userAgent))();
const $52e3354521f75c8c$var$saveAs = !$52e3354521f75c8c$var$IS_CLIENT ? ()=>{} // noop
 : typeof HTMLAnchorElement !== 'undefined' && 'download' in HTMLAnchorElement.prototype && !$52e3354521f75c8c$var$isMacOSWebView ? $52e3354521f75c8c$var$downloadSaveAs : 'msSaveOrOpenBlob' in $52e3354521f75c8c$var$_navigator ? $52e3354521f75c8c$var$msSaveAs : $52e3354521f75c8c$var$fileSaverSaveAs;
function $52e3354521f75c8c$var$downloadSaveAs(blob, name = 'download', opts) {
    const a = document.createElement('a');
    a.download = name;
    a.rel = 'noopener'; // tabnabbing
    // TODO: detect chrome extensions & packaged apps
    // a.target = '_blank'
    if (typeof blob === 'string') {
        // Support regular links
        a.href = blob;
        if (a.origin !== location.origin) {
            if ($52e3354521f75c8c$var$corsEnabled(a.href)) $52e3354521f75c8c$var$download(blob, name, opts);
            else {
                a.target = '_blank';
                $52e3354521f75c8c$var$click(a);
            }
        } else $52e3354521f75c8c$var$click(a);
    } else {
        // Support blobs
        a.href = URL.createObjectURL(blob);
        setTimeout(function() {
            URL.revokeObjectURL(a.href);
        }, 4e4); // 40s
        setTimeout(function() {
            $52e3354521f75c8c$var$click(a);
        }, 0);
    }
}
function $52e3354521f75c8c$var$msSaveAs(blob, name = 'download', opts) {
    if (typeof blob === 'string') {
        if ($52e3354521f75c8c$var$corsEnabled(blob)) $52e3354521f75c8c$var$download(blob, name, opts);
        else {
            const a = document.createElement('a');
            a.href = blob;
            a.target = '_blank';
            setTimeout(function() {
                $52e3354521f75c8c$var$click(a);
            });
        }
    } else // @ts-ignore: works on windows
    navigator.msSaveOrOpenBlob($52e3354521f75c8c$var$bom(blob, opts), name);
}
function $52e3354521f75c8c$var$fileSaverSaveAs(blob, name, opts, popup) {
    // Open a popup immediately do go around popup blocker
    // Mostly only available on user interaction and the fileReader is async so...
    popup = popup || open('', '_blank');
    if (popup) popup.document.title = popup.document.body.innerText = 'downloading...';
    if (typeof blob === 'string') return $52e3354521f75c8c$var$download(blob, name, opts);
    const force = blob.type === 'application/octet-stream';
    const isSafari = /constructor/i.test(String($52e3354521f75c8c$var$_global.HTMLElement)) || 'safari' in $52e3354521f75c8c$var$_global;
    const isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent);
    if ((isChromeIOS || force && isSafari || $52e3354521f75c8c$var$isMacOSWebView) && typeof FileReader !== 'undefined') {
        // Safari doesn't allow downloading of blob URLs
        const reader = new FileReader();
        reader.onloadend = function() {
            let url = reader.result;
            if (typeof url !== 'string') {
                popup = null;
                throw new Error('Wrong reader.result type');
            }
            url = isChromeIOS ? url : url.replace(/^data:[^;]*;/, 'data:attachment/file;');
            if (popup) popup.location.href = url;
            else location.assign(url);
            popup = null; // reverse-tabnabbing #460
        };
        reader.readAsDataURL(blob);
    } else {
        const url = URL.createObjectURL(blob);
        if (popup) popup.location.assign(url);
        else location.href = url;
        popup = null; // reverse-tabnabbing #460
        setTimeout(function() {
            URL.revokeObjectURL(url);
        }, 4e4); // 40s
    }
}
/**
 * Shows a toast or console.log
 *
 * @param message - message to log
 * @param type - different color of the tooltip
 */ function $52e3354521f75c8c$var$toastMessage(message, type) {
    const piniaMessage = "\uD83C\uDF4D " + message;
    if (typeof __VUE_DEVTOOLS_TOAST__ === 'function') // No longer available :(
    __VUE_DEVTOOLS_TOAST__(piniaMessage, type);
    else if (type === 'error') console.error(piniaMessage);
    else if (type === 'warn') console.warn(piniaMessage);
    else console.log(piniaMessage);
}
function $52e3354521f75c8c$var$isPinia(o) {
    return '_a' in o && 'install' in o;
}
/**
 * This file contain devtools actions, they are not Pinia actions.
 */ // ---
function $52e3354521f75c8c$var$checkClipboardAccess() {
    if (!('clipboard' in navigator)) {
        $52e3354521f75c8c$var$toastMessage(`Your browser doesn't support the Clipboard API`, 'error');
        return true;
    }
}
function $52e3354521f75c8c$var$checkNotFocusedError(error) {
    if (error instanceof Error && error.message.toLowerCase().includes('document is not focused')) {
        $52e3354521f75c8c$var$toastMessage('You need to activate the "Emulate a focused page" setting in the "Rendering" panel of devtools.', 'warn');
        return true;
    }
    return false;
}
async function $52e3354521f75c8c$var$actionGlobalCopyState(pinia) {
    if ($52e3354521f75c8c$var$checkClipboardAccess()) return;
    try {
        await navigator.clipboard.writeText(JSON.stringify(pinia.state.value));
        $52e3354521f75c8c$var$toastMessage('Global state copied to clipboard.');
    } catch (error) {
        if ($52e3354521f75c8c$var$checkNotFocusedError(error)) return;
        $52e3354521f75c8c$var$toastMessage(`Failed to serialize the state. Check the console for more details.`, 'error');
        console.error(error);
    }
}
async function $52e3354521f75c8c$var$actionGlobalPasteState(pinia) {
    if ($52e3354521f75c8c$var$checkClipboardAccess()) return;
    try {
        $52e3354521f75c8c$var$loadStoresState(pinia, JSON.parse(await navigator.clipboard.readText()));
        $52e3354521f75c8c$var$toastMessage('Global state pasted from clipboard.');
    } catch (error) {
        if ($52e3354521f75c8c$var$checkNotFocusedError(error)) return;
        $52e3354521f75c8c$var$toastMessage(`Failed to deserialize the state from clipboard. Check the console for more details.`, 'error');
        console.error(error);
    }
}
async function $52e3354521f75c8c$var$actionGlobalSaveState(pinia) {
    try {
        $52e3354521f75c8c$var$saveAs(new Blob([
            JSON.stringify(pinia.state.value)
        ], {
            type: 'text/plain;charset=utf-8'
        }), 'pinia-state.json');
    } catch (error) {
        $52e3354521f75c8c$var$toastMessage(`Failed to export the state as JSON. Check the console for more details.`, 'error');
        console.error(error);
    }
}
let $52e3354521f75c8c$var$fileInput;
function $52e3354521f75c8c$var$getFileOpener() {
    if (!$52e3354521f75c8c$var$fileInput) {
        $52e3354521f75c8c$var$fileInput = document.createElement('input');
        $52e3354521f75c8c$var$fileInput.type = 'file';
        $52e3354521f75c8c$var$fileInput.accept = '.json';
    }
    function openFile() {
        return new Promise((resolve, reject)=>{
            $52e3354521f75c8c$var$fileInput.onchange = async ()=>{
                const files = $52e3354521f75c8c$var$fileInput.files;
                if (!files) return resolve(null);
                const file = files.item(0);
                if (!file) return resolve(null);
                return resolve({
                    text: await file.text(),
                    file: file
                });
            };
            // @ts-ignore: TODO: changed from 4.3 to 4.4
            $52e3354521f75c8c$var$fileInput.oncancel = ()=>resolve(null);
            $52e3354521f75c8c$var$fileInput.onerror = reject;
            $52e3354521f75c8c$var$fileInput.click();
        });
    }
    return openFile;
}
async function $52e3354521f75c8c$var$actionGlobalOpenStateFile(pinia) {
    try {
        const open1 = $52e3354521f75c8c$var$getFileOpener();
        const result = await open1();
        if (!result) return;
        const { text: text, file: file } = result;
        $52e3354521f75c8c$var$loadStoresState(pinia, JSON.parse(text));
        $52e3354521f75c8c$var$toastMessage(`Global state imported from "${file.name}".`);
    } catch (error) {
        $52e3354521f75c8c$var$toastMessage(`Failed to import the state from JSON. Check the console for more details.`, 'error');
        console.error(error);
    }
}
function $52e3354521f75c8c$var$loadStoresState(pinia, state) {
    for(const key in state){
        const storeState = pinia.state.value[key];
        // store is already instantiated, patch it
        if (storeState) Object.assign(storeState, state[key]);
        else // store is not instantiated, set the initial state
        pinia.state.value[key] = state[key];
    }
}
function $52e3354521f75c8c$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
const $52e3354521f75c8c$var$PINIA_ROOT_LABEL = "\uD83C\uDF4D Pinia (root)";
const $52e3354521f75c8c$var$PINIA_ROOT_ID = '_root';
function $52e3354521f75c8c$var$formatStoreForInspectorTree(store) {
    return $52e3354521f75c8c$var$isPinia(store) ? {
        id: $52e3354521f75c8c$var$PINIA_ROOT_ID,
        label: $52e3354521f75c8c$var$PINIA_ROOT_LABEL
    } : {
        id: store.$id,
        label: store.$id
    };
}
function $52e3354521f75c8c$var$formatStoreForInspectorState(store) {
    if ($52e3354521f75c8c$var$isPinia(store)) {
        const storeNames = Array.from(store._s.keys());
        const storeMap = store._s;
        const state = {
            state: storeNames.map((storeId)=>({
                    editable: true,
                    key: storeId,
                    value: store.state.value[storeId]
                })),
            getters: storeNames.filter((id)=>storeMap.get(id)._getters).map((id)=>{
                const store = storeMap.get(id);
                return {
                    editable: false,
                    key: id,
                    value: store._getters.reduce((getters, key)=>{
                        getters[key] = store[key];
                        return getters;
                    }, {})
                };
            })
        };
        return state;
    }
    const state = {
        state: Object.keys(store.$state).map((key)=>({
                editable: true,
                key: key,
                value: store.$state[key]
            }))
    };
    // avoid adding empty getters
    if (store._getters && store._getters.length) state.getters = store._getters.map((getterName)=>({
            editable: false,
            key: getterName,
            value: store[getterName]
        }));
    if (store._customProperties.size) state.customProperties = Array.from(store._customProperties).map((key)=>({
            editable: true,
            key: key,
            value: store[key]
        }));
    return state;
}
function $52e3354521f75c8c$var$formatEventData(events) {
    if (!events) return {};
    if (Array.isArray(events)) // TODO: handle add and delete for arrays and objects
    return events.reduce((data, event)=>{
        data.keys.push(event.key);
        data.operations.push(event.type);
        data.oldValue[event.key] = event.oldValue;
        data.newValue[event.key] = event.newValue;
        return data;
    }, {
        oldValue: {},
        keys: [],
        operations: [],
        newValue: {}
    });
    else return {
        operation: $52e3354521f75c8c$var$formatDisplay(events.type),
        key: $52e3354521f75c8c$var$formatDisplay(events.key),
        oldValue: events.oldValue,
        newValue: events.newValue
    };
}
function $52e3354521f75c8c$var$formatMutationType(type) {
    switch(type){
        case $52e3354521f75c8c$export$d97371ba8df8c539.direct:
            return 'mutation';
        case $52e3354521f75c8c$export$d97371ba8df8c539.patchFunction:
            return '$patch';
        case $52e3354521f75c8c$export$d97371ba8df8c539.patchObject:
            return '$patch';
        default:
            return 'unknown';
    }
}
// timeline can be paused when directly changing the state
let $52e3354521f75c8c$var$isTimelineActive = true;
const $52e3354521f75c8c$var$componentStateTypes = [];
const $52e3354521f75c8c$var$MUTATIONS_LAYER_ID = 'pinia:mutations';
const $52e3354521f75c8c$var$INSPECTOR_ID = 'pinia';
const { assign: $52e3354521f75c8c$var$assign$1 } = Object;
/**
 * Gets the displayed name of a store in devtools
 *
 * @param id - id of the store
 * @returns a formatted string
 */ const $52e3354521f75c8c$var$getStoreType = (id)=>"\uD83C\uDF4D " + id;
/**
 * Add the pinia plugin without any store. Allows displaying a Pinia plugin tab
 * as soon as it is added to the application.
 *
 * @param app - Vue application
 * @param pinia - pinia instance
 */ function $52e3354521f75c8c$var$registerPiniaDevtools(app, pinia) {
    (0, $70eLC.setupDevToolsPlugin)({
        id: 'dev.esm.pinia',
        label: "Pinia \uD83C\uDF4D",
        logo: 'https://pinia.vuejs.org/logo.svg',
        packageName: 'pinia',
        homepage: 'https://pinia.vuejs.org',
        componentStateTypes: $52e3354521f75c8c$var$componentStateTypes,
        app: app
    }, (api)=>{
        if (typeof api.now !== 'function') $52e3354521f75c8c$var$toastMessage('You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.');
        api.addTimelineLayer({
            id: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
            label: `Pinia \u{1F34D}`,
            color: 0xe5df88
        });
        api.addInspector({
            id: $52e3354521f75c8c$var$INSPECTOR_ID,
            label: "Pinia \uD83C\uDF4D",
            icon: 'storage',
            treeFilterPlaceholder: 'Search stores',
            actions: [
                {
                    icon: 'content_copy',
                    action: ()=>{
                        $52e3354521f75c8c$var$actionGlobalCopyState(pinia);
                    },
                    tooltip: 'Serialize and copy the state'
                },
                {
                    icon: 'content_paste',
                    action: async ()=>{
                        await $52e3354521f75c8c$var$actionGlobalPasteState(pinia);
                        api.sendInspectorTree($52e3354521f75c8c$var$INSPECTOR_ID);
                        api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
                    },
                    tooltip: 'Replace the state with the content of your clipboard'
                },
                {
                    icon: 'save',
                    action: ()=>{
                        $52e3354521f75c8c$var$actionGlobalSaveState(pinia);
                    },
                    tooltip: 'Save the state as a JSON file'
                },
                {
                    icon: 'folder_open',
                    action: async ()=>{
                        await $52e3354521f75c8c$var$actionGlobalOpenStateFile(pinia);
                        api.sendInspectorTree($52e3354521f75c8c$var$INSPECTOR_ID);
                        api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
                    },
                    tooltip: 'Import the state from a JSON file'
                }
            ],
            nodeActions: [
                {
                    icon: 'restore',
                    tooltip: 'Reset the state (with "$reset")',
                    action: (nodeId)=>{
                        const store = pinia._s.get(nodeId);
                        if (!store) $52e3354521f75c8c$var$toastMessage(`Cannot reset "${nodeId}" store because it wasn't found.`, 'warn');
                        else if (typeof store.$reset !== 'function') $52e3354521f75c8c$var$toastMessage(`Cannot reset "${nodeId}" store because it doesn't have a "$reset" method implemented.`, 'warn');
                        else {
                            store.$reset();
                            $52e3354521f75c8c$var$toastMessage(`Store "${nodeId}" reset.`);
                        }
                    }
                }
            ]
        });
        api.on.inspectComponent((payload)=>{
            const proxy = payload.componentInstance && payload.componentInstance.proxy;
            if (proxy && proxy._pStores) {
                const piniaStores = payload.componentInstance.proxy._pStores;
                Object.values(piniaStores).forEach((store)=>{
                    payload.instanceData.state.push({
                        type: $52e3354521f75c8c$var$getStoreType(store.$id),
                        key: 'state',
                        editable: true,
                        value: store._isOptionsAPI ? {
                            _custom: {
                                value: (0, $01W3b.toRaw)(store.$state),
                                actions: [
                                    {
                                        icon: 'restore',
                                        tooltip: 'Reset the state of this store',
                                        action: ()=>store.$reset()
                                    }
                                ]
                            }
                        } : Object.keys(store.$state).reduce((state, key)=>{
                            state[key] = store.$state[key];
                            return state;
                        }, {})
                    });
                    if (store._getters && store._getters.length) payload.instanceData.state.push({
                        type: $52e3354521f75c8c$var$getStoreType(store.$id),
                        key: 'getters',
                        editable: false,
                        value: store._getters.reduce((getters, key)=>{
                            try {
                                getters[key] = store[key];
                            } catch (error) {
                                // @ts-expect-error: we just want to show it in devtools
                                getters[key] = error;
                            }
                            return getters;
                        }, {})
                    });
                });
            }
        });
        api.on.getInspectorTree((payload)=>{
            if (payload.app === app && payload.inspectorId === $52e3354521f75c8c$var$INSPECTOR_ID) {
                let stores = [
                    pinia
                ];
                stores = stores.concat(Array.from(pinia._s.values()));
                payload.rootNodes = (payload.filter ? stores.filter((store)=>'$id' in store ? store.$id.toLowerCase().includes(payload.filter.toLowerCase()) : $52e3354521f75c8c$var$PINIA_ROOT_LABEL.toLowerCase().includes(payload.filter.toLowerCase())) : stores).map($52e3354521f75c8c$var$formatStoreForInspectorTree);
            }
        });
        // Expose pinia instance as $pinia to window
        globalThis.$pinia = pinia;
        api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === $52e3354521f75c8c$var$INSPECTOR_ID) {
                const inspectedStore = payload.nodeId === $52e3354521f75c8c$var$PINIA_ROOT_ID ? pinia : pinia._s.get(payload.nodeId);
                if (!inspectedStore) // this could be the selected store restored for a different project
                // so it's better not to say anything here
                return;
                if (inspectedStore) {
                    // Expose selected store as $store to window
                    if (payload.nodeId !== $52e3354521f75c8c$var$PINIA_ROOT_ID) globalThis.$store = (0, $01W3b.toRaw)(inspectedStore);
                    payload.state = $52e3354521f75c8c$var$formatStoreForInspectorState(inspectedStore);
                }
            }
        });
        api.on.editInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === $52e3354521f75c8c$var$INSPECTOR_ID) {
                const inspectedStore = payload.nodeId === $52e3354521f75c8c$var$PINIA_ROOT_ID ? pinia : pinia._s.get(payload.nodeId);
                if (!inspectedStore) return $52e3354521f75c8c$var$toastMessage(`store "${payload.nodeId}" not found`, 'error');
                const { path: path } = payload;
                if (!$52e3354521f75c8c$var$isPinia(inspectedStore)) // access only the state
                {
                    if (path.length !== 1 || !inspectedStore._customProperties.has(path[0]) || path[0] in inspectedStore.$state) path.unshift('$state');
                } else // Root access, we can omit the `.value` because the devtools API does it for us
                path.unshift('state');
                $52e3354521f75c8c$var$isTimelineActive = false;
                payload.set(inspectedStore, path, payload.state.value);
                $52e3354521f75c8c$var$isTimelineActive = true;
            }
        });
        api.on.editComponentState((payload)=>{
            if (payload.type.startsWith("\uD83C\uDF4D")) {
                const storeId = payload.type.replace(/^🍍\s*/, '');
                const store = pinia._s.get(storeId);
                if (!store) return $52e3354521f75c8c$var$toastMessage(`store "${storeId}" not found`, 'error');
                const { path: path } = payload;
                if (path[0] !== 'state') return $52e3354521f75c8c$var$toastMessage(`Invalid path for store "${storeId}":\n${path}\nOnly state can be modified.`);
                // rewrite the first entry to be able to directly set the state as
                // well as any other path
                path[0] = '$state';
                $52e3354521f75c8c$var$isTimelineActive = false;
                payload.set(store, path, payload.state.value);
                $52e3354521f75c8c$var$isTimelineActive = true;
            }
        });
    });
}
function $52e3354521f75c8c$var$addStoreToDevtools(app, store) {
    if (!$52e3354521f75c8c$var$componentStateTypes.includes($52e3354521f75c8c$var$getStoreType(store.$id))) $52e3354521f75c8c$var$componentStateTypes.push($52e3354521f75c8c$var$getStoreType(store.$id));
    (0, $70eLC.setupDevToolsPlugin)({
        id: 'dev.esm.pinia',
        label: "Pinia \uD83C\uDF4D",
        logo: 'https://pinia.vuejs.org/logo.svg',
        packageName: 'pinia',
        homepage: 'https://pinia.vuejs.org',
        componentStateTypes: $52e3354521f75c8c$var$componentStateTypes,
        app: app,
        settings: {
            logStoreChanges: {
                label: 'Notify about new/deleted stores',
                type: 'boolean',
                defaultValue: true
            }
        }
    }, (api)=>{
        // gracefully handle errors
        const now = typeof api.now === 'function' ? api.now.bind(api) : Date.now;
        store.$onAction(({ after: after, onError: onError, name: name, args: args })=>{
            const groupId = $52e3354521f75c8c$var$runningActionId++;
            api.addTimelineEvent({
                layerId: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
                event: {
                    time: now(),
                    title: "\uD83D\uDEEB " + name,
                    subtitle: 'start',
                    data: {
                        store: $52e3354521f75c8c$var$formatDisplay(store.$id),
                        action: $52e3354521f75c8c$var$formatDisplay(name),
                        args: args
                    },
                    groupId: groupId
                }
            });
            after((result)=>{
                $52e3354521f75c8c$var$activeAction = undefined;
                api.addTimelineEvent({
                    layerId: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        title: "\uD83D\uDEEC " + name,
                        subtitle: 'end',
                        data: {
                            store: $52e3354521f75c8c$var$formatDisplay(store.$id),
                            action: $52e3354521f75c8c$var$formatDisplay(name),
                            args: args,
                            result: result
                        },
                        groupId: groupId
                    }
                });
            });
            onError((error)=>{
                $52e3354521f75c8c$var$activeAction = undefined;
                api.addTimelineEvent({
                    layerId: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        logType: 'error',
                        title: "\uD83D\uDCA5 " + name,
                        subtitle: 'end',
                        data: {
                            store: $52e3354521f75c8c$var$formatDisplay(store.$id),
                            action: $52e3354521f75c8c$var$formatDisplay(name),
                            args: args,
                            error: error
                        },
                        groupId: groupId
                    }
                });
            });
        }, true);
        store._customProperties.forEach((name)=>{
            (0, $01W3b.watch)(()=>(0, $01W3b.unref)(store[name]), (newValue, oldValue)=>{
                api.notifyComponentUpdate();
                api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
                if ($52e3354521f75c8c$var$isTimelineActive) api.addTimelineEvent({
                    layerId: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        title: 'Change',
                        subtitle: name,
                        data: {
                            newValue: newValue,
                            oldValue: oldValue
                        },
                        groupId: $52e3354521f75c8c$var$activeAction
                    }
                });
            }, {
                deep: true
            });
        });
        store.$subscribe(({ events: events, type: type }, state)=>{
            api.notifyComponentUpdate();
            api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
            if (!$52e3354521f75c8c$var$isTimelineActive) return;
            // rootStore.state[store.id] = state
            const eventData = {
                time: now(),
                title: $52e3354521f75c8c$var$formatMutationType(type),
                data: $52e3354521f75c8c$var$assign$1({
                    store: $52e3354521f75c8c$var$formatDisplay(store.$id)
                }, $52e3354521f75c8c$var$formatEventData(events)),
                groupId: $52e3354521f75c8c$var$activeAction
            };
            if (type === $52e3354521f75c8c$export$d97371ba8df8c539.patchFunction) eventData.subtitle = "\u2935\uFE0F";
            else if (type === $52e3354521f75c8c$export$d97371ba8df8c539.patchObject) eventData.subtitle = "\uD83E\uDDE9";
            else if (events && !Array.isArray(events)) eventData.subtitle = events.type;
            if (events) eventData.data['rawEvent(s)'] = {
                _custom: {
                    display: 'DebuggerEvent',
                    type: 'object',
                    tooltip: 'raw DebuggerEvent[]',
                    value: events
                }
            };
            api.addTimelineEvent({
                layerId: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
                event: eventData
            });
        }, {
            detached: true,
            flush: 'sync'
        });
        const hotUpdate = store._hotUpdate;
        store._hotUpdate = (0, $01W3b.markRaw)((newStore)=>{
            hotUpdate(newStore);
            api.addTimelineEvent({
                layerId: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
                event: {
                    time: now(),
                    title: "\uD83D\uDD25 " + store.$id,
                    subtitle: 'HMR update',
                    data: {
                        store: $52e3354521f75c8c$var$formatDisplay(store.$id),
                        info: $52e3354521f75c8c$var$formatDisplay(`HMR update`)
                    }
                }
            });
            // update the devtools too
            api.notifyComponentUpdate();
            api.sendInspectorTree($52e3354521f75c8c$var$INSPECTOR_ID);
            api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
        });
        const { $dispose: $dispose } = store;
        store.$dispose = ()=>{
            $dispose();
            api.notifyComponentUpdate();
            api.sendInspectorTree($52e3354521f75c8c$var$INSPECTOR_ID);
            api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
            api.getSettings().logStoreChanges && $52e3354521f75c8c$var$toastMessage(`Disposed "${store.$id}" store \u{1F5D1}`);
        };
        // trigger an update so it can display new registered stores
        api.notifyComponentUpdate();
        api.sendInspectorTree($52e3354521f75c8c$var$INSPECTOR_ID);
        api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
        api.getSettings().logStoreChanges && $52e3354521f75c8c$var$toastMessage(`"${store.$id}" store installed \u{1F195}`);
    });
}
let $52e3354521f75c8c$var$runningActionId = 0;
let $52e3354521f75c8c$var$activeAction;
/**
 * Patches a store to enable action grouping in devtools by wrapping the store with a Proxy that is passed as the
 * context of all actions, allowing us to set `runningAction` on each access and effectively associating any state
 * mutation to the action.
 *
 * @param store - store to patch
 * @param actionNames - list of actionst to patch
 */ function $52e3354521f75c8c$var$patchActionForGrouping(store, actionNames, wrapWithProxy) {
    // original actions of the store as they are given by pinia. We are going to override them
    const actions = actionNames.reduce((storeActions, actionName)=>{
        // use toRaw to avoid tracking #541
        storeActions[actionName] = (0, $01W3b.toRaw)(store)[actionName];
        return storeActions;
    }, {});
    for(const actionName in actions)store[actionName] = function() {
        // the running action id is incremented in a before action hook
        const _actionId = $52e3354521f75c8c$var$runningActionId;
        const trackedStore = wrapWithProxy ? new Proxy(store, {
            get (...args) {
                $52e3354521f75c8c$var$activeAction = _actionId;
                return Reflect.get(...args);
            },
            set (...args) {
                $52e3354521f75c8c$var$activeAction = _actionId;
                return Reflect.set(...args);
            }
        }) : store;
        // For Setup Stores we need https://github.com/tc39/proposal-async-context
        $52e3354521f75c8c$var$activeAction = _actionId;
        const retValue = actions[actionName].apply(trackedStore, arguments);
        // this is safer as async actions in Setup Stores would associate mutations done outside of the action
        $52e3354521f75c8c$var$activeAction = undefined;
        return retValue;
    };
}
/**
 * pinia.use(devtoolsPlugin)
 */ function $52e3354521f75c8c$var$devtoolsPlugin({ app: app, store: store, options: options }) {
    // HMR module
    if (store.$id.startsWith('__hot:')) return;
    // detect option api vs setup api
    store._isOptionsAPI = !!options.state;
    // Do not overwrite actions mocked by @pinia/testing (#2298)
    if (!store._p._testing) {
        $52e3354521f75c8c$var$patchActionForGrouping(store, Object.keys(options.actions), store._isOptionsAPI);
        // Upgrade the HMR to also update the new actions
        const originalHotUpdate = store._hotUpdate;
        (0, $01W3b.toRaw)(store)._hotUpdate = function(newStore) {
            originalHotUpdate.apply(this, arguments);
            $52e3354521f75c8c$var$patchActionForGrouping(store, Object.keys(newStore._hmrPayload.actions), !!store._isOptionsAPI);
        };
    }
    $52e3354521f75c8c$var$addStoreToDevtools(app, // FIXME: is there a way to allow the assignment from Store<Id, S, G, A> to StoreGeneric?
    store);
}
/**
 * Creates a Pinia instance to be used by the application
 */ function $52e3354521f75c8c$export$4b9f6a0748623d44() {
    const scope = (0, $01W3b.effectScope)(true);
    // NOTE: here we could check the window object for a state and directly set it
    // if there is anything like it with Vue 3 SSR
    const state = scope.run(()=>(0, $01W3b.ref)({}));
    let _p = [];
    // plugins added before calling app.use(pinia)
    let toBeInstalled = [];
    const pinia = (0, $01W3b.markRaw)({
        install (app) {
            // this allows calling useStore() outside of a component setup after
            // installing pinia's plugin
            $52e3354521f75c8c$export$89ffb8149ccd46af(pinia);
            pinia._a = app;
            app.provide($52e3354521f75c8c$var$piniaSymbol, pinia);
            app.config.globalProperties.$pinia = pinia;
            /* istanbul ignore else */ if (typeof __VUE_PROD_DEVTOOLS__ !== 'undefined' && __VUE_PROD_DEVTOOLS__ && true && $52e3354521f75c8c$var$IS_CLIENT) $52e3354521f75c8c$var$registerPiniaDevtools(app, pinia);
            toBeInstalled.forEach((plugin)=>_p.push(plugin));
            toBeInstalled = [];
        },
        use (plugin) {
            if (!this._a) toBeInstalled.push(plugin);
            else _p.push(plugin);
            return this;
        },
        _p: _p,
        // it's actually undefined here
        // @ts-expect-error
        _a: null,
        _e: scope,
        _s: new Map(),
        state: state
    });
    // pinia devtools rely on dev only features so they cannot be forced unless
    // the dev build of Vue is used. Avoid old browsers like IE11.
    if (typeof __VUE_PROD_DEVTOOLS__ !== 'undefined' && __VUE_PROD_DEVTOOLS__ && true && $52e3354521f75c8c$var$IS_CLIENT && typeof Proxy !== 'undefined') pinia.use($52e3354521f75c8c$var$devtoolsPlugin);
    return pinia;
}
/**
 * Dispose a Pinia instance by stopping its effectScope and removing the state, plugins and stores. This is mostly
 * useful in tests, with both a testing pinia or a regular pinia and in applications that use multiple pinia instances.
 * Once disposed, the pinia instance cannot be used anymore.
 *
 * @param pinia - pinia instance
 */ function $52e3354521f75c8c$export$75b0179c67a9344e(pinia) {
    pinia._e.stop();
    pinia._s.clear();
    pinia._p.splice(0);
    pinia.state.value = {};
    // @ts-expect-error: non valid
    pinia._a = null;
}
/**
 * Checks if a function is a `StoreDefinition`.
 *
 * @param fn - object to test
 * @returns true if `fn` is a StoreDefinition
 */ const $52e3354521f75c8c$var$isUseStore = (fn)=>{
    return typeof fn === 'function' && typeof fn.$id === 'string';
};
/**
 * Mutates in place `newState` with `oldState` to _hot update_ it. It will
 * remove any key not existing in `newState` and recursively merge plain
 * objects.
 *
 * @param newState - new state object to be patched
 * @param oldState - old state that should be used to patch newState
 * @returns - newState
 */ function $52e3354521f75c8c$var$patchObject(newState, oldState) {
    // no need to go through symbols because they cannot be serialized anyway
    for(const key in oldState){
        const subPatch = oldState[key];
        // skip the whole sub tree
        if (!(key in newState)) continue;
        const targetValue = newState[key];
        if ($52e3354521f75c8c$var$isPlainObject(targetValue) && $52e3354521f75c8c$var$isPlainObject(subPatch) && !(0, $01W3b.isRef)(subPatch) && !(0, $01W3b.isReactive)(subPatch)) newState[key] = $52e3354521f75c8c$var$patchObject(targetValue, subPatch);
        else // objects are either a bit more complex (e.g. refs) or primitives, so we
        // just set the whole thing
        newState[key] = subPatch;
    }
    return newState;
}
/**
 * Creates an _accept_ function to pass to `import.meta.hot` in Vite applications.
 *
 * @example
 * ```js
 * const useUser = defineStore(...)
 * if (import.meta.hot) {
 *   import.meta.hot.accept(acceptHMRUpdate(useUser, import.meta.hot))
 * }
 * ```
 *
 * @param initialUseStore - return of the defineStore to hot update
 * @param hot - `import.meta.hot`
 */ function $52e3354521f75c8c$export$d3530ca2abd36d5e(initialUseStore, hot) {
    var newModule;
    return ()=>{};
}
const $52e3354521f75c8c$var$noop = ()=>{};
function $52e3354521f75c8c$var$addSubscription(subscriptions, callback, detached, onCleanup = $52e3354521f75c8c$var$noop) {
    subscriptions.push(callback);
    const removeSubscription = ()=>{
        const idx = subscriptions.indexOf(callback);
        if (idx > -1) {
            subscriptions.splice(idx, 1);
            onCleanup();
        }
    };
    if (!detached && (0, $01W3b.getCurrentScope)()) (0, $01W3b.onScopeDispose)(removeSubscription);
    return removeSubscription;
}
function $52e3354521f75c8c$var$triggerSubscriptions(subscriptions, ...args) {
    subscriptions.slice().forEach((callback)=>{
        callback(...args);
    });
}
const $52e3354521f75c8c$var$fallbackRunWithContext = (fn)=>fn();
/**
 * Marks a function as an action for `$onAction`
 * @internal
 */ const $52e3354521f75c8c$var$ACTION_MARKER = Symbol();
/**
 * Action name symbol. Allows to add a name to an action after defining it
 * @internal
 */ const $52e3354521f75c8c$var$ACTION_NAME = Symbol();
function $52e3354521f75c8c$var$mergeReactiveObjects(target, patchToApply) {
    // Handle Map instances
    if (target instanceof Map && patchToApply instanceof Map) patchToApply.forEach((value, key)=>target.set(key, value));
    else if (target instanceof Set && patchToApply instanceof Set) // Handle Set instances
    patchToApply.forEach(target.add, target);
    // no need to go through symbols because they cannot be serialized anyway
    for(const key in patchToApply){
        if (!patchToApply.hasOwnProperty(key)) continue;
        const subPatch = patchToApply[key];
        const targetValue = target[key];
        if ($52e3354521f75c8c$var$isPlainObject(targetValue) && $52e3354521f75c8c$var$isPlainObject(subPatch) && target.hasOwnProperty(key) && !(0, $01W3b.isRef)(subPatch) && !(0, $01W3b.isReactive)(subPatch)) // NOTE: here I wanted to warn about inconsistent types but it's not possible because in setup stores one might
        // start the value of a property as a certain type e.g. a Map, and then for some reason, during SSR, change that
        // to `undefined`. When trying to hydrate, we want to override the Map with `undefined`.
        target[key] = $52e3354521f75c8c$var$mergeReactiveObjects(targetValue, subPatch);
        else // @ts-expect-error: subPatch is a valid value
        target[key] = subPatch;
    }
    return target;
}
const $52e3354521f75c8c$var$skipHydrateSymbol = /* istanbul ignore next */ Symbol();
/**
 * Tells Pinia to skip the hydration process of a given object. This is useful in setup stores (only) when you return a
 * stateful object in the store but it isn't really state. e.g. returning a router instance in a setup store.
 *
 * @param obj - target object
 * @returns obj
 */ function $52e3354521f75c8c$export$dbb88672ab248e88(obj) {
    return Object.defineProperty(obj, $52e3354521f75c8c$var$skipHydrateSymbol, {});
}
/**
 * Returns whether a value should be hydrated
 *
 * @param obj - target variable
 * @returns true if `obj` should be hydrated
 */ function $52e3354521f75c8c$export$bdc3d2e33d3136e5(obj) {
    return !$52e3354521f75c8c$var$isPlainObject(obj) || !obj.hasOwnProperty($52e3354521f75c8c$var$skipHydrateSymbol);
}
const { assign: $52e3354521f75c8c$var$assign } = Object;
function $52e3354521f75c8c$var$isComputed(o) {
    return !!((0, $01W3b.isRef)(o) && o.effect);
}
function $52e3354521f75c8c$var$createOptionsStore(id, options, pinia, hot) {
    const { state: state, actions: actions, getters: getters } = options;
    const initialState = pinia.state.value[id];
    let store;
    function setup() {
        if (!initialState && true) /* istanbul ignore if */ pinia.state.value[id] = state ? state() : {};
        // avoid creating a state in pinia.state.value
        const localState = (0, $01W3b.toRefs)(pinia.state.value[id]);
        return $52e3354521f75c8c$var$assign(localState, actions, Object.keys(getters || {}).reduce((computedGetters, name)=>{
            computedGetters[name] = (0, $01W3b.markRaw)((0, $01W3b.computed)(()=>{
                $52e3354521f75c8c$export$89ffb8149ccd46af(pinia);
                // it was created just before
                const store = pinia._s.get(id);
                // allow cross using stores
                // @ts-expect-error
                // return getters![name].call(context, context)
                // TODO: avoid reading the getter while assigning with a global variable
                return getters[name].call(store, store);
            }));
            return computedGetters;
        }, {}));
    }
    store = $52e3354521f75c8c$var$createSetupStore(id, setup, options, pinia, hot, true);
    return store;
}
function $52e3354521f75c8c$var$createSetupStore($id, setup, options = {}, pinia, hot, isOptionsStore) {
    let scope;
    const optionsForPlugin = $52e3354521f75c8c$var$assign({
        actions: {}
    }, options);
    // watcher options for $subscribe
    const $subscribeOptions = {
        deep: true
    };
    var event;
    // internal state
    let isListening; // set to true at the end
    let isSyncListening; // set to true at the end
    let subscriptions = [];
    let actionSubscriptions = [];
    let debuggerEvents;
    const initialState = pinia.state.value[$id];
    // avoid setting the state for option stores if it is set
    // by the setup
    if (!isOptionsStore && !initialState && true) /* istanbul ignore if */ pinia.state.value[$id] = {};
    const hotState = (0, $01W3b.ref)({});
    // avoid triggering too many listeners
    // https://github.com/vuejs/pinia/issues/1129
    let activeListener;
    function $patch(partialStateOrMutator) {
        let subscriptionMutation;
        isListening = isSyncListening = false;
        if (typeof partialStateOrMutator === 'function') {
            partialStateOrMutator(pinia.state.value[$id]);
            subscriptionMutation = {
                type: $52e3354521f75c8c$export$d97371ba8df8c539.patchFunction,
                storeId: $id,
                events: debuggerEvents
            };
        } else {
            $52e3354521f75c8c$var$mergeReactiveObjects(pinia.state.value[$id], partialStateOrMutator);
            subscriptionMutation = {
                type: $52e3354521f75c8c$export$d97371ba8df8c539.patchObject,
                payload: partialStateOrMutator,
                storeId: $id,
                events: debuggerEvents
            };
        }
        const myListenerId = activeListener = Symbol();
        (0, $TusQn.nextTick)().then(()=>{
            if (activeListener === myListenerId) isListening = true;
        });
        isSyncListening = true;
        // because we paused the watcher, we need to manually call the subscriptions
        $52e3354521f75c8c$var$triggerSubscriptions(subscriptions, subscriptionMutation, pinia.state.value[$id]);
    }
    const $reset = isOptionsStore ? function $reset() {
        const { state: state } = options;
        const newState = state ? state() : {};
        // we use a patch to group all changes into one single subscription
        this.$patch(($state)=>{
            // @ts-expect-error: FIXME: shouldn't error?
            $52e3354521f75c8c$var$assign($state, newState);
        });
    } : $52e3354521f75c8c$var$noop;
    function $dispose() {
        scope.stop();
        subscriptions = [];
        actionSubscriptions = [];
        pinia._s.delete($id);
    }
    /**
     * Helper that wraps function so it can be tracked with $onAction
     * @param fn - action to wrap
     * @param name - name of the action
     */ const action = (fn, name = '')=>{
        if ($52e3354521f75c8c$var$ACTION_MARKER in fn) {
            fn[$52e3354521f75c8c$var$ACTION_NAME] = name;
            return fn;
        }
        const wrappedAction = function() {
            $52e3354521f75c8c$export$89ffb8149ccd46af(pinia);
            const args = Array.from(arguments);
            const afterCallbackList = [];
            const onErrorCallbackList = [];
            function after(callback) {
                afterCallbackList.push(callback);
            }
            function onError(callback) {
                onErrorCallbackList.push(callback);
            }
            // @ts-expect-error
            $52e3354521f75c8c$var$triggerSubscriptions(actionSubscriptions, {
                args: args,
                name: wrappedAction[$52e3354521f75c8c$var$ACTION_NAME],
                store: store,
                after: after,
                onError: onError
            });
            let ret;
            try {
                ret = fn.apply(this && this.$id === $id ? this : store, args);
            // handle sync errors
            } catch (error) {
                $52e3354521f75c8c$var$triggerSubscriptions(onErrorCallbackList, error);
                throw error;
            }
            if (ret instanceof Promise) return ret.then((value)=>{
                $52e3354521f75c8c$var$triggerSubscriptions(afterCallbackList, value);
                return value;
            }).catch((error)=>{
                $52e3354521f75c8c$var$triggerSubscriptions(onErrorCallbackList, error);
                return Promise.reject(error);
            });
            // trigger after callbacks
            $52e3354521f75c8c$var$triggerSubscriptions(afterCallbackList, ret);
            return ret;
        };
        wrappedAction[$52e3354521f75c8c$var$ACTION_MARKER] = true;
        wrappedAction[$52e3354521f75c8c$var$ACTION_NAME] = name; // will be set later
        // @ts-expect-error: we are intentionally limiting the returned type to just Fn
        // because all the added properties are internals that are exposed through `$onAction()` only
        return wrappedAction;
    };
    const _hmrPayload = /*#__PURE__*/ (0, $01W3b.markRaw)({
        actions: {},
        getters: {},
        state: [],
        hotState: hotState
    });
    const partialStore = {
        _p: pinia,
        $id: // _s: scope,
        $id,
        $onAction: $52e3354521f75c8c$var$addSubscription.bind(null, actionSubscriptions),
        $patch: $patch,
        $reset: $reset,
        $subscribe (callback, options = {}) {
            const removeSubscription = $52e3354521f75c8c$var$addSubscription(subscriptions, callback, options.detached, ()=>stopWatcher());
            const stopWatcher = scope.run(()=>(0, $01W3b.watch)(()=>pinia.state.value[$id], (state)=>{
                    if (options.flush === 'sync' ? isSyncListening : isListening) callback({
                        storeId: $id,
                        type: $52e3354521f75c8c$export$d97371ba8df8c539.direct,
                        events: debuggerEvents
                    }, state);
                }, $52e3354521f75c8c$var$assign({}, $subscribeOptions, options)));
            return removeSubscription;
        },
        $dispose: $dispose
    };
    const store = (0, $01W3b.reactive)(typeof __VUE_PROD_DEVTOOLS__ !== 'undefined' && __VUE_PROD_DEVTOOLS__ && true && $52e3354521f75c8c$var$IS_CLIENT ? $52e3354521f75c8c$var$assign({
        _hmrPayload: _hmrPayload,
        _customProperties: (0, $01W3b.markRaw)(new Set())
    }, partialStore) : partialStore);
    // store the partial store now so the setup of stores can instantiate each other before they are finished without
    // creating infinite loops.
    pinia._s.set($id, store);
    const runWithContext = pinia._a && pinia._a.runWithContext || $52e3354521f75c8c$var$fallbackRunWithContext;
    // TODO: idea create skipSerialize that marks properties as non serializable and they are skipped
    const setupStore = runWithContext(()=>pinia._e.run(()=>(scope = (0, $01W3b.effectScope)()).run(()=>setup({
                    action: action
                }))));
    // overwrite existing actions to support $onAction
    for(const key in setupStore){
        const prop = setupStore[key];
        if ((0, $01W3b.isRef)(prop) && !$52e3354521f75c8c$var$isComputed(prop) || (0, $01W3b.isReactive)(prop)) {
            if (!isOptionsStore) {
                // in setup stores we must hydrate the state and sync pinia state tree with the refs the user just created
                if (initialState && $52e3354521f75c8c$export$bdc3d2e33d3136e5(prop)) {
                    if ((0, $01W3b.isRef)(prop)) prop.value = initialState[key];
                    else // probably a reactive object, lets recursively assign
                    // @ts-expect-error: prop is unknown
                    $52e3354521f75c8c$var$mergeReactiveObjects(prop, initialState[key]);
                }
                // transfer the ref to the pinia state to keep everything in sync
                pinia.state.value[$id][key] = prop;
            }
        } else if (typeof prop === 'function') {
            const actionValue = action(prop, key);
            // this a hot module replacement store because the hotUpdate method needs
            // to do it with the right context
            // @ts-expect-error
            setupStore[key] = actionValue;
            // list actions so they can be used in plugins
            // @ts-expect-error
            optionsForPlugin.actions[key] = prop;
        }
    }
    // add the state, getters, and action properties
    /* istanbul ignore if */ $52e3354521f75c8c$var$assign(store, setupStore);
    // allows retrieving reactive objects with `storeToRefs()`. Must be called after assigning to the reactive object.
    // Make `storeToRefs()` work with `reactive()` #799
    $52e3354521f75c8c$var$assign((0, $01W3b.toRaw)(store), setupStore);
    // use this instead of a computed with setter to be able to create it anywhere
    // without linking the computed lifespan to wherever the store is first
    // created.
    Object.defineProperty(store, '$state', {
        get: ()=>(0, pinia.state.value[$id]),
        set: (state)=>{
            $patch(($state)=>{
                // @ts-expect-error: FIXME: shouldn't error?
                $52e3354521f75c8c$var$assign($state, state);
            });
        }
    });
    var newStore, stateKey, stateKey1, key, key1;
    if (typeof __VUE_PROD_DEVTOOLS__ !== 'undefined' && __VUE_PROD_DEVTOOLS__ && true && $52e3354521f75c8c$var$IS_CLIENT) {
        const nonEnumerable = {
            writable: true,
            configurable: true,
            // avoid warning on devtools trying to display this property
            enumerable: false
        };
        [
            '_p',
            '_hmrPayload',
            '_getters',
            '_customProperties'
        ].forEach((p)=>{
            Object.defineProperty(store, p, $52e3354521f75c8c$var$assign({
                value: store[p]
            }, nonEnumerable));
        });
    }
    // apply all plugins
    pinia._p.forEach((extender)=>{
        /* istanbul ignore else */ if (typeof __VUE_PROD_DEVTOOLS__ !== 'undefined' && __VUE_PROD_DEVTOOLS__ && true && $52e3354521f75c8c$var$IS_CLIENT) {
            const extensions = scope.run(()=>extender({
                    store: store,
                    app: pinia._a,
                    pinia: pinia,
                    options: optionsForPlugin
                }));
            Object.keys(extensions || {}).forEach((key)=>store._customProperties.add(key));
            $52e3354521f75c8c$var$assign(store, extensions);
        } else $52e3354521f75c8c$var$assign(store, scope.run(()=>extender({
                store: store,
                app: pinia._a,
                pinia: pinia,
                options: optionsForPlugin
            })));
    });
    // only apply hydrate to option stores with an initial state in pinia
    if (initialState && isOptionsStore && options.hydrate) options.hydrate(store.$state, initialState);
    isListening = true;
    isSyncListening = true;
    return store;
}
// allows unused stores to be tree shaken
/*! #__NO_SIDE_EFFECTS__ */ function $52e3354521f75c8c$export$5061c4f75bbcb4a(// TODO: add proper types from above
id, setup, setupOptions) {
    let options;
    const isSetupStore = typeof setup === 'function';
    // the option store setup will contain the actual options in this case
    options = isSetupStore ? setupOptions : setup;
    function useStore(pinia, hot) {
        const hasContext = (0, $TusQn.hasInjectionContext)();
        pinia = pinia || (hasContext ? (0, $TusQn.inject)($52e3354521f75c8c$var$piniaSymbol, null) : null);
        if (pinia) $52e3354521f75c8c$export$89ffb8149ccd46af(pinia);
        pinia = $52e3354521f75c8c$var$activePinia;
        if (!pinia._s.has(id)) {
            // creating the store registers it in `pinia._s`
            if (isSetupStore) $52e3354521f75c8c$var$createSetupStore(id, setup, options, pinia);
            else $52e3354521f75c8c$var$createOptionsStore(id, options, pinia);
        }
        const store = pinia._s.get(id);
        // StoreGeneric cannot be casted towards Store
        return store;
    }
    useStore.$id = id;
    return useStore;
}
let $52e3354521f75c8c$var$mapStoreSuffix = 'Store';
/**
 * Changes the suffix added by `mapStores()`. Can be set to an empty string.
 * Defaults to `"Store"`. Make sure to extend the MapStoresCustomization
 * interface if you are using TypeScript.
 *
 * @param suffix - new suffix
 */ function $52e3354521f75c8c$export$3c0d0850ffd38177(suffix // could be 'Store' but that would be annoying for JS
) {
    $52e3354521f75c8c$var$mapStoreSuffix = suffix;
}
/**
 * Allows using stores without the composition API (`setup()`) by generating an
 * object to be spread in the `computed` field of a component. It accepts a list
 * of store definitions.
 *
 * @example
 * ```js
 * export default {
 *   computed: {
 *     // other computed properties
 *     ...mapStores(useUserStore, useCartStore)
 *   },
 *
 *   created() {
 *     this.userStore // store with id "user"
 *     this.cartStore // store with id "cart"
 *   }
 * }
 * ```
 *
 * @param stores - list of stores to map to an object
 */ function $52e3354521f75c8c$export$4701f243feba9f88(...stores) {
    return stores.reduce((reduced, useStore)=>{
        // @ts-expect-error: $id is added by defineStore
        reduced[useStore.$id + $52e3354521f75c8c$var$mapStoreSuffix] = function() {
            return useStore(this.$pinia);
        };
        return reduced;
    }, {});
}
/**
 * Allows using state and getters from one store without using the composition
 * API (`setup()`) by generating an object to be spread in the `computed` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */ function $52e3354521f75c8c$export$a337c713bdba072(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper) ? keysOrMapper.reduce((reduced, key)=>{
        reduced[key] = function() {
            // @ts-expect-error: FIXME: should work?
            return useStore(this.$pinia)[key];
        };
        return reduced;
    }, {}) : Object.keys(keysOrMapper).reduce((reduced, key)=>{
        // @ts-expect-error
        reduced[key] = function() {
            const store = useStore(this.$pinia);
            const storeKey = keysOrMapper[key];
            // for some reason TS is unable to infer the type of storeKey to be a
            // function
            return typeof storeKey === 'function' ? storeKey.call(this, store) : store[storeKey];
        };
        return reduced;
    }, {});
}
/**
 * Alias for `mapState()`. You should use `mapState()` instead.
 * @deprecated use `mapState()` instead.
 */ const $52e3354521f75c8c$export$74d9085e6d5a97cb = $52e3354521f75c8c$export$a337c713bdba072;
/**
 * Allows directly using actions from your store without using the composition
 * API (`setup()`) by generating an object to be spread in the `methods` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */ function $52e3354521f75c8c$export$1d73b9b98821f6dc(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper) ? keysOrMapper.reduce((reduced, key)=>{
        // @ts-expect-error
        reduced[key] = function(...args) {
            // @ts-expect-error: FIXME: should work?
            return useStore(this.$pinia)[key](...args);
        };
        return reduced;
    }, {}) : Object.keys(keysOrMapper).reduce((reduced, key)=>{
        // @ts-expect-error
        reduced[key] = function(...args) {
            // @ts-expect-error: FIXME: should work?
            return useStore(this.$pinia)[keysOrMapper[key]](...args);
        };
        return reduced;
    }, {});
}
/**
 * Allows using state and getters from one store without using the composition
 * API (`setup()`) by generating an object to be spread in the `computed` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */ function $52e3354521f75c8c$export$c069310e76f1a3e7(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper) ? keysOrMapper.reduce((reduced, key)=>{
        reduced[key] = {
            get () {
                return useStore(this.$pinia)[key];
            },
            set (value) {
                return useStore(this.$pinia)[key] = value;
            }
        };
        return reduced;
    }, {}) : Object.keys(keysOrMapper).reduce((reduced, key)=>{
        reduced[key] = {
            get () {
                return useStore(this.$pinia)[keysOrMapper[key]];
            },
            set (value) {
                return useStore(this.$pinia)[keysOrMapper[key]] = value;
            }
        };
        return reduced;
    }, {});
}
/**
 * Creates an object of references with all the state, getters, and plugin-added
 * state properties of the store. Similar to `toRefs()` but specifically
 * designed for Pinia stores so methods and non reactive properties are
 * completely ignored.
 *
 * @param store - store to extract the refs from
 */ function $52e3354521f75c8c$export$586af8bd019552de(store) {
    const rawStore = (0, $01W3b.toRaw)(store);
    const refs = {};
    for(const key in rawStore){
        const value = rawStore[key];
        // There is no native method to check for a computed
        // https://github.com/vuejs/core/pull/4165
        if (value.effect) // @ts-expect-error: too hard to type correctly
        refs[key] = // ...
        (0, $01W3b.computed)({
            get: ()=>store[key],
            set (value) {
                store[key] = value;
            }
        });
        else if ((0, $01W3b.isRef)(value) || (0, $01W3b.isReactive)(value)) // @ts-expect-error: the key is state or getter
        refs[key] = // ---
        (0, $01W3b.toRef)(store, key);
    }
    return refs;
}

});
parcelRegister("70eLC", function(module, exports) {

$parcel$export(module.exports, "setupDevToolsPlugin", () => $5193fce5c5df8bb9$export$1f0daed17c8e64f);

var $i0cUC = parcelRequire("i0cUC");

var $dj5lJ = parcelRequire("dj5lJ");

var $ptPDd = parcelRequire("ptPDd");

var $enkGC = parcelRequire("enkGC");
var $5193fce5c5df8bb9$var$__create = Object.create;
var $5193fce5c5df8bb9$var$__defProp = Object.defineProperty;
var $5193fce5c5df8bb9$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $5193fce5c5df8bb9$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $5193fce5c5df8bb9$var$__getProtoOf = Object.getPrototypeOf;
var $5193fce5c5df8bb9$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5193fce5c5df8bb9$var$__esm = (fn, res)=>function __init() {
        return fn && (res = (0, fn[$5193fce5c5df8bb9$var$__getOwnPropNames(fn)[0]])(fn = 0)), res;
    };
var $5193fce5c5df8bb9$var$__commonJS = (cb, mod)=>function __require() {
        return mod || (0, cb[$5193fce5c5df8bb9$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $5193fce5c5df8bb9$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $5193fce5c5df8bb9$var$__getOwnPropNames(from))if (!$5193fce5c5df8bb9$var$__hasOwnProp.call(to, key) && key !== except) $5193fce5c5df8bb9$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $5193fce5c5df8bb9$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $5193fce5c5df8bb9$var$__toESM = (mod, isNodeMode, target22)=>(target22 = mod != null ? $5193fce5c5df8bb9$var$__create($5193fce5c5df8bb9$var$__getProtoOf(mod)) : {}, $5193fce5c5df8bb9$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $5193fce5c5df8bb9$var$__defProp(target22, "default", {
        value: mod,
        enumerable: true
    }) : target22, mod));
// ../../node_modules/.pnpm/tsup@8.3.5_@microsoft+api-extractor@7.48.1_@types+node@22.10.5__jiti@2.4.2_postcss@8.4.49_tsx_s7k37zks4wtn7x2grzma6lrsfa/node_modules/tsup/assets/esm_shims.js
var $5193fce5c5df8bb9$var$init_esm_shims = $5193fce5c5df8bb9$var$__esm({
    "../../node_modules/.pnpm/tsup@8.3.5_@microsoft+api-extractor@7.48.1_@types+node@22.10.5__jiti@2.4.2_postcss@8.4.49_tsx_s7k37zks4wtn7x2grzma6lrsfa/node_modules/tsup/assets/esm_shims.js" () {
        "use strict";
    }
});
// ../../node_modules/.pnpm/speakingurl@14.0.1/node_modules/speakingurl/lib/speakingurl.js
var $5193fce5c5df8bb9$var$require_speakingurl = $5193fce5c5df8bb9$var$__commonJS({
    "../../node_modules/.pnpm/speakingurl@14.0.1/node_modules/speakingurl/lib/speakingurl.js" (exports, module) {
        "use strict";
        $5193fce5c5df8bb9$var$init_esm_shims();
        (function(root) {
            "use strict";
            var charMap = {
                // latin
                "\xC0": "A",
                "\xC1": "A",
                "\xC2": "A",
                "\xC3": "A",
                "\xC4": "Ae",
                "\xC5": "A",
                "\xC6": "AE",
                "\xC7": "C",
                "\xC8": "E",
                "\xC9": "E",
                "\xCA": "E",
                "\xCB": "E",
                "\xCC": "I",
                "\xCD": "I",
                "\xCE": "I",
                "\xCF": "I",
                "\xD0": "D",
                "\xD1": "N",
                "\xD2": "O",
                "\xD3": "O",
                "\xD4": "O",
                "\xD5": "O",
                "\xD6": "Oe",
                "\u0150": "O",
                "\xD8": "O",
                "\xD9": "U",
                "\xDA": "U",
                "\xDB": "U",
                "\xDC": "Ue",
                "\u0170": "U",
                "\xDD": "Y",
                "\xDE": "TH",
                "\xDF": "ss",
                "\xE0": "a",
                "\xE1": "a",
                "\xE2": "a",
                "\xE3": "a",
                "\xE4": "ae",
                "\xE5": "a",
                "\xE6": "ae",
                "\xE7": "c",
                "\xE8": "e",
                "\xE9": "e",
                "\xEA": "e",
                "\xEB": "e",
                "\xEC": "i",
                "\xED": "i",
                "\xEE": "i",
                "\xEF": "i",
                "\xF0": "d",
                "\xF1": "n",
                "\xF2": "o",
                "\xF3": "o",
                "\xF4": "o",
                "\xF5": "o",
                "\xF6": "oe",
                "\u0151": "o",
                "\xF8": "o",
                "\xF9": "u",
                "\xFA": "u",
                "\xFB": "u",
                "\xFC": "ue",
                "\u0171": "u",
                "\xFD": "y",
                "\xFE": "th",
                "\xFF": "y",
                "\u1E9E": "SS",
                // language specific
                // Arabic
                "\u0627": "a",
                "\u0623": "a",
                "\u0625": "i",
                "\u0622": "aa",
                "\u0624": "u",
                "\u0626": "e",
                "\u0621": "a",
                "\u0628": "b",
                "\u062A": "t",
                "\u062B": "th",
                "\u062C": "j",
                "\u062D": "h",
                "\u062E": "kh",
                "\u062F": "d",
                "\u0630": "th",
                "\u0631": "r",
                "\u0632": "z",
                "\u0633": "s",
                "\u0634": "sh",
                "\u0635": "s",
                "\u0636": "dh",
                "\u0637": "t",
                "\u0638": "z",
                "\u0639": "a",
                "\u063A": "gh",
                "\u0641": "f",
                "\u0642": "q",
                "\u0643": "k",
                "\u0644": "l",
                "\u0645": "m",
                "\u0646": "n",
                "\u0647": "h",
                "\u0648": "w",
                "\u064A": "y",
                "\u0649": "a",
                "\u0629": "h",
                "\uFEFB": "la",
                "\uFEF7": "laa",
                "\uFEF9": "lai",
                "\uFEF5": "laa",
                // Persian additional characters than Arabic
                "\u06AF": "g",
                "\u0686": "ch",
                "\u067E": "p",
                "\u0698": "zh",
                "\u06A9": "k",
                "\u06CC": "y",
                // Arabic diactrics
                "\u064E": "a",
                "\u064B": "an",
                "\u0650": "e",
                "\u064D": "en",
                "\u064F": "u",
                "\u064C": "on",
                "\u0652": "",
                // Arabic numbers
                "\u0660": "0",
                "\u0661": "1",
                "\u0662": "2",
                "\u0663": "3",
                "\u0664": "4",
                "\u0665": "5",
                "\u0666": "6",
                "\u0667": "7",
                "\u0668": "8",
                "\u0669": "9",
                // Persian numbers
                "\u06F0": "0",
                "\u06F1": "1",
                "\u06F2": "2",
                "\u06F3": "3",
                "\u06F4": "4",
                "\u06F5": "5",
                "\u06F6": "6",
                "\u06F7": "7",
                "\u06F8": "8",
                "\u06F9": "9",
                // Burmese consonants
                "\u1000": "k",
                "\u1001": "kh",
                "\u1002": "g",
                "\u1003": "ga",
                "\u1004": "ng",
                "\u1005": "s",
                "\u1006": "sa",
                "\u1007": "z",
                "\u1005\u103B": "za",
                "\u100A": "ny",
                "\u100B": "t",
                "\u100C": "ta",
                "\u100D": "d",
                "\u100E": "da",
                "\u100F": "na",
                "\u1010": "t",
                "\u1011": "ta",
                "\u1012": "d",
                "\u1013": "da",
                "\u1014": "n",
                "\u1015": "p",
                "\u1016": "pa",
                "\u1017": "b",
                "\u1018": "ba",
                "\u1019": "m",
                "\u101A": "y",
                "\u101B": "ya",
                "\u101C": "l",
                "\u101D": "w",
                "\u101E": "th",
                "\u101F": "h",
                "\u1020": "la",
                "\u1021": "a",
                // consonant character combos
                "\u103C": "y",
                "\u103B": "ya",
                "\u103D": "w",
                "\u103C\u103D": "yw",
                "\u103B\u103D": "ywa",
                "\u103E": "h",
                // independent vowels
                "\u1027": "e",
                "\u104F": "-e",
                "\u1023": "i",
                "\u1024": "-i",
                "\u1009": "u",
                "\u1026": "-u",
                "\u1029": "aw",
                "\u101E\u103C\u1031\u102C": "aw",
                "\u102A": "aw",
                // numbers
                "\u1040": "0",
                "\u1041": "1",
                "\u1042": "2",
                "\u1043": "3",
                "\u1044": "4",
                "\u1045": "5",
                "\u1046": "6",
                "\u1047": "7",
                "\u1048": "8",
                "\u1049": "9",
                // virama and tone marks which are silent in transliteration
                "\u1039": "",
                "\u1037": "",
                "\u1038": "",
                // Czech
                "\u010D": "c",
                "\u010F": "d",
                "\u011B": "e",
                "\u0148": "n",
                "\u0159": "r",
                "\u0161": "s",
                "\u0165": "t",
                "\u016F": "u",
                "\u017E": "z",
                "\u010C": "C",
                "\u010E": "D",
                "\u011A": "E",
                "\u0147": "N",
                "\u0158": "R",
                "\u0160": "S",
                "\u0164": "T",
                "\u016E": "U",
                "\u017D": "Z",
                // Dhivehi
                "\u0780": "h",
                "\u0781": "sh",
                "\u0782": "n",
                "\u0783": "r",
                "\u0784": "b",
                "\u0785": "lh",
                "\u0786": "k",
                "\u0787": "a",
                "\u0788": "v",
                "\u0789": "m",
                "\u078A": "f",
                "\u078B": "dh",
                "\u078C": "th",
                "\u078D": "l",
                "\u078E": "g",
                "\u078F": "gn",
                "\u0790": "s",
                "\u0791": "d",
                "\u0792": "z",
                "\u0793": "t",
                "\u0794": "y",
                "\u0795": "p",
                "\u0796": "j",
                "\u0797": "ch",
                "\u0798": "tt",
                "\u0799": "hh",
                "\u079A": "kh",
                "\u079B": "th",
                "\u079C": "z",
                "\u079D": "sh",
                "\u079E": "s",
                "\u079F": "d",
                "\u07A0": "t",
                "\u07A1": "z",
                "\u07A2": "a",
                "\u07A3": "gh",
                "\u07A4": "q",
                "\u07A5": "w",
                "\u07A6": "a",
                "\u07A7": "aa",
                "\u07A8": "i",
                "\u07A9": "ee",
                "\u07AA": "u",
                "\u07AB": "oo",
                "\u07AC": "e",
                "\u07AD": "ey",
                "\u07AE": "o",
                "\u07AF": "oa",
                "\u07B0": "",
                // Georgian https://en.wikipedia.org/wiki/Romanization_of_Georgian
                // National system (2002)
                "\u10D0": "a",
                "\u10D1": "b",
                "\u10D2": "g",
                "\u10D3": "d",
                "\u10D4": "e",
                "\u10D5": "v",
                "\u10D6": "z",
                "\u10D7": "t",
                "\u10D8": "i",
                "\u10D9": "k",
                "\u10DA": "l",
                "\u10DB": "m",
                "\u10DC": "n",
                "\u10DD": "o",
                "\u10DE": "p",
                "\u10DF": "zh",
                "\u10E0": "r",
                "\u10E1": "s",
                "\u10E2": "t",
                "\u10E3": "u",
                "\u10E4": "p",
                "\u10E5": "k",
                "\u10E6": "gh",
                "\u10E7": "q",
                "\u10E8": "sh",
                "\u10E9": "ch",
                "\u10EA": "ts",
                "\u10EB": "dz",
                "\u10EC": "ts",
                "\u10ED": "ch",
                "\u10EE": "kh",
                "\u10EF": "j",
                "\u10F0": "h",
                // Greek
                "\u03B1": "a",
                "\u03B2": "v",
                "\u03B3": "g",
                "\u03B4": "d",
                "\u03B5": "e",
                "\u03B6": "z",
                "\u03B7": "i",
                "\u03B8": "th",
                "\u03B9": "i",
                "\u03BA": "k",
                "\u03BB": "l",
                "\u03BC": "m",
                "\u03BD": "n",
                "\u03BE": "ks",
                "\u03BF": "o",
                "\u03C0": "p",
                "\u03C1": "r",
                "\u03C3": "s",
                "\u03C4": "t",
                "\u03C5": "y",
                "\u03C6": "f",
                "\u03C7": "x",
                "\u03C8": "ps",
                "\u03C9": "o",
                "\u03AC": "a",
                "\u03AD": "e",
                "\u03AF": "i",
                "\u03CC": "o",
                "\u03CD": "y",
                "\u03AE": "i",
                "\u03CE": "o",
                "\u03C2": "s",
                "\u03CA": "i",
                "\u03B0": "y",
                "\u03CB": "y",
                "\u0390": "i",
                "\u0391": "A",
                "\u0392": "B",
                "\u0393": "G",
                "\u0394": "D",
                "\u0395": "E",
                "\u0396": "Z",
                "\u0397": "I",
                "\u0398": "TH",
                "\u0399": "I",
                "\u039A": "K",
                "\u039B": "L",
                "\u039C": "M",
                "\u039D": "N",
                "\u039E": "KS",
                "\u039F": "O",
                "\u03A0": "P",
                "\u03A1": "R",
                "\u03A3": "S",
                "\u03A4": "T",
                "\u03A5": "Y",
                "\u03A6": "F",
                "\u03A7": "X",
                "\u03A8": "PS",
                "\u03A9": "O",
                "\u0386": "A",
                "\u0388": "E",
                "\u038A": "I",
                "\u038C": "O",
                "\u038E": "Y",
                "\u0389": "I",
                "\u038F": "O",
                "\u03AA": "I",
                "\u03AB": "Y",
                // Latvian
                "\u0101": "a",
                // 'č': 'c', // duplicate
                "\u0113": "e",
                "\u0123": "g",
                "\u012B": "i",
                "\u0137": "k",
                "\u013C": "l",
                "\u0146": "n",
                // 'š': 's', // duplicate
                "\u016B": "u",
                // 'ž': 'z', // duplicate
                "\u0100": "A",
                // 'Č': 'C', // duplicate
                "\u0112": "E",
                "\u0122": "G",
                "\u012A": "I",
                "\u0136": "k",
                "\u013B": "L",
                "\u0145": "N",
                // 'Š': 'S', // duplicate
                "\u016A": "U",
                // 'Ž': 'Z', // duplicate
                // Macedonian
                "\u040C": "Kj",
                "\u045C": "kj",
                "\u0409": "Lj",
                "\u0459": "lj",
                "\u040A": "Nj",
                "\u045A": "nj",
                "\u0422\u0441": "Ts",
                "\u0442\u0441": "ts",
                // Polish
                "\u0105": "a",
                "\u0107": "c",
                "\u0119": "e",
                "\u0142": "l",
                "\u0144": "n",
                // 'ó': 'o', // duplicate
                "\u015B": "s",
                "\u017A": "z",
                "\u017C": "z",
                "\u0104": "A",
                "\u0106": "C",
                "\u0118": "E",
                "\u0141": "L",
                "\u0143": "N",
                "\u015A": "S",
                "\u0179": "Z",
                "\u017B": "Z",
                // Ukranian
                "\u0404": "Ye",
                "\u0406": "I",
                "\u0407": "Yi",
                "\u0490": "G",
                "\u0454": "ye",
                "\u0456": "i",
                "\u0457": "yi",
                "\u0491": "g",
                // Romanian
                "\u0103": "a",
                "\u0102": "A",
                "\u0219": "s",
                "\u0218": "S",
                // 'ş': 's', // duplicate
                // 'Ş': 'S', // duplicate
                "\u021B": "t",
                "\u021A": "T",
                "\u0163": "t",
                "\u0162": "T",
                // Russian https://en.wikipedia.org/wiki/Romanization_of_Russian
                // ICAO
                "\u0430": "a",
                "\u0431": "b",
                "\u0432": "v",
                "\u0433": "g",
                "\u0434": "d",
                "\u0435": "e",
                "\u0451": "yo",
                "\u0436": "zh",
                "\u0437": "z",
                "\u0438": "i",
                "\u0439": "i",
                "\u043A": "k",
                "\u043B": "l",
                "\u043C": "m",
                "\u043D": "n",
                "\u043E": "o",
                "\u043F": "p",
                "\u0440": "r",
                "\u0441": "s",
                "\u0442": "t",
                "\u0443": "u",
                "\u0444": "f",
                "\u0445": "kh",
                "\u0446": "c",
                "\u0447": "ch",
                "\u0448": "sh",
                "\u0449": "sh",
                "\u044A": "",
                "\u044B": "y",
                "\u044C": "",
                "\u044D": "e",
                "\u044E": "yu",
                "\u044F": "ya",
                "\u0410": "A",
                "\u0411": "B",
                "\u0412": "V",
                "\u0413": "G",
                "\u0414": "D",
                "\u0415": "E",
                "\u0401": "Yo",
                "\u0416": "Zh",
                "\u0417": "Z",
                "\u0418": "I",
                "\u0419": "I",
                "\u041A": "K",
                "\u041B": "L",
                "\u041C": "M",
                "\u041D": "N",
                "\u041E": "O",
                "\u041F": "P",
                "\u0420": "R",
                "\u0421": "S",
                "\u0422": "T",
                "\u0423": "U",
                "\u0424": "F",
                "\u0425": "Kh",
                "\u0426": "C",
                "\u0427": "Ch",
                "\u0428": "Sh",
                "\u0429": "Sh",
                "\u042A": "",
                "\u042B": "Y",
                "\u042C": "",
                "\u042D": "E",
                "\u042E": "Yu",
                "\u042F": "Ya",
                // Serbian
                "\u0452": "dj",
                "\u0458": "j",
                // 'љ': 'lj',  // duplicate
                // 'њ': 'nj', // duplicate
                "\u045B": "c",
                "\u045F": "dz",
                "\u0402": "Dj",
                "\u0408": "j",
                // 'Љ': 'Lj', // duplicate
                // 'Њ': 'Nj', // duplicate
                "\u040B": "C",
                "\u040F": "Dz",
                // Slovak
                "\u013E": "l",
                "\u013A": "l",
                "\u0155": "r",
                "\u013D": "L",
                "\u0139": "L",
                "\u0154": "R",
                // Turkish
                "\u015F": "s",
                "\u015E": "S",
                "\u0131": "i",
                "\u0130": "I",
                // 'ç': 'c', // duplicate
                // 'Ç': 'C', // duplicate
                // 'ü': 'u', // duplicate, see langCharMap
                // 'Ü': 'U', // duplicate, see langCharMap
                // 'ö': 'o', // duplicate, see langCharMap
                // 'Ö': 'O', // duplicate, see langCharMap
                "\u011F": "g",
                "\u011E": "G",
                // Vietnamese
                "\u1EA3": "a",
                "\u1EA2": "A",
                "\u1EB3": "a",
                "\u1EB2": "A",
                "\u1EA9": "a",
                "\u1EA8": "A",
                "\u0111": "d",
                "\u0110": "D",
                "\u1EB9": "e",
                "\u1EB8": "E",
                "\u1EBD": "e",
                "\u1EBC": "E",
                "\u1EBB": "e",
                "\u1EBA": "E",
                "\u1EBF": "e",
                "\u1EBE": "E",
                "\u1EC1": "e",
                "\u1EC0": "E",
                "\u1EC7": "e",
                "\u1EC6": "E",
                "\u1EC5": "e",
                "\u1EC4": "E",
                "\u1EC3": "e",
                "\u1EC2": "E",
                "\u1ECF": "o",
                "\u1ECD": "o",
                "\u1ECC": "o",
                "\u1ED1": "o",
                "\u1ED0": "O",
                "\u1ED3": "o",
                "\u1ED2": "O",
                "\u1ED5": "o",
                "\u1ED4": "O",
                "\u1ED9": "o",
                "\u1ED8": "O",
                "\u1ED7": "o",
                "\u1ED6": "O",
                "\u01A1": "o",
                "\u01A0": "O",
                "\u1EDB": "o",
                "\u1EDA": "O",
                "\u1EDD": "o",
                "\u1EDC": "O",
                "\u1EE3": "o",
                "\u1EE2": "O",
                "\u1EE1": "o",
                "\u1EE0": "O",
                "\u1EDE": "o",
                "\u1EDF": "o",
                "\u1ECB": "i",
                "\u1ECA": "I",
                "\u0129": "i",
                "\u0128": "I",
                "\u1EC9": "i",
                "\u1EC8": "i",
                "\u1EE7": "u",
                "\u1EE6": "U",
                "\u1EE5": "u",
                "\u1EE4": "U",
                "\u0169": "u",
                "\u0168": "U",
                "\u01B0": "u",
                "\u01AF": "U",
                "\u1EE9": "u",
                "\u1EE8": "U",
                "\u1EEB": "u",
                "\u1EEA": "U",
                "\u1EF1": "u",
                "\u1EF0": "U",
                "\u1EEF": "u",
                "\u1EEE": "U",
                "\u1EED": "u",
                "\u1EEC": "\u01B0",
                "\u1EF7": "y",
                "\u1EF6": "y",
                "\u1EF3": "y",
                "\u1EF2": "Y",
                "\u1EF5": "y",
                "\u1EF4": "Y",
                "\u1EF9": "y",
                "\u1EF8": "Y",
                "\u1EA1": "a",
                "\u1EA0": "A",
                "\u1EA5": "a",
                "\u1EA4": "A",
                "\u1EA7": "a",
                "\u1EA6": "A",
                "\u1EAD": "a",
                "\u1EAC": "A",
                "\u1EAB": "a",
                "\u1EAA": "A",
                // 'ă': 'a', // duplicate
                // 'Ă': 'A', // duplicate
                "\u1EAF": "a",
                "\u1EAE": "A",
                "\u1EB1": "a",
                "\u1EB0": "A",
                "\u1EB7": "a",
                "\u1EB6": "A",
                "\u1EB5": "a",
                "\u1EB4": "A",
                "\u24EA": "0",
                "\u2460": "1",
                "\u2461": "2",
                "\u2462": "3",
                "\u2463": "4",
                "\u2464": "5",
                "\u2465": "6",
                "\u2466": "7",
                "\u2467": "8",
                "\u2468": "9",
                "\u2469": "10",
                "\u246A": "11",
                "\u246B": "12",
                "\u246C": "13",
                "\u246D": "14",
                "\u246E": "15",
                "\u246F": "16",
                "\u2470": "17",
                "\u2471": "18",
                "\u2472": "18",
                "\u2473": "18",
                "\u24F5": "1",
                "\u24F6": "2",
                "\u24F7": "3",
                "\u24F8": "4",
                "\u24F9": "5",
                "\u24FA": "6",
                "\u24FB": "7",
                "\u24FC": "8",
                "\u24FD": "9",
                "\u24FE": "10",
                "\u24FF": "0",
                "\u24EB": "11",
                "\u24EC": "12",
                "\u24ED": "13",
                "\u24EE": "14",
                "\u24EF": "15",
                "\u24F0": "16",
                "\u24F1": "17",
                "\u24F2": "18",
                "\u24F3": "19",
                "\u24F4": "20",
                "\u24B6": "A",
                "\u24B7": "B",
                "\u24B8": "C",
                "\u24B9": "D",
                "\u24BA": "E",
                "\u24BB": "F",
                "\u24BC": "G",
                "\u24BD": "H",
                "\u24BE": "I",
                "\u24BF": "J",
                "\u24C0": "K",
                "\u24C1": "L",
                "\u24C2": "M",
                "\u24C3": "N",
                "\u24C4": "O",
                "\u24C5": "P",
                "\u24C6": "Q",
                "\u24C7": "R",
                "\u24C8": "S",
                "\u24C9": "T",
                "\u24CA": "U",
                "\u24CB": "V",
                "\u24CC": "W",
                "\u24CD": "X",
                "\u24CE": "Y",
                "\u24CF": "Z",
                "\u24D0": "a",
                "\u24D1": "b",
                "\u24D2": "c",
                "\u24D3": "d",
                "\u24D4": "e",
                "\u24D5": "f",
                "\u24D6": "g",
                "\u24D7": "h",
                "\u24D8": "i",
                "\u24D9": "j",
                "\u24DA": "k",
                "\u24DB": "l",
                "\u24DC": "m",
                "\u24DD": "n",
                "\u24DE": "o",
                "\u24DF": "p",
                "\u24E0": "q",
                "\u24E1": "r",
                "\u24E2": "s",
                "\u24E3": "t",
                "\u24E4": "u",
                "\u24E6": "v",
                "\u24E5": "w",
                "\u24E7": "x",
                "\u24E8": "y",
                "\u24E9": "z",
                // symbols
                "\u201C": '"',
                "\u201D": '"',
                "\u2018": "'",
                "\u2019": "'",
                "\u2202": "d",
                "\u0192": "f",
                "\u2122": "(TM)",
                "\xA9": "(C)",
                "\u0153": "oe",
                "\u0152": "OE",
                "\xAE": "(R)",
                "\u2020": "+",
                "\u2120": "(SM)",
                "\u2026": "...",
                "\u02DA": "o",
                "\xBA": "o",
                "\xAA": "a",
                "\u2022": "*",
                "\u104A": ",",
                "\u104B": ".",
                // currency
                "$": "USD",
                "\u20AC": "EUR",
                "\u20A2": "BRN",
                "\u20A3": "FRF",
                "\xA3": "GBP",
                "\u20A4": "ITL",
                "\u20A6": "NGN",
                "\u20A7": "ESP",
                "\u20A9": "KRW",
                "\u20AA": "ILS",
                "\u20AB": "VND",
                "\u20AD": "LAK",
                "\u20AE": "MNT",
                "\u20AF": "GRD",
                "\u20B1": "ARS",
                "\u20B2": "PYG",
                "\u20B3": "ARA",
                "\u20B4": "UAH",
                "\u20B5": "GHS",
                "\xA2": "cent",
                "\xA5": "CNY",
                "\u5143": "CNY",
                "\u5186": "YEN",
                "\uFDFC": "IRR",
                "\u20A0": "EWE",
                "\u0E3F": "THB",
                "\u20A8": "INR",
                "\u20B9": "INR",
                "\u20B0": "PF",
                "\u20BA": "TRY",
                "\u060B": "AFN",
                "\u20BC": "AZN",
                "\u043B\u0432": "BGN",
                "\u17DB": "KHR",
                "\u20A1": "CRC",
                "\u20B8": "KZT",
                "\u0434\u0435\u043D": "MKD",
                "z\u0142": "PLN",
                "\u20BD": "RUB",
                "\u20BE": "GEL"
            };
            var lookAheadCharArray = [
                // burmese
                "\u103A",
                // Dhivehi
                "\u07B0"
            ];
            var diatricMap = {
                // Burmese
                // dependent vowels
                "\u102C": "a",
                "\u102B": "a",
                "\u1031": "e",
                "\u1032": "e",
                "\u102D": "i",
                "\u102E": "i",
                "\u102D\u102F": "o",
                "\u102F": "u",
                "\u1030": "u",
                "\u1031\u102B\u1004\u103A": "aung",
                "\u1031\u102C": "aw",
                "\u1031\u102C\u103A": "aw",
                "\u1031\u102B": "aw",
                "\u1031\u102B\u103A": "aw",
                "\u103A": "\u103A",
                // this is special case but the character will be converted to latin in the code
                "\u1000\u103A": "et",
                "\u102D\u102F\u1000\u103A": "aik",
                "\u1031\u102C\u1000\u103A": "auk",
                "\u1004\u103A": "in",
                "\u102D\u102F\u1004\u103A": "aing",
                "\u1031\u102C\u1004\u103A": "aung",
                "\u1005\u103A": "it",
                "\u100A\u103A": "i",
                "\u1010\u103A": "at",
                "\u102D\u1010\u103A": "eik",
                "\u102F\u1010\u103A": "ok",
                "\u103D\u1010\u103A": "ut",
                "\u1031\u1010\u103A": "it",
                "\u1012\u103A": "d",
                "\u102D\u102F\u1012\u103A": "ok",
                "\u102F\u1012\u103A": "ait",
                "\u1014\u103A": "an",
                "\u102C\u1014\u103A": "an",
                "\u102D\u1014\u103A": "ein",
                "\u102F\u1014\u103A": "on",
                "\u103D\u1014\u103A": "un",
                "\u1015\u103A": "at",
                "\u102D\u1015\u103A": "eik",
                "\u102F\u1015\u103A": "ok",
                "\u103D\u1015\u103A": "ut",
                "\u1014\u103A\u102F\u1015\u103A": "nub",
                "\u1019\u103A": "an",
                "\u102D\u1019\u103A": "ein",
                "\u102F\u1019\u103A": "on",
                "\u103D\u1019\u103A": "un",
                "\u101A\u103A": "e",
                "\u102D\u102F\u101C\u103A": "ol",
                "\u1009\u103A": "in",
                "\u1036": "an",
                "\u102D\u1036": "ein",
                "\u102F\u1036": "on",
                // Dhivehi
                "\u07A6\u0787\u07B0": "ah",
                "\u07A6\u0781\u07B0": "ah"
            };
            var langCharMap = {
                "en": {},
                // default language
                "az": {
                    // Azerbaijani
                    "\xE7": "c",
                    "\u0259": "e",
                    "\u011F": "g",
                    "\u0131": "i",
                    "\xF6": "o",
                    "\u015F": "s",
                    "\xFC": "u",
                    "\xC7": "C",
                    "\u018F": "E",
                    "\u011E": "G",
                    "\u0130": "I",
                    "\xD6": "O",
                    "\u015E": "S",
                    "\xDC": "U"
                },
                "cs": {
                    // Czech
                    "\u010D": "c",
                    "\u010F": "d",
                    "\u011B": "e",
                    "\u0148": "n",
                    "\u0159": "r",
                    "\u0161": "s",
                    "\u0165": "t",
                    "\u016F": "u",
                    "\u017E": "z",
                    "\u010C": "C",
                    "\u010E": "D",
                    "\u011A": "E",
                    "\u0147": "N",
                    "\u0158": "R",
                    "\u0160": "S",
                    "\u0164": "T",
                    "\u016E": "U",
                    "\u017D": "Z"
                },
                "fi": {
                    // Finnish
                    // 'å': 'a', duplicate see charMap/latin
                    // 'Å': 'A', duplicate see charMap/latin
                    "\xE4": "a",
                    // ok
                    "\xC4": "A",
                    // ok
                    "\xF6": "o",
                    // ok
                    "\xD6": "O"
                },
                "hu": {
                    // Hungarian
                    "\xE4": "a",
                    // ok
                    "\xC4": "A",
                    // ok
                    // 'á': 'a', duplicate see charMap/latin
                    // 'Á': 'A', duplicate see charMap/latin
                    "\xF6": "o",
                    // ok
                    "\xD6": "O",
                    // ok
                    // 'ő': 'o', duplicate see charMap/latin
                    // 'Ő': 'O', duplicate see charMap/latin
                    "\xFC": "u",
                    "\xDC": "U",
                    "\u0171": "u",
                    "\u0170": "U"
                },
                "lt": {
                    // Lithuanian
                    "\u0105": "a",
                    "\u010D": "c",
                    "\u0119": "e",
                    "\u0117": "e",
                    "\u012F": "i",
                    "\u0161": "s",
                    "\u0173": "u",
                    "\u016B": "u",
                    "\u017E": "z",
                    "\u0104": "A",
                    "\u010C": "C",
                    "\u0118": "E",
                    "\u0116": "E",
                    "\u012E": "I",
                    "\u0160": "S",
                    "\u0172": "U",
                    "\u016A": "U"
                },
                "lv": {
                    // Latvian
                    "\u0101": "a",
                    "\u010D": "c",
                    "\u0113": "e",
                    "\u0123": "g",
                    "\u012B": "i",
                    "\u0137": "k",
                    "\u013C": "l",
                    "\u0146": "n",
                    "\u0161": "s",
                    "\u016B": "u",
                    "\u017E": "z",
                    "\u0100": "A",
                    "\u010C": "C",
                    "\u0112": "E",
                    "\u0122": "G",
                    "\u012A": "i",
                    "\u0136": "k",
                    "\u013B": "L",
                    "\u0145": "N",
                    "\u0160": "S",
                    "\u016A": "u",
                    "\u017D": "Z"
                },
                "pl": {
                    // Polish
                    "\u0105": "a",
                    "\u0107": "c",
                    "\u0119": "e",
                    "\u0142": "l",
                    "\u0144": "n",
                    "\xF3": "o",
                    "\u015B": "s",
                    "\u017A": "z",
                    "\u017C": "z",
                    "\u0104": "A",
                    "\u0106": "C",
                    "\u0118": "e",
                    "\u0141": "L",
                    "\u0143": "N",
                    "\xD3": "O",
                    "\u015A": "S",
                    "\u0179": "Z",
                    "\u017B": "Z"
                },
                "sv": {
                    // Swedish
                    // 'å': 'a', duplicate see charMap/latin
                    // 'Å': 'A', duplicate see charMap/latin
                    "\xE4": "a",
                    // ok
                    "\xC4": "A",
                    // ok
                    "\xF6": "o",
                    // ok
                    "\xD6": "O"
                },
                "sk": {
                    // Slovak
                    "\xE4": "a",
                    "\xC4": "A"
                },
                "sr": {
                    // Serbian
                    "\u0459": "lj",
                    "\u045A": "nj",
                    "\u0409": "Lj",
                    "\u040A": "Nj",
                    "\u0111": "dj",
                    "\u0110": "Dj"
                },
                "tr": {
                    // Turkish
                    "\xDC": "U",
                    "\xD6": "O",
                    "\xFC": "u",
                    "\xF6": "o"
                }
            };
            var symbolMap = {
                "ar": {
                    "\u2206": "delta",
                    "\u221E": "la-nihaya",
                    "\u2665": "hob",
                    "&": "wa",
                    "|": "aw",
                    "<": "aqal-men",
                    ">": "akbar-men",
                    "\u2211": "majmou",
                    "\xA4": "omla"
                },
                "az": {},
                "ca": {
                    "\u2206": "delta",
                    "\u221E": "infinit",
                    "\u2665": "amor",
                    "&": "i",
                    "|": "o",
                    "<": "menys que",
                    ">": "mes que",
                    "\u2211": "suma dels",
                    "\xA4": "moneda"
                },
                "cs": {
                    "\u2206": "delta",
                    "\u221E": "nekonecno",
                    "\u2665": "laska",
                    "&": "a",
                    "|": "nebo",
                    "<": "mensi nez",
                    ">": "vetsi nez",
                    "\u2211": "soucet",
                    "\xA4": "mena"
                },
                "de": {
                    "\u2206": "delta",
                    "\u221E": "unendlich",
                    "\u2665": "Liebe",
                    "&": "und",
                    "|": "oder",
                    "<": "kleiner als",
                    ">": "groesser als",
                    "\u2211": "Summe von",
                    "\xA4": "Waehrung"
                },
                "dv": {
                    "\u2206": "delta",
                    "\u221E": "kolunulaa",
                    "\u2665": "loabi",
                    "&": "aai",
                    "|": "noonee",
                    "<": "ah vure kuda",
                    ">": "ah vure bodu",
                    "\u2211": "jumula",
                    "\xA4": "faisaa"
                },
                "en": {
                    "\u2206": "delta",
                    "\u221E": "infinity",
                    "\u2665": "love",
                    "&": "and",
                    "|": "or",
                    "<": "less than",
                    ">": "greater than",
                    "\u2211": "sum",
                    "\xA4": "currency"
                },
                "es": {
                    "\u2206": "delta",
                    "\u221E": "infinito",
                    "\u2665": "amor",
                    "&": "y",
                    "|": "u",
                    "<": "menos que",
                    ">": "mas que",
                    "\u2211": "suma de los",
                    "\xA4": "moneda"
                },
                "fa": {
                    "\u2206": "delta",
                    "\u221E": "bi-nahayat",
                    "\u2665": "eshgh",
                    "&": "va",
                    "|": "ya",
                    "<": "kamtar-az",
                    ">": "bishtar-az",
                    "\u2211": "majmooe",
                    "\xA4": "vahed"
                },
                "fi": {
                    "\u2206": "delta",
                    "\u221E": "aarettomyys",
                    "\u2665": "rakkaus",
                    "&": "ja",
                    "|": "tai",
                    "<": "pienempi kuin",
                    ">": "suurempi kuin",
                    "\u2211": "summa",
                    "\xA4": "valuutta"
                },
                "fr": {
                    "\u2206": "delta",
                    "\u221E": "infiniment",
                    "\u2665": "Amour",
                    "&": "et",
                    "|": "ou",
                    "<": "moins que",
                    ">": "superieure a",
                    "\u2211": "somme des",
                    "\xA4": "monnaie"
                },
                "ge": {
                    "\u2206": "delta",
                    "\u221E": "usasruloba",
                    "\u2665": "siqvaruli",
                    "&": "da",
                    "|": "an",
                    "<": "naklebi",
                    ">": "meti",
                    "\u2211": "jami",
                    "\xA4": "valuta"
                },
                "gr": {},
                "hu": {
                    "\u2206": "delta",
                    "\u221E": "vegtelen",
                    "\u2665": "szerelem",
                    "&": "es",
                    "|": "vagy",
                    "<": "kisebb mint",
                    ">": "nagyobb mint",
                    "\u2211": "szumma",
                    "\xA4": "penznem"
                },
                "it": {
                    "\u2206": "delta",
                    "\u221E": "infinito",
                    "\u2665": "amore",
                    "&": "e",
                    "|": "o",
                    "<": "minore di",
                    ">": "maggiore di",
                    "\u2211": "somma",
                    "\xA4": "moneta"
                },
                "lt": {
                    "\u2206": "delta",
                    "\u221E": "begalybe",
                    "\u2665": "meile",
                    "&": "ir",
                    "|": "ar",
                    "<": "maziau nei",
                    ">": "daugiau nei",
                    "\u2211": "suma",
                    "\xA4": "valiuta"
                },
                "lv": {
                    "\u2206": "delta",
                    "\u221E": "bezgaliba",
                    "\u2665": "milestiba",
                    "&": "un",
                    "|": "vai",
                    "<": "mazak neka",
                    ">": "lielaks neka",
                    "\u2211": "summa",
                    "\xA4": "valuta"
                },
                "my": {
                    "\u2206": "kwahkhyaet",
                    "\u221E": "asaonasme",
                    "\u2665": "akhyait",
                    "&": "nhin",
                    "|": "tho",
                    "<": "ngethaw",
                    ">": "kyithaw",
                    "\u2211": "paungld",
                    "\xA4": "ngwekye"
                },
                "mk": {},
                "nl": {
                    "\u2206": "delta",
                    "\u221E": "oneindig",
                    "\u2665": "liefde",
                    "&": "en",
                    "|": "of",
                    "<": "kleiner dan",
                    ">": "groter dan",
                    "\u2211": "som",
                    "\xA4": "valuta"
                },
                "pl": {
                    "\u2206": "delta",
                    "\u221E": "nieskonczonosc",
                    "\u2665": "milosc",
                    "&": "i",
                    "|": "lub",
                    "<": "mniejsze niz",
                    ">": "wieksze niz",
                    "\u2211": "suma",
                    "\xA4": "waluta"
                },
                "pt": {
                    "\u2206": "delta",
                    "\u221E": "infinito",
                    "\u2665": "amor",
                    "&": "e",
                    "|": "ou",
                    "<": "menor que",
                    ">": "maior que",
                    "\u2211": "soma",
                    "\xA4": "moeda"
                },
                "ro": {
                    "\u2206": "delta",
                    "\u221E": "infinit",
                    "\u2665": "dragoste",
                    "&": "si",
                    "|": "sau",
                    "<": "mai mic ca",
                    ">": "mai mare ca",
                    "\u2211": "suma",
                    "\xA4": "valuta"
                },
                "ru": {
                    "\u2206": "delta",
                    "\u221E": "beskonechno",
                    "\u2665": "lubov",
                    "&": "i",
                    "|": "ili",
                    "<": "menshe",
                    ">": "bolshe",
                    "\u2211": "summa",
                    "\xA4": "valjuta"
                },
                "sk": {
                    "\u2206": "delta",
                    "\u221E": "nekonecno",
                    "\u2665": "laska",
                    "&": "a",
                    "|": "alebo",
                    "<": "menej ako",
                    ">": "viac ako",
                    "\u2211": "sucet",
                    "\xA4": "mena"
                },
                "sr": {},
                "tr": {
                    "\u2206": "delta",
                    "\u221E": "sonsuzluk",
                    "\u2665": "ask",
                    "&": "ve",
                    "|": "veya",
                    "<": "kucuktur",
                    ">": "buyuktur",
                    "\u2211": "toplam",
                    "\xA4": "para birimi"
                },
                "uk": {
                    "\u2206": "delta",
                    "\u221E": "bezkinechnist",
                    "\u2665": "lubov",
                    "&": "i",
                    "|": "abo",
                    "<": "menshe",
                    ">": "bilshe",
                    "\u2211": "suma",
                    "\xA4": "valjuta"
                },
                "vn": {
                    "\u2206": "delta",
                    "\u221E": "vo cuc",
                    "\u2665": "yeu",
                    "&": "va",
                    "|": "hoac",
                    "<": "nho hon",
                    ">": "lon hon",
                    "\u2211": "tong",
                    "\xA4": "tien te"
                }
            };
            var uricChars = [
                ";",
                "?",
                ":",
                "@",
                "&",
                "=",
                "+",
                "$",
                ",",
                "/"
            ].join("");
            var uricNoSlashChars = [
                ";",
                "?",
                ":",
                "@",
                "&",
                "=",
                "+",
                "$",
                ","
            ].join("");
            var markChars = [
                ".",
                "!",
                "~",
                "*",
                "'",
                "(",
                ")"
            ].join("");
            var getSlug = function getSlug2(input, opts) {
                var separator = "-";
                var result = "";
                var diatricString = "";
                var convertSymbols = true;
                var customReplacements = {};
                var maintainCase;
                var titleCase;
                var truncate;
                var uricFlag;
                var uricNoSlashFlag;
                var markFlag;
                var symbol;
                var langChar;
                var lucky;
                var i;
                var ch;
                var l;
                var lastCharWasSymbol;
                var lastCharWasDiatric;
                var allowedChars = "";
                if (typeof input !== "string") return "";
                if (typeof opts === "string") separator = opts;
                symbol = symbolMap.en;
                langChar = langCharMap.en;
                if (typeof opts === "object") {
                    maintainCase = opts.maintainCase || false;
                    customReplacements = opts.custom && typeof opts.custom === "object" ? opts.custom : customReplacements;
                    truncate = +opts.truncate > 1 && opts.truncate || false;
                    uricFlag = opts.uric || false;
                    uricNoSlashFlag = opts.uricNoSlash || false;
                    markFlag = opts.mark || false;
                    convertSymbols = opts.symbols === false || opts.lang === false ? false : true;
                    separator = opts.separator || separator;
                    if (uricFlag) allowedChars += uricChars;
                    if (uricNoSlashFlag) allowedChars += uricNoSlashChars;
                    if (markFlag) allowedChars += markChars;
                    symbol = opts.lang && symbolMap[opts.lang] && convertSymbols ? symbolMap[opts.lang] : convertSymbols ? symbolMap.en : {};
                    langChar = opts.lang && langCharMap[opts.lang] ? langCharMap[opts.lang] : opts.lang === false || opts.lang === true ? {} : langCharMap.en;
                    if (opts.titleCase && typeof opts.titleCase.length === "number" && Array.prototype.toString.call(opts.titleCase)) {
                        opts.titleCase.forEach(function(v) {
                            customReplacements[v + ""] = v + "";
                        });
                        titleCase = true;
                    } else titleCase = !!opts.titleCase;
                    if (opts.custom && typeof opts.custom.length === "number" && Array.prototype.toString.call(opts.custom)) opts.custom.forEach(function(v) {
                        customReplacements[v + ""] = v + "";
                    });
                    Object.keys(customReplacements).forEach(function(v) {
                        var r;
                        if (v.length > 1) r = new RegExp("\\b" + escapeChars(v) + "\\b", "gi");
                        else r = new RegExp(escapeChars(v), "gi");
                        input = input.replace(r, customReplacements[v]);
                    });
                    for(ch in customReplacements)allowedChars += ch;
                }
                allowedChars += separator;
                allowedChars = escapeChars(allowedChars);
                input = input.replace(/(^\s+|\s+$)/g, "");
                lastCharWasSymbol = false;
                lastCharWasDiatric = false;
                for(i = 0, l = input.length; i < l; i++){
                    ch = input[i];
                    if (isReplacedCustomChar(ch, customReplacements)) lastCharWasSymbol = false;
                    else if (langChar[ch]) {
                        ch = lastCharWasSymbol && langChar[ch].match(/[A-Za-z0-9]/) ? " " + langChar[ch] : langChar[ch];
                        lastCharWasSymbol = false;
                    } else if (ch in charMap) {
                        if (i + 1 < l && lookAheadCharArray.indexOf(input[i + 1]) >= 0) {
                            diatricString += ch;
                            ch = "";
                        } else if (lastCharWasDiatric === true) {
                            ch = diatricMap[diatricString] + charMap[ch];
                            diatricString = "";
                        } else ch = lastCharWasSymbol && charMap[ch].match(/[A-Za-z0-9]/) ? " " + charMap[ch] : charMap[ch];
                        lastCharWasSymbol = false;
                        lastCharWasDiatric = false;
                    } else if (ch in diatricMap) {
                        diatricString += ch;
                        ch = "";
                        if (i === l - 1) ch = diatricMap[diatricString];
                        lastCharWasDiatric = true;
                    } else if (// process symbol chars
                    symbol[ch] && !(uricFlag && uricChars.indexOf(ch) !== -1) && !(uricNoSlashFlag && uricNoSlashChars.indexOf(ch) !== -1)) {
                        ch = lastCharWasSymbol || result.substr(-1).match(/[A-Za-z0-9]/) ? separator + symbol[ch] : symbol[ch];
                        ch += input[i + 1] !== void 0 && input[i + 1].match(/[A-Za-z0-9]/) ? separator : "";
                        lastCharWasSymbol = true;
                    } else {
                        if (lastCharWasDiatric === true) {
                            ch = diatricMap[diatricString] + ch;
                            diatricString = "";
                            lastCharWasDiatric = false;
                        } else if (lastCharWasSymbol && (/[A-Za-z0-9]/.test(ch) || result.substr(-1).match(/A-Za-z0-9]/))) ch = " " + ch;
                        lastCharWasSymbol = false;
                    }
                    result += ch.replace(new RegExp("[^\\w\\s" + allowedChars + "_-]", "g"), separator);
                }
                if (titleCase) result = result.replace(/(\w)(\S*)/g, function(_, i2, r) {
                    var j = i2.toUpperCase() + (r !== null ? r : "");
                    return Object.keys(customReplacements).indexOf(j.toLowerCase()) < 0 ? j : j.toLowerCase();
                });
                result = result.replace(/\s+/g, separator).replace(new RegExp("\\" + separator + "+", "g"), separator).replace(new RegExp("(^\\" + separator + "+|\\" + separator + "+$)", "g"), "");
                if (truncate && result.length > truncate) {
                    lucky = result.charAt(truncate) === separator;
                    result = result.slice(0, truncate);
                    if (!lucky) result = result.slice(0, result.lastIndexOf(separator));
                }
                if (!maintainCase && !titleCase) result = result.toLowerCase();
                return result;
            };
            var createSlug = function createSlug2(opts) {
                return function getSlugWithConfig(input) {
                    return getSlug(input, opts);
                };
            };
            var escapeChars = function escapeChars2(input) {
                return input.replace(/[-\\^$*+?.()|[\]{}\/]/g, "\\$&");
            };
            var isReplacedCustomChar = function(ch, customReplacements) {
                for(var c in customReplacements){
                    if (customReplacements[c] === ch) return true;
                }
            };
            if (typeof module !== "undefined" && module.exports) {
                module.exports = getSlug;
                module.exports.createSlug = createSlug;
            } else if (typeof define !== "undefined" && define.amd) define([], function() {
                return getSlug;
            });
            else try {
                if (root.getSlug || root.createSlug) throw "speakingurl: globals exists /(getSlug|createSlug)/";
                else {
                    root.getSlug = getSlug;
                    root.createSlug = createSlug;
                }
            } catch (e) {}
        })(exports);
    }
});
// ../../node_modules/.pnpm/speakingurl@14.0.1/node_modules/speakingurl/index.js
var $5193fce5c5df8bb9$var$require_speakingurl2 = $5193fce5c5df8bb9$var$__commonJS({
    "../../node_modules/.pnpm/speakingurl@14.0.1/node_modules/speakingurl/index.js" (exports, module) {
        "use strict";
        $5193fce5c5df8bb9$var$init_esm_shims();
        module.exports = $5193fce5c5df8bb9$var$require_speakingurl();
    }
});
// src/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/compat/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$onLegacyDevToolsPluginApiAvailable(cb) {
    if ((0, $i0cUC.target).__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__) {
        cb();
        return;
    }
    Object.defineProperty((0, $i0cUC.target), "__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__", {
        set (value) {
            if (value) cb();
        },
        configurable: true
    });
}
// src/ctx/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/ctx/api.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/component-highlighter/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/component/state/bounding-rect.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/component/utils/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$getComponentTypeName(options) {
    var _a25;
    const name = options.name || options._componentTag || options.__VUE_DEVTOOLS_COMPONENT_GUSSED_NAME__ || options.__name;
    if (name === "index" && ((_a25 = options.__file) == null ? void 0 : _a25.endsWith("index.vue"))) return "";
    return name;
}
function $5193fce5c5df8bb9$var$getComponentFileName(options) {
    const file = options.__file;
    if (file) return (0, $i0cUC.classify)((0, $i0cUC.basename)(file, ".vue"));
}
function $5193fce5c5df8bb9$var$getComponentName(options) {
    const name = options.displayName || options.name || options._componentTag;
    if (name) return name;
    return $5193fce5c5df8bb9$var$getComponentFileName(options);
}
function $5193fce5c5df8bb9$var$saveComponentGussedName(instance, name) {
    instance.type.__VUE_DEVTOOLS_COMPONENT_GUSSED_NAME__ = name;
    return name;
}
function $5193fce5c5df8bb9$var$getAppRecord(instance) {
    if (instance.__VUE_DEVTOOLS_NEXT_APP_RECORD__) return instance.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
    else if (instance.root) return instance.appContext.app.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
}
async function $5193fce5c5df8bb9$var$getComponentId(options) {
    const { app: app, uid: uid, instance: instance } = options;
    try {
        if (instance.__VUE_DEVTOOLS_NEXT_UID__) return instance.__VUE_DEVTOOLS_NEXT_UID__;
        const appRecord = await $5193fce5c5df8bb9$var$getAppRecord(app);
        if (!appRecord) return null;
        const isRoot = appRecord.rootInstance === instance;
        return `${appRecord.id}:${isRoot ? "root" : uid}`;
    } catch (e) {}
}
function $5193fce5c5df8bb9$var$isFragment(instance) {
    var _a25, _b25;
    const subTreeType = (_a25 = instance.subTree) == null ? void 0 : _a25.type;
    const appRecord = $5193fce5c5df8bb9$var$getAppRecord(instance);
    if (appRecord) return ((_b25 = appRecord == null ? void 0 : appRecord.types) == null ? void 0 : _b25.Fragment) === subTreeType;
    return false;
}
function $5193fce5c5df8bb9$var$isBeingDestroyed(instance) {
    return instance._isBeingDestroyed || instance.isUnmounted;
}
function $5193fce5c5df8bb9$var$getInstanceName(instance) {
    var _a25, _b25, _c;
    const name = $5193fce5c5df8bb9$var$getComponentTypeName((instance == null ? void 0 : instance.type) || {});
    if (name) return name;
    if ((instance == null ? void 0 : instance.root) === instance) return "Root";
    for(const key in (_b25 = (_a25 = instance.parent) == null ? void 0 : _a25.type) == null ? void 0 : _b25.components){
        if (instance.parent.type.components[key] === (instance == null ? void 0 : instance.type)) return $5193fce5c5df8bb9$var$saveComponentGussedName(instance, key);
    }
    for(const key in (_c = instance.appContext) == null ? void 0 : _c.components){
        if (instance.appContext.components[key] === (instance == null ? void 0 : instance.type)) return $5193fce5c5df8bb9$var$saveComponentGussedName(instance, key);
    }
    const fileName = $5193fce5c5df8bb9$var$getComponentFileName((instance == null ? void 0 : instance.type) || {});
    if (fileName) return fileName;
    return "Anonymous Component";
}
function $5193fce5c5df8bb9$var$getUniqueComponentId(instance) {
    var _a25, _b25, _c;
    const appId = (_c = (_b25 = (_a25 = instance == null ? void 0 : instance.appContext) == null ? void 0 : _a25.app) == null ? void 0 : _b25.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__) != null ? _c : 0;
    const instanceId = instance === (instance == null ? void 0 : instance.root) ? "root" : instance.uid;
    return `${appId}:${instanceId}`;
}
function $5193fce5c5df8bb9$var$getRenderKey(value) {
    if (value == null) return "";
    if (typeof value === "number") return value;
    else if (typeof value === "string") return `'${value}'`;
    else if (Array.isArray(value)) return "Array";
    else return "Object";
}
function $5193fce5c5df8bb9$var$returnError(cb) {
    try {
        return cb();
    } catch (e) {
        return e;
    }
}
function $5193fce5c5df8bb9$var$getComponentInstance(appRecord, instanceId) {
    instanceId = instanceId || `${appRecord.id}:root`;
    const instance = appRecord.instanceMap.get(instanceId);
    return instance || appRecord.instanceMap.get(":root");
}
function $5193fce5c5df8bb9$var$ensurePropertyExists(obj, key, skipObjCheck = false) {
    return skipObjCheck ? key in obj : typeof obj === "object" && obj !== null ? key in obj : false;
}
// src/core/component/state/bounding-rect.ts
function $5193fce5c5df8bb9$var$createRect() {
    const rect = {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        get width () {
            return rect.right - rect.left;
        },
        get height () {
            return rect.bottom - rect.top;
        }
    };
    return rect;
}
var $5193fce5c5df8bb9$var$range;
function $5193fce5c5df8bb9$var$getTextRect(node) {
    if (!$5193fce5c5df8bb9$var$range) $5193fce5c5df8bb9$var$range = document.createRange();
    $5193fce5c5df8bb9$var$range.selectNode(node);
    return $5193fce5c5df8bb9$var$range.getBoundingClientRect();
}
function $5193fce5c5df8bb9$var$getFragmentRect(vnode) {
    const rect = $5193fce5c5df8bb9$var$createRect();
    if (!vnode.children) return rect;
    for(let i = 0, l = vnode.children.length; i < l; i++){
        const childVnode = vnode.children[i];
        let childRect;
        if (childVnode.component) childRect = $5193fce5c5df8bb9$var$getComponentBoundingRect(childVnode.component);
        else if (childVnode.el) {
            const el = childVnode.el;
            if (el.nodeType === 1 || el.getBoundingClientRect) childRect = el.getBoundingClientRect();
            else if (el.nodeType === 3 && el.data.trim()) childRect = $5193fce5c5df8bb9$var$getTextRect(el);
        }
        if (childRect) $5193fce5c5df8bb9$var$mergeRects(rect, childRect);
    }
    return rect;
}
function $5193fce5c5df8bb9$var$mergeRects(a, b) {
    if (!a.top || b.top < a.top) a.top = b.top;
    if (!a.bottom || b.bottom > a.bottom) a.bottom = b.bottom;
    if (!a.left || b.left < a.left) a.left = b.left;
    if (!a.right || b.right > a.right) a.right = b.right;
    return a;
}
var $5193fce5c5df8bb9$var$DEFAULT_RECT = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: 0,
    height: 0
};
function $5193fce5c5df8bb9$var$getComponentBoundingRect(instance) {
    const el = instance.subTree.el;
    if (typeof window === "undefined") return $5193fce5c5df8bb9$var$DEFAULT_RECT;
    if ($5193fce5c5df8bb9$var$isFragment(instance)) return $5193fce5c5df8bb9$var$getFragmentRect(instance.subTree);
    else if ((el == null ? void 0 : el.nodeType) === 1) return el == null ? void 0 : el.getBoundingClientRect();
    else if (instance.subTree.component) return $5193fce5c5df8bb9$var$getComponentBoundingRect(instance.subTree.component);
    else return $5193fce5c5df8bb9$var$DEFAULT_RECT;
}
// src/core/component/tree/el.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$getRootElementsFromComponentInstance(instance) {
    if ($5193fce5c5df8bb9$var$isFragment(instance)) return $5193fce5c5df8bb9$var$getFragmentRootElements(instance.subTree);
    if (!instance.subTree) return [];
    return [
        instance.subTree.el
    ];
}
function $5193fce5c5df8bb9$var$getFragmentRootElements(vnode) {
    if (!vnode.children) return [];
    const list = [];
    vnode.children.forEach((childVnode)=>{
        if (childVnode.component) list.push(...$5193fce5c5df8bb9$var$getRootElementsFromComponentInstance(childVnode.component));
        else if (childVnode == null ? void 0 : childVnode.el) list.push(childVnode.el);
    });
    return list;
}
// src/core/component-highlighter/index.ts
var $5193fce5c5df8bb9$var$CONTAINER_ELEMENT_ID = "__vue-devtools-component-inspector__";
var $5193fce5c5df8bb9$var$CARD_ELEMENT_ID = "__vue-devtools-component-inspector__card__";
var $5193fce5c5df8bb9$var$COMPONENT_NAME_ELEMENT_ID = "__vue-devtools-component-inspector__name__";
var $5193fce5c5df8bb9$var$INDICATOR_ELEMENT_ID = "__vue-devtools-component-inspector__indicator__";
var $5193fce5c5df8bb9$var$containerStyles = {
    display: "block",
    zIndex: 2147483640,
    position: "fixed",
    backgroundColor: "#42b88325",
    border: "1px solid #42b88350",
    borderRadius: "5px",
    transition: "all 0.1s ease-in",
    pointerEvents: "none"
};
var $5193fce5c5df8bb9$var$cardStyles = {
    fontFamily: "Arial, Helvetica, sans-serif",
    padding: "5px 8px",
    borderRadius: "4px",
    textAlign: "left",
    position: "absolute",
    left: 0,
    color: "#e9e9e9",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "24px",
    backgroundColor: "#42b883",
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)"
};
var $5193fce5c5df8bb9$var$indicatorStyles = {
    display: "inline-block",
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "12px",
    opacity: 0.7
};
function $5193fce5c5df8bb9$var$getContainerElement() {
    return document.getElementById($5193fce5c5df8bb9$var$CONTAINER_ELEMENT_ID);
}
function $5193fce5c5df8bb9$var$getCardElement() {
    return document.getElementById($5193fce5c5df8bb9$var$CARD_ELEMENT_ID);
}
function $5193fce5c5df8bb9$var$getIndicatorElement() {
    return document.getElementById($5193fce5c5df8bb9$var$INDICATOR_ELEMENT_ID);
}
function $5193fce5c5df8bb9$var$getNameElement() {
    return document.getElementById($5193fce5c5df8bb9$var$COMPONENT_NAME_ELEMENT_ID);
}
function $5193fce5c5df8bb9$var$getStyles(bounds) {
    return {
        left: `${Math.round(bounds.left * 100) / 100}px`,
        top: `${Math.round(bounds.top * 100) / 100}px`,
        width: `${Math.round(bounds.width * 100) / 100}px`,
        height: `${Math.round(bounds.height * 100) / 100}px`
    };
}
function $5193fce5c5df8bb9$var$create(options) {
    var _a25;
    const containerEl = document.createElement("div");
    containerEl.id = (_a25 = options.elementId) != null ? _a25 : $5193fce5c5df8bb9$var$CONTAINER_ELEMENT_ID;
    Object.assign(containerEl.style, {
        ...$5193fce5c5df8bb9$var$containerStyles,
        ...$5193fce5c5df8bb9$var$getStyles(options.bounds),
        ...options.style
    });
    const cardEl = document.createElement("span");
    cardEl.id = $5193fce5c5df8bb9$var$CARD_ELEMENT_ID;
    Object.assign(cardEl.style, {
        ...$5193fce5c5df8bb9$var$cardStyles,
        top: options.bounds.top < 35 ? 0 : "-35px"
    });
    const nameEl = document.createElement("span");
    nameEl.id = $5193fce5c5df8bb9$var$COMPONENT_NAME_ELEMENT_ID;
    nameEl.innerHTML = `&lt;${options.name}&gt;&nbsp;&nbsp;`;
    const indicatorEl = document.createElement("i");
    indicatorEl.id = $5193fce5c5df8bb9$var$INDICATOR_ELEMENT_ID;
    indicatorEl.innerHTML = `${Math.round(options.bounds.width * 100) / 100} x ${Math.round(options.bounds.height * 100) / 100}`;
    Object.assign(indicatorEl.style, $5193fce5c5df8bb9$var$indicatorStyles);
    cardEl.appendChild(nameEl);
    cardEl.appendChild(indicatorEl);
    containerEl.appendChild(cardEl);
    document.body.appendChild(containerEl);
    return containerEl;
}
function $5193fce5c5df8bb9$var$update(options) {
    const containerEl = $5193fce5c5df8bb9$var$getContainerElement();
    const cardEl = $5193fce5c5df8bb9$var$getCardElement();
    const nameEl = $5193fce5c5df8bb9$var$getNameElement();
    const indicatorEl = $5193fce5c5df8bb9$var$getIndicatorElement();
    if (containerEl) {
        Object.assign(containerEl.style, {
            ...$5193fce5c5df8bb9$var$containerStyles,
            ...$5193fce5c5df8bb9$var$getStyles(options.bounds)
        });
        Object.assign(cardEl.style, {
            top: options.bounds.top < 35 ? 0 : "-35px"
        });
        nameEl.innerHTML = `&lt;${options.name}&gt;&nbsp;&nbsp;`;
        indicatorEl.innerHTML = `${Math.round(options.bounds.width * 100) / 100} x ${Math.round(options.bounds.height * 100) / 100}`;
    }
}
function $5193fce5c5df8bb9$var$highlight(instance) {
    const bounds = $5193fce5c5df8bb9$var$getComponentBoundingRect(instance);
    if (!bounds.width && !bounds.height) return;
    const name = $5193fce5c5df8bb9$var$getInstanceName(instance);
    const container = $5193fce5c5df8bb9$var$getContainerElement();
    container ? $5193fce5c5df8bb9$var$update({
        bounds: bounds,
        name: name
    }) : $5193fce5c5df8bb9$var$create({
        bounds: bounds,
        name: name
    });
}
function $5193fce5c5df8bb9$var$unhighlight() {
    const el = $5193fce5c5df8bb9$var$getContainerElement();
    if (el) el.style.display = "none";
}
var $5193fce5c5df8bb9$var$inspectInstance = null;
function $5193fce5c5df8bb9$var$inspectFn(e) {
    const target22 = e.target;
    if (target22) {
        const instance = target22.__vueParentComponent;
        if (instance) {
            $5193fce5c5df8bb9$var$inspectInstance = instance;
            const el = instance.vnode.el;
            if (el) {
                const bounds = $5193fce5c5df8bb9$var$getComponentBoundingRect(instance);
                const name = $5193fce5c5df8bb9$var$getInstanceName(instance);
                const container = $5193fce5c5df8bb9$var$getContainerElement();
                container ? $5193fce5c5df8bb9$var$update({
                    bounds: bounds,
                    name: name
                }) : $5193fce5c5df8bb9$var$create({
                    bounds: bounds,
                    name: name
                });
            }
        }
    }
}
function $5193fce5c5df8bb9$var$selectComponentFn(e, cb) {
    e.preventDefault();
    e.stopPropagation();
    if ($5193fce5c5df8bb9$var$inspectInstance) {
        const uniqueComponentId = $5193fce5c5df8bb9$var$getUniqueComponentId($5193fce5c5df8bb9$var$inspectInstance);
        cb(uniqueComponentId);
    }
}
var $5193fce5c5df8bb9$var$inspectComponentHighLighterSelectFn = null;
function $5193fce5c5df8bb9$var$cancelInspectComponentHighLighter() {
    $5193fce5c5df8bb9$var$unhighlight();
    window.removeEventListener("mouseover", $5193fce5c5df8bb9$var$inspectFn);
    window.removeEventListener("click", $5193fce5c5df8bb9$var$inspectComponentHighLighterSelectFn, true);
    $5193fce5c5df8bb9$var$inspectComponentHighLighterSelectFn = null;
}
function $5193fce5c5df8bb9$var$inspectComponentHighLighter() {
    window.addEventListener("mouseover", $5193fce5c5df8bb9$var$inspectFn);
    return new Promise((resolve)=>{
        function onSelect(e) {
            e.preventDefault();
            e.stopPropagation();
            $5193fce5c5df8bb9$var$selectComponentFn(e, (id)=>{
                window.removeEventListener("click", onSelect, true);
                $5193fce5c5df8bb9$var$inspectComponentHighLighterSelectFn = null;
                window.removeEventListener("mouseover", $5193fce5c5df8bb9$var$inspectFn);
                const el = $5193fce5c5df8bb9$var$getContainerElement();
                if (el) el.style.display = "none";
                resolve(JSON.stringify({
                    id: id
                }));
            });
        }
        $5193fce5c5df8bb9$var$inspectComponentHighLighterSelectFn = onSelect;
        window.addEventListener("click", onSelect, true);
    });
}
function $5193fce5c5df8bb9$var$scrollToComponent(options) {
    const instance = $5193fce5c5df8bb9$var$getComponentInstance($5193fce5c5df8bb9$export$162128841a7f2877.value, options.id);
    if (instance) {
        const [el] = $5193fce5c5df8bb9$var$getRootElementsFromComponentInstance(instance);
        if (typeof el.scrollIntoView === "function") el.scrollIntoView({
            behavior: "smooth"
        });
        else {
            const bounds = $5193fce5c5df8bb9$var$getComponentBoundingRect(instance);
            const scrollTarget = document.createElement("div");
            const styles = {
                ...$5193fce5c5df8bb9$var$getStyles(bounds),
                position: "absolute"
            };
            Object.assign(scrollTarget.style, styles);
            document.body.appendChild(scrollTarget);
            scrollTarget.scrollIntoView({
                behavior: "smooth"
            });
            setTimeout(()=>{
                document.body.removeChild(scrollTarget);
            }, 2e3);
        }
        setTimeout(()=>{
            const bounds = $5193fce5c5df8bb9$var$getComponentBoundingRect(instance);
            if (bounds.width || bounds.height) {
                const name = $5193fce5c5df8bb9$var$getInstanceName(instance);
                const el2 = $5193fce5c5df8bb9$var$getContainerElement();
                el2 ? $5193fce5c5df8bb9$var$update({
                    ...options,
                    name: name,
                    bounds: bounds
                }) : $5193fce5c5df8bb9$var$create({
                    ...options,
                    name: name,
                    bounds: bounds
                });
                setTimeout(()=>{
                    if (el2) el2.style.display = "none";
                }, 1500);
            }
        }, 1200);
    }
}
// src/core/component-inspector/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$_a, $5193fce5c5df8bb9$var$_b;
($5193fce5c5df8bb9$var$_b = ($5193fce5c5df8bb9$var$_a = (0, $i0cUC.target)).__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__) != null ? $5193fce5c5df8bb9$var$_b : $5193fce5c5df8bb9$var$_a.__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__ = true;
function $5193fce5c5df8bb9$export$56455f68fb6e3b63(enabled) {
    (0, $i0cUC.target).__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__ = enabled;
}
function $5193fce5c5df8bb9$var$waitForInspectorInit(cb) {
    let total = 0;
    const timer = setInterval(()=>{
        if ((0, $i0cUC.target).__VUE_INSPECTOR__) {
            clearInterval(timer);
            total += 30;
            cb();
        }
        if (total >= /* 5s */ 5e3) clearInterval(timer);
    }, 30);
}
function $5193fce5c5df8bb9$var$setupInspector() {
    const inspector = (0, $i0cUC.target).__VUE_INSPECTOR__;
    const _openInEditor = inspector.openInEditor;
    inspector.openInEditor = async (...params)=>{
        inspector.disable();
        _openInEditor(...params);
    };
}
function $5193fce5c5df8bb9$var$getComponentInspector() {
    return new Promise((resolve)=>{
        function setup() {
            $5193fce5c5df8bb9$var$setupInspector();
            resolve((0, $i0cUC.target).__VUE_INSPECTOR__);
        }
        if (!(0, $i0cUC.target).__VUE_INSPECTOR__) $5193fce5c5df8bb9$var$waitForInspectorInit(()=>{
            setup();
        });
        else setup();
    });
}
// src/core/component/state/editor.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/shared/stub-vue.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$isReadonly(value) {
    return !!(value && value["__v_isReadonly" /* IS_READONLY */ ]);
}
function $5193fce5c5df8bb9$var$isReactive(value) {
    if ($5193fce5c5df8bb9$var$isReadonly(value)) return $5193fce5c5df8bb9$var$isReactive(value["__v_raw" /* RAW */ ]);
    return !!(value && value["__v_isReactive" /* IS_REACTIVE */ ]);
}
function $5193fce5c5df8bb9$var$isRef(r) {
    return !!(r && r.__v_isRef === true);
}
function $5193fce5c5df8bb9$var$toRaw(observed) {
    const raw = observed && observed["__v_raw" /* RAW */ ];
    return raw ? $5193fce5c5df8bb9$var$toRaw(raw) : observed;
}
var $5193fce5c5df8bb9$var$Fragment = Symbol.for("v-fgt");
// src/core/component/state/editor.ts
var $5193fce5c5df8bb9$var$StateEditor = class {
    constructor(){
        this.refEditor = new $5193fce5c5df8bb9$var$RefStateEditor();
    }
    set(object, path, value, cb) {
        const sections = Array.isArray(path) ? path : path.split(".");
        const markRef = false;
        while(sections.length > 1){
            const section = sections.shift();
            if (object instanceof Map) object = object.get(section);
            if (object instanceof Set) object = Array.from(object.values())[section];
            else object = object[section];
            if (this.refEditor.isRef(object)) object = this.refEditor.get(object);
        }
        const field = sections[0];
        const item = this.refEditor.get(object)[field];
        if (cb) cb(object, field, value);
        else {
            if (this.refEditor.isRef(item)) this.refEditor.set(item, value);
            else if (markRef) object[field] = value;
            else object[field] = value;
        }
    }
    get(object, path) {
        const sections = Array.isArray(path) ? path : path.split(".");
        for(let i = 0; i < sections.length; i++){
            if (object instanceof Map) object = object.get(sections[i]);
            else object = object[sections[i]];
            if (this.refEditor.isRef(object)) object = this.refEditor.get(object);
            if (!object) return void 0;
        }
        return object;
    }
    has(object, path, parent = false) {
        if (typeof object === "undefined") return false;
        const sections = Array.isArray(path) ? path.slice() : path.split(".");
        const size = !parent ? 1 : 2;
        while(object && sections.length > size){
            const section = sections.shift();
            object = object[section];
            if (this.refEditor.isRef(object)) object = this.refEditor.get(object);
        }
        return object != null && Object.prototype.hasOwnProperty.call(object, sections[0]);
    }
    createDefaultSetCallback(state) {
        return (object, field, value)=>{
            if (state.remove || state.newKey) {
                if (Array.isArray(object)) object.splice(field, 1);
                else if ($5193fce5c5df8bb9$var$toRaw(object) instanceof Map) object.delete(field);
                else if ($5193fce5c5df8bb9$var$toRaw(object) instanceof Set) object.delete(Array.from(object.values())[field]);
                else Reflect.deleteProperty(object, field);
            }
            if (!state.remove) {
                const target22 = object[state.newKey || field];
                if (this.refEditor.isRef(target22)) this.refEditor.set(target22, value);
                else if ($5193fce5c5df8bb9$var$toRaw(object) instanceof Map) object.set(state.newKey || field, value);
                else if ($5193fce5c5df8bb9$var$toRaw(object) instanceof Set) object.add(value);
                else object[state.newKey || field] = value;
            }
        };
    }
};
var $5193fce5c5df8bb9$var$RefStateEditor = class {
    set(ref, value) {
        if ($5193fce5c5df8bb9$var$isRef(ref)) ref.value = value;
        else {
            if (ref instanceof Set && Array.isArray(value)) {
                ref.clear();
                value.forEach((v)=>ref.add(v));
                return;
            }
            const currentKeys = Object.keys(value);
            if (ref instanceof Map) {
                const previousKeysSet2 = new Set(ref.keys());
                currentKeys.forEach((key)=>{
                    ref.set(key, Reflect.get(value, key));
                    previousKeysSet2.delete(key);
                });
                previousKeysSet2.forEach((key)=>ref.delete(key));
                return;
            }
            const previousKeysSet = new Set(Object.keys(ref));
            currentKeys.forEach((key)=>{
                Reflect.set(ref, key, Reflect.get(value, key));
                previousKeysSet.delete(key);
            });
            previousKeysSet.forEach((key)=>Reflect.deleteProperty(ref, key));
        }
    }
    get(ref) {
        return $5193fce5c5df8bb9$var$isRef(ref) ? ref.value : ref;
    }
    isRef(ref) {
        return $5193fce5c5df8bb9$var$isRef(ref) || $5193fce5c5df8bb9$var$isReactive(ref);
    }
};
async function $5193fce5c5df8bb9$var$editComponentState(payload, stateEditor2) {
    const { path: path, nodeId: nodeId, state: state, type: type } = payload;
    const instance = $5193fce5c5df8bb9$var$getComponentInstance($5193fce5c5df8bb9$export$162128841a7f2877.value, nodeId);
    if (!instance) return;
    const targetPath = path.slice();
    let target22;
    if (Object.keys(instance.props).includes(path[0])) target22 = instance.props;
    else if (instance.devtoolsRawSetupState && Object.keys(instance.devtoolsRawSetupState).includes(path[0])) target22 = instance.devtoolsRawSetupState;
    else if (instance.data && Object.keys(instance.data).includes(path[0])) target22 = instance.data;
    else target22 = instance.proxy;
    if (target22 && targetPath) {
        state.type === "object" && type;
        stateEditor2.set(target22, targetPath, state.value, stateEditor2.createDefaultSetCallback(state));
    }
}
var $5193fce5c5df8bb9$var$stateEditor = new $5193fce5c5df8bb9$var$StateEditor();
async function $5193fce5c5df8bb9$var$editState(payload) {
    $5193fce5c5df8bb9$var$editComponentState(payload, $5193fce5c5df8bb9$var$stateEditor);
}
// src/core/open-in-editor/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/ctx/state.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/timeline/storage.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$TIMELINE_LAYERS_STATE_STORAGE_ID = "__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS_STATE__";
function $5193fce5c5df8bb9$var$addTimelineLayersStateToStorage(state) {
    if (!(0, $i0cUC.isBrowser) || typeof localStorage === "undefined" || localStorage === null) return;
    localStorage.setItem($5193fce5c5df8bb9$var$TIMELINE_LAYERS_STATE_STORAGE_ID, JSON.stringify(state));
}
function $5193fce5c5df8bb9$var$getTimelineLayersStateFromStorage() {
    if (!(0, $i0cUC.isBrowser) || typeof localStorage === "undefined" || localStorage === null) return {
        recordingState: false,
        mouseEventEnabled: false,
        keyboardEventEnabled: false,
        componentEventEnabled: false,
        performanceEventEnabled: false,
        selected: ""
    };
    const state = localStorage.getItem($5193fce5c5df8bb9$var$TIMELINE_LAYERS_STATE_STORAGE_ID);
    return state ? JSON.parse(state) : {
        recordingState: false,
        mouseEventEnabled: false,
        keyboardEventEnabled: false,
        componentEventEnabled: false,
        performanceEventEnabled: false,
        selected: ""
    };
}
// src/ctx/hook.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/ctx/inspector.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/ctx/timeline.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$_a2, $5193fce5c5df8bb9$var$_b2;
($5193fce5c5df8bb9$var$_b2 = ($5193fce5c5df8bb9$var$_a2 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS) != null ? $5193fce5c5df8bb9$var$_b2 : $5193fce5c5df8bb9$var$_a2.__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS = [];
var $5193fce5c5df8bb9$var$devtoolsTimelineLayers = new Proxy((0, $i0cUC.target).__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS, {
    get (target22, prop, receiver) {
        return Reflect.get(target22, prop, receiver);
    }
});
function $5193fce5c5df8bb9$var$addTimelineLayer(options, descriptor) {
    $5193fce5c5df8bb9$export$a67dd585df937baa.timelineLayersState[descriptor.id] = false;
    $5193fce5c5df8bb9$var$devtoolsTimelineLayers.push({
        ...options,
        descriptorId: descriptor.id,
        appRecord: $5193fce5c5df8bb9$var$getAppRecord(descriptor.app)
    });
}
function $5193fce5c5df8bb9$export$736910b7e8839d93(state) {
    const updatedState = {
        ...$5193fce5c5df8bb9$export$a67dd585df937baa.timelineLayersState,
        ...state
    };
    $5193fce5c5df8bb9$var$addTimelineLayersStateToStorage(updatedState);
    $5193fce5c5df8bb9$export$ee22a7aaf6b41ce2({
        timelineLayersState: updatedState
    });
}
// src/ctx/inspector.ts
var $5193fce5c5df8bb9$var$_a3, $5193fce5c5df8bb9$var$_b3;
($5193fce5c5df8bb9$var$_b3 = ($5193fce5c5df8bb9$var$_a3 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_INSPECTOR__) != null ? $5193fce5c5df8bb9$var$_b3 : $5193fce5c5df8bb9$var$_a3.__VUE_DEVTOOLS_KIT_INSPECTOR__ = [];
var $5193fce5c5df8bb9$export$996e3c8abad0143f = new Proxy((0, $i0cUC.target).__VUE_DEVTOOLS_KIT_INSPECTOR__, {
    get (target22, prop, receiver) {
        return Reflect.get(target22, prop, receiver);
    }
});
var $5193fce5c5df8bb9$export$17f8005932e80cc0 = (0, $dj5lJ.debounce)(()=>{
    $5193fce5c5df8bb9$export$4f1904c03898171b.hooks.callHook("sendInspectorToClient" /* SEND_INSPECTOR_TO_CLIENT */ , $5193fce5c5df8bb9$export$2844c7432ba9d166());
});
function $5193fce5c5df8bb9$export$e863e3b6c2ff029b(inspector, descriptor) {
    var _a25, _b25;
    $5193fce5c5df8bb9$export$996e3c8abad0143f.push({
        options: inspector,
        descriptor: descriptor,
        treeFilterPlaceholder: (_a25 = inspector.treeFilterPlaceholder) != null ? _a25 : "Search tree...",
        stateFilterPlaceholder: (_b25 = inspector.stateFilterPlaceholder) != null ? _b25 : "Search state...",
        treeFilter: "",
        selectedNodeId: "",
        appRecord: $5193fce5c5df8bb9$var$getAppRecord(descriptor.app)
    });
    $5193fce5c5df8bb9$export$17f8005932e80cc0();
}
function $5193fce5c5df8bb9$export$2844c7432ba9d166() {
    return $5193fce5c5df8bb9$export$996e3c8abad0143f.filter((inspector)=>inspector.descriptor.app === $5193fce5c5df8bb9$export$162128841a7f2877.value.app).filter((inspector)=>inspector.descriptor.id !== "components").map((inspector)=>{
        var _a25;
        const descriptor = inspector.descriptor;
        const options = inspector.options;
        return {
            id: options.id,
            label: options.label,
            logo: descriptor.logo,
            icon: `custom-ic-baseline-${(_a25 = options == null ? void 0 : options.icon) == null ? void 0 : _a25.replace(/_/g, "-")}`,
            packageName: descriptor.packageName,
            homepage: descriptor.homepage,
            pluginId: descriptor.id
        };
    });
}
function $5193fce5c5df8bb9$export$5042bdc6f02e4304(id) {
    const inspector = $5193fce5c5df8bb9$export$aa4140d0f5ce4bbe(id, $5193fce5c5df8bb9$export$162128841a7f2877.value.app);
    if (!inspector) return;
    const descriptor = inspector.descriptor;
    const options = inspector.options;
    const timelineLayers = $5193fce5c5df8bb9$var$devtoolsTimelineLayers.filter((layer)=>layer.descriptorId === descriptor.id).map((item)=>({
            id: item.id,
            label: item.label,
            color: item.color
        }));
    return {
        id: options.id,
        label: options.label,
        logo: descriptor.logo,
        packageName: descriptor.packageName,
        homepage: descriptor.homepage,
        timelineLayers: timelineLayers,
        treeFilterPlaceholder: inspector.treeFilterPlaceholder,
        stateFilterPlaceholder: inspector.stateFilterPlaceholder
    };
}
function $5193fce5c5df8bb9$export$aa4140d0f5ce4bbe(id, app) {
    return $5193fce5c5df8bb9$export$996e3c8abad0143f.find((inspector)=>inspector.options.id === id && (app ? inspector.descriptor.app === app : true));
}
function $5193fce5c5df8bb9$export$54eb86d2eca92815(id) {
    const inspector = $5193fce5c5df8bb9$export$aa4140d0f5ce4bbe(id);
    return inspector == null ? void 0 : inspector.options.actions;
}
function $5193fce5c5df8bb9$export$eebdca42b352a0b2(id) {
    const inspector = $5193fce5c5df8bb9$export$aa4140d0f5ce4bbe(id);
    return inspector == null ? void 0 : inspector.options.nodeActions;
}
// src/ctx/hook.ts
var $5193fce5c5df8bb9$export$3936435a794cb908 = /* @__PURE__ */ ((DevToolsV6PluginAPIHookKeys2)=>{
    DevToolsV6PluginAPIHookKeys2["VISIT_COMPONENT_TREE"] = "visitComponentTree";
    DevToolsV6PluginAPIHookKeys2["INSPECT_COMPONENT"] = "inspectComponent";
    DevToolsV6PluginAPIHookKeys2["EDIT_COMPONENT_STATE"] = "editComponentState";
    DevToolsV6PluginAPIHookKeys2["GET_INSPECTOR_TREE"] = "getInspectorTree";
    DevToolsV6PluginAPIHookKeys2["GET_INSPECTOR_STATE"] = "getInspectorState";
    DevToolsV6PluginAPIHookKeys2["EDIT_INSPECTOR_STATE"] = "editInspectorState";
    DevToolsV6PluginAPIHookKeys2["INSPECT_TIMELINE_EVENT"] = "inspectTimelineEvent";
    DevToolsV6PluginAPIHookKeys2["TIMELINE_CLEARED"] = "timelineCleared";
    DevToolsV6PluginAPIHookKeys2["SET_PLUGIN_SETTINGS"] = "setPluginSettings";
    return DevToolsV6PluginAPIHookKeys2;
})($5193fce5c5df8bb9$export$3936435a794cb908 || {});
var $5193fce5c5df8bb9$export$4c35c03df042a977 = /* @__PURE__ */ ((DevToolsContextHookKeys2)=>{
    DevToolsContextHookKeys2["ADD_INSPECTOR"] = "addInspector";
    DevToolsContextHookKeys2["SEND_INSPECTOR_TREE"] = "sendInspectorTree";
    DevToolsContextHookKeys2["SEND_INSPECTOR_STATE"] = "sendInspectorState";
    DevToolsContextHookKeys2["CUSTOM_INSPECTOR_SELECT_NODE"] = "customInspectorSelectNode";
    DevToolsContextHookKeys2["TIMELINE_LAYER_ADDED"] = "timelineLayerAdded";
    DevToolsContextHookKeys2["TIMELINE_EVENT_ADDED"] = "timelineEventAdded";
    DevToolsContextHookKeys2["GET_COMPONENT_INSTANCES"] = "getComponentInstances";
    DevToolsContextHookKeys2["GET_COMPONENT_BOUNDS"] = "getComponentBounds";
    DevToolsContextHookKeys2["GET_COMPONENT_NAME"] = "getComponentName";
    DevToolsContextHookKeys2["COMPONENT_HIGHLIGHT"] = "componentHighlight";
    DevToolsContextHookKeys2["COMPONENT_UNHIGHLIGHT"] = "componentUnhighlight";
    return DevToolsContextHookKeys2;
})($5193fce5c5df8bb9$export$4c35c03df042a977 || {});
var $5193fce5c5df8bb9$export$12aa7e661bddec80 = /* @__PURE__ */ ((DevToolsMessagingHookKeys2)=>{
    DevToolsMessagingHookKeys2["SEND_INSPECTOR_TREE_TO_CLIENT"] = "sendInspectorTreeToClient";
    DevToolsMessagingHookKeys2["SEND_INSPECTOR_STATE_TO_CLIENT"] = "sendInspectorStateToClient";
    DevToolsMessagingHookKeys2["SEND_TIMELINE_EVENT_TO_CLIENT"] = "sendTimelineEventToClient";
    DevToolsMessagingHookKeys2["SEND_INSPECTOR_TO_CLIENT"] = "sendInspectorToClient";
    DevToolsMessagingHookKeys2["SEND_ACTIVE_APP_UNMOUNTED_TO_CLIENT"] = "sendActiveAppUpdatedToClient";
    DevToolsMessagingHookKeys2["DEVTOOLS_STATE_UPDATED"] = "devtoolsStateUpdated";
    DevToolsMessagingHookKeys2["DEVTOOLS_CONNECTED_UPDATED"] = "devtoolsConnectedUpdated";
    DevToolsMessagingHookKeys2["ROUTER_INFO_UPDATED"] = "routerInfoUpdated";
    return DevToolsMessagingHookKeys2;
})($5193fce5c5df8bb9$export$12aa7e661bddec80 || {});
function $5193fce5c5df8bb9$export$73be3ac6032ad9bb() {
    const hooks2 = (0, $ptPDd.createHooks)();
    hooks2.hook("addInspector" /* ADD_INSPECTOR */ , ({ inspector: inspector, plugin: plugin })=>{
        $5193fce5c5df8bb9$export$e863e3b6c2ff029b(inspector, plugin.descriptor);
    });
    const debounceSendInspectorTree = (0, $dj5lJ.debounce)(async ({ inspectorId: inspectorId, plugin: plugin })=>{
        var _a25;
        if (!inspectorId || !((_a25 = plugin == null ? void 0 : plugin.descriptor) == null ? void 0 : _a25.app) || $5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
        const inspector = $5193fce5c5df8bb9$export$aa4140d0f5ce4bbe(inspectorId, plugin.descriptor.app);
        const _payload = {
            app: plugin.descriptor.app,
            inspectorId: inspectorId,
            filter: (inspector == null ? void 0 : inspector.treeFilter) || "",
            rootNodes: []
        };
        await new Promise((resolve)=>{
            hooks2.callHookWith(async (callbacks)=>{
                await Promise.all(callbacks.map((cb)=>cb(_payload)));
                resolve();
            }, "getInspectorTree" /* GET_INSPECTOR_TREE */ );
        });
        hooks2.callHookWith(async (callbacks)=>{
            await Promise.all(callbacks.map((cb)=>cb({
                    inspectorId: inspectorId,
                    rootNodes: _payload.rootNodes
                })));
        }, "sendInspectorTreeToClient" /* SEND_INSPECTOR_TREE_TO_CLIENT */ );
    }, 120);
    hooks2.hook("sendInspectorTree" /* SEND_INSPECTOR_TREE */ , debounceSendInspectorTree);
    const debounceSendInspectorState = (0, $dj5lJ.debounce)(async ({ inspectorId: inspectorId, plugin: plugin })=>{
        var _a25;
        if (!inspectorId || !((_a25 = plugin == null ? void 0 : plugin.descriptor) == null ? void 0 : _a25.app) || $5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
        const inspector = $5193fce5c5df8bb9$export$aa4140d0f5ce4bbe(inspectorId, plugin.descriptor.app);
        const _payload = {
            app: plugin.descriptor.app,
            inspectorId: inspectorId,
            nodeId: (inspector == null ? void 0 : inspector.selectedNodeId) || "",
            state: null
        };
        const ctx = {
            currentTab: `custom-inspector:${inspectorId}`
        };
        if (_payload.nodeId) await new Promise((resolve)=>{
            hooks2.callHookWith(async (callbacks)=>{
                await Promise.all(callbacks.map((cb)=>cb(_payload, ctx)));
                resolve();
            }, "getInspectorState" /* GET_INSPECTOR_STATE */ );
        });
        hooks2.callHookWith(async (callbacks)=>{
            await Promise.all(callbacks.map((cb)=>cb({
                    inspectorId: inspectorId,
                    nodeId: _payload.nodeId,
                    state: _payload.state
                })));
        }, "sendInspectorStateToClient" /* SEND_INSPECTOR_STATE_TO_CLIENT */ );
    }, 120);
    hooks2.hook("sendInspectorState" /* SEND_INSPECTOR_STATE */ , debounceSendInspectorState);
    hooks2.hook("customInspectorSelectNode" /* CUSTOM_INSPECTOR_SELECT_NODE */ , ({ inspectorId: inspectorId, nodeId: nodeId, plugin: plugin })=>{
        const inspector = $5193fce5c5df8bb9$export$aa4140d0f5ce4bbe(inspectorId, plugin.descriptor.app);
        if (!inspector) return;
        inspector.selectedNodeId = nodeId;
    });
    hooks2.hook("timelineLayerAdded" /* TIMELINE_LAYER_ADDED */ , ({ options: options, plugin: plugin })=>{
        $5193fce5c5df8bb9$var$addTimelineLayer(options, plugin.descriptor);
    });
    hooks2.hook("timelineEventAdded" /* TIMELINE_EVENT_ADDED */ , ({ options: options, plugin: plugin })=>{
        var _a25;
        const internalLayerIds = [
            "performance",
            "component-event",
            "keyboard",
            "mouse"
        ];
        if ($5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled || !((_a25 = $5193fce5c5df8bb9$export$a67dd585df937baa.timelineLayersState) == null ? void 0 : _a25[plugin.descriptor.id]) && !internalLayerIds.includes(options.layerId)) return;
        hooks2.callHookWith(async (callbacks)=>{
            await Promise.all(callbacks.map((cb)=>cb(options)));
        }, "sendTimelineEventToClient" /* SEND_TIMELINE_EVENT_TO_CLIENT */ );
    });
    hooks2.hook("getComponentInstances" /* GET_COMPONENT_INSTANCES */ , async ({ app: app })=>{
        const appRecord = app.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
        if (!appRecord) return null;
        const appId = appRecord.id.toString();
        const instances = [
            ...appRecord.instanceMap
        ].filter(([key])=>key.split(":")[0] === appId).map(([, instance])=>instance);
        return instances;
    });
    hooks2.hook("getComponentBounds" /* GET_COMPONENT_BOUNDS */ , async ({ instance: instance })=>{
        const bounds = $5193fce5c5df8bb9$var$getComponentBoundingRect(instance);
        return bounds;
    });
    hooks2.hook("getComponentName" /* GET_COMPONENT_NAME */ , ({ instance: instance })=>{
        const name = $5193fce5c5df8bb9$var$getInstanceName(instance);
        return name;
    });
    hooks2.hook("componentHighlight" /* COMPONENT_HIGHLIGHT */ , ({ uid: uid })=>{
        const instance = $5193fce5c5df8bb9$export$162128841a7f2877.value.instanceMap.get(uid);
        if (instance) $5193fce5c5df8bb9$var$highlight(instance);
    });
    hooks2.hook("componentUnhighlight" /* COMPONENT_UNHIGHLIGHT */ , ()=>{
        $5193fce5c5df8bb9$var$unhighlight();
    });
    return hooks2;
}
// src/ctx/state.ts
var $5193fce5c5df8bb9$var$_a4, $5193fce5c5df8bb9$var$_b4;
($5193fce5c5df8bb9$var$_b4 = ($5193fce5c5df8bb9$var$_a4 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_APP_RECORDS__) != null ? $5193fce5c5df8bb9$var$_b4 : $5193fce5c5df8bb9$var$_a4.__VUE_DEVTOOLS_KIT_APP_RECORDS__ = [];
var $5193fce5c5df8bb9$var$_a5, $5193fce5c5df8bb9$var$_b5;
($5193fce5c5df8bb9$var$_b5 = ($5193fce5c5df8bb9$var$_a5 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__) != null ? $5193fce5c5df8bb9$var$_b5 : $5193fce5c5df8bb9$var$_a5.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ = {};
var $5193fce5c5df8bb9$var$_a6, $5193fce5c5df8bb9$var$_b6;
($5193fce5c5df8bb9$var$_b6 = ($5193fce5c5df8bb9$var$_a6 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__) != null ? $5193fce5c5df8bb9$var$_b6 : $5193fce5c5df8bb9$var$_a6.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ = "";
var $5193fce5c5df8bb9$var$_a7, $5193fce5c5df8bb9$var$_b7;
($5193fce5c5df8bb9$var$_b7 = ($5193fce5c5df8bb9$var$_a7 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__) != null ? $5193fce5c5df8bb9$var$_b7 : $5193fce5c5df8bb9$var$_a7.__VUE_DEVTOOLS_KIT_CUSTOM_TABS__ = [];
var $5193fce5c5df8bb9$var$_a8, $5193fce5c5df8bb9$var$_b8;
($5193fce5c5df8bb9$var$_b8 = ($5193fce5c5df8bb9$var$_a8 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__) != null ? $5193fce5c5df8bb9$var$_b8 : $5193fce5c5df8bb9$var$_a8.__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__ = [];
var $5193fce5c5df8bb9$var$STATE_KEY = "__VUE_DEVTOOLS_KIT_GLOBAL_STATE__";
function $5193fce5c5df8bb9$var$initStateFactory() {
    return {
        connected: false,
        clientConnected: false,
        vitePluginDetected: true,
        appRecords: [],
        activeAppRecordId: "",
        tabs: [],
        commands: [],
        highPerfModeEnabled: true,
        devtoolsClientDetected: {},
        perfUniqueGroupId: 0,
        timelineLayersState: $5193fce5c5df8bb9$var$getTimelineLayersStateFromStorage()
    };
}
var $5193fce5c5df8bb9$var$_a9, $5193fce5c5df8bb9$var$_b9;
($5193fce5c5df8bb9$var$_b9 = ($5193fce5c5df8bb9$var$_a9 = (0, $i0cUC.target))[$5193fce5c5df8bb9$var$STATE_KEY]) != null ? $5193fce5c5df8bb9$var$_b9 : $5193fce5c5df8bb9$var$_a9[$5193fce5c5df8bb9$var$STATE_KEY] = $5193fce5c5df8bb9$var$initStateFactory();
var $5193fce5c5df8bb9$export$ff4fc651602b9735 = (0, $dj5lJ.debounce)((state)=>{
    $5193fce5c5df8bb9$export$4f1904c03898171b.hooks.callHook("devtoolsStateUpdated" /* DEVTOOLS_STATE_UPDATED */ , {
        state: state
    });
});
var $5193fce5c5df8bb9$export$ce292af96ab94f7c = (0, $dj5lJ.debounce)((state, oldState)=>{
    $5193fce5c5df8bb9$export$4f1904c03898171b.hooks.callHook("devtoolsConnectedUpdated" /* DEVTOOLS_CONNECTED_UPDATED */ , {
        state: state,
        oldState: oldState
    });
});
var $5193fce5c5df8bb9$export$d3c0473489b1d63b = new Proxy((0, $i0cUC.target).__VUE_DEVTOOLS_KIT_APP_RECORDS__, {
    get (_target, prop, receiver) {
        if (prop === "value") return (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_APP_RECORDS__;
        return (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_APP_RECORDS__[prop];
    }
});
var $5193fce5c5df8bb9$export$c1761479e1420543 = (app)=>{
    (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_APP_RECORDS__ = [
        ...(0, $i0cUC.target).__VUE_DEVTOOLS_KIT_APP_RECORDS__,
        app
    ];
};
var $5193fce5c5df8bb9$export$4d20c72f1da170ba = (app)=>{
    (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_APP_RECORDS__ = $5193fce5c5df8bb9$export$d3c0473489b1d63b.value.filter((record)=>record.app !== app);
};
var $5193fce5c5df8bb9$export$162128841a7f2877 = new Proxy((0, $i0cUC.target).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__, {
    get (_target, prop, receiver) {
        if (prop === "value") return (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__;
        else if (prop === "id") return (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__;
        return (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__[prop];
    }
});
function $5193fce5c5df8bb9$var$updateAllStates() {
    $5193fce5c5df8bb9$export$ff4fc651602b9735({
        ...(0, $i0cUC.target)[$5193fce5c5df8bb9$var$STATE_KEY],
        appRecords: $5193fce5c5df8bb9$export$d3c0473489b1d63b.value,
        activeAppRecordId: $5193fce5c5df8bb9$export$162128841a7f2877.id,
        tabs: (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__,
        commands: (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__
    });
}
function $5193fce5c5df8bb9$export$1574774def61bdf9(app) {
    (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ = app;
    $5193fce5c5df8bb9$var$updateAllStates();
}
function $5193fce5c5df8bb9$export$1a7804ab8d8511d1(id) {
    (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ = id;
    $5193fce5c5df8bb9$var$updateAllStates();
}
var $5193fce5c5df8bb9$export$a67dd585df937baa = new Proxy((0, $i0cUC.target)[$5193fce5c5df8bb9$var$STATE_KEY], {
    get (target22, property) {
        if (property === "appRecords") return $5193fce5c5df8bb9$export$d3c0473489b1d63b;
        else if (property === "activeAppRecordId") return $5193fce5c5df8bb9$export$162128841a7f2877.id;
        else if (property === "tabs") return (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__;
        else if (property === "commands") return (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__;
        return (0, $i0cUC.target)[$5193fce5c5df8bb9$var$STATE_KEY][property];
    },
    deleteProperty (target22, property) {
        delete target22[property];
        return true;
    },
    set (target22, property, value) {
        const oldState = {
            ...(0, $i0cUC.target)[$5193fce5c5df8bb9$var$STATE_KEY]
        };
        target22[property] = value;
        (0, $i0cUC.target)[$5193fce5c5df8bb9$var$STATE_KEY][property] = value;
        return true;
    }
});
function $5193fce5c5df8bb9$export$ed70a0f71250535e() {
    Object.assign((0, $i0cUC.target)[$5193fce5c5df8bb9$var$STATE_KEY], $5193fce5c5df8bb9$var$initStateFactory());
}
function $5193fce5c5df8bb9$export$ee22a7aaf6b41ce2(state) {
    const oldState = {
        ...(0, $i0cUC.target)[$5193fce5c5df8bb9$var$STATE_KEY],
        appRecords: $5193fce5c5df8bb9$export$d3c0473489b1d63b.value,
        activeAppRecordId: $5193fce5c5df8bb9$export$162128841a7f2877.id
    };
    if (oldState.connected !== state.connected && state.connected || oldState.clientConnected !== state.clientConnected && state.clientConnected) $5193fce5c5df8bb9$export$ce292af96ab94f7c((0, $i0cUC.target)[$5193fce5c5df8bb9$var$STATE_KEY], oldState);
    Object.assign((0, $i0cUC.target)[$5193fce5c5df8bb9$var$STATE_KEY], state);
    $5193fce5c5df8bb9$var$updateAllStates();
}
function $5193fce5c5df8bb9$export$814e9e34f2c01770(fn) {
    return new Promise((resolve)=>{
        if ($5193fce5c5df8bb9$export$a67dd585df937baa.connected) {
            fn();
            resolve();
        }
        $5193fce5c5df8bb9$export$4f1904c03898171b.hooks.hook("devtoolsConnectedUpdated" /* DEVTOOLS_CONNECTED_UPDATED */ , ({ state: state })=>{
            if (state.connected) {
                fn();
                resolve();
            }
        });
    });
}
var $5193fce5c5df8bb9$var$resolveIcon = (icon)=>{
    if (!icon) return;
    if (icon.startsWith("baseline-")) return `custom-ic-${icon}`;
    if (icon.startsWith("i-") || (0, $i0cUC.isUrlString)(icon)) return icon;
    return `custom-ic-baseline-${icon}`;
};
function $5193fce5c5df8bb9$export$9ce008646970742b(tab) {
    const tabs = (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__;
    if (tabs.some((t)=>t.name === tab.name)) return;
    tabs.push({
        ...tab,
        icon: $5193fce5c5df8bb9$var$resolveIcon(tab.icon)
    });
    $5193fce5c5df8bb9$var$updateAllStates();
}
function $5193fce5c5df8bb9$export$faa8225e4ad5293(action) {
    const commands = (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__;
    if (commands.some((t)=>t.id === action.id)) return;
    commands.push({
        ...action,
        icon: $5193fce5c5df8bb9$var$resolveIcon(action.icon),
        children: action.children ? action.children.map((child)=>({
                ...child,
                icon: $5193fce5c5df8bb9$var$resolveIcon(child.icon)
            })) : void 0
    });
    $5193fce5c5df8bb9$var$updateAllStates();
}
function $5193fce5c5df8bb9$export$8791c0d68ff21044(actionId) {
    const commands = (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__;
    const index = commands.findIndex((t)=>t.id === actionId);
    if (index === -1) return;
    commands.splice(index, 1);
    $5193fce5c5df8bb9$var$updateAllStates();
}
function $5193fce5c5df8bb9$export$b2de3679515b1d6b(state) {
    $5193fce5c5df8bb9$export$ee22a7aaf6b41ce2({
        clientConnected: state
    });
}
// src/core/open-in-editor/index.ts
function $5193fce5c5df8bb9$export$d4398ad178564033(url) {
    (0, $i0cUC.target).__VUE_DEVTOOLS_OPEN_IN_EDITOR_BASE_URL__ = url;
}
function $5193fce5c5df8bb9$var$openInEditor(options = {}) {
    var _a25, _b25, _c;
    const { file: file, host: host, baseUrl: baseUrl = window.location.origin, line: line = 0, column: column = 0 } = options;
    if (file) {
        if (host === "chrome-extension") {
            const fileName = file.replace(/\\/g, "\\\\");
            const _baseUrl = (_b25 = (_a25 = window.VUE_DEVTOOLS_CONFIG) == null ? void 0 : _a25.openInEditorHost) != null ? _b25 : "/";
            fetch(`${_baseUrl}__open-in-editor?file=${encodeURI(file)}`).then((response)=>{
                if (!response.ok) {
                    const msg = `Opening component ${fileName} failed`;
                    console.log(`%c${msg}`, "color:red");
                }
            });
        } else if ($5193fce5c5df8bb9$export$a67dd585df937baa.vitePluginDetected) {
            const _baseUrl = (_c = (0, $i0cUC.target).__VUE_DEVTOOLS_OPEN_IN_EDITOR_BASE_URL__) != null ? _c : baseUrl;
            (0, $i0cUC.target).__VUE_INSPECTOR__.openInEditor(_baseUrl, file, line, column);
        }
    }
}
// src/core/plugin/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/api/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/api/v6/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/plugin/plugin-settings.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/ctx/plugin.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$_a10, $5193fce5c5df8bb9$var$_b10;
($5193fce5c5df8bb9$var$_b10 = ($5193fce5c5df8bb9$var$_a10 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__) != null ? $5193fce5c5df8bb9$var$_b10 : $5193fce5c5df8bb9$var$_a10.__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__ = [];
var $5193fce5c5df8bb9$export$df02dcb86618c10f = new Proxy((0, $i0cUC.target).__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__, {
    get (target22, prop, receiver) {
        return Reflect.get(target22, prop, receiver);
    }
});
function $5193fce5c5df8bb9$export$5158df7771943590(pluginDescriptor, setupFn) {
    $5193fce5c5df8bb9$export$df02dcb86618c10f.push([
        pluginDescriptor,
        setupFn
    ]);
}
// src/core/plugin/plugin-settings.ts
function $5193fce5c5df8bb9$var$_getSettings(settings) {
    const _settings = {};
    Object.keys(settings).forEach((key)=>{
        _settings[key] = settings[key].defaultValue;
    });
    return _settings;
}
function $5193fce5c5df8bb9$var$getPluginLocalKey(pluginId) {
    return `__VUE_DEVTOOLS_NEXT_PLUGIN_SETTINGS__${pluginId}__`;
}
function $5193fce5c5df8bb9$var$getPluginSettingsOptions(pluginId) {
    var _a25, _b25, _c;
    const item = (_b25 = (_a25 = $5193fce5c5df8bb9$export$df02dcb86618c10f.find((item2)=>{
        var _a26;
        return item2[0].id === pluginId && !!((_a26 = item2[0]) == null ? void 0 : _a26.settings);
    })) == null ? void 0 : _a25[0]) != null ? _b25 : null;
    return (_c = item == null ? void 0 : item.settings) != null ? _c : null;
}
function $5193fce5c5df8bb9$var$getPluginSettings(pluginId, fallbackValue) {
    var _a25, _b25, _c;
    const localKey = $5193fce5c5df8bb9$var$getPluginLocalKey(pluginId);
    if (localKey) {
        const localSettings = localStorage.getItem(localKey);
        if (localSettings) return JSON.parse(localSettings);
    }
    if (pluginId) {
        const item = (_b25 = (_a25 = $5193fce5c5df8bb9$export$df02dcb86618c10f.find((item2)=>item2[0].id === pluginId)) == null ? void 0 : _a25[0]) != null ? _b25 : null;
        return $5193fce5c5df8bb9$var$_getSettings((_c = item == null ? void 0 : item.settings) != null ? _c : {});
    }
    return $5193fce5c5df8bb9$var$_getSettings(fallbackValue);
}
function $5193fce5c5df8bb9$var$initPluginSettings(pluginId, settings) {
    const localKey = $5193fce5c5df8bb9$var$getPluginLocalKey(pluginId);
    const localSettings = localStorage.getItem(localKey);
    if (!localSettings) localStorage.setItem(localKey, JSON.stringify($5193fce5c5df8bb9$var$_getSettings(settings)));
}
function $5193fce5c5df8bb9$var$setPluginSettings(pluginId, key, value) {
    const localKey = $5193fce5c5df8bb9$var$getPluginLocalKey(pluginId);
    const localSettings = localStorage.getItem(localKey);
    const parsedLocalSettings = JSON.parse(localSettings || "{}");
    const updated = {
        ...parsedLocalSettings,
        [key]: value
    };
    localStorage.setItem(localKey, JSON.stringify(updated));
    $5193fce5c5df8bb9$export$4f1904c03898171b.hooks.callHookWith((callbacks)=>{
        callbacks.forEach((cb)=>cb({
                pluginId: pluginId,
                key: key,
                oldValue: parsedLocalSettings[key],
                newValue: value,
                settings: updated
            }));
    }, "setPluginSettings" /* SET_PLUGIN_SETTINGS */ );
}
// src/hook/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/types/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/types/app.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/types/command.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/types/component.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/types/hook.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/types/inspector.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/types/plugin.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/types/router.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/types/tab.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/types/timeline.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/hook/index.ts
var $5193fce5c5df8bb9$var$_a11, $5193fce5c5df8bb9$var$_b11;
var $5193fce5c5df8bb9$var$devtoolsHooks = ($5193fce5c5df8bb9$var$_b11 = ($5193fce5c5df8bb9$var$_a11 = (0, $i0cUC.target)).__VUE_DEVTOOLS_HOOK) != null ? $5193fce5c5df8bb9$var$_b11 : $5193fce5c5df8bb9$var$_a11.__VUE_DEVTOOLS_HOOK = (0, $ptPDd.createHooks)();
var $5193fce5c5df8bb9$var$on = {
    vueAppInit (fn) {
        $5193fce5c5df8bb9$var$devtoolsHooks.hook("app:init" /* APP_INIT */ , fn);
    },
    vueAppUnmount (fn) {
        $5193fce5c5df8bb9$var$devtoolsHooks.hook("app:unmount" /* APP_UNMOUNT */ , fn);
    },
    vueAppConnected (fn) {
        $5193fce5c5df8bb9$var$devtoolsHooks.hook("app:connected" /* APP_CONNECTED */ , fn);
    },
    componentAdded (fn) {
        return $5193fce5c5df8bb9$var$devtoolsHooks.hook("component:added" /* COMPONENT_ADDED */ , fn);
    },
    componentEmit (fn) {
        return $5193fce5c5df8bb9$var$devtoolsHooks.hook("component:emit" /* COMPONENT_EMIT */ , fn);
    },
    componentUpdated (fn) {
        return $5193fce5c5df8bb9$var$devtoolsHooks.hook("component:updated" /* COMPONENT_UPDATED */ , fn);
    },
    componentRemoved (fn) {
        return $5193fce5c5df8bb9$var$devtoolsHooks.hook("component:removed" /* COMPONENT_REMOVED */ , fn);
    },
    setupDevtoolsPlugin (fn) {
        $5193fce5c5df8bb9$var$devtoolsHooks.hook("devtools-plugin:setup" /* SETUP_DEVTOOLS_PLUGIN */ , fn);
    },
    perfStart (fn) {
        return $5193fce5c5df8bb9$var$devtoolsHooks.hook("perf:start" /* PERFORMANCE_START */ , fn);
    },
    perfEnd (fn) {
        return $5193fce5c5df8bb9$var$devtoolsHooks.hook("perf:end" /* PERFORMANCE_END */ , fn);
    }
};
function $5193fce5c5df8bb9$var$createDevToolsHook() {
    return {
        id: "vue-devtools-next",
        devtoolsVersion: "7.0",
        enabled: false,
        appRecords: [],
        apps: [],
        events: /* @__PURE__ */ new Map(),
        on (event, fn) {
            var _a25;
            if (!this.events.has(event)) this.events.set(event, []);
            (_a25 = this.events.get(event)) == null || _a25.push(fn);
            return ()=>this.off(event, fn);
        },
        once (event, fn) {
            const onceFn = (...args)=>{
                this.off(event, onceFn);
                fn(...args);
            };
            this.on(event, onceFn);
            return [
                event,
                onceFn
            ];
        },
        off (event, fn) {
            if (this.events.has(event)) {
                const eventCallbacks = this.events.get(event);
                const index = eventCallbacks.indexOf(fn);
                if (index !== -1) eventCallbacks.splice(index, 1);
            }
        },
        emit (event, ...payload) {
            if (this.events.has(event)) this.events.get(event).forEach((fn)=>fn(...payload));
        }
    };
}
function $5193fce5c5df8bb9$var$subscribeDevToolsHook(hook2) {
    hook2.on("app:init" /* APP_INIT */ , (app, version, types)=>{
        var _a25, _b25, _c;
        if ((_c = (_b25 = (_a25 = app == null ? void 0 : app._instance) == null ? void 0 : _a25.type) == null ? void 0 : _b25.devtools) == null ? void 0 : _c.hide) return;
        $5193fce5c5df8bb9$var$devtoolsHooks.callHook("app:init" /* APP_INIT */ , app, version, types);
    });
    hook2.on("app:unmount" /* APP_UNMOUNT */ , (app)=>{
        $5193fce5c5df8bb9$var$devtoolsHooks.callHook("app:unmount" /* APP_UNMOUNT */ , app);
    });
    hook2.on("component:added" /* COMPONENT_ADDED */ , async (app, uid, parentUid, component)=>{
        var _a25, _b25, _c;
        if (((_c = (_b25 = (_a25 = app == null ? void 0 : app._instance) == null ? void 0 : _a25.type) == null ? void 0 : _b25.devtools) == null ? void 0 : _c.hide) || $5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
        if (!app || typeof uid !== "number" && !uid || !component) return;
        $5193fce5c5df8bb9$var$devtoolsHooks.callHook("component:added" /* COMPONENT_ADDED */ , app, uid, parentUid, component);
    });
    hook2.on("component:updated" /* COMPONENT_UPDATED */ , (app, uid, parentUid, component)=>{
        if (!app || typeof uid !== "number" && !uid || !component || $5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
        $5193fce5c5df8bb9$var$devtoolsHooks.callHook("component:updated" /* COMPONENT_UPDATED */ , app, uid, parentUid, component);
    });
    hook2.on("component:removed" /* COMPONENT_REMOVED */ , async (app, uid, parentUid, component)=>{
        if (!app || typeof uid !== "number" && !uid || !component || $5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
        $5193fce5c5df8bb9$var$devtoolsHooks.callHook("component:removed" /* COMPONENT_REMOVED */ , app, uid, parentUid, component);
    });
    hook2.on("component:emit" /* COMPONENT_EMIT */ , async (app, instance, event, params)=>{
        if (!app || !instance || $5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
        $5193fce5c5df8bb9$var$devtoolsHooks.callHook("component:emit" /* COMPONENT_EMIT */ , app, instance, event, params);
    });
    hook2.on("perf:start" /* PERFORMANCE_START */ , (app, uid, vm, type, time)=>{
        if (!app || $5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
        $5193fce5c5df8bb9$var$devtoolsHooks.callHook("perf:start" /* PERFORMANCE_START */ , app, uid, vm, type, time);
    });
    hook2.on("perf:end" /* PERFORMANCE_END */ , (app, uid, vm, type, time)=>{
        if (!app || $5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
        $5193fce5c5df8bb9$var$devtoolsHooks.callHook("perf:end" /* PERFORMANCE_END */ , app, uid, vm, type, time);
    });
    hook2.on("devtools-plugin:setup" /* SETUP_DEVTOOLS_PLUGIN */ , (pluginDescriptor, setupFn, options)=>{
        if ((options == null ? void 0 : options.target) === "legacy") return;
        $5193fce5c5df8bb9$var$devtoolsHooks.callHook("devtools-plugin:setup" /* SETUP_DEVTOOLS_PLUGIN */ , pluginDescriptor, setupFn);
    });
}
var $5193fce5c5df8bb9$var$hook = {
    on: $5193fce5c5df8bb9$var$on,
    setupDevToolsPlugin (pluginDescriptor, setupFn) {
        return $5193fce5c5df8bb9$var$devtoolsHooks.callHook("devtools-plugin:setup" /* SETUP_DEVTOOLS_PLUGIN */ , pluginDescriptor, setupFn);
    }
};
// src/api/v6/index.ts
var $5193fce5c5df8bb9$var$DevToolsV6PluginAPI = class {
    constructor({ plugin: plugin, ctx: ctx }){
        this.hooks = ctx.hooks;
        this.plugin = plugin;
    }
    get on() {
        return {
            // component inspector
            visitComponentTree: (handler)=>{
                this.hooks.hook("visitComponentTree" /* VISIT_COMPONENT_TREE */ , handler);
            },
            inspectComponent: (handler)=>{
                this.hooks.hook("inspectComponent" /* INSPECT_COMPONENT */ , handler);
            },
            editComponentState: (handler)=>{
                this.hooks.hook("editComponentState" /* EDIT_COMPONENT_STATE */ , handler);
            },
            // custom inspector
            getInspectorTree: (handler)=>{
                this.hooks.hook("getInspectorTree" /* GET_INSPECTOR_TREE */ , handler);
            },
            getInspectorState: (handler)=>{
                this.hooks.hook("getInspectorState" /* GET_INSPECTOR_STATE */ , handler);
            },
            editInspectorState: (handler)=>{
                this.hooks.hook("editInspectorState" /* EDIT_INSPECTOR_STATE */ , handler);
            },
            // timeline
            inspectTimelineEvent: (handler)=>{
                this.hooks.hook("inspectTimelineEvent" /* INSPECT_TIMELINE_EVENT */ , handler);
            },
            timelineCleared: (handler)=>{
                this.hooks.hook("timelineCleared" /* TIMELINE_CLEARED */ , handler);
            },
            // settings
            setPluginSettings: (handler)=>{
                this.hooks.hook("setPluginSettings" /* SET_PLUGIN_SETTINGS */ , handler);
            }
        };
    }
    // component inspector
    notifyComponentUpdate(instance) {
        var _a25;
        if ($5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
        const inspector = $5193fce5c5df8bb9$export$2844c7432ba9d166().find((i)=>i.packageName === this.plugin.descriptor.packageName);
        if (inspector == null ? void 0 : inspector.id) {
            if (instance) {
                const args = [
                    instance.appContext.app,
                    instance.uid,
                    (_a25 = instance.parent) == null ? void 0 : _a25.uid,
                    instance
                ];
                $5193fce5c5df8bb9$var$devtoolsHooks.callHook("component:updated" /* COMPONENT_UPDATED */ , ...args);
            } else $5193fce5c5df8bb9$var$devtoolsHooks.callHook("component:updated" /* COMPONENT_UPDATED */ );
            this.hooks.callHook("sendInspectorState" /* SEND_INSPECTOR_STATE */ , {
                inspectorId: inspector.id,
                plugin: this.plugin
            });
        }
    }
    // custom inspector
    addInspector(options) {
        this.hooks.callHook("addInspector" /* ADD_INSPECTOR */ , {
            inspector: options,
            plugin: this.plugin
        });
        if (this.plugin.descriptor.settings) $5193fce5c5df8bb9$var$initPluginSettings(options.id, this.plugin.descriptor.settings);
    }
    sendInspectorTree(inspectorId) {
        if ($5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
        this.hooks.callHook("sendInspectorTree" /* SEND_INSPECTOR_TREE */ , {
            inspectorId: inspectorId,
            plugin: this.plugin
        });
    }
    sendInspectorState(inspectorId) {
        if ($5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
        this.hooks.callHook("sendInspectorState" /* SEND_INSPECTOR_STATE */ , {
            inspectorId: inspectorId,
            plugin: this.plugin
        });
    }
    selectInspectorNode(inspectorId, nodeId) {
        this.hooks.callHook("customInspectorSelectNode" /* CUSTOM_INSPECTOR_SELECT_NODE */ , {
            inspectorId: inspectorId,
            nodeId: nodeId,
            plugin: this.plugin
        });
    }
    visitComponentTree(payload) {
        return this.hooks.callHook("visitComponentTree" /* VISIT_COMPONENT_TREE */ , payload);
    }
    // timeline
    now() {
        if ($5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return 0;
        return Date.now();
    }
    addTimelineLayer(options) {
        this.hooks.callHook("timelineLayerAdded" /* TIMELINE_LAYER_ADDED */ , {
            options: options,
            plugin: this.plugin
        });
    }
    addTimelineEvent(options) {
        if ($5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
        this.hooks.callHook("timelineEventAdded" /* TIMELINE_EVENT_ADDED */ , {
            options: options,
            plugin: this.plugin
        });
    }
    // settings
    getSettings(pluginId) {
        return $5193fce5c5df8bb9$var$getPluginSettings(pluginId != null ? pluginId : this.plugin.descriptor.id, this.plugin.descriptor.settings);
    }
    // utilities
    getComponentInstances(app) {
        return this.hooks.callHook("getComponentInstances" /* GET_COMPONENT_INSTANCES */ , {
            app: app
        });
    }
    getComponentBounds(instance) {
        return this.hooks.callHook("getComponentBounds" /* GET_COMPONENT_BOUNDS */ , {
            instance: instance
        });
    }
    getComponentName(instance) {
        return this.hooks.callHook("getComponentName" /* GET_COMPONENT_NAME */ , {
            instance: instance
        });
    }
    highlightElement(instance) {
        const uid = instance.__VUE_DEVTOOLS_NEXT_UID__;
        return this.hooks.callHook("componentHighlight" /* COMPONENT_HIGHLIGHT */ , {
            uid: uid
        });
    }
    unhighlightElement() {
        return this.hooks.callHook("componentUnhighlight" /* COMPONENT_UNHIGHLIGHT */ );
    }
};
// src/api/index.ts
var $5193fce5c5df8bb9$var$DevToolsPluginAPI = $5193fce5c5df8bb9$var$DevToolsV6PluginAPI;
// src/core/plugin/components.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/component/state/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/component/state/process.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/component/state/constants.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$vueBuiltins = /* @__PURE__ */ new Set([
    "nextTick",
    "defineComponent",
    "defineAsyncComponent",
    "defineCustomElement",
    "ref",
    "computed",
    "reactive",
    "readonly",
    "watchEffect",
    "watchPostEffect",
    "watchSyncEffect",
    "watch",
    "isRef",
    "unref",
    "toRef",
    "toRefs",
    "isProxy",
    "isReactive",
    "isReadonly",
    "shallowRef",
    "triggerRef",
    "customRef",
    "shallowReactive",
    "shallowReadonly",
    "toRaw",
    "markRaw",
    "effectScope",
    "getCurrentScope",
    "onScopeDispose",
    "onMounted",
    "onUpdated",
    "onUnmounted",
    "onBeforeMount",
    "onBeforeUpdate",
    "onBeforeUnmount",
    "onErrorCaptured",
    "onRenderTracked",
    "onRenderTriggered",
    "onActivated",
    "onDeactivated",
    "onServerPrefetch",
    "provide",
    "inject",
    "h",
    "mergeProps",
    "cloneVNode",
    "isVNode",
    "resolveComponent",
    "resolveDirective",
    "withDirectives",
    "withModifiers"
]);
var $5193fce5c5df8bb9$var$symbolRE = /^\[native Symbol Symbol\((.*)\)\]$/;
var $5193fce5c5df8bb9$var$rawTypeRE = /^\[object (\w+)\]$/;
var $5193fce5c5df8bb9$var$specialTypeRE = /^\[native (\w+) (.*?)(<>(([\s\S])*))?\]$/;
var $5193fce5c5df8bb9$var$fnTypeRE = /^(?:function|class) (\w+)/;
var $5193fce5c5df8bb9$var$MAX_STRING_SIZE = 1e4;
var $5193fce5c5df8bb9$var$MAX_ARRAY_SIZE = 5e3;
var $5193fce5c5df8bb9$export$6db089fe7b26f5b6 = "__vue_devtool_undefined__";
var $5193fce5c5df8bb9$export$b4bf424ed968e242 = "__vue_devtool_infinity__";
var $5193fce5c5df8bb9$export$95cb88e357cbada8 = "__vue_devtool_negative_infinity__";
var $5193fce5c5df8bb9$export$d7ae0f70ebb9e144 = "__vue_devtool_nan__";
var $5193fce5c5df8bb9$var$ESC = {
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "&": "&amp;"
};
// src/core/component/state/util.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/component/state/is.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$isVueInstance(value) {
    if (!$5193fce5c5df8bb9$var$ensurePropertyExists(value, "_")) return false;
    if (!$5193fce5c5df8bb9$export$53b83ca8eaab0383(value._)) return false;
    return Object.keys(value._).includes("vnode");
}
function $5193fce5c5df8bb9$export$53b83ca8eaab0383(obj) {
    return Object.prototype.toString.call(obj) === "[object Object]";
}
function $5193fce5c5df8bb9$var$isPrimitive(data) {
    if (data == null) return true;
    const type = typeof data;
    return type === "string" || type === "number" || type === "boolean";
}
function $5193fce5c5df8bb9$var$isRef2(raw) {
    return !!raw.__v_isRef;
}
function $5193fce5c5df8bb9$var$isComputed(raw) {
    return $5193fce5c5df8bb9$var$isRef2(raw) && !!raw.effect;
}
function $5193fce5c5df8bb9$var$isReactive2(raw) {
    return !!raw.__v_isReactive;
}
function $5193fce5c5df8bb9$var$isReadOnly(raw) {
    return !!raw.__v_isReadonly;
}
// src/core/component/state/util.ts
var $5193fce5c5df8bb9$var$tokenMap = {
    [$5193fce5c5df8bb9$export$6db089fe7b26f5b6]: "undefined",
    [$5193fce5c5df8bb9$export$d7ae0f70ebb9e144]: "NaN",
    [$5193fce5c5df8bb9$export$b4bf424ed968e242]: "Infinity",
    [$5193fce5c5df8bb9$export$95cb88e357cbada8]: "-Infinity"
};
var $5193fce5c5df8bb9$var$reversedTokenMap = Object.entries($5193fce5c5df8bb9$var$tokenMap).reduce((acc, [key, value])=>{
    acc[value] = key;
    return acc;
}, {});
function $5193fce5c5df8bb9$var$internalStateTokenToString(value) {
    if (value === null) return "null";
    return typeof value === "string" && $5193fce5c5df8bb9$var$tokenMap[value] || false;
}
function $5193fce5c5df8bb9$var$replaceTokenToString(value) {
    const replaceRegex = new RegExp(`"(${Object.keys($5193fce5c5df8bb9$var$tokenMap).join("|")})"`, "g");
    return value.replace(replaceRegex, (_, g1)=>$5193fce5c5df8bb9$var$tokenMap[g1]);
}
function $5193fce5c5df8bb9$var$replaceStringToToken(value) {
    const literalValue = $5193fce5c5df8bb9$var$reversedTokenMap[value.trim()];
    if (literalValue) return `"${literalValue}"`;
    const replaceRegex = new RegExp(`:\\s*(${Object.keys($5193fce5c5df8bb9$var$reversedTokenMap).join("|")})`, "g");
    return value.replace(replaceRegex, (_, g1)=>`:"${$5193fce5c5df8bb9$var$reversedTokenMap[g1]}"`);
}
function $5193fce5c5df8bb9$var$getPropType(type) {
    if (Array.isArray(type)) return type.map((t)=>$5193fce5c5df8bb9$var$getPropType(t)).join(" or ");
    if (type == null) return "null";
    const match = type.toString().match($5193fce5c5df8bb9$var$fnTypeRE);
    return typeof type === "function" ? match && match[1] || "any" : "any";
}
function $5193fce5c5df8bb9$var$sanitize(data) {
    if (!$5193fce5c5df8bb9$var$isPrimitive(data) && !Array.isArray(data) && !$5193fce5c5df8bb9$export$53b83ca8eaab0383(data)) return Object.prototype.toString.call(data);
    else return data;
}
function $5193fce5c5df8bb9$var$getSetupStateType(raw) {
    try {
        return {
            ref: $5193fce5c5df8bb9$var$isRef2(raw),
            computed: $5193fce5c5df8bb9$var$isComputed(raw),
            reactive: $5193fce5c5df8bb9$var$isReactive2(raw),
            readonly: $5193fce5c5df8bb9$var$isReadOnly(raw)
        };
    } catch (e) {
        return {
            ref: false,
            computed: false,
            reactive: false,
            readonly: false
        };
    }
}
function $5193fce5c5df8bb9$var$toRaw2(value) {
    if (value == null ? void 0 : value.__v_raw) return value.__v_raw;
    return value;
}
function $5193fce5c5df8bb9$export$4e7f196112fea3c5(s) {
    return s.replace(/[<>"&]/g, (s2)=>{
        return $5193fce5c5df8bb9$var$ESC[s2] || s2;
    });
}
// src/core/component/state/process.ts
function $5193fce5c5df8bb9$var$mergeOptions(to, from, instance) {
    if (typeof from === "function") from = from.options;
    if (!from) return to;
    const { mixins: mixins, extends: extendsOptions } = from;
    extendsOptions && $5193fce5c5df8bb9$var$mergeOptions(to, extendsOptions, instance);
    mixins && mixins.forEach((m)=>$5193fce5c5df8bb9$var$mergeOptions(to, m, instance));
    for (const key of [
        "computed",
        "inject"
    ])if (Object.prototype.hasOwnProperty.call(from, key)) {
        if (!to[key]) to[key] = from[key];
        else Object.assign(to[key], from[key]);
    }
    return to;
}
function $5193fce5c5df8bb9$var$resolveMergedOptions(instance) {
    const raw = instance == null ? void 0 : instance.type;
    if (!raw) return {};
    const { mixins: mixins, extends: extendsOptions } = raw;
    const globalMixins = instance.appContext.mixins;
    if (!globalMixins.length && !mixins && !extendsOptions) return raw;
    const options = {};
    globalMixins.forEach((m)=>$5193fce5c5df8bb9$var$mergeOptions(options, m, instance));
    $5193fce5c5df8bb9$var$mergeOptions(options, raw, instance);
    return options;
}
function $5193fce5c5df8bb9$var$processProps(instance) {
    var _a25;
    const props = [];
    const propDefinitions = (_a25 = instance == null ? void 0 : instance.type) == null ? void 0 : _a25.props;
    for(const key in instance == null ? void 0 : instance.props){
        const propDefinition = propDefinitions ? propDefinitions[key] : null;
        const camelizeKey = (0, $i0cUC.camelize)(key);
        props.push({
            type: "props",
            key: camelizeKey,
            value: $5193fce5c5df8bb9$var$returnError(()=>instance.props[key]),
            editable: true,
            meta: propDefinition ? {
                type: propDefinition.type ? $5193fce5c5df8bb9$var$getPropType(propDefinition.type) : "any",
                required: !!propDefinition.required,
                ...propDefinition.default ? {
                    default: propDefinition.default.toString()
                } : {}
            } : {
                type: "invalid"
            }
        });
    }
    return props;
}
function $5193fce5c5df8bb9$var$processState(instance) {
    const type = instance.type;
    const props = type == null ? void 0 : type.props;
    const getters = type.vuex && type.vuex.getters;
    const computedDefs = type.computed;
    const data = {
        ...instance.data,
        ...instance.renderContext
    };
    return Object.keys(data).filter((key)=>!(props && key in props) && !(getters && key in getters) && !(computedDefs && key in computedDefs)).map((key)=>({
            key: key,
            type: "data",
            value: $5193fce5c5df8bb9$var$returnError(()=>data[key]),
            editable: true
        }));
}
function $5193fce5c5df8bb9$var$getStateTypeAndName(info) {
    const stateType = info.computed ? "computed" : info.ref ? "ref" : info.reactive ? "reactive" : null;
    const stateTypeName = stateType ? `${stateType.charAt(0).toUpperCase()}${stateType.slice(1)}` : null;
    return {
        stateType: stateType,
        stateTypeName: stateTypeName
    };
}
function $5193fce5c5df8bb9$var$processSetupState(instance) {
    const raw = instance.devtoolsRawSetupState || {};
    return Object.keys(instance.setupState).filter((key)=>!$5193fce5c5df8bb9$var$vueBuiltins.has(key) && key.split(/(?=[A-Z])/)[0] !== "use").map((key)=>{
        var _a25, _b25, _c, _d;
        const value = $5193fce5c5df8bb9$var$returnError(()=>$5193fce5c5df8bb9$var$toRaw2(instance.setupState[key]));
        const accessError = value instanceof Error;
        const rawData = raw[key];
        let result;
        let isOtherType = accessError || typeof value === "function" || $5193fce5c5df8bb9$var$ensurePropertyExists(value, "render") && typeof value.render === "function" || $5193fce5c5df8bb9$var$ensurePropertyExists(value, "__asyncLoader") && typeof value.__asyncLoader === "function" || typeof value === "object" && value && ("setup" in value || "props" in value) || /^v[A-Z]/.test(key);
        if (rawData && !accessError) {
            const info = $5193fce5c5df8bb9$var$getSetupStateType(rawData);
            const { stateType: stateType, stateTypeName: stateTypeName } = $5193fce5c5df8bb9$var$getStateTypeAndName(info);
            const isState = info.ref || info.computed || info.reactive;
            const raw2 = $5193fce5c5df8bb9$var$ensurePropertyExists(rawData, "effect") ? ((_b25 = (_a25 = rawData.effect) == null ? void 0 : _a25.raw) == null ? void 0 : _b25.toString()) || ((_d = (_c = rawData.effect) == null ? void 0 : _c.fn) == null ? void 0 : _d.toString()) : null;
            if (stateType) isOtherType = false;
            result = {
                ...stateType ? {
                    stateType: stateType,
                    stateTypeName: stateTypeName
                } : {},
                ...raw2 ? {
                    raw: raw2
                } : {},
                editable: isState && !info.readonly
            };
        }
        const type = isOtherType ? "setup (other)" : "setup";
        return {
            key: key,
            value: value,
            type: type,
            // @ts-expect-error ignore
            ...result
        };
    });
}
function $5193fce5c5df8bb9$var$processComputed(instance, mergedType) {
    const type = mergedType;
    const computed = [];
    const defs = type.computed || {};
    for(const key in defs){
        const def = defs[key];
        const type2 = typeof def === "function" && def.vuex ? "vuex bindings" : "computed";
        computed.push({
            type: type2,
            key: key,
            value: $5193fce5c5df8bb9$var$returnError(()=>{
                var _a25;
                return (_a25 = instance == null ? void 0 : instance.proxy) == null ? void 0 : _a25[key];
            }),
            editable: typeof def.set === "function"
        });
    }
    return computed;
}
function $5193fce5c5df8bb9$var$processAttrs(instance) {
    return Object.keys(instance.attrs).map((key)=>({
            type: "attrs",
            key: key,
            value: $5193fce5c5df8bb9$var$returnError(()=>instance.attrs[key])
        }));
}
function $5193fce5c5df8bb9$var$processProvide(instance) {
    return Reflect.ownKeys(instance.provides).map((key)=>({
            type: "provided",
            key: key.toString(),
            value: $5193fce5c5df8bb9$var$returnError(()=>instance.provides[key])
        }));
}
function $5193fce5c5df8bb9$var$processInject(instance, mergedType) {
    if (!(mergedType == null ? void 0 : mergedType.inject)) return [];
    let keys = [];
    let defaultValue;
    if (Array.isArray(mergedType.inject)) keys = mergedType.inject.map((key)=>({
            key: key,
            originalKey: key
        }));
    else keys = Reflect.ownKeys(mergedType.inject).map((key)=>{
        const value = mergedType.inject[key];
        let originalKey;
        if (typeof value === "string" || typeof value === "symbol") originalKey = value;
        else {
            originalKey = value.from;
            defaultValue = value.default;
        }
        return {
            key: key,
            originalKey: originalKey
        };
    });
    return keys.map(({ key: key, originalKey: originalKey })=>({
            type: "injected",
            key: originalKey && key !== originalKey ? `${originalKey.toString()} \u279E ${key.toString()}` : key.toString(),
            // eslint-disable-next-line no-prototype-builtins
            value: $5193fce5c5df8bb9$var$returnError(()=>instance.ctx.hasOwnProperty(key) ? instance.ctx[key] : instance.provides.hasOwnProperty(originalKey) ? instance.provides[originalKey] : defaultValue)
        }));
}
function $5193fce5c5df8bb9$var$processRefs(instance) {
    return Object.keys(instance.refs).map((key)=>({
            type: "template refs",
            key: key,
            value: $5193fce5c5df8bb9$var$returnError(()=>instance.refs[key])
        }));
}
function $5193fce5c5df8bb9$var$processEventListeners(instance) {
    var _a25, _b25;
    const emitsDefinition = instance.type.emits;
    const declaredEmits = Array.isArray(emitsDefinition) ? emitsDefinition : Object.keys(emitsDefinition != null ? emitsDefinition : {});
    const keys = Object.keys((_b25 = (_a25 = instance == null ? void 0 : instance.vnode) == null ? void 0 : _a25.props) != null ? _b25 : {});
    const result = [];
    for (const key of keys){
        const [prefix, ...eventNameParts] = key.split(/(?=[A-Z])/);
        if (prefix === "on") {
            const eventName = eventNameParts.join("-").toLowerCase();
            const isDeclared = declaredEmits.includes(eventName);
            result.push({
                type: "event listeners",
                key: eventName,
                value: {
                    _custom: {
                        displayText: isDeclared ? "\u2705 Declared" : "\u26A0\uFE0F Not declared",
                        key: isDeclared ? "\u2705 Declared" : "\u26A0\uFE0F Not declared",
                        value: isDeclared ? "\u2705 Declared" : "\u26A0\uFE0F Not declared",
                        tooltipText: !isDeclared ? `The event <code>${eventName}</code> is not declared in the <code>emits</code> option. It will leak into the component's attributes (<code>$attrs</code>).` : null
                    }
                }
            });
        }
    }
    return result;
}
function $5193fce5c5df8bb9$var$processInstanceState(instance) {
    const mergedType = $5193fce5c5df8bb9$var$resolveMergedOptions(instance);
    return $5193fce5c5df8bb9$var$processProps(instance).concat($5193fce5c5df8bb9$var$processState(instance), $5193fce5c5df8bb9$var$processSetupState(instance), $5193fce5c5df8bb9$var$processComputed(instance, mergedType), $5193fce5c5df8bb9$var$processAttrs(instance), $5193fce5c5df8bb9$var$processProvide(instance), $5193fce5c5df8bb9$var$processInject(instance, mergedType), $5193fce5c5df8bb9$var$processRefs(instance), $5193fce5c5df8bb9$var$processEventListeners(instance));
}
// src/core/component/state/index.ts
function $5193fce5c5df8bb9$var$getInstanceState(params) {
    var _a25;
    const instance = $5193fce5c5df8bb9$var$getComponentInstance($5193fce5c5df8bb9$export$162128841a7f2877.value, params.instanceId);
    const id = $5193fce5c5df8bb9$var$getUniqueComponentId(instance);
    const name = $5193fce5c5df8bb9$var$getInstanceName(instance);
    const file = (_a25 = instance == null ? void 0 : instance.type) == null ? void 0 : _a25.__file;
    const state = $5193fce5c5df8bb9$var$processInstanceState(instance);
    return {
        id: id,
        name: name,
        file: file,
        state: state,
        instance: instance
    };
}
// src/core/component/tree/walker.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/component/tree/filter.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$ComponentFilter = class {
    constructor(filter){
        this.filter = filter || "";
    }
    /**
   * Check if an instance is qualified.
   *
   * @param {Vue|Vnode} instance
   * @return {boolean}
   */ isQualified(instance) {
        const name = $5193fce5c5df8bb9$var$getInstanceName(instance);
        return (0, $i0cUC.classify)(name).toLowerCase().includes(this.filter) || (0, $i0cUC.kebabize)(name).toLowerCase().includes(this.filter);
    }
};
function $5193fce5c5df8bb9$var$createComponentFilter(filterText) {
    return new $5193fce5c5df8bb9$var$ComponentFilter(filterText);
}
// src/core/component/tree/walker.ts
var $5193fce5c5df8bb9$var$ComponentWalker = class {
    constructor(options){
        // Dedupe instances (Some instances may be both on a component and on a child abstract/functional component)
        this.captureIds = /* @__PURE__ */ new Map();
        const { filterText: filterText = "", maxDepth: maxDepth, recursively: recursively, api: api } = options;
        this.componentFilter = $5193fce5c5df8bb9$var$createComponentFilter(filterText);
        this.maxDepth = maxDepth;
        this.recursively = recursively;
        this.api = api;
    }
    getComponentTree(instance) {
        this.captureIds = /* @__PURE__ */ new Map();
        return this.findQualifiedChildren(instance, 0);
    }
    getComponentParents(instance) {
        this.captureIds = /* @__PURE__ */ new Map();
        const parents = [];
        this.captureId(instance);
        let parent = instance;
        while(parent = parent.parent){
            this.captureId(parent);
            parents.push(parent);
        }
        return parents;
    }
    captureId(instance) {
        if (!instance) return null;
        const id = instance.__VUE_DEVTOOLS_NEXT_UID__ != null ? instance.__VUE_DEVTOOLS_NEXT_UID__ : $5193fce5c5df8bb9$var$getUniqueComponentId(instance);
        instance.__VUE_DEVTOOLS_NEXT_UID__ = id;
        if (this.captureIds.has(id)) return null;
        else this.captureIds.set(id, void 0);
        this.mark(instance);
        return id;
    }
    /**
   * Capture the meta information of an instance. (recursive)
   *
   * @param {Vue} instance
   * @return {object}
   */ async capture(instance, depth) {
        var _a25;
        if (!instance) return null;
        const id = this.captureId(instance);
        const name = $5193fce5c5df8bb9$var$getInstanceName(instance);
        const children = this.getInternalInstanceChildren(instance.subTree).filter((child)=>!$5193fce5c5df8bb9$var$isBeingDestroyed(child));
        const parents = this.getComponentParents(instance) || [];
        const inactive = !!instance.isDeactivated || parents.some((parent)=>parent.isDeactivated);
        const treeNode = {
            uid: instance.uid,
            id: id,
            name: name,
            renderKey: $5193fce5c5df8bb9$var$getRenderKey(instance.vnode ? instance.vnode.key : null),
            inactive: inactive,
            children: [],
            isFragment: $5193fce5c5df8bb9$var$isFragment(instance),
            tags: typeof instance.type !== "function" ? [] : [
                {
                    label: "functional",
                    textColor: 5592405,
                    backgroundColor: 15658734
                }
            ],
            autoOpen: this.recursively,
            file: instance.type.__file || ""
        };
        if (depth < this.maxDepth || instance.type.__isKeepAlive || parents.some((parent)=>parent.type.__isKeepAlive)) treeNode.children = await Promise.all(children.map((child)=>this.capture(child, depth + 1)).filter(Boolean));
        if (this.isKeepAlive(instance)) {
            const cachedComponents = this.getKeepAliveCachedInstances(instance);
            const childrenIds = children.map((child)=>child.__VUE_DEVTOOLS_NEXT_UID__);
            for (const cachedChild of cachedComponents)if (!childrenIds.includes(cachedChild.__VUE_DEVTOOLS_NEXT_UID__)) {
                const node = await this.capture({
                    ...cachedChild,
                    isDeactivated: true
                }, depth + 1);
                if (node) treeNode.children.push(node);
            }
        }
        const rootElements = $5193fce5c5df8bb9$var$getRootElementsFromComponentInstance(instance);
        const firstElement = rootElements[0];
        if (firstElement == null ? void 0 : firstElement.parentElement) {
            const parentInstance = instance.parent;
            const parentRootElements = parentInstance ? $5193fce5c5df8bb9$var$getRootElementsFromComponentInstance(parentInstance) : [];
            let el = firstElement;
            const indexList = [];
            do {
                indexList.push(Array.from(el.parentElement.childNodes).indexOf(el));
                el = el.parentElement;
            }while (el.parentElement && parentRootElements.length && !parentRootElements.includes(el));
            treeNode.domOrder = indexList.reverse();
        } else treeNode.domOrder = [
            -1
        ];
        if ((_a25 = instance.suspense) == null ? void 0 : _a25.suspenseKey) {
            treeNode.tags.push({
                label: instance.suspense.suspenseKey,
                backgroundColor: 14979812,
                textColor: 16777215
            });
            this.mark(instance, true);
        }
        this.api.visitComponentTree({
            treeNode: treeNode,
            componentInstance: instance,
            app: instance.appContext.app,
            filter: this.componentFilter.filter
        });
        return treeNode;
    }
    /**
   * Find qualified children from a single instance.
   * If the instance itself is qualified, just return itself.
   * This is ok because [].concat works in both cases.
   *
   * @param {Vue|Vnode} instance
   * @return {Vue|Array}
   */ async findQualifiedChildren(instance, depth) {
        var _a25;
        if (this.componentFilter.isQualified(instance) && !((_a25 = instance.type.devtools) == null ? void 0 : _a25.hide)) return [
            await this.capture(instance, depth)
        ];
        else if (instance.subTree) {
            const list = this.isKeepAlive(instance) ? this.getKeepAliveCachedInstances(instance) : this.getInternalInstanceChildren(instance.subTree);
            return this.findQualifiedChildrenFromList(list, depth);
        } else return [];
    }
    /**
   * Iterate through an array of instances and flatten it into
   * an array of qualified instances. This is a depth-first
   * traversal - e.g. if an instance is not matched, we will
   * recursively go deeper until a qualified child is found.
   *
   * @param {Array} instances
   * @return {Array}
   */ async findQualifiedChildrenFromList(instances, depth) {
        instances = instances.filter((child)=>{
            var _a25;
            return !$5193fce5c5df8bb9$var$isBeingDestroyed(child) && !((_a25 = child.type.devtools) == null ? void 0 : _a25.hide);
        });
        if (!this.componentFilter.filter) return Promise.all(instances.map((child)=>this.capture(child, depth)));
        else return Array.prototype.concat.apply([], await Promise.all(instances.map((i)=>this.findQualifiedChildren(i, depth))));
    }
    /**
   * Get children from a component instance.
   */ getInternalInstanceChildren(subTree, suspense = null) {
        const list = [];
        if (subTree) {
            if (subTree.component) !suspense ? list.push(subTree.component) : list.push({
                ...subTree.component,
                suspense: suspense
            });
            else if (subTree.suspense) {
                const suspenseKey = !subTree.suspense.isInFallback ? "suspense default" : "suspense fallback";
                list.push(...this.getInternalInstanceChildren(subTree.suspense.activeBranch, {
                    ...subTree.suspense,
                    suspenseKey: suspenseKey
                }));
            } else if (Array.isArray(subTree.children)) subTree.children.forEach((childSubTree)=>{
                if (childSubTree.component) !suspense ? list.push(childSubTree.component) : list.push({
                    ...childSubTree.component,
                    suspense: suspense
                });
                else list.push(...this.getInternalInstanceChildren(childSubTree, suspense));
            });
        }
        return list.filter((child)=>{
            var _a25;
            return !$5193fce5c5df8bb9$var$isBeingDestroyed(child) && !((_a25 = child.type.devtools) == null ? void 0 : _a25.hide);
        });
    }
    /**
   * Mark an instance as captured and store it in the instance map.
   *
   * @param {Vue} instance
   */ mark(instance, force = false) {
        const instanceMap = $5193fce5c5df8bb9$var$getAppRecord(instance).instanceMap;
        if (force || !instanceMap.has(instance.__VUE_DEVTOOLS_NEXT_UID__)) {
            instanceMap.set(instance.__VUE_DEVTOOLS_NEXT_UID__, instance);
            $5193fce5c5df8bb9$export$162128841a7f2877.value.instanceMap = instanceMap;
        }
    }
    isKeepAlive(instance) {
        return instance.type.__isKeepAlive && instance.__v_cache;
    }
    getKeepAliveCachedInstances(instance) {
        return Array.from(instance.__v_cache.values()).map((vnode)=>vnode.component).filter(Boolean);
    }
};
// src/core/timeline/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/timeline/perf.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$markEndQueue = /* @__PURE__ */ new Map();
var $5193fce5c5df8bb9$var$PERFORMANCE_EVENT_LAYER_ID = "performance";
async function $5193fce5c5df8bb9$var$performanceMarkStart(api, app, uid, vm, type, time) {
    const appRecord = await $5193fce5c5df8bb9$var$getAppRecord(app);
    if (!appRecord) return;
    const componentName = $5193fce5c5df8bb9$var$getInstanceName(vm) || "Unknown Component";
    const groupId = $5193fce5c5df8bb9$export$a67dd585df937baa.perfUniqueGroupId++;
    const groupKey = `${uid}-${type}`;
    appRecord.perfGroupIds.set(groupKey, {
        groupId: groupId,
        time: time
    });
    await api.addTimelineEvent({
        layerId: $5193fce5c5df8bb9$var$PERFORMANCE_EVENT_LAYER_ID,
        event: {
            time: Date.now(),
            data: {
                component: componentName,
                type: type,
                measure: "start"
            },
            title: componentName,
            subtitle: type,
            groupId: groupId
        }
    });
    if ($5193fce5c5df8bb9$var$markEndQueue.has(groupKey)) {
        const { app: app2, uid: uid2, instance: instance, type: type2, time: time2 } = $5193fce5c5df8bb9$var$markEndQueue.get(groupKey);
        $5193fce5c5df8bb9$var$markEndQueue.delete(groupKey);
        await $5193fce5c5df8bb9$var$performanceMarkEnd(api, app2, uid2, instance, type2, time2);
    }
}
function $5193fce5c5df8bb9$var$performanceMarkEnd(api, app, uid, vm, type, time) {
    const appRecord = $5193fce5c5df8bb9$var$getAppRecord(app);
    if (!appRecord) return;
    const componentName = $5193fce5c5df8bb9$var$getInstanceName(vm) || "Unknown Component";
    const groupKey = `${uid}-${type}`;
    const groupInfo = appRecord.perfGroupIds.get(groupKey);
    if (groupInfo) {
        const groupId = groupInfo.groupId;
        const startTime = groupInfo.time;
        const duration = time - startTime;
        api.addTimelineEvent({
            layerId: $5193fce5c5df8bb9$var$PERFORMANCE_EVENT_LAYER_ID,
            event: {
                time: Date.now(),
                data: {
                    component: componentName,
                    type: type,
                    measure: "end",
                    duration: {
                        _custom: {
                            type: "Duration",
                            value: duration,
                            display: `${duration} ms`
                        }
                    }
                },
                title: componentName,
                subtitle: type,
                groupId: groupId
            }
        });
    } else $5193fce5c5df8bb9$var$markEndQueue.set(groupKey, {
        app: app,
        uid: uid,
        instance: vm,
        type: type,
        time: time
    });
}
// src/core/timeline/index.ts
var $5193fce5c5df8bb9$var$COMPONENT_EVENT_LAYER_ID = "component-event";
function $5193fce5c5df8bb9$var$setupBuiltinTimelineLayers(api) {
    if (!(0, $i0cUC.isBrowser)) return;
    api.addTimelineLayer({
        id: "mouse",
        label: "Mouse",
        color: 10768815
    });
    [
        "mousedown",
        "mouseup",
        "click",
        "dblclick"
    ].forEach((eventType)=>{
        if (!$5193fce5c5df8bb9$export$a67dd585df937baa.timelineLayersState.recordingState || !$5193fce5c5df8bb9$export$a67dd585df937baa.timelineLayersState.mouseEventEnabled) return;
        window.addEventListener(eventType, async (event)=>{
            await api.addTimelineEvent({
                layerId: "mouse",
                event: {
                    time: Date.now(),
                    data: {
                        type: eventType,
                        x: event.clientX,
                        y: event.clientY
                    },
                    title: eventType
                }
            });
        }, {
            capture: true,
            passive: true
        });
    });
    api.addTimelineLayer({
        id: "keyboard",
        label: "Keyboard",
        color: 8475055
    });
    [
        "keyup",
        "keydown",
        "keypress"
    ].forEach((eventType)=>{
        window.addEventListener(eventType, async (event)=>{
            if (!$5193fce5c5df8bb9$export$a67dd585df937baa.timelineLayersState.recordingState || !$5193fce5c5df8bb9$export$a67dd585df937baa.timelineLayersState.keyboardEventEnabled) return;
            await api.addTimelineEvent({
                layerId: "keyboard",
                event: {
                    time: Date.now(),
                    data: {
                        type: eventType,
                        key: event.key,
                        ctrlKey: event.ctrlKey,
                        shiftKey: event.shiftKey,
                        altKey: event.altKey,
                        metaKey: event.metaKey
                    },
                    title: event.key
                }
            });
        }, {
            capture: true,
            passive: true
        });
    });
    api.addTimelineLayer({
        id: $5193fce5c5df8bb9$var$COMPONENT_EVENT_LAYER_ID,
        label: "Component events",
        color: 5226637
    });
    $5193fce5c5df8bb9$var$hook.on.componentEmit(async (app, instance, event, params)=>{
        if (!$5193fce5c5df8bb9$export$a67dd585df937baa.timelineLayersState.recordingState || !$5193fce5c5df8bb9$export$a67dd585df937baa.timelineLayersState.componentEventEnabled) return;
        const appRecord = await $5193fce5c5df8bb9$var$getAppRecord(app);
        if (!appRecord) return;
        const componentId = `${appRecord.id}:${instance.uid}`;
        const componentName = $5193fce5c5df8bb9$var$getInstanceName(instance) || "Unknown Component";
        api.addTimelineEvent({
            layerId: $5193fce5c5df8bb9$var$COMPONENT_EVENT_LAYER_ID,
            event: {
                time: Date.now(),
                data: {
                    component: {
                        _custom: {
                            type: "component-definition",
                            display: componentName
                        }
                    },
                    event: event,
                    params: params
                },
                title: event,
                subtitle: `by ${componentName}`,
                meta: {
                    componentId: componentId
                }
            }
        });
    });
    api.addTimelineLayer({
        id: "performance",
        label: $5193fce5c5df8bb9$var$PERFORMANCE_EVENT_LAYER_ID,
        color: 4307050
    });
    $5193fce5c5df8bb9$var$hook.on.perfStart((app, uid, vm, type, time)=>{
        if (!$5193fce5c5df8bb9$export$a67dd585df937baa.timelineLayersState.recordingState || !$5193fce5c5df8bb9$export$a67dd585df937baa.timelineLayersState.performanceEventEnabled) return;
        $5193fce5c5df8bb9$var$performanceMarkStart(api, app, uid, vm, type, time);
    });
    $5193fce5c5df8bb9$var$hook.on.perfEnd((app, uid, vm, type, time)=>{
        if (!$5193fce5c5df8bb9$export$a67dd585df937baa.timelineLayersState.recordingState || !$5193fce5c5df8bb9$export$a67dd585df937baa.timelineLayersState.performanceEventEnabled) return;
        $5193fce5c5df8bb9$var$performanceMarkEnd(api, app, uid, vm, type, time);
    });
}
// src/core/vm/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$MAX_$VM = 10;
var $5193fce5c5df8bb9$var$$vmQueue = [];
function $5193fce5c5df8bb9$var$exposeInstanceToWindow(componentInstance) {
    if (typeof window === "undefined") return;
    const win = window;
    if (!componentInstance) return;
    win.$vm = componentInstance;
    if ($5193fce5c5df8bb9$var$$vmQueue[0] !== componentInstance) {
        if ($5193fce5c5df8bb9$var$$vmQueue.length >= $5193fce5c5df8bb9$var$MAX_$VM) $5193fce5c5df8bb9$var$$vmQueue.pop();
        for(let i = $5193fce5c5df8bb9$var$$vmQueue.length; i > 0; i--)win[`$vm${i}`] = $5193fce5c5df8bb9$var$$vmQueue[i] = $5193fce5c5df8bb9$var$$vmQueue[i - 1];
        win.$vm0 = $5193fce5c5df8bb9$var$$vmQueue[0] = componentInstance;
    }
}
// src/core/plugin/components.ts
var $5193fce5c5df8bb9$var$INSPECTOR_ID = "components";
function $5193fce5c5df8bb9$export$7e5554ded389d004(app) {
    const descriptor = {
        id: $5193fce5c5df8bb9$var$INSPECTOR_ID,
        label: "Components",
        app: app
    };
    const setupFn = (api)=>{
        api.addInspector({
            id: $5193fce5c5df8bb9$var$INSPECTOR_ID,
            label: "Components",
            treeFilterPlaceholder: "Search components"
        });
        $5193fce5c5df8bb9$var$setupBuiltinTimelineLayers(api);
        api.on.getInspectorTree(async (payload)=>{
            if (payload.app === app && payload.inspectorId === $5193fce5c5df8bb9$var$INSPECTOR_ID) {
                const instance = $5193fce5c5df8bb9$var$getComponentInstance($5193fce5c5df8bb9$export$162128841a7f2877.value, payload.instanceId);
                if (instance) {
                    const walker2 = new $5193fce5c5df8bb9$var$ComponentWalker({
                        filterText: payload.filter,
                        // @TODO: should make this configurable?
                        maxDepth: 100,
                        recursively: false,
                        api: api
                    });
                    payload.rootNodes = await walker2.getComponentTree(instance);
                }
            }
        });
        api.on.getInspectorState(async (payload)=>{
            var _a25;
            if (payload.app === app && payload.inspectorId === $5193fce5c5df8bb9$var$INSPECTOR_ID) {
                const result = $5193fce5c5df8bb9$var$getInstanceState({
                    instanceId: payload.nodeId
                });
                const componentInstance = result.instance;
                const app2 = (_a25 = result.instance) == null ? void 0 : _a25.appContext.app;
                const _payload = {
                    componentInstance: componentInstance,
                    app: app2,
                    instanceData: result
                };
                $5193fce5c5df8bb9$export$4f1904c03898171b.hooks.callHookWith((callbacks)=>{
                    callbacks.forEach((cb)=>cb(_payload));
                }, "inspectComponent" /* INSPECT_COMPONENT */ );
                payload.state = result;
                $5193fce5c5df8bb9$var$exposeInstanceToWindow(componentInstance);
            }
        });
        api.on.editInspectorState(async (payload)=>{
            if (payload.app === app && payload.inspectorId === $5193fce5c5df8bb9$var$INSPECTOR_ID) {
                $5193fce5c5df8bb9$var$editState(payload);
                await api.sendInspectorState("components");
            }
        });
        const debounceSendInspectorTree = (0, $dj5lJ.debounce)(()=>{
            api.sendInspectorTree($5193fce5c5df8bb9$var$INSPECTOR_ID);
        }, 120);
        const debounceSendInspectorState = (0, $dj5lJ.debounce)(()=>{
            api.sendInspectorState($5193fce5c5df8bb9$var$INSPECTOR_ID);
        }, 120);
        const componentAddedCleanup = $5193fce5c5df8bb9$var$hook.on.componentAdded(async (app2, uid, parentUid, component)=>{
            var _a25, _b25, _c;
            if ($5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
            if ((_c = (_b25 = (_a25 = app2 == null ? void 0 : app2._instance) == null ? void 0 : _a25.type) == null ? void 0 : _b25.devtools) == null ? void 0 : _c.hide) return;
            if (!app2 || typeof uid !== "number" && !uid || !component) return;
            const id = await $5193fce5c5df8bb9$var$getComponentId({
                app: app2,
                uid: uid,
                instance: component
            });
            const appRecord = await $5193fce5c5df8bb9$var$getAppRecord(app2);
            if (component) {
                if (component.__VUE_DEVTOOLS_NEXT_UID__ == null) component.__VUE_DEVTOOLS_NEXT_UID__ = id;
                if (!(appRecord == null ? void 0 : appRecord.instanceMap.has(id))) {
                    appRecord == null || appRecord.instanceMap.set(id, component);
                    if ($5193fce5c5df8bb9$export$162128841a7f2877.value.id === (appRecord == null ? void 0 : appRecord.id)) $5193fce5c5df8bb9$export$162128841a7f2877.value.instanceMap = appRecord.instanceMap;
                }
            }
            if (!appRecord) return;
            debounceSendInspectorTree();
        });
        const componentUpdatedCleanup = $5193fce5c5df8bb9$var$hook.on.componentUpdated(async (app2, uid, parentUid, component)=>{
            var _a25, _b25, _c;
            if ($5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
            if ((_c = (_b25 = (_a25 = app2 == null ? void 0 : app2._instance) == null ? void 0 : _a25.type) == null ? void 0 : _b25.devtools) == null ? void 0 : _c.hide) return;
            if (!app2 || typeof uid !== "number" && !uid || !component) return;
            const id = await $5193fce5c5df8bb9$var$getComponentId({
                app: app2,
                uid: uid,
                instance: component
            });
            const appRecord = await $5193fce5c5df8bb9$var$getAppRecord(app2);
            if (component) {
                if (component.__VUE_DEVTOOLS_NEXT_UID__ == null) component.__VUE_DEVTOOLS_NEXT_UID__ = id;
                if (!(appRecord == null ? void 0 : appRecord.instanceMap.has(id))) {
                    appRecord == null || appRecord.instanceMap.set(id, component);
                    if ($5193fce5c5df8bb9$export$162128841a7f2877.value.id === (appRecord == null ? void 0 : appRecord.id)) $5193fce5c5df8bb9$export$162128841a7f2877.value.instanceMap = appRecord.instanceMap;
                }
            }
            if (!appRecord) return;
            debounceSendInspectorTree();
            debounceSendInspectorState();
        });
        const componentRemovedCleanup = $5193fce5c5df8bb9$var$hook.on.componentRemoved(async (app2, uid, parentUid, component)=>{
            var _a25, _b25, _c;
            if ($5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
            if ((_c = (_b25 = (_a25 = app2 == null ? void 0 : app2._instance) == null ? void 0 : _a25.type) == null ? void 0 : _b25.devtools) == null ? void 0 : _c.hide) return;
            if (!app2 || typeof uid !== "number" && !uid || !component) return;
            const appRecord = await $5193fce5c5df8bb9$var$getAppRecord(app2);
            if (!appRecord) return;
            const id = await $5193fce5c5df8bb9$var$getComponentId({
                app: app2,
                uid: uid,
                instance: component
            });
            appRecord == null || appRecord.instanceMap.delete(id);
            if ($5193fce5c5df8bb9$export$162128841a7f2877.value.id === (appRecord == null ? void 0 : appRecord.id)) $5193fce5c5df8bb9$export$162128841a7f2877.value.instanceMap = appRecord.instanceMap;
            debounceSendInspectorTree();
        });
    };
    return [
        descriptor,
        setupFn
    ];
}
// src/core/plugin/index.ts
var $5193fce5c5df8bb9$var$_a12, $5193fce5c5df8bb9$var$_b12;
($5193fce5c5df8bb9$var$_b12 = ($5193fce5c5df8bb9$var$_a12 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__) != null ? $5193fce5c5df8bb9$var$_b12 : $5193fce5c5df8bb9$var$_a12.__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__ = /* @__PURE__ */ new Set();
function $5193fce5c5df8bb9$export$1f0daed17c8e64f(pluginDescriptor, setupFn) {
    return $5193fce5c5df8bb9$var$hook.setupDevToolsPlugin(pluginDescriptor, setupFn);
}
function $5193fce5c5df8bb9$export$873c261f47a243e7(plugin, app) {
    const [pluginDescriptor, setupFn] = plugin;
    if (pluginDescriptor.app !== app) return;
    const api = new $5193fce5c5df8bb9$var$DevToolsPluginAPI({
        plugin: {
            setupFn: setupFn,
            descriptor: pluginDescriptor
        },
        ctx: $5193fce5c5df8bb9$export$4f1904c03898171b
    });
    if (pluginDescriptor.packageName === "vuex") api.on.editInspectorState((payload)=>{
        api.sendInspectorState(payload.inspectorId);
    });
    setupFn(api);
}
function $5193fce5c5df8bb9$export$7f52963080ec618f(app) {
    (0, $i0cUC.target).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.delete(app);
}
function $5193fce5c5df8bb9$export$c357c87447719db2(app, options) {
    if ((0, $i0cUC.target).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.has(app)) return;
    if ($5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled && !(options == null ? void 0 : options.inspectingComponent)) return;
    (0, $i0cUC.target).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.add(app);
    $5193fce5c5df8bb9$export$df02dcb86618c10f.forEach((plugin)=>{
        $5193fce5c5df8bb9$export$873c261f47a243e7(plugin, app);
    });
}
// src/core/router/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/ctx/router.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$export$57206cad6442cbbb = "__VUE_DEVTOOLS_ROUTER__";
var $5193fce5c5df8bb9$export$bcb936c2c1e0b8ba = "__VUE_DEVTOOLS_ROUTER_INFO__";
var $5193fce5c5df8bb9$var$_a13, $5193fce5c5df8bb9$var$_b13;
($5193fce5c5df8bb9$var$_b13 = ($5193fce5c5df8bb9$var$_a13 = (0, $i0cUC.target))[$5193fce5c5df8bb9$export$bcb936c2c1e0b8ba]) != null ? $5193fce5c5df8bb9$var$_b13 : $5193fce5c5df8bb9$var$_a13[$5193fce5c5df8bb9$export$bcb936c2c1e0b8ba] = {
    currentRoute: null,
    routes: []
};
var $5193fce5c5df8bb9$var$_a14, $5193fce5c5df8bb9$var$_b14;
($5193fce5c5df8bb9$var$_b14 = ($5193fce5c5df8bb9$var$_a14 = (0, $i0cUC.target))[$5193fce5c5df8bb9$export$57206cad6442cbbb]) != null ? $5193fce5c5df8bb9$var$_b14 : $5193fce5c5df8bb9$var$_a14[$5193fce5c5df8bb9$export$57206cad6442cbbb] = {};
var $5193fce5c5df8bb9$export$10a28a01c0e59bea = new Proxy((0, $i0cUC.target)[$5193fce5c5df8bb9$export$bcb936c2c1e0b8ba], {
    get (target22, property) {
        return (0, $i0cUC.target)[$5193fce5c5df8bb9$export$bcb936c2c1e0b8ba][property];
    }
});
var $5193fce5c5df8bb9$export$73b6e4968c970971 = new Proxy((0, $i0cUC.target)[$5193fce5c5df8bb9$export$57206cad6442cbbb], {
    get (target22, property) {
        if (property === "value") return (0, $i0cUC.target)[$5193fce5c5df8bb9$export$57206cad6442cbbb];
    }
});
// src/core/router/index.ts
function $5193fce5c5df8bb9$var$getRoutes(router) {
    const routesMap = /* @__PURE__ */ new Map();
    return ((router == null ? void 0 : router.getRoutes()) || []).filter((i)=>!routesMap.has(i.path) && routesMap.set(i.path, 1));
}
function $5193fce5c5df8bb9$var$filterRoutes(routes) {
    return routes.map((item)=>{
        let { path: path, name: name, children: children, meta: meta } = item;
        if (children == null ? void 0 : children.length) children = $5193fce5c5df8bb9$var$filterRoutes(children);
        return {
            path: path,
            name: name,
            children: children,
            meta: meta
        };
    });
}
function $5193fce5c5df8bb9$var$filterCurrentRoute(route) {
    if (route) {
        const { fullPath: fullPath, hash: hash, href: href, path: path, name: name, matched: matched, params: params, query: query } = route;
        return {
            fullPath: fullPath,
            hash: hash,
            href: href,
            path: path,
            name: name,
            params: params,
            query: query,
            matched: $5193fce5c5df8bb9$var$filterRoutes(matched)
        };
    }
    return route;
}
function $5193fce5c5df8bb9$var$normalizeRouterInfo(appRecord, activeAppRecord2) {
    function init() {
        var _a25;
        const router = (_a25 = appRecord.app) == null ? void 0 : _a25.config.globalProperties.$router;
        const currentRoute = $5193fce5c5df8bb9$var$filterCurrentRoute(router == null ? void 0 : router.currentRoute.value);
        const routes = $5193fce5c5df8bb9$var$filterRoutes($5193fce5c5df8bb9$var$getRoutes(router));
        const c = console.warn;
        console.warn = ()=>{};
        (0, $i0cUC.target)[$5193fce5c5df8bb9$export$bcb936c2c1e0b8ba] = {
            currentRoute: currentRoute ? (0, $i0cUC.deepClone)(currentRoute) : {},
            routes: (0, $i0cUC.deepClone)(routes)
        };
        (0, $i0cUC.target)[$5193fce5c5df8bb9$export$57206cad6442cbbb] = router;
        console.warn = c;
    }
    init();
    $5193fce5c5df8bb9$var$hook.on.componentUpdated((0, $dj5lJ.debounce)(()=>{
        var _a25;
        if (((_a25 = activeAppRecord2.value) == null ? void 0 : _a25.app) !== appRecord.app) return;
        init();
        if ($5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
        $5193fce5c5df8bb9$export$4f1904c03898171b.hooks.callHook("routerInfoUpdated" /* ROUTER_INFO_UPDATED */ , {
            state: (0, $i0cUC.target)[$5193fce5c5df8bb9$export$bcb936c2c1e0b8ba]
        });
    }, 200));
}
// src/ctx/api.ts
function $5193fce5c5df8bb9$export$bb51459158adb36b(hooks2) {
    return {
        // get inspector tree
        async getInspectorTree (payload) {
            const _payload = {
                ...payload,
                app: $5193fce5c5df8bb9$export$162128841a7f2877.value.app,
                rootNodes: []
            };
            await new Promise((resolve)=>{
                hooks2.callHookWith(async (callbacks)=>{
                    await Promise.all(callbacks.map((cb)=>cb(_payload)));
                    resolve();
                }, "getInspectorTree" /* GET_INSPECTOR_TREE */ );
            });
            return _payload.rootNodes;
        },
        // get inspector state
        async getInspectorState (payload) {
            const _payload = {
                ...payload,
                app: $5193fce5c5df8bb9$export$162128841a7f2877.value.app,
                state: null
            };
            const ctx = {
                currentTab: `custom-inspector:${payload.inspectorId}`
            };
            await new Promise((resolve)=>{
                hooks2.callHookWith(async (callbacks)=>{
                    await Promise.all(callbacks.map((cb)=>cb(_payload, ctx)));
                    resolve();
                }, "getInspectorState" /* GET_INSPECTOR_STATE */ );
            });
            return _payload.state;
        },
        // edit inspector state
        editInspectorState (payload) {
            const stateEditor2 = new $5193fce5c5df8bb9$var$StateEditor();
            const _payload = {
                ...payload,
                app: $5193fce5c5df8bb9$export$162128841a7f2877.value.app,
                set: (obj, path = payload.path, value = payload.state.value, cb)=>{
                    stateEditor2.set(obj, path, value, cb || stateEditor2.createDefaultSetCallback(payload.state));
                }
            };
            hooks2.callHookWith((callbacks)=>{
                callbacks.forEach((cb)=>cb(_payload));
            }, "editInspectorState" /* EDIT_INSPECTOR_STATE */ );
        },
        // send inspector state
        sendInspectorState (inspectorId) {
            const inspector = $5193fce5c5df8bb9$export$aa4140d0f5ce4bbe(inspectorId);
            hooks2.callHook("sendInspectorState" /* SEND_INSPECTOR_STATE */ , {
                inspectorId: inspectorId,
                plugin: {
                    descriptor: inspector.descriptor,
                    setupFn: ()=>({})
                }
            });
        },
        // inspect component inspector
        inspectComponentInspector () {
            return $5193fce5c5df8bb9$var$inspectComponentHighLighter();
        },
        // cancel inspect component inspector
        cancelInspectComponentInspector () {
            return $5193fce5c5df8bb9$var$cancelInspectComponentHighLighter();
        },
        // get component render code
        getComponentRenderCode (id) {
            const instance = $5193fce5c5df8bb9$var$getComponentInstance($5193fce5c5df8bb9$export$162128841a7f2877.value, id);
            if (instance) return !((instance == null ? void 0 : instance.type) instanceof Function) ? instance.render.toString() : instance.type.toString();
        },
        // scroll to component
        scrollToComponent (id) {
            return $5193fce5c5df8bb9$var$scrollToComponent({
                id: id
            });
        },
        openInEditor: // open in editor
        $5193fce5c5df8bb9$var$openInEditor,
        // get vue inspector
        getVueInspector: $5193fce5c5df8bb9$var$getComponentInspector,
        // toggle app
        toggleApp (id, options) {
            const appRecord = $5193fce5c5df8bb9$export$d3c0473489b1d63b.value.find((record)=>record.id === id);
            if (appRecord) {
                $5193fce5c5df8bb9$export$1a7804ab8d8511d1(id);
                $5193fce5c5df8bb9$export$1574774def61bdf9(appRecord);
                $5193fce5c5df8bb9$var$normalizeRouterInfo(appRecord, $5193fce5c5df8bb9$export$162128841a7f2877);
                $5193fce5c5df8bb9$export$17f8005932e80cc0();
                $5193fce5c5df8bb9$export$c357c87447719db2(appRecord.app, options);
            }
        },
        // inspect dom
        inspectDOM (instanceId) {
            const instance = $5193fce5c5df8bb9$var$getComponentInstance($5193fce5c5df8bb9$export$162128841a7f2877.value, instanceId);
            if (instance) {
                const [el] = $5193fce5c5df8bb9$var$getRootElementsFromComponentInstance(instance);
                if (el) (0, $i0cUC.target).__VUE_DEVTOOLS_INSPECT_DOM_TARGET__ = el;
            }
        },
        updatePluginSettings (pluginId, key, value) {
            $5193fce5c5df8bb9$var$setPluginSettings(pluginId, key, value);
        },
        getPluginSettings (pluginId) {
            return {
                options: $5193fce5c5df8bb9$var$getPluginSettingsOptions(pluginId),
                values: $5193fce5c5df8bb9$var$getPluginSettings(pluginId)
            };
        }
    };
}
// src/ctx/env.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$_a15, $5193fce5c5df8bb9$var$_b15;
($5193fce5c5df8bb9$var$_b15 = ($5193fce5c5df8bb9$var$_a15 = (0, $i0cUC.target)).__VUE_DEVTOOLS_ENV__) != null ? $5193fce5c5df8bb9$var$_b15 : $5193fce5c5df8bb9$var$_a15.__VUE_DEVTOOLS_ENV__ = {
    vitePluginDetected: false
};
function $5193fce5c5df8bb9$export$6fcf3c68ecb51939() {
    return (0, $i0cUC.target).__VUE_DEVTOOLS_ENV__;
}
function $5193fce5c5df8bb9$export$b209b470d7c4ea55(env) {
    (0, $i0cUC.target).__VUE_DEVTOOLS_ENV__ = {
        ...(0, $i0cUC.target).__VUE_DEVTOOLS_ENV__,
        ...env
    };
}
// src/ctx/index.ts
var $5193fce5c5df8bb9$var$hooks = $5193fce5c5df8bb9$export$73be3ac6032ad9bb();
var $5193fce5c5df8bb9$var$_a16, $5193fce5c5df8bb9$var$_b16;
($5193fce5c5df8bb9$var$_b16 = ($5193fce5c5df8bb9$var$_a16 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_CONTEXT__) != null ? $5193fce5c5df8bb9$var$_b16 : $5193fce5c5df8bb9$var$_a16.__VUE_DEVTOOLS_KIT_CONTEXT__ = {
    hooks: $5193fce5c5df8bb9$var$hooks,
    get state () {
        return {
            ...$5193fce5c5df8bb9$export$a67dd585df937baa,
            activeAppRecordId: $5193fce5c5df8bb9$export$162128841a7f2877.id,
            activeAppRecord: $5193fce5c5df8bb9$export$162128841a7f2877.value,
            appRecords: $5193fce5c5df8bb9$export$d3c0473489b1d63b.value
        };
    },
    api: $5193fce5c5df8bb9$export$bb51459158adb36b($5193fce5c5df8bb9$var$hooks)
};
var $5193fce5c5df8bb9$export$4f1904c03898171b = (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_CONTEXT__;
// src/core/app/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$import_speakingurl = $5193fce5c5df8bb9$var$__toESM($5193fce5c5df8bb9$var$require_speakingurl2(), 1);
var $5193fce5c5df8bb9$var$_a17, $5193fce5c5df8bb9$var$_b17;
var $5193fce5c5df8bb9$var$appRecordInfo = ($5193fce5c5df8bb9$var$_b17 = ($5193fce5c5df8bb9$var$_a17 = (0, $i0cUC.target)).__VUE_DEVTOOLS_NEXT_APP_RECORD_INFO__) != null ? $5193fce5c5df8bb9$var$_b17 : $5193fce5c5df8bb9$var$_a17.__VUE_DEVTOOLS_NEXT_APP_RECORD_INFO__ = {
    id: 0,
    appIds: /* @__PURE__ */ new Set()
};
function $5193fce5c5df8bb9$var$getAppRecordName(app, fallbackName) {
    var _a25;
    return ((_a25 = app == null ? void 0 : app._component) == null ? void 0 : _a25.name) || `App ${fallbackName}`;
}
function $5193fce5c5df8bb9$var$getAppRootInstance(app) {
    var _a25, _b25, _c, _d;
    if (app._instance) return app._instance;
    else if ((_b25 = (_a25 = app._container) == null ? void 0 : _a25._vnode) == null ? void 0 : _b25.component) return (_d = (_c = app._container) == null ? void 0 : _c._vnode) == null ? void 0 : _d.component;
}
function $5193fce5c5df8bb9$var$removeAppRecordId(app) {
    const id = app.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__;
    if (id != null) {
        $5193fce5c5df8bb9$var$appRecordInfo.appIds.delete(id);
        $5193fce5c5df8bb9$var$appRecordInfo.id--;
    }
}
function $5193fce5c5df8bb9$var$getAppRecordId(app, defaultId) {
    if (app.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__ != null) return app.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__;
    let id = defaultId != null ? defaultId : ($5193fce5c5df8bb9$var$appRecordInfo.id++).toString();
    if (defaultId && $5193fce5c5df8bb9$var$appRecordInfo.appIds.has(id)) {
        let count = 1;
        while($5193fce5c5df8bb9$var$appRecordInfo.appIds.has(`${defaultId}_${count}`))count++;
        id = `${defaultId}_${count}`;
    }
    $5193fce5c5df8bb9$var$appRecordInfo.appIds.add(id);
    app.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__ = id;
    return id;
}
function $5193fce5c5df8bb9$var$createAppRecord(app, types) {
    const rootInstance = $5193fce5c5df8bb9$var$getAppRootInstance(app);
    if (rootInstance) {
        $5193fce5c5df8bb9$var$appRecordInfo.id++;
        const name = $5193fce5c5df8bb9$var$getAppRecordName(app, $5193fce5c5df8bb9$var$appRecordInfo.id.toString());
        const id = $5193fce5c5df8bb9$var$getAppRecordId(app, (0, $5193fce5c5df8bb9$var$import_speakingurl.default)(name));
        const record = {
            id: id,
            name: name,
            types: types,
            instanceMap: /* @__PURE__ */ new Map(),
            perfGroupIds: /* @__PURE__ */ new Map(),
            rootInstance: rootInstance
        };
        app.__VUE_DEVTOOLS_NEXT_APP_RECORD__ = record;
        const rootId = `${record.id}:root`;
        record.instanceMap.set(rootId, record.rootInstance);
        record.rootInstance.__VUE_DEVTOOLS_NEXT_UID__ = rootId;
        return record;
    } else return {};
}
// src/core/index.ts
function $5193fce5c5df8bb9$export$93f430585c3f6d11() {
    var _a25;
    $5193fce5c5df8bb9$export$ee22a7aaf6b41ce2({
        vitePluginDetected: $5193fce5c5df8bb9$export$6fcf3c68ecb51939().vitePluginDetected
    });
    const isDevToolsNext = ((_a25 = (0, $i0cUC.target).__VUE_DEVTOOLS_GLOBAL_HOOK__) == null ? void 0 : _a25.id) === "vue-devtools-next";
    if ((0, $i0cUC.target).__VUE_DEVTOOLS_GLOBAL_HOOK__ && isDevToolsNext) return;
    const _devtoolsHook = $5193fce5c5df8bb9$var$createDevToolsHook();
    if ((0, $i0cUC.target).__VUE_DEVTOOLS_HOOK_REPLAY__) try {
        (0, $i0cUC.target).__VUE_DEVTOOLS_HOOK_REPLAY__.forEach((cb)=>cb(_devtoolsHook));
        (0, $i0cUC.target).__VUE_DEVTOOLS_HOOK_REPLAY__ = [];
    } catch (e) {
        console.error("[vue-devtools] Error during hook replay", e);
    }
    _devtoolsHook.once("init", (Vue)=>{
        (0, $i0cUC.target).__VUE_DEVTOOLS_VUE2_APP_DETECTED__ = true;
        console.log("%c[_____Vue DevTools v7 log_____]", "color: red; font-bold: 600; font-size: 16px;");
        console.log("%cVue DevTools v7 detected in your Vue2 project. v7 only supports Vue3 and will not work.", "font-bold: 500; font-size: 14px;");
        const url = "https://chromewebstore.google.com/detail/vuejs-devtools/iaajmlceplecbljialhhkmedjlpdblhp";
        console.log(`%cThe legacy version that supports both Vue 2 and Vue 3 has been moved to %c ${url}`, "font-size: 14px;", "text-decoration: underline; cursor: pointer;font-size: 14px;");
        console.log("%cPlease install and enable only the legacy version for your Vue2 app.", "font-bold: 500; font-size: 14px;");
        console.log("%c[_____Vue DevTools v7 log_____]", "color: red; font-bold: 600; font-size: 16px;");
    });
    $5193fce5c5df8bb9$var$hook.on.setupDevtoolsPlugin((pluginDescriptor, setupFn)=>{
        var _a26;
        $5193fce5c5df8bb9$export$5158df7771943590(pluginDescriptor, setupFn);
        const { app: app } = (_a26 = $5193fce5c5df8bb9$export$162128841a7f2877) != null ? _a26 : {};
        if (pluginDescriptor.settings) $5193fce5c5df8bb9$var$initPluginSettings(pluginDescriptor.id, pluginDescriptor.settings);
        if (!app) return;
        $5193fce5c5df8bb9$export$873c261f47a243e7([
            pluginDescriptor,
            setupFn
        ], app);
    });
    $5193fce5c5df8bb9$var$onLegacyDevToolsPluginApiAvailable(()=>{
        const normalizedPluginBuffer = $5193fce5c5df8bb9$export$df02dcb86618c10f.filter(([item])=>item.id !== "components");
        normalizedPluginBuffer.forEach(([pluginDescriptor, setupFn])=>{
            _devtoolsHook.emit("devtools-plugin:setup" /* SETUP_DEVTOOLS_PLUGIN */ , pluginDescriptor, setupFn, {
                target: "legacy"
            });
        });
    });
    $5193fce5c5df8bb9$var$hook.on.vueAppInit(async (app, version, types)=>{
        const appRecord = $5193fce5c5df8bb9$var$createAppRecord(app, types);
        const normalizedAppRecord = {
            ...appRecord,
            app: app,
            version: version
        };
        $5193fce5c5df8bb9$export$c1761479e1420543(normalizedAppRecord);
        if ($5193fce5c5df8bb9$export$d3c0473489b1d63b.value.length === 1) {
            $5193fce5c5df8bb9$export$1574774def61bdf9(normalizedAppRecord);
            $5193fce5c5df8bb9$export$1a7804ab8d8511d1(normalizedAppRecord.id);
            $5193fce5c5df8bb9$var$normalizeRouterInfo(normalizedAppRecord, $5193fce5c5df8bb9$export$162128841a7f2877);
            $5193fce5c5df8bb9$export$c357c87447719db2(normalizedAppRecord.app);
        }
        $5193fce5c5df8bb9$export$1f0daed17c8e64f(...$5193fce5c5df8bb9$export$7e5554ded389d004(normalizedAppRecord.app));
        $5193fce5c5df8bb9$export$ee22a7aaf6b41ce2({
            connected: true
        });
        _devtoolsHook.apps.push(app);
    });
    $5193fce5c5df8bb9$var$hook.on.vueAppUnmount(async (app)=>{
        const activeRecords = $5193fce5c5df8bb9$export$d3c0473489b1d63b.value.filter((appRecord)=>appRecord.app !== app);
        if (activeRecords.length === 0) $5193fce5c5df8bb9$export$ee22a7aaf6b41ce2({
            connected: false
        });
        $5193fce5c5df8bb9$export$4d20c72f1da170ba(app);
        $5193fce5c5df8bb9$var$removeAppRecordId(app);
        if ($5193fce5c5df8bb9$export$162128841a7f2877.value.app === app) {
            $5193fce5c5df8bb9$export$1574774def61bdf9(activeRecords[0]);
            $5193fce5c5df8bb9$export$4f1904c03898171b.hooks.callHook("sendActiveAppUpdatedToClient" /* SEND_ACTIVE_APP_UNMOUNTED_TO_CLIENT */ );
        }
        (0, $i0cUC.target).__VUE_DEVTOOLS_GLOBAL_HOOK__.apps.splice((0, $i0cUC.target).__VUE_DEVTOOLS_GLOBAL_HOOK__.apps.indexOf(app), 1);
        $5193fce5c5df8bb9$export$7f52963080ec618f(app);
    });
    $5193fce5c5df8bb9$var$subscribeDevToolsHook(_devtoolsHook);
    if (!(0, $i0cUC.target).__VUE_DEVTOOLS_GLOBAL_HOOK__) Object.defineProperty((0, $i0cUC.target), "__VUE_DEVTOOLS_GLOBAL_HOOK__", {
        get () {
            return _devtoolsHook;
        }
    });
    else if (!(0, $i0cUC.isNuxtApp)) Object.assign(__VUE_DEVTOOLS_GLOBAL_HOOK__, _devtoolsHook);
}
function $5193fce5c5df8bb9$export$cb42e76452729606(fn) {
    return new Promise((resolve)=>{
        if ($5193fce5c5df8bb9$export$a67dd585df937baa.connected && $5193fce5c5df8bb9$export$a67dd585df937baa.clientConnected) {
            fn();
            resolve();
            return;
        }
        $5193fce5c5df8bb9$export$4f1904c03898171b.hooks.hook("devtoolsConnectedUpdated" /* DEVTOOLS_CONNECTED_UPDATED */ , ({ state: state })=>{
            if (state.connected && state.clientConnected) {
                fn();
                resolve();
            }
        });
    });
}
// src/core/high-perf-mode/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$export$6f15da7a796da26a(state) {
    $5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled = state != null ? state : !$5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled;
    if (!state && $5193fce5c5df8bb9$export$162128841a7f2877.value) $5193fce5c5df8bb9$export$c357c87447719db2($5193fce5c5df8bb9$export$162128841a7f2877.value.app);
}
// src/core/component/state/format.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/component/state/reviver.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$reviveSet(val) {
    const result = /* @__PURE__ */ new Set();
    const list = val._custom.value;
    for(let i = 0; i < list.length; i++){
        const value = list[i];
        result.add($5193fce5c5df8bb9$var$revive(value));
    }
    return result;
}
function $5193fce5c5df8bb9$var$reviveMap(val) {
    const result = /* @__PURE__ */ new Map();
    const list = val._custom.value;
    for(let i = 0; i < list.length; i++){
        const { key: key, value: value } = list[i];
        result.set(key, $5193fce5c5df8bb9$var$revive(value));
    }
    return result;
}
function $5193fce5c5df8bb9$var$revive(val) {
    if (val === $5193fce5c5df8bb9$export$6db089fe7b26f5b6) return void 0;
    else if (val === $5193fce5c5df8bb9$export$b4bf424ed968e242) return Number.POSITIVE_INFINITY;
    else if (val === $5193fce5c5df8bb9$export$95cb88e357cbada8) return Number.NEGATIVE_INFINITY;
    else if (val === $5193fce5c5df8bb9$export$d7ae0f70ebb9e144) return Number.NaN;
    else if (val && val._custom) {
        const { _custom: custom } = val;
        if (custom.type === "component") return $5193fce5c5df8bb9$export$162128841a7f2877.value.instanceMap.get(custom.id);
        else if (custom.type === "map") return $5193fce5c5df8bb9$var$reviveMap(val);
        else if (custom.type === "set") return $5193fce5c5df8bb9$var$reviveSet(val);
        else if (custom.type === "bigint") return BigInt(custom.value);
        else return $5193fce5c5df8bb9$var$revive(custom.value);
    } else if ($5193fce5c5df8bb9$var$symbolRE.test(val)) {
        const [, string] = $5193fce5c5df8bb9$var$symbolRE.exec(val);
        return Symbol.for(string);
    } else if ($5193fce5c5df8bb9$var$specialTypeRE.test(val)) {
        const [, type, string, , details] = $5193fce5c5df8bb9$var$specialTypeRE.exec(val);
        const result = new (0, $i0cUC.target)[type](string);
        if (type === "Error" && details) result.stack = details;
        return result;
    } else return val;
}
function $5193fce5c5df8bb9$var$reviver(key, value) {
    return $5193fce5c5df8bb9$var$revive(value);
}
// src/core/component/state/format.ts
function $5193fce5c5df8bb9$export$a2acd0fde5480ad5(value, raw = true) {
    const type = typeof value;
    if (value == null || value === $5193fce5c5df8bb9$export$6db089fe7b26f5b6 || value === "undefined") return "null";
    else if (type === "boolean" || type === "number" || value === $5193fce5c5df8bb9$export$b4bf424ed968e242 || value === $5193fce5c5df8bb9$export$95cb88e357cbada8 || value === $5193fce5c5df8bb9$export$d7ae0f70ebb9e144) return "literal";
    else if (value == null ? void 0 : value._custom) {
        if (raw || value._custom.display != null || value._custom.displayText != null) return "custom";
        else return $5193fce5c5df8bb9$export$a2acd0fde5480ad5(value._custom.value);
    } else if (typeof value === "string") {
        const typeMatch = $5193fce5c5df8bb9$var$specialTypeRE.exec(value);
        if (typeMatch) {
            const [, type2] = typeMatch;
            return `native ${type2}`;
        } else return "string";
    } else if (Array.isArray(value) || (value == null ? void 0 : value._isArray)) return "array";
    else if ($5193fce5c5df8bb9$export$53b83ca8eaab0383(value)) return "plain-object";
    else return "unknown";
}
function $5193fce5c5df8bb9$export$6c635c17a78ff695(value, quotes = false, options) {
    var _a25, _b25, _c;
    const { customClass: customClass } = options != null ? options : {};
    let result;
    const type = $5193fce5c5df8bb9$export$a2acd0fde5480ad5(value, false);
    if (type !== "custom" && (value == null ? void 0 : value._custom)) value = value._custom.value;
    if (result = $5193fce5c5df8bb9$var$internalStateTokenToString(value)) return result;
    else if (type === "custom") {
        const nestedName = ((_a25 = value._custom.value) == null ? void 0 : _a25._custom) && $5193fce5c5df8bb9$export$6c635c17a78ff695(value._custom.value, quotes, options);
        return nestedName || value._custom.displayText || value._custom.display;
    } else if (type === "array") return `Array[${value.length}]`;
    else if (type === "plain-object") return `Object${Object.keys(value).length ? "" : " (empty)"}`;
    else if (type == null ? void 0 : type.includes("native")) return $5193fce5c5df8bb9$export$4e7f196112fea3c5((_b25 = $5193fce5c5df8bb9$var$specialTypeRE.exec(value)) == null ? void 0 : _b25[2]);
    else if (typeof value === "string") {
        const typeMatch = value.match($5193fce5c5df8bb9$var$rawTypeRE);
        if (typeMatch) value = $5193fce5c5df8bb9$var$escapeString(typeMatch[1]);
        else if (quotes) value = `<span>"</span>${(customClass == null ? void 0 : customClass.string) ? `<span class=${customClass.string}>${$5193fce5c5df8bb9$var$escapeString(value)}</span>` : $5193fce5c5df8bb9$var$escapeString(value)}<span>"</span>`;
        else value = (customClass == null ? void 0 : customClass.string) ? `<span class="${(_c = customClass == null ? void 0 : customClass.string) != null ? _c : ""}">${$5193fce5c5df8bb9$var$escapeString(value)}</span>` : $5193fce5c5df8bb9$var$escapeString(value);
    }
    return value;
}
function $5193fce5c5df8bb9$var$escapeString(value) {
    return $5193fce5c5df8bb9$export$4e7f196112fea3c5(value).replace(/ /g, "&nbsp;").replace(/\n/g, "<span>\\n</span>");
}
function $5193fce5c5df8bb9$export$d049e3525cb8af5d(value) {
    var _a25, _b25, _c;
    let customType;
    const isCustom = $5193fce5c5df8bb9$export$a2acd0fde5480ad5(value) === "custom";
    let inherit = {};
    if (isCustom) {
        const data = value;
        const customValue = (_a25 = data._custom) == null ? void 0 : _a25.value;
        const currentCustomType = (_b25 = data._custom) == null ? void 0 : _b25.type;
        const nestedCustom = typeof customValue === "object" && customValue !== null && "_custom" in customValue ? $5193fce5c5df8bb9$export$d049e3525cb8af5d(customValue) : {
            inherit: void 0,
            value: void 0,
            customType: void 0
        };
        inherit = nestedCustom.inherit || ((_c = data._custom) == null ? void 0 : _c.fields) || {};
        value = nestedCustom.value || customValue;
        customType = nestedCustom.customType || currentCustomType;
    }
    if (value && value._isArray) value = value.items;
    return {
        value: value,
        inherit: inherit,
        customType: customType
    };
}
function $5193fce5c5df8bb9$export$b0067b146e5937f7(value, customType) {
    if (customType === "bigint") return value;
    if (customType === "date") return value;
    return $5193fce5c5df8bb9$var$replaceTokenToString(JSON.stringify(value));
}
function $5193fce5c5df8bb9$export$d61dc8d725d3735e(value, customType) {
    if (customType === "bigint") return BigInt(value);
    if (customType === "date") return new Date(value);
    return JSON.parse($5193fce5c5df8bb9$var$replaceStringToToken(value), $5193fce5c5df8bb9$var$reviver);
}
// src/core/devtools-client/detected.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$export$2fce292577290205(params) {
    $5193fce5c5df8bb9$export$a67dd585df937baa.devtoolsClientDetected = {
        ...$5193fce5c5df8bb9$export$a67dd585df937baa.devtoolsClientDetected,
        ...params
    };
    const devtoolsClientVisible = Object.values($5193fce5c5df8bb9$export$a67dd585df937baa.devtoolsClientDetected).some(Boolean);
    $5193fce5c5df8bb9$export$6f15da7a796da26a(!devtoolsClientVisible);
}
var $5193fce5c5df8bb9$var$_a18, $5193fce5c5df8bb9$var$_b18;
($5193fce5c5df8bb9$var$_b18 = ($5193fce5c5df8bb9$var$_a18 = (0, $i0cUC.target)).__VUE_DEVTOOLS_UPDATE_CLIENT_DETECTED__) != null ? $5193fce5c5df8bb9$var$_b18 : $5193fce5c5df8bb9$var$_a18.__VUE_DEVTOOLS_UPDATE_CLIENT_DETECTED__ = $5193fce5c5df8bb9$export$2fce292577290205;
// src/messaging/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/presets/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/presets/broadcast-channel/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/index.js
$5193fce5c5df8bb9$var$init_esm_shims();
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/class-registry.js
$5193fce5c5df8bb9$var$init_esm_shims();
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/registry.js
$5193fce5c5df8bb9$var$init_esm_shims();
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/double-indexed-kv.js
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$DoubleIndexedKV = class {
    constructor(){
        this.keyToValue = /* @__PURE__ */ new Map();
        this.valueToKey = /* @__PURE__ */ new Map();
    }
    set(key, value) {
        this.keyToValue.set(key, value);
        this.valueToKey.set(value, key);
    }
    getByKey(key) {
        return this.keyToValue.get(key);
    }
    getByValue(value) {
        return this.valueToKey.get(value);
    }
    clear() {
        this.keyToValue.clear();
        this.valueToKey.clear();
    }
};
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/registry.js
var $5193fce5c5df8bb9$var$Registry = class {
    constructor(generateIdentifier){
        this.generateIdentifier = generateIdentifier;
        this.kv = new $5193fce5c5df8bb9$var$DoubleIndexedKV();
    }
    register(value, identifier) {
        if (this.kv.getByValue(value)) return;
        if (!identifier) identifier = this.generateIdentifier(value);
        this.kv.set(identifier, value);
    }
    clear() {
        this.kv.clear();
    }
    getIdentifier(value) {
        return this.kv.getByValue(value);
    }
    getValue(identifier) {
        return this.kv.getByKey(identifier);
    }
};
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/class-registry.js
var $5193fce5c5df8bb9$var$ClassRegistry = class extends $5193fce5c5df8bb9$var$Registry {
    constructor(){
        super((c)=>c.name);
        this.classToAllowedProps = /* @__PURE__ */ new Map();
    }
    register(value, options) {
        if (typeof options === "object") {
            if (options.allowProps) this.classToAllowedProps.set(value, options.allowProps);
            super.register(value, options.identifier);
        } else super.register(value, options);
    }
    getAllowedProps(value) {
        return this.classToAllowedProps.get(value);
    }
};
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/custom-transformer-registry.js
$5193fce5c5df8bb9$var$init_esm_shims();
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/util.js
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$valuesOfObj(record) {
    if ("values" in Object) return Object.values(record);
    const values = [];
    for(const key in record)if (record.hasOwnProperty(key)) values.push(record[key]);
    return values;
}
function $5193fce5c5df8bb9$var$find(record, predicate) {
    const values = $5193fce5c5df8bb9$var$valuesOfObj(record);
    if ("find" in values) return values.find(predicate);
    const valuesNotNever = values;
    for(let i = 0; i < valuesNotNever.length; i++){
        const value = valuesNotNever[i];
        if (predicate(value)) return value;
    }
    return void 0;
}
function $5193fce5c5df8bb9$var$forEach(record, run) {
    Object.entries(record).forEach(([key, value])=>run(value, key));
}
function $5193fce5c5df8bb9$var$includes(arr, value) {
    return arr.indexOf(value) !== -1;
}
function $5193fce5c5df8bb9$var$findArr(record, predicate) {
    for(let i = 0; i < record.length; i++){
        const value = record[i];
        if (predicate(value)) return value;
    }
    return void 0;
}
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/custom-transformer-registry.js
var $5193fce5c5df8bb9$var$CustomTransformerRegistry = class {
    constructor(){
        this.transfomers = {};
    }
    register(transformer) {
        this.transfomers[transformer.name] = transformer;
    }
    findApplicable(v) {
        return $5193fce5c5df8bb9$var$find(this.transfomers, (transformer)=>transformer.isApplicable(v));
    }
    findByName(name) {
        return this.transfomers[name];
    }
};
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/plainer.js
$5193fce5c5df8bb9$var$init_esm_shims();
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/is.js
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$getType = (payload)=>Object.prototype.toString.call(payload).slice(8, -1);
var $5193fce5c5df8bb9$var$isUndefined = (payload)=>typeof payload === "undefined";
var $5193fce5c5df8bb9$var$isNull = (payload)=>payload === null;
var $5193fce5c5df8bb9$var$isPlainObject2 = (payload)=>{
    if (typeof payload !== "object" || payload === null) return false;
    if (payload === Object.prototype) return false;
    if (Object.getPrototypeOf(payload) === null) return true;
    return Object.getPrototypeOf(payload) === Object.prototype;
};
var $5193fce5c5df8bb9$var$isEmptyObject = (payload)=>$5193fce5c5df8bb9$var$isPlainObject2(payload) && Object.keys(payload).length === 0;
var $5193fce5c5df8bb9$var$isArray = (payload)=>Array.isArray(payload);
var $5193fce5c5df8bb9$var$isString = (payload)=>typeof payload === "string";
var $5193fce5c5df8bb9$var$isNumber = (payload)=>typeof payload === "number" && !isNaN(payload);
var $5193fce5c5df8bb9$var$isBoolean = (payload)=>typeof payload === "boolean";
var $5193fce5c5df8bb9$var$isRegExp = (payload)=>payload instanceof RegExp;
var $5193fce5c5df8bb9$var$isMap = (payload)=>payload instanceof Map;
var $5193fce5c5df8bb9$var$isSet = (payload)=>payload instanceof Set;
var $5193fce5c5df8bb9$var$isSymbol = (payload)=>$5193fce5c5df8bb9$var$getType(payload) === "Symbol";
var $5193fce5c5df8bb9$var$isDate = (payload)=>payload instanceof Date && !isNaN(payload.valueOf());
var $5193fce5c5df8bb9$var$isError = (payload)=>payload instanceof Error;
var $5193fce5c5df8bb9$var$isNaNValue = (payload)=>typeof payload === "number" && isNaN(payload);
var $5193fce5c5df8bb9$var$isPrimitive2 = (payload)=>$5193fce5c5df8bb9$var$isBoolean(payload) || $5193fce5c5df8bb9$var$isNull(payload) || $5193fce5c5df8bb9$var$isUndefined(payload) || $5193fce5c5df8bb9$var$isNumber(payload) || $5193fce5c5df8bb9$var$isString(payload) || $5193fce5c5df8bb9$var$isSymbol(payload);
var $5193fce5c5df8bb9$var$isBigint = (payload)=>typeof payload === "bigint";
var $5193fce5c5df8bb9$var$isInfinite = (payload)=>payload === Infinity || payload === -Infinity;
var $5193fce5c5df8bb9$var$isTypedArray = (payload)=>ArrayBuffer.isView(payload) && !(payload instanceof DataView);
var $5193fce5c5df8bb9$var$isURL = (payload)=>payload instanceof URL;
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/pathstringifier.js
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$escapeKey = (key)=>key.replace(/\./g, "\\.");
var $5193fce5c5df8bb9$var$stringifyPath = (path)=>path.map(String).map($5193fce5c5df8bb9$var$escapeKey).join(".");
var $5193fce5c5df8bb9$var$parsePath = (string)=>{
    const result = [];
    let segment = "";
    for(let i = 0; i < string.length; i++){
        let char = string.charAt(i);
        const isEscapedDot = char === "\\" && string.charAt(i + 1) === ".";
        if (isEscapedDot) {
            segment += ".";
            i++;
            continue;
        }
        const isEndOfSegment = char === ".";
        if (isEndOfSegment) {
            result.push(segment);
            segment = "";
            continue;
        }
        segment += char;
    }
    const lastSegment = segment;
    result.push(lastSegment);
    return result;
};
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/transformer.js
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$simpleTransformation(isApplicable, annotation, transform, untransform) {
    return {
        isApplicable: isApplicable,
        annotation: annotation,
        transform: transform,
        untransform: untransform
    };
}
var $5193fce5c5df8bb9$var$simpleRules = [
    $5193fce5c5df8bb9$var$simpleTransformation($5193fce5c5df8bb9$var$isUndefined, "undefined", ()=>null, ()=>void 0),
    $5193fce5c5df8bb9$var$simpleTransformation($5193fce5c5df8bb9$var$isBigint, "bigint", (v)=>v.toString(), (v)=>{
        if (typeof BigInt !== "undefined") return BigInt(v);
        console.error("Please add a BigInt polyfill.");
        return v;
    }),
    $5193fce5c5df8bb9$var$simpleTransformation($5193fce5c5df8bb9$var$isDate, "Date", (v)=>v.toISOString(), (v)=>new Date(v)),
    $5193fce5c5df8bb9$var$simpleTransformation($5193fce5c5df8bb9$var$isError, "Error", (v, superJson)=>{
        const baseError = {
            name: v.name,
            message: v.message
        };
        superJson.allowedErrorProps.forEach((prop)=>{
            baseError[prop] = v[prop];
        });
        return baseError;
    }, (v, superJson)=>{
        const e = new Error(v.message);
        e.name = v.name;
        e.stack = v.stack;
        superJson.allowedErrorProps.forEach((prop)=>{
            e[prop] = v[prop];
        });
        return e;
    }),
    $5193fce5c5df8bb9$var$simpleTransformation($5193fce5c5df8bb9$var$isRegExp, "regexp", (v)=>"" + v, (regex)=>{
        const body = regex.slice(1, regex.lastIndexOf("/"));
        const flags = regex.slice(regex.lastIndexOf("/") + 1);
        return new RegExp(body, flags);
    }),
    $5193fce5c5df8bb9$var$simpleTransformation($5193fce5c5df8bb9$var$isSet, "set", // (sets only exist in es6+)
    // eslint-disable-next-line es5/no-es6-methods
    (v)=>[
            ...v.values()
        ], (v)=>new Set(v)),
    $5193fce5c5df8bb9$var$simpleTransformation($5193fce5c5df8bb9$var$isMap, "map", (v)=>[
            ...v.entries()
        ], (v)=>new Map(v)),
    $5193fce5c5df8bb9$var$simpleTransformation((v)=>$5193fce5c5df8bb9$var$isNaNValue(v) || $5193fce5c5df8bb9$var$isInfinite(v), "number", (v)=>{
        if ($5193fce5c5df8bb9$var$isNaNValue(v)) return "NaN";
        if (v > 0) return "Infinity";
        else return "-Infinity";
    }, Number),
    $5193fce5c5df8bb9$var$simpleTransformation((v)=>v === 0 && 1 / v === -Infinity, "number", ()=>{
        return "-0";
    }, Number),
    $5193fce5c5df8bb9$var$simpleTransformation($5193fce5c5df8bb9$var$isURL, "URL", (v)=>v.toString(), (v)=>new URL(v))
];
function $5193fce5c5df8bb9$var$compositeTransformation(isApplicable, annotation, transform, untransform) {
    return {
        isApplicable: isApplicable,
        annotation: annotation,
        transform: transform,
        untransform: untransform
    };
}
var $5193fce5c5df8bb9$var$symbolRule = $5193fce5c5df8bb9$var$compositeTransformation((s, superJson)=>{
    if ($5193fce5c5df8bb9$var$isSymbol(s)) {
        const isRegistered = !!superJson.symbolRegistry.getIdentifier(s);
        return isRegistered;
    }
    return false;
}, (s, superJson)=>{
    const identifier = superJson.symbolRegistry.getIdentifier(s);
    return [
        "symbol",
        identifier
    ];
}, (v)=>v.description, (_, a, superJson)=>{
    const value = superJson.symbolRegistry.getValue(a[1]);
    if (!value) throw new Error("Trying to deserialize unknown symbol");
    return value;
});
var $5193fce5c5df8bb9$var$constructorToName = [
    Int8Array,
    Uint8Array,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array,
    Uint8ClampedArray
].reduce((obj, ctor)=>{
    obj[ctor.name] = ctor;
    return obj;
}, {});
var $5193fce5c5df8bb9$var$typedArrayRule = $5193fce5c5df8bb9$var$compositeTransformation($5193fce5c5df8bb9$var$isTypedArray, (v)=>[
        "typed-array",
        v.constructor.name
    ], (v)=>[
        ...v
    ], (v, a)=>{
    const ctor = $5193fce5c5df8bb9$var$constructorToName[a[1]];
    if (!ctor) throw new Error("Trying to deserialize unknown typed array");
    return new ctor(v);
});
function $5193fce5c5df8bb9$var$isInstanceOfRegisteredClass(potentialClass, superJson) {
    if (potentialClass == null ? void 0 : potentialClass.constructor) {
        const isRegistered = !!superJson.classRegistry.getIdentifier(potentialClass.constructor);
        return isRegistered;
    }
    return false;
}
var $5193fce5c5df8bb9$var$classRule = $5193fce5c5df8bb9$var$compositeTransformation($5193fce5c5df8bb9$var$isInstanceOfRegisteredClass, (clazz, superJson)=>{
    const identifier = superJson.classRegistry.getIdentifier(clazz.constructor);
    return [
        "class",
        identifier
    ];
}, (clazz, superJson)=>{
    const allowedProps = superJson.classRegistry.getAllowedProps(clazz.constructor);
    if (!allowedProps) return {
        ...clazz
    };
    const result = {};
    allowedProps.forEach((prop)=>{
        result[prop] = clazz[prop];
    });
    return result;
}, (v, a, superJson)=>{
    const clazz = superJson.classRegistry.getValue(a[1]);
    if (!clazz) throw new Error(`Trying to deserialize unknown class '${a[1]}' - check https://github.com/blitz-js/superjson/issues/116#issuecomment-773996564`);
    return Object.assign(Object.create(clazz.prototype), v);
});
var $5193fce5c5df8bb9$var$customRule = $5193fce5c5df8bb9$var$compositeTransformation((value, superJson)=>{
    return !!superJson.customTransformerRegistry.findApplicable(value);
}, (value, superJson)=>{
    const transformer = superJson.customTransformerRegistry.findApplicable(value);
    return [
        "custom",
        transformer.name
    ];
}, (value, superJson)=>{
    const transformer = superJson.customTransformerRegistry.findApplicable(value);
    return transformer.serialize(value);
}, (v, a, superJson)=>{
    const transformer = superJson.customTransformerRegistry.findByName(a[1]);
    if (!transformer) throw new Error("Trying to deserialize unknown custom value");
    return transformer.deserialize(v);
});
var $5193fce5c5df8bb9$var$compositeRules = [
    $5193fce5c5df8bb9$var$classRule,
    $5193fce5c5df8bb9$var$symbolRule,
    $5193fce5c5df8bb9$var$customRule,
    $5193fce5c5df8bb9$var$typedArrayRule
];
var $5193fce5c5df8bb9$var$transformValue = (value, superJson)=>{
    const applicableCompositeRule = $5193fce5c5df8bb9$var$findArr($5193fce5c5df8bb9$var$compositeRules, (rule)=>rule.isApplicable(value, superJson));
    if (applicableCompositeRule) return {
        value: applicableCompositeRule.transform(value, superJson),
        type: applicableCompositeRule.annotation(value, superJson)
    };
    const applicableSimpleRule = $5193fce5c5df8bb9$var$findArr($5193fce5c5df8bb9$var$simpleRules, (rule)=>rule.isApplicable(value, superJson));
    if (applicableSimpleRule) return {
        value: applicableSimpleRule.transform(value, superJson),
        type: applicableSimpleRule.annotation
    };
    return void 0;
};
var $5193fce5c5df8bb9$var$simpleRulesByAnnotation = {};
$5193fce5c5df8bb9$var$simpleRules.forEach((rule)=>{
    $5193fce5c5df8bb9$var$simpleRulesByAnnotation[rule.annotation] = rule;
});
var $5193fce5c5df8bb9$var$untransformValue = (json, type, superJson)=>{
    if ($5193fce5c5df8bb9$var$isArray(type)) switch(type[0]){
        case "symbol":
            return $5193fce5c5df8bb9$var$symbolRule.untransform(json, type, superJson);
        case "class":
            return $5193fce5c5df8bb9$var$classRule.untransform(json, type, superJson);
        case "custom":
            return $5193fce5c5df8bb9$var$customRule.untransform(json, type, superJson);
        case "typed-array":
            return $5193fce5c5df8bb9$var$typedArrayRule.untransform(json, type, superJson);
        default:
            throw new Error("Unknown transformation: " + type);
    }
    else {
        const transformation = $5193fce5c5df8bb9$var$simpleRulesByAnnotation[type];
        if (!transformation) throw new Error("Unknown transformation: " + type);
        return transformation.untransform(json, superJson);
    }
};
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/accessDeep.js
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$getNthKey = (value, n)=>{
    if (n > value.size) throw new Error("index out of bounds");
    const keys = value.keys();
    while(n > 0){
        keys.next();
        n--;
    }
    return keys.next().value;
};
function $5193fce5c5df8bb9$var$validatePath(path) {
    if ($5193fce5c5df8bb9$var$includes(path, "__proto__")) throw new Error("__proto__ is not allowed as a property");
    if ($5193fce5c5df8bb9$var$includes(path, "prototype")) throw new Error("prototype is not allowed as a property");
    if ($5193fce5c5df8bb9$var$includes(path, "constructor")) throw new Error("constructor is not allowed as a property");
}
var $5193fce5c5df8bb9$var$getDeep = (object, path)=>{
    $5193fce5c5df8bb9$var$validatePath(path);
    for(let i = 0; i < path.length; i++){
        const key = path[i];
        if ($5193fce5c5df8bb9$var$isSet(object)) object = $5193fce5c5df8bb9$var$getNthKey(object, +key);
        else if ($5193fce5c5df8bb9$var$isMap(object)) {
            const row = +key;
            const type = +path[++i] === 0 ? "key" : "value";
            const keyOfRow = $5193fce5c5df8bb9$var$getNthKey(object, row);
            switch(type){
                case "key":
                    object = keyOfRow;
                    break;
                case "value":
                    object = object.get(keyOfRow);
                    break;
            }
        } else object = object[key];
    }
    return object;
};
var $5193fce5c5df8bb9$var$setDeep = (object, path, mapper)=>{
    $5193fce5c5df8bb9$var$validatePath(path);
    if (path.length === 0) return mapper(object);
    let parent = object;
    for(let i = 0; i < path.length - 1; i++){
        const key = path[i];
        if ($5193fce5c5df8bb9$var$isArray(parent)) {
            const index = +key;
            parent = parent[index];
        } else if ($5193fce5c5df8bb9$var$isPlainObject2(parent)) parent = parent[key];
        else if ($5193fce5c5df8bb9$var$isSet(parent)) {
            const row = +key;
            parent = $5193fce5c5df8bb9$var$getNthKey(parent, row);
        } else if ($5193fce5c5df8bb9$var$isMap(parent)) {
            const isEnd = i === path.length - 2;
            if (isEnd) break;
            const row = +key;
            const type = +path[++i] === 0 ? "key" : "value";
            const keyOfRow = $5193fce5c5df8bb9$var$getNthKey(parent, row);
            switch(type){
                case "key":
                    parent = keyOfRow;
                    break;
                case "value":
                    parent = parent.get(keyOfRow);
                    break;
            }
        }
    }
    const lastKey = path[path.length - 1];
    if ($5193fce5c5df8bb9$var$isArray(parent)) parent[+lastKey] = mapper(parent[+lastKey]);
    else if ($5193fce5c5df8bb9$var$isPlainObject2(parent)) parent[lastKey] = mapper(parent[lastKey]);
    if ($5193fce5c5df8bb9$var$isSet(parent)) {
        const oldValue = $5193fce5c5df8bb9$var$getNthKey(parent, +lastKey);
        const newValue = mapper(oldValue);
        if (oldValue !== newValue) {
            parent.delete(oldValue);
            parent.add(newValue);
        }
    }
    if ($5193fce5c5df8bb9$var$isMap(parent)) {
        const row = +path[path.length - 2];
        const keyToRow = $5193fce5c5df8bb9$var$getNthKey(parent, row);
        const type = +lastKey === 0 ? "key" : "value";
        switch(type){
            case "key":
                {
                    const newKey = mapper(keyToRow);
                    parent.set(newKey, parent.get(keyToRow));
                    if (newKey !== keyToRow) parent.delete(keyToRow);
                    break;
                }
            case "value":
                parent.set(keyToRow, mapper(parent.get(keyToRow)));
                break;
        }
    }
    return object;
};
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/plainer.js
function $5193fce5c5df8bb9$var$traverse(tree, walker2, origin = []) {
    if (!tree) return;
    if (!$5193fce5c5df8bb9$var$isArray(tree)) {
        $5193fce5c5df8bb9$var$forEach(tree, (subtree, key)=>$5193fce5c5df8bb9$var$traverse(subtree, walker2, [
                ...origin,
                ...$5193fce5c5df8bb9$var$parsePath(key)
            ]));
        return;
    }
    const [nodeValue, children] = tree;
    if (children) $5193fce5c5df8bb9$var$forEach(children, (child, key)=>{
        $5193fce5c5df8bb9$var$traverse(child, walker2, [
            ...origin,
            ...$5193fce5c5df8bb9$var$parsePath(key)
        ]);
    });
    walker2(nodeValue, origin);
}
function $5193fce5c5df8bb9$var$applyValueAnnotations(plain, annotations, superJson) {
    $5193fce5c5df8bb9$var$traverse(annotations, (type, path)=>{
        plain = $5193fce5c5df8bb9$var$setDeep(plain, path, (v)=>$5193fce5c5df8bb9$var$untransformValue(v, type, superJson));
    });
    return plain;
}
function $5193fce5c5df8bb9$var$applyReferentialEqualityAnnotations(plain, annotations) {
    function apply(identicalPaths, path) {
        const object = $5193fce5c5df8bb9$var$getDeep(plain, $5193fce5c5df8bb9$var$parsePath(path));
        identicalPaths.map($5193fce5c5df8bb9$var$parsePath).forEach((identicalObjectPath)=>{
            plain = $5193fce5c5df8bb9$var$setDeep(plain, identicalObjectPath, ()=>object);
        });
    }
    if ($5193fce5c5df8bb9$var$isArray(annotations)) {
        const [root, other] = annotations;
        root.forEach((identicalPath)=>{
            plain = $5193fce5c5df8bb9$var$setDeep(plain, $5193fce5c5df8bb9$var$parsePath(identicalPath), ()=>plain);
        });
        if (other) $5193fce5c5df8bb9$var$forEach(other, apply);
    } else $5193fce5c5df8bb9$var$forEach(annotations, apply);
    return plain;
}
var $5193fce5c5df8bb9$var$isDeep = (object, superJson)=>$5193fce5c5df8bb9$var$isPlainObject2(object) || $5193fce5c5df8bb9$var$isArray(object) || $5193fce5c5df8bb9$var$isMap(object) || $5193fce5c5df8bb9$var$isSet(object) || $5193fce5c5df8bb9$var$isInstanceOfRegisteredClass(object, superJson);
function $5193fce5c5df8bb9$var$addIdentity(object, path, identities) {
    const existingSet = identities.get(object);
    if (existingSet) existingSet.push(path);
    else identities.set(object, [
        path
    ]);
}
function $5193fce5c5df8bb9$var$generateReferentialEqualityAnnotations(identitites, dedupe) {
    const result = {};
    let rootEqualityPaths = void 0;
    identitites.forEach((paths)=>{
        if (paths.length <= 1) return;
        if (!dedupe) paths = paths.map((path)=>path.map(String)).sort((a, b)=>a.length - b.length);
        const [representativePath, ...identicalPaths] = paths;
        if (representativePath.length === 0) rootEqualityPaths = identicalPaths.map($5193fce5c5df8bb9$var$stringifyPath);
        else result[$5193fce5c5df8bb9$var$stringifyPath(representativePath)] = identicalPaths.map($5193fce5c5df8bb9$var$stringifyPath);
    });
    if (rootEqualityPaths) {
        if ($5193fce5c5df8bb9$var$isEmptyObject(result)) return [
            rootEqualityPaths
        ];
        else return [
            rootEqualityPaths,
            result
        ];
    } else return $5193fce5c5df8bb9$var$isEmptyObject(result) ? void 0 : result;
}
var $5193fce5c5df8bb9$var$walker = (object, identities, superJson, dedupe, path = [], objectsInThisPath = [], seenObjects = /* @__PURE__ */ new Map())=>{
    var _a25;
    const primitive = $5193fce5c5df8bb9$var$isPrimitive2(object);
    if (!primitive) {
        $5193fce5c5df8bb9$var$addIdentity(object, path, identities);
        const seen = seenObjects.get(object);
        if (seen) return dedupe ? {
            transformedValue: null
        } : seen;
    }
    if (!$5193fce5c5df8bb9$var$isDeep(object, superJson)) {
        const transformed2 = $5193fce5c5df8bb9$var$transformValue(object, superJson);
        const result2 = transformed2 ? {
            transformedValue: transformed2.value,
            annotations: [
                transformed2.type
            ]
        } : {
            transformedValue: object
        };
        if (!primitive) seenObjects.set(object, result2);
        return result2;
    }
    if ($5193fce5c5df8bb9$var$includes(objectsInThisPath, object)) return {
        transformedValue: null
    };
    const transformationResult = $5193fce5c5df8bb9$var$transformValue(object, superJson);
    const transformed = (_a25 = transformationResult == null ? void 0 : transformationResult.value) != null ? _a25 : object;
    const transformedValue = $5193fce5c5df8bb9$var$isArray(transformed) ? [] : {};
    const innerAnnotations = {};
    $5193fce5c5df8bb9$var$forEach(transformed, (value, index)=>{
        if (index === "__proto__" || index === "constructor" || index === "prototype") throw new Error(`Detected property ${index}. This is a prototype pollution risk, please remove it from your object.`);
        const recursiveResult = $5193fce5c5df8bb9$var$walker(value, identities, superJson, dedupe, [
            ...path,
            index
        ], [
            ...objectsInThisPath,
            object
        ], seenObjects);
        transformedValue[index] = recursiveResult.transformedValue;
        if ($5193fce5c5df8bb9$var$isArray(recursiveResult.annotations)) innerAnnotations[index] = recursiveResult.annotations;
        else if ($5193fce5c5df8bb9$var$isPlainObject2(recursiveResult.annotations)) $5193fce5c5df8bb9$var$forEach(recursiveResult.annotations, (tree, key)=>{
            innerAnnotations[$5193fce5c5df8bb9$var$escapeKey(index) + "." + key] = tree;
        });
    });
    const result = $5193fce5c5df8bb9$var$isEmptyObject(innerAnnotations) ? {
        transformedValue: transformedValue,
        annotations: !!transformationResult ? [
            transformationResult.type
        ] : void 0
    } : {
        transformedValue: transformedValue,
        annotations: !!transformationResult ? [
            transformationResult.type,
            innerAnnotations
        ] : innerAnnotations
    };
    if (!primitive) seenObjects.set(object, result);
    return result;
};
// ../../node_modules/.pnpm/copy-anything@3.0.5/node_modules/copy-anything/dist/index.js
$5193fce5c5df8bb9$var$init_esm_shims();
// ../../node_modules/.pnpm/is-what@4.1.16/node_modules/is-what/dist/index.js
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$getType2(payload) {
    return Object.prototype.toString.call(payload).slice(8, -1);
}
function $5193fce5c5df8bb9$var$isArray2(payload) {
    return $5193fce5c5df8bb9$var$getType2(payload) === "Array";
}
function $5193fce5c5df8bb9$var$isPlainObject3(payload) {
    if ($5193fce5c5df8bb9$var$getType2(payload) !== "Object") return false;
    const prototype = Object.getPrototypeOf(payload);
    return !!prototype && prototype.constructor === Object && prototype === Object.prototype;
}
function $5193fce5c5df8bb9$var$isNull2(payload) {
    return $5193fce5c5df8bb9$var$getType2(payload) === "Null";
}
function $5193fce5c5df8bb9$var$isOneOf(a, b, c, d, e) {
    return (value)=>a(value) || b(value) || !!c && c(value) || !!d && d(value) || !!e && e(value);
}
function $5193fce5c5df8bb9$var$isUndefined2(payload) {
    return $5193fce5c5df8bb9$var$getType2(payload) === "Undefined";
}
var $5193fce5c5df8bb9$var$isNullOrUndefined = $5193fce5c5df8bb9$var$isOneOf($5193fce5c5df8bb9$var$isNull2, $5193fce5c5df8bb9$var$isUndefined2);
// ../../node_modules/.pnpm/copy-anything@3.0.5/node_modules/copy-anything/dist/index.js
function $5193fce5c5df8bb9$var$assignProp(carry, key, newVal, originalObject, includeNonenumerable) {
    const propType = ({}).propertyIsEnumerable.call(originalObject, key) ? "enumerable" : "nonenumerable";
    if (propType === "enumerable") carry[key] = newVal;
    if (includeNonenumerable && propType === "nonenumerable") Object.defineProperty(carry, key, {
        value: newVal,
        enumerable: false,
        writable: true,
        configurable: true
    });
}
function $5193fce5c5df8bb9$var$copy(target22, options = {}) {
    if ($5193fce5c5df8bb9$var$isArray2(target22)) return target22.map((item)=>$5193fce5c5df8bb9$var$copy(item, options));
    if (!$5193fce5c5df8bb9$var$isPlainObject3(target22)) return target22;
    const props = Object.getOwnPropertyNames(target22);
    const symbols = Object.getOwnPropertySymbols(target22);
    return [
        ...props,
        ...symbols
    ].reduce((carry, key)=>{
        if ($5193fce5c5df8bb9$var$isArray2(options.props) && !options.props.includes(key)) return carry;
        const val = target22[key];
        const newVal = $5193fce5c5df8bb9$var$copy(val, options);
        $5193fce5c5df8bb9$var$assignProp(carry, key, newVal, target22, options.nonenumerable);
        return carry;
    }, {});
}
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/index.js
var $5193fce5c5df8bb9$var$SuperJSON = class {
    /**
   * @param dedupeReferentialEqualities  If true, SuperJSON will make sure only one instance of referentially equal objects are serialized and the rest are replaced with `null`.
   */ constructor({ dedupe: dedupe = false } = {}){
        this.classRegistry = new $5193fce5c5df8bb9$var$ClassRegistry();
        this.symbolRegistry = new $5193fce5c5df8bb9$var$Registry((s)=>{
            var _a25;
            return (_a25 = s.description) != null ? _a25 : "";
        });
        this.customTransformerRegistry = new $5193fce5c5df8bb9$var$CustomTransformerRegistry();
        this.allowedErrorProps = [];
        this.dedupe = dedupe;
    }
    serialize(object) {
        const identities = /* @__PURE__ */ new Map();
        const output = $5193fce5c5df8bb9$var$walker(object, identities, this, this.dedupe);
        const res = {
            json: output.transformedValue
        };
        if (output.annotations) res.meta = {
            ...res.meta,
            values: output.annotations
        };
        const equalityAnnotations = $5193fce5c5df8bb9$var$generateReferentialEqualityAnnotations(identities, this.dedupe);
        if (equalityAnnotations) res.meta = {
            ...res.meta,
            referentialEqualities: equalityAnnotations
        };
        return res;
    }
    deserialize(payload) {
        const { json: json, meta: meta } = payload;
        let result = $5193fce5c5df8bb9$var$copy(json);
        if (meta == null ? void 0 : meta.values) result = $5193fce5c5df8bb9$var$applyValueAnnotations(result, meta.values, this);
        if (meta == null ? void 0 : meta.referentialEqualities) result = $5193fce5c5df8bb9$var$applyReferentialEqualityAnnotations(result, meta.referentialEqualities);
        return result;
    }
    stringify(object) {
        return JSON.stringify(this.serialize(object));
    }
    parse(string) {
        return this.deserialize(JSON.parse(string));
    }
    registerClass(v, options) {
        this.classRegistry.register(v, options);
    }
    registerSymbol(v, identifier) {
        this.symbolRegistry.register(v, identifier);
    }
    registerCustom(transformer, name) {
        this.customTransformerRegistry.register({
            name: name,
            ...transformer
        });
    }
    allowErrorProps(...props) {
        this.allowedErrorProps.push(...props);
    }
};
$5193fce5c5df8bb9$var$SuperJSON.defaultInstance = new $5193fce5c5df8bb9$var$SuperJSON();
$5193fce5c5df8bb9$var$SuperJSON.serialize = $5193fce5c5df8bb9$var$SuperJSON.defaultInstance.serialize.bind($5193fce5c5df8bb9$var$SuperJSON.defaultInstance);
$5193fce5c5df8bb9$var$SuperJSON.deserialize = $5193fce5c5df8bb9$var$SuperJSON.defaultInstance.deserialize.bind($5193fce5c5df8bb9$var$SuperJSON.defaultInstance);
$5193fce5c5df8bb9$var$SuperJSON.stringify = $5193fce5c5df8bb9$var$SuperJSON.defaultInstance.stringify.bind($5193fce5c5df8bb9$var$SuperJSON.defaultInstance);
$5193fce5c5df8bb9$var$SuperJSON.parse = $5193fce5c5df8bb9$var$SuperJSON.defaultInstance.parse.bind($5193fce5c5df8bb9$var$SuperJSON.defaultInstance);
$5193fce5c5df8bb9$var$SuperJSON.registerClass = $5193fce5c5df8bb9$var$SuperJSON.defaultInstance.registerClass.bind($5193fce5c5df8bb9$var$SuperJSON.defaultInstance);
$5193fce5c5df8bb9$var$SuperJSON.registerSymbol = $5193fce5c5df8bb9$var$SuperJSON.defaultInstance.registerSymbol.bind($5193fce5c5df8bb9$var$SuperJSON.defaultInstance);
$5193fce5c5df8bb9$var$SuperJSON.registerCustom = $5193fce5c5df8bb9$var$SuperJSON.defaultInstance.registerCustom.bind($5193fce5c5df8bb9$var$SuperJSON.defaultInstance);
$5193fce5c5df8bb9$var$SuperJSON.allowErrorProps = $5193fce5c5df8bb9$var$SuperJSON.defaultInstance.allowErrorProps.bind($5193fce5c5df8bb9$var$SuperJSON.defaultInstance);
var $5193fce5c5df8bb9$var$serialize = $5193fce5c5df8bb9$var$SuperJSON.serialize;
var $5193fce5c5df8bb9$var$deserialize = $5193fce5c5df8bb9$var$SuperJSON.deserialize;
var $5193fce5c5df8bb9$var$stringify = $5193fce5c5df8bb9$var$SuperJSON.stringify;
var $5193fce5c5df8bb9$var$parse = $5193fce5c5df8bb9$var$SuperJSON.parse;
var $5193fce5c5df8bb9$var$registerClass = $5193fce5c5df8bb9$var$SuperJSON.registerClass;
var $5193fce5c5df8bb9$var$registerCustom = $5193fce5c5df8bb9$var$SuperJSON.registerCustom;
var $5193fce5c5df8bb9$var$registerSymbol = $5193fce5c5df8bb9$var$SuperJSON.registerSymbol;
var $5193fce5c5df8bb9$var$allowErrorProps = $5193fce5c5df8bb9$var$SuperJSON.allowErrorProps;
// src/messaging/presets/broadcast-channel/context.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_BROADCAST_MESSAGING_EVENT_KEY = "__devtools-kit-broadcast-messaging-event-key__";
// src/messaging/presets/broadcast-channel/index.ts
var $5193fce5c5df8bb9$var$BROADCAST_CHANNEL_NAME = "__devtools-kit:broadcast-channel__";
function $5193fce5c5df8bb9$var$createBroadcastChannel() {
    const channel = new BroadcastChannel($5193fce5c5df8bb9$var$BROADCAST_CHANNEL_NAME);
    return {
        post: (data)=>{
            channel.postMessage($5193fce5c5df8bb9$var$SuperJSON.stringify({
                event: $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_BROADCAST_MESSAGING_EVENT_KEY,
                data: data
            }));
        },
        on: (handler)=>{
            channel.onmessage = (event)=>{
                const parsed = $5193fce5c5df8bb9$var$SuperJSON.parse(event.data);
                if (parsed.event === $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_BROADCAST_MESSAGING_EVENT_KEY) handler(parsed.data);
            };
        }
    };
}
// src/messaging/presets/electron/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/presets/electron/client.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/presets/electron/context.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$__ELECTRON_CLIENT_CONTEXT__ = "electron:client-context";
var $5193fce5c5df8bb9$var$__ELECTRON_RPOXY_CONTEXT__ = "electron:proxy-context";
var $5193fce5c5df8bb9$var$__ELECTRON_SERVER_CONTEXT__ = "electron:server-context";
var $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__ = {
    // client
    CLIENT_TO_PROXY: "client->proxy",
    // on: proxy->client
    // proxy
    PROXY_TO_CLIENT: "proxy->client",
    // on: server->proxy
    PROXY_TO_SERVER: "proxy->server",
    // on: client->proxy
    // server
    SERVER_TO_PROXY: "server->proxy"
};
function $5193fce5c5df8bb9$var$getElectronClientContext() {
    return (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__ELECTRON_CLIENT_CONTEXT__];
}
function $5193fce5c5df8bb9$export$2837faaf25ee2c9a(context) {
    (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__ELECTRON_CLIENT_CONTEXT__] = context;
}
function $5193fce5c5df8bb9$var$getElectronProxyContext() {
    return (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__ELECTRON_RPOXY_CONTEXT__];
}
function $5193fce5c5df8bb9$export$f4b34d15f9836c97(context) {
    (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__ELECTRON_RPOXY_CONTEXT__] = context;
}
function $5193fce5c5df8bb9$var$getElectronServerContext() {
    return (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__ELECTRON_SERVER_CONTEXT__];
}
function $5193fce5c5df8bb9$export$d8c81043a9a1bbbe(context) {
    (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__ELECTRON_SERVER_CONTEXT__] = context;
}
// src/messaging/presets/electron/client.ts
function $5193fce5c5df8bb9$var$createElectronClientChannel() {
    const socket = $5193fce5c5df8bb9$var$getElectronClientContext();
    return {
        post: (data)=>{
            socket.emit($5193fce5c5df8bb9$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.CLIENT_TO_PROXY, $5193fce5c5df8bb9$var$SuperJSON.stringify(data));
        },
        on: (handler)=>{
            socket.on($5193fce5c5df8bb9$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.PROXY_TO_CLIENT, (e)=>{
                handler($5193fce5c5df8bb9$var$SuperJSON.parse(e));
            });
        }
    };
}
// src/messaging/presets/electron/proxy.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$createElectronProxyChannel() {
    const socket = $5193fce5c5df8bb9$var$getElectronProxyContext();
    return {
        post: (data)=>{},
        on: (handler)=>{
            socket.on($5193fce5c5df8bb9$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.SERVER_TO_PROXY, (data)=>{
                socket.broadcast.emit($5193fce5c5df8bb9$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.PROXY_TO_CLIENT, data);
            });
            socket.on($5193fce5c5df8bb9$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.CLIENT_TO_PROXY, (data)=>{
                socket.broadcast.emit($5193fce5c5df8bb9$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.PROXY_TO_SERVER, data);
            });
        }
    };
}
// src/messaging/presets/electron/server.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$createElectronServerChannel() {
    const socket = $5193fce5c5df8bb9$var$getElectronServerContext();
    return {
        post: (data)=>{
            socket.emit($5193fce5c5df8bb9$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.SERVER_TO_PROXY, $5193fce5c5df8bb9$var$SuperJSON.stringify(data));
        },
        on: (handler)=>{
            socket.on($5193fce5c5df8bb9$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.PROXY_TO_SERVER, (data)=>{
                handler($5193fce5c5df8bb9$var$SuperJSON.parse(data));
            });
        }
    };
}
// src/messaging/presets/extension/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/presets/extension/client.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/presets/extension/context.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$__EXTENSION_CLIENT_CONTEXT__ = "electron:client-context";
var $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__ = {
    // client
    CLIENT_TO_PROXY: "client->proxy",
    // on: proxy->client
    // proxy
    PROXY_TO_CLIENT: "proxy->client",
    // on: server->proxy
    PROXY_TO_SERVER: "proxy->server",
    // on: client->proxy
    // server
    SERVER_TO_PROXY: "server->proxy"
};
function $5193fce5c5df8bb9$export$6c3de6c2be1b2806() {
    return (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__EXTENSION_CLIENT_CONTEXT__];
}
function $5193fce5c5df8bb9$export$31a9a778785defb(context) {
    (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__EXTENSION_CLIENT_CONTEXT__] = context;
}
// src/messaging/presets/extension/client.ts
function $5193fce5c5df8bb9$var$createExtensionClientChannel() {
    let disconnected = false;
    let port = null;
    let reconnectTimer = null;
    let onMessageHandler = null;
    function connect() {
        try {
            clearTimeout(reconnectTimer);
            port = chrome.runtime.connect({
                name: `${chrome.devtools.inspectedWindow.tabId}`
            });
            $5193fce5c5df8bb9$export$31a9a778785defb(port);
            disconnected = false;
            port == null || port.onMessage.addListener(onMessageHandler);
            port.onDisconnect.addListener(()=>{
                disconnected = true;
                port == null || port.onMessage.removeListener(onMessageHandler);
                reconnectTimer = setTimeout(connect, 1e3);
            });
        } catch (e) {
            disconnected = true;
        }
    }
    connect();
    return {
        post: (data)=>{
            if (disconnected) return;
            port == null || port.postMessage($5193fce5c5df8bb9$var$SuperJSON.stringify(data));
        },
        on: (handler)=>{
            onMessageHandler = (data)=>{
                if (disconnected) return;
                handler($5193fce5c5df8bb9$var$SuperJSON.parse(data));
            };
            port == null || port.onMessage.addListener(onMessageHandler);
        }
    };
}
// src/messaging/presets/extension/proxy.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$createExtensionProxyChannel() {
    const port = chrome.runtime.connect({
        name: "content-script"
    });
    function sendMessageToUserApp(payload) {
        window.postMessage({
            source: $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__.PROXY_TO_SERVER,
            payload: payload
        }, "*");
    }
    function sendMessageToDevToolsClient(e) {
        if (e.data && e.data.source === $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__.SERVER_TO_PROXY) try {
            port.postMessage(e.data.payload);
        } catch (e2) {}
    }
    port.onMessage.addListener(sendMessageToUserApp);
    window.addEventListener("message", sendMessageToDevToolsClient);
    port.onDisconnect.addListener(()=>{
        window.removeEventListener("message", sendMessageToDevToolsClient);
        sendMessageToUserApp($5193fce5c5df8bb9$var$SuperJSON.stringify({
            event: "shutdown"
        }));
    });
    sendMessageToUserApp($5193fce5c5df8bb9$var$SuperJSON.stringify({
        event: "init"
    }));
    return {
        post: (data)=>{},
        on: (handler)=>{}
    };
}
// src/messaging/presets/extension/server.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$createExtensionServerChannel() {
    return {
        post: (data)=>{
            window.postMessage({
                source: $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__.SERVER_TO_PROXY,
                payload: $5193fce5c5df8bb9$var$SuperJSON.stringify(data)
            }, "*");
        },
        on: (handler)=>{
            const listener = (event)=>{
                if (event.data.source === $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__.PROXY_TO_SERVER && event.data.payload) handler($5193fce5c5df8bb9$var$SuperJSON.parse(event.data.payload));
            };
            window.addEventListener("message", listener);
            return ()=>{
                window.removeEventListener("message", listener);
            };
        }
    };
}
// src/messaging/presets/iframe/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/presets/iframe/client.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/presets/iframe/context.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_IFRAME_MESSAGING_EVENT_KEY = "__devtools-kit-iframe-messaging-event-key__";
var $5193fce5c5df8bb9$var$__IFRAME_SERVER_CONTEXT__ = "iframe:server-context";
function $5193fce5c5df8bb9$var$getIframeServerContext() {
    return (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__IFRAME_SERVER_CONTEXT__];
}
function $5193fce5c5df8bb9$export$918b6d08f99ca1d5(context) {
    (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__IFRAME_SERVER_CONTEXT__] = context;
}
// src/messaging/presets/iframe/client.ts
function $5193fce5c5df8bb9$var$createIframeClientChannel() {
    if (!(0, $i0cUC.isBrowser)) return {
        post: (data)=>{},
        on: (handler)=>{}
    };
    return {
        post: (data)=>window.parent.postMessage($5193fce5c5df8bb9$var$SuperJSON.stringify({
                event: $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_IFRAME_MESSAGING_EVENT_KEY,
                data: data
            }), "*"),
        on: (handler)=>window.addEventListener("message", (event)=>{
                try {
                    const parsed = $5193fce5c5df8bb9$var$SuperJSON.parse(event.data);
                    if (event.source === window.parent && parsed.event === $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_IFRAME_MESSAGING_EVENT_KEY) handler(parsed.data);
                } catch (e) {}
            })
    };
}
// src/messaging/presets/iframe/server.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$createIframeServerChannel() {
    if (!(0, $i0cUC.isBrowser)) return {
        post: (data)=>{},
        on: (handler)=>{}
    };
    return {
        post: (data)=>{
            var _a25;
            const iframe = $5193fce5c5df8bb9$var$getIframeServerContext();
            (_a25 = iframe == null ? void 0 : iframe.contentWindow) == null || _a25.postMessage($5193fce5c5df8bb9$var$SuperJSON.stringify({
                event: $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_IFRAME_MESSAGING_EVENT_KEY,
                data: data
            }), "*");
        },
        on: (handler)=>{
            window.addEventListener("message", (event)=>{
                const iframe = $5193fce5c5df8bb9$var$getIframeServerContext();
                try {
                    const parsed = $5193fce5c5df8bb9$var$SuperJSON.parse(event.data);
                    if (event.source === (iframe == null ? void 0 : iframe.contentWindow) && parsed.event === $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_IFRAME_MESSAGING_EVENT_KEY) handler(parsed.data);
                } catch (e) {}
            });
        }
    };
}
// src/messaging/presets/vite/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/presets/vite/client.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/presets/vite/context.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY = "__devtools-kit-vite-messaging-event-key__";
var $5193fce5c5df8bb9$var$__VITE_CLIENT_CONTEXT__ = "vite:client-context";
var $5193fce5c5df8bb9$var$__VITE_SERVER_CONTEXT__ = "vite:server-context";
function $5193fce5c5df8bb9$var$getViteClientContext() {
    return (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__VITE_CLIENT_CONTEXT__];
}
function $5193fce5c5df8bb9$export$8559d72d41937efd(context) {
    (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__VITE_CLIENT_CONTEXT__] = context;
}
function $5193fce5c5df8bb9$var$getViteServerContext() {
    return (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__VITE_SERVER_CONTEXT__];
}
function $5193fce5c5df8bb9$export$4c32fe701137877e(context) {
    (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__VITE_SERVER_CONTEXT__] = context;
}
// src/messaging/presets/vite/client.ts
function $5193fce5c5df8bb9$var$createViteClientChannel() {
    const client = $5193fce5c5df8bb9$var$getViteClientContext();
    return {
        post: (data)=>{
            client == null || client.send($5193fce5c5df8bb9$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY, $5193fce5c5df8bb9$var$SuperJSON.stringify(data));
        },
        on: (handler)=>{
            client == null || client.on($5193fce5c5df8bb9$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY, (event)=>{
                handler($5193fce5c5df8bb9$var$SuperJSON.parse(event));
            });
        }
    };
}
// src/messaging/presets/vite/server.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$createViteServerChannel() {
    var _a25;
    const viteServer = $5193fce5c5df8bb9$var$getViteServerContext();
    const ws = (_a25 = viteServer.hot) != null ? _a25 : viteServer.ws;
    return {
        post: (data)=>ws == null ? void 0 : ws.send($5193fce5c5df8bb9$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY, $5193fce5c5df8bb9$var$SuperJSON.stringify(data)),
        on: (handler)=>ws == null ? void 0 : ws.on($5193fce5c5df8bb9$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY, (event)=>{
                handler($5193fce5c5df8bb9$var$SuperJSON.parse(event));
            })
    };
}
// src/messaging/presets/ws/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/presets/ws/client.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/presets/ws/context.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/presets/ws/server.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/index.ts
var $5193fce5c5df8bb9$var$_a19, $5193fce5c5df8bb9$var$_b19;
($5193fce5c5df8bb9$var$_b19 = ($5193fce5c5df8bb9$var$_a19 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_MESSAGE_CHANNELS__) != null ? $5193fce5c5df8bb9$var$_b19 : $5193fce5c5df8bb9$var$_a19.__VUE_DEVTOOLS_KIT_MESSAGE_CHANNELS__ = [];
var $5193fce5c5df8bb9$var$_a20, $5193fce5c5df8bb9$var$_b20;
($5193fce5c5df8bb9$var$_b20 = ($5193fce5c5df8bb9$var$_a20 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_RPC_CLIENT__) != null ? $5193fce5c5df8bb9$var$_b20 : $5193fce5c5df8bb9$var$_a20.__VUE_DEVTOOLS_KIT_RPC_CLIENT__ = null;
var $5193fce5c5df8bb9$var$_a21, $5193fce5c5df8bb9$var$_b21;
($5193fce5c5df8bb9$var$_b21 = ($5193fce5c5df8bb9$var$_a21 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_RPC_SERVER__) != null ? $5193fce5c5df8bb9$var$_b21 : $5193fce5c5df8bb9$var$_a21.__VUE_DEVTOOLS_KIT_RPC_SERVER__ = null;
var $5193fce5c5df8bb9$var$_a22, $5193fce5c5df8bb9$var$_b22;
($5193fce5c5df8bb9$var$_b22 = ($5193fce5c5df8bb9$var$_a22 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__) != null ? $5193fce5c5df8bb9$var$_b22 : $5193fce5c5df8bb9$var$_a22.__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__ = null;
var $5193fce5c5df8bb9$var$_a23, $5193fce5c5df8bb9$var$_b23;
($5193fce5c5df8bb9$var$_b23 = ($5193fce5c5df8bb9$var$_a23 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__) != null ? $5193fce5c5df8bb9$var$_b23 : $5193fce5c5df8bb9$var$_a23.__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__ = null;
var $5193fce5c5df8bb9$var$_a24, $5193fce5c5df8bb9$var$_b24;
($5193fce5c5df8bb9$var$_b24 = ($5193fce5c5df8bb9$var$_a24 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_BROADCAST_RPC_SERVER__) != null ? $5193fce5c5df8bb9$var$_b24 : $5193fce5c5df8bb9$var$_a24.__VUE_DEVTOOLS_KIT_BROADCAST_RPC_SERVER__ = null;
function $5193fce5c5df8bb9$var$setRpcClientToGlobal(rpc) {
    (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_RPC_CLIENT__ = rpc;
}
function $5193fce5c5df8bb9$export$7f98be55f66c4a0d(rpc) {
    (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_RPC_SERVER__ = rpc;
}
function $5193fce5c5df8bb9$export$9362d59e25b9feb1() {
    return (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_RPC_CLIENT__;
}
function $5193fce5c5df8bb9$export$380718822fedc343() {
    return (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_RPC_SERVER__;
}
function $5193fce5c5df8bb9$export$5f8b48d38df9666a(rpc) {
    (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__ = rpc;
}
function $5193fce5c5df8bb9$export$5105f0908e5b2002(rpc) {
    (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__ = rpc;
}
function $5193fce5c5df8bb9$export$c7310d0d7eeaac08() {
    return (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__;
}
function $5193fce5c5df8bb9$export$97b242d29756c723() {
    return (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__;
}
function $5193fce5c5df8bb9$var$getChannel(preset, host = "client") {
    const channel = {
        iframe: {
            client: $5193fce5c5df8bb9$var$createIframeClientChannel,
            server: $5193fce5c5df8bb9$var$createIframeServerChannel
        }[host],
        electron: {
            client: $5193fce5c5df8bb9$var$createElectronClientChannel,
            proxy: $5193fce5c5df8bb9$var$createElectronProxyChannel,
            server: $5193fce5c5df8bb9$var$createElectronServerChannel
        }[host],
        vite: {
            client: $5193fce5c5df8bb9$var$createViteClientChannel,
            server: $5193fce5c5df8bb9$var$createViteServerChannel
        }[host],
        broadcast: {
            client: $5193fce5c5df8bb9$var$createBroadcastChannel,
            server: $5193fce5c5df8bb9$var$createBroadcastChannel
        }[host],
        extension: {
            client: $5193fce5c5df8bb9$var$createExtensionClientChannel,
            proxy: $5193fce5c5df8bb9$var$createExtensionProxyChannel,
            server: $5193fce5c5df8bb9$var$createExtensionServerChannel
        }[host]
    }[preset];
    return channel();
}
function $5193fce5c5df8bb9$export$9c13c20c639717e6(functions, options = {}) {
    const { channel: _channel, options: _options, preset: preset } = options;
    const channel = preset ? $5193fce5c5df8bb9$var$getChannel(preset) : _channel;
    const rpc = (0, $enkGC.createBirpc)(functions, {
        ..._options,
        ...channel,
        timeout: -1
    });
    if (preset === "vite") {
        $5193fce5c5df8bb9$export$5f8b48d38df9666a(rpc);
        return;
    }
    $5193fce5c5df8bb9$var$setRpcClientToGlobal(rpc);
    return rpc;
}
function $5193fce5c5df8bb9$export$fbf8e1689a053c1c(functions, options = {}) {
    const { channel: _channel, options: _options, preset: preset } = options;
    const channel = preset ? $5193fce5c5df8bb9$var$getChannel(preset, "server") : _channel;
    const rpcServer = $5193fce5c5df8bb9$export$380718822fedc343();
    if (!rpcServer) {
        const group = (0, $enkGC.createBirpcGroup)(functions, [
            channel
        ], {
            ..._options,
            timeout: -1
        });
        if (preset === "vite") {
            $5193fce5c5df8bb9$export$5105f0908e5b2002(group);
            return;
        }
        $5193fce5c5df8bb9$export$7f98be55f66c4a0d(group);
    } else rpcServer.updateChannels((channels)=>{
        channels.push(channel);
    });
}
function $5193fce5c5df8bb9$export$490df4aa0eb47722(options = {}) {
    const { channel: _channel, options: _options, preset: preset } = options;
    const channel = preset ? $5193fce5c5df8bb9$var$getChannel(preset, "proxy") : _channel;
    return (0, $enkGC.createBirpc)({}, {
        ..._options,
        ...channel,
        timeout: -1
    });
}
// src/shared/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/shared/env.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/shared/time.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/shared/util.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/component/state/replacer.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/component/state/custom.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$getFunctionDetails(func) {
    let string = "";
    let matches = null;
    try {
        string = Function.prototype.toString.call(func);
        matches = String.prototype.match.call(string, /\([\s\S]*?\)/);
    } catch (e) {}
    const match = matches && matches[0];
    const args = typeof match === "string" ? match : "(?)";
    const name = typeof func.name === "string" ? func.name : "";
    return {
        _custom: {
            type: "function",
            displayText: `<span style="opacity:.8;margin-right:5px;">function</span> <span style="white-space:nowrap;">${$5193fce5c5df8bb9$export$4e7f196112fea3c5(name)}${args}</span>`,
            tooltipText: string.trim() ? `<pre>${string}</pre>` : null
        }
    };
}
function $5193fce5c5df8bb9$var$getBigIntDetails(val) {
    const stringifiedBigInt = BigInt.prototype.toString.call(val);
    return {
        _custom: {
            type: "bigint",
            displayText: `BigInt(${stringifiedBigInt})`,
            value: stringifiedBigInt
        }
    };
}
function $5193fce5c5df8bb9$var$getDateDetails(val) {
    const date = new Date(val.getTime());
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return {
        _custom: {
            type: "date",
            displayText: Date.prototype.toString.call(val),
            value: date.toISOString().slice(0, -1)
        }
    };
}
function $5193fce5c5df8bb9$var$getMapDetails(val) {
    const list = Object.fromEntries(val);
    return {
        _custom: {
            type: "map",
            displayText: "Map",
            value: list,
            readOnly: true,
            fields: {
                abstract: true
            }
        }
    };
}
function $5193fce5c5df8bb9$var$getSetDetails(val) {
    const list = Array.from(val);
    return {
        _custom: {
            type: "set",
            displayText: `Set[${list.length}]`,
            value: list,
            readOnly: true
        }
    };
}
function $5193fce5c5df8bb9$var$getCaughtGetters(store) {
    const getters = {};
    const origGetters = store.getters || {};
    const keys = Object.keys(origGetters);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        Object.defineProperty(getters, key, {
            enumerable: true,
            get: ()=>{
                try {
                    return origGetters[key];
                } catch (e) {
                    return e;
                }
            }
        });
    }
    return getters;
}
function $5193fce5c5df8bb9$var$reduceStateList(list) {
    if (!list.length) return void 0;
    return list.reduce((map, item)=>{
        const key = item.type || "data";
        const obj = map[key] = map[key] || {};
        obj[item.key] = item.value;
        return map;
    }, {});
}
function $5193fce5c5df8bb9$var$namedNodeMapToObject(map) {
    const result = {};
    const l = map.length;
    for(let i = 0; i < l; i++){
        const node = map.item(i);
        result[node.name] = node.value;
    }
    return result;
}
function $5193fce5c5df8bb9$var$getStoreDetails(store) {
    return {
        _custom: {
            type: "store",
            displayText: "Store",
            value: {
                state: store.state,
                getters: $5193fce5c5df8bb9$var$getCaughtGetters(store)
            },
            fields: {
                abstract: true
            }
        }
    };
}
function $5193fce5c5df8bb9$var$getRouterDetails(router) {
    return {
        _custom: {
            type: "router",
            displayText: "VueRouter",
            value: {
                options: router.options,
                currentRoute: router.currentRoute
            },
            fields: {
                abstract: true
            }
        }
    };
}
function $5193fce5c5df8bb9$var$getInstanceDetails(instance) {
    if (instance._) instance = instance._;
    const state = $5193fce5c5df8bb9$var$processInstanceState(instance);
    return {
        _custom: {
            type: "component",
            id: instance.__VUE_DEVTOOLS_NEXT_UID__,
            displayText: $5193fce5c5df8bb9$var$getInstanceName(instance),
            tooltipText: "Component instance",
            value: $5193fce5c5df8bb9$var$reduceStateList(state),
            fields: {
                abstract: true
            }
        }
    };
}
function $5193fce5c5df8bb9$var$getComponentDefinitionDetails(definition) {
    let display = $5193fce5c5df8bb9$var$getComponentName(definition);
    if (display) {
        if (definition.name && definition.__file) display += ` <span>(${definition.__file})</span>`;
    } else display = "<i>Unknown Component</i>";
    return {
        _custom: {
            type: "component-definition",
            displayText: display,
            tooltipText: "Component definition",
            ...definition.__file ? {
                file: definition.__file
            } : {}
        }
    };
}
function $5193fce5c5df8bb9$var$getHTMLElementDetails(value) {
    try {
        return {
            _custom: {
                type: "HTMLElement",
                displayText: `<span class="opacity-30">&lt;</span><span class="text-blue-500">${value.tagName.toLowerCase()}</span><span class="opacity-30">&gt;</span>`,
                value: $5193fce5c5df8bb9$var$namedNodeMapToObject(value.attributes)
            }
        };
    } catch (e) {
        return {
            _custom: {
                type: "HTMLElement",
                displayText: `<span class="text-blue-500">${String(value)}</span>`
            }
        };
    }
}
function $5193fce5c5df8bb9$var$tryGetRefValue(ref) {
    if ($5193fce5c5df8bb9$var$ensurePropertyExists(ref, "_value", true)) return ref._value;
    if ($5193fce5c5df8bb9$var$ensurePropertyExists(ref, "value", true)) return ref.value;
}
function $5193fce5c5df8bb9$var$getObjectDetails(object) {
    var _a25, _b25, _c, _d;
    const info = $5193fce5c5df8bb9$var$getSetupStateType(object);
    const isState = info.ref || info.computed || info.reactive;
    if (isState) {
        const stateTypeName = info.computed ? "Computed" : info.ref ? "Ref" : info.reactive ? "Reactive" : null;
        const value = $5193fce5c5df8bb9$var$toRaw2(info.reactive ? object : $5193fce5c5df8bb9$var$tryGetRefValue(object));
        const raw = $5193fce5c5df8bb9$var$ensurePropertyExists(object, "effect") ? ((_b25 = (_a25 = object.effect) == null ? void 0 : _a25.raw) == null ? void 0 : _b25.toString()) || ((_d = (_c = object.effect) == null ? void 0 : _c.fn) == null ? void 0 : _d.toString()) : null;
        return {
            _custom: {
                type: stateTypeName == null ? void 0 : stateTypeName.toLowerCase(),
                stateTypeName: stateTypeName,
                value: value,
                ...raw ? {
                    tooltipText: `<span class="font-mono">${raw}</span>`
                } : {}
            }
        };
    }
    if ($5193fce5c5df8bb9$var$ensurePropertyExists(object, "__asyncLoader") && typeof object.__asyncLoader === "function") return {
        _custom: {
            type: "component-definition",
            display: "Async component definition"
        }
    };
}
// src/core/component/state/replacer.ts
function $5193fce5c5df8bb9$var$stringifyReplacer(key, _value, depth, seenInstance) {
    var _a25;
    if (key === "compilerOptions") return;
    const val = this[key];
    const type = typeof val;
    if (Array.isArray(val)) {
        const l = val.length;
        if (l > $5193fce5c5df8bb9$var$MAX_ARRAY_SIZE) return {
            _isArray: true,
            length: l,
            items: val.slice(0, $5193fce5c5df8bb9$var$MAX_ARRAY_SIZE)
        };
        return val;
    } else if (typeof val === "string") {
        if (val.length > $5193fce5c5df8bb9$var$MAX_STRING_SIZE) return `${val.substring(0, $5193fce5c5df8bb9$var$MAX_STRING_SIZE)}... (${val.length} total length)`;
        else return val;
    } else if (type === "undefined") return $5193fce5c5df8bb9$export$6db089fe7b26f5b6;
    else if (val === Number.POSITIVE_INFINITY) return $5193fce5c5df8bb9$export$b4bf424ed968e242;
    else if (val === Number.NEGATIVE_INFINITY) return $5193fce5c5df8bb9$export$95cb88e357cbada8;
    else if (typeof val === "function") return $5193fce5c5df8bb9$var$getFunctionDetails(val);
    else if (type === "symbol") return `[native Symbol ${Symbol.prototype.toString.call(val)}]`;
    else if (typeof val === "bigint") return $5193fce5c5df8bb9$var$getBigIntDetails(val);
    else if (val !== null && typeof val === "object") {
        const proto = Object.prototype.toString.call(val);
        if (proto === "[object Map]") return $5193fce5c5df8bb9$var$getMapDetails(val);
        else if (proto === "[object Set]") return $5193fce5c5df8bb9$var$getSetDetails(val);
        else if (proto === "[object RegExp]") return `[native RegExp ${RegExp.prototype.toString.call(val)}]`;
        else if (proto === "[object Date]") return $5193fce5c5df8bb9$var$getDateDetails(val);
        else if (proto === "[object Error]") return `[native Error ${val.message}<>${val.stack}]`;
        else if ($5193fce5c5df8bb9$var$ensurePropertyExists(val, "state", true) && $5193fce5c5df8bb9$var$ensurePropertyExists(val, "_vm", true)) return $5193fce5c5df8bb9$var$getStoreDetails(val);
        else if (val.constructor && val.constructor.name === "VueRouter") return $5193fce5c5df8bb9$var$getRouterDetails(val);
        else if ($5193fce5c5df8bb9$var$isVueInstance(val)) {
            const componentVal = $5193fce5c5df8bb9$var$getInstanceDetails(val);
            const parentInstanceDepth = seenInstance == null ? void 0 : seenInstance.get(val);
            if (parentInstanceDepth && parentInstanceDepth < depth) return `[[CircularRef]] <${componentVal._custom.displayText}>`;
            seenInstance == null || seenInstance.set(val, depth);
            return componentVal;
        } else if ($5193fce5c5df8bb9$var$ensurePropertyExists(val, "render", true) && typeof val.render === "function") return $5193fce5c5df8bb9$var$getComponentDefinitionDetails(val);
        else if (val.constructor && val.constructor.name === "VNode") return `[native VNode <${val.tag}>]`;
        else if (typeof HTMLElement !== "undefined" && val instanceof HTMLElement) return $5193fce5c5df8bb9$var$getHTMLElementDetails(val);
        else if (((_a25 = val.constructor) == null ? void 0 : _a25.name) === "Store" && "_wrappedGetters" in val) return "[object Store]";
        else if ($5193fce5c5df8bb9$var$ensurePropertyExists(val, "currentRoute", true)) return "[object Router]";
        const customDetails = $5193fce5c5df8bb9$var$getObjectDetails(val);
        if (customDetails != null) return customDetails;
    } else if (Number.isNaN(val)) return $5193fce5c5df8bb9$export$d7ae0f70ebb9e144;
    return $5193fce5c5df8bb9$var$sanitize(val);
}
// src/shared/transfer.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$MAX_SERIALIZED_SIZE = 2097152;
function $5193fce5c5df8bb9$var$isObject(_data, proto) {
    return proto === "[object Object]";
}
function $5193fce5c5df8bb9$var$isArray3(_data, proto) {
    return proto === "[object Array]";
}
function $5193fce5c5df8bb9$var$isVueReactiveLinkNode(node) {
    var _a25;
    const constructorName = (_a25 = node == null ? void 0 : node.constructor) == null ? void 0 : _a25.name;
    return constructorName === "Dep" && "activeLink" in node || constructorName === "Link" && "dep" in node;
}
function $5193fce5c5df8bb9$var$encode(data, replacer, list, seen, depth = 0, seenVueInstance = /* @__PURE__ */ new Map()) {
    let stored;
    let key;
    let value;
    let i;
    let l;
    const seenIndex = seen.get(data);
    if (seenIndex != null) return seenIndex;
    const index = list.length;
    const proto = Object.prototype.toString.call(data);
    if ($5193fce5c5df8bb9$var$isObject(data, proto)) {
        if ($5193fce5c5df8bb9$var$isVueReactiveLinkNode(data)) return index;
        stored = {};
        seen.set(data, index);
        list.push(stored);
        const keys = Object.keys(data);
        for(i = 0, l = keys.length; i < l; i++){
            key = keys[i];
            if (key === "compilerOptions") return index;
            value = data[key];
            const isVm = value != null && $5193fce5c5df8bb9$var$isObject(value, Object.prototype.toString.call(data)) && $5193fce5c5df8bb9$var$isVueInstance(value);
            try {
                if (replacer) value = replacer.call(data, key, value, depth, seenVueInstance);
            } catch (e) {
                value = e;
            }
            stored[key] = $5193fce5c5df8bb9$var$encode(value, replacer, list, seen, depth + 1, seenVueInstance);
            if (isVm) seenVueInstance.delete(value);
        }
    } else if ($5193fce5c5df8bb9$var$isArray3(data, proto)) {
        stored = [];
        seen.set(data, index);
        list.push(stored);
        for(i = 0, l = data.length; i < l; i++){
            try {
                value = data[i];
                if (replacer) value = replacer.call(data, i, value, depth, seenVueInstance);
            } catch (e) {
                value = e;
            }
            stored[i] = $5193fce5c5df8bb9$var$encode(value, replacer, list, seen, depth + 1, seenVueInstance);
        }
    } else list.push(data);
    return index;
}
function $5193fce5c5df8bb9$var$decode(list, reviver2 = null) {
    let i = list.length;
    let j, k, data, key, value, proto;
    while(i--){
        data = list[i];
        proto = Object.prototype.toString.call(data);
        if (proto === "[object Object]") {
            const keys = Object.keys(data);
            for(j = 0, k = keys.length; j < k; j++){
                key = keys[j];
                value = list[data[key]];
                if (reviver2) value = reviver2.call(data, key, value);
                data[key] = value;
            }
        } else if (proto === "[object Array]") for(j = 0, k = data.length; j < k; j++){
            value = list[data[j]];
            if (reviver2) value = reviver2.call(data, j, value);
            data[j] = value;
        }
    }
}
function $5193fce5c5df8bb9$var$stringifyCircularAutoChunks(data, replacer = null, space = null) {
    let result;
    try {
        result = arguments.length === 1 ? JSON.stringify(data) : JSON.stringify(data, (k, v)=>{
            var _a25;
            return (_a25 = replacer == null ? void 0 : replacer(k, v)) == null ? void 0 : _a25.call(this);
        }, space);
    } catch (e) {
        result = $5193fce5c5df8bb9$var$stringifyStrictCircularAutoChunks(data, replacer, space);
    }
    if (result.length > $5193fce5c5df8bb9$var$MAX_SERIALIZED_SIZE) {
        const chunkCount = Math.ceil(result.length / $5193fce5c5df8bb9$var$MAX_SERIALIZED_SIZE);
        const chunks = [];
        for(let i = 0; i < chunkCount; i++)chunks.push(result.slice(i * $5193fce5c5df8bb9$var$MAX_SERIALIZED_SIZE, (i + 1) * $5193fce5c5df8bb9$var$MAX_SERIALIZED_SIZE));
        return chunks;
    }
    return result;
}
function $5193fce5c5df8bb9$var$stringifyStrictCircularAutoChunks(data, replacer = null, space = null) {
    const list = [];
    $5193fce5c5df8bb9$var$encode(data, replacer, list, /* @__PURE__ */ new Map());
    return space ? ` ${JSON.stringify(list, null, space)}` : ` ${JSON.stringify(list)}`;
}
function $5193fce5c5df8bb9$var$parseCircularAutoChunks(data, reviver2 = null) {
    if (Array.isArray(data)) data = data.join("");
    const hasCircular = /^\s/.test(data);
    if (!hasCircular) return arguments.length === 1 ? JSON.parse(data) : JSON.parse(data, reviver2);
    else {
        const list = JSON.parse(data);
        $5193fce5c5df8bb9$var$decode(list, reviver2);
        return list[0];
    }
}
// src/shared/util.ts
function $5193fce5c5df8bb9$export$fac44ee5b035f737(data) {
    return $5193fce5c5df8bb9$var$stringifyCircularAutoChunks(data, $5193fce5c5df8bb9$var$stringifyReplacer);
}
function $5193fce5c5df8bb9$export$98e6a39c04603d36(data, revive2 = false) {
    if (data == void 0) return {};
    return revive2 ? $5193fce5c5df8bb9$var$parseCircularAutoChunks(data, $5193fce5c5df8bb9$var$reviver) : $5193fce5c5df8bb9$var$parseCircularAutoChunks(data);
}
// src/index.ts
var $5193fce5c5df8bb9$export$6922d3b3a607469e = {
    hook: $5193fce5c5df8bb9$var$hook,
    init: ()=>{
        $5193fce5c5df8bb9$export$93f430585c3f6d11();
    },
    get ctx () {
        return $5193fce5c5df8bb9$export$4f1904c03898171b;
    },
    get api () {
        return $5193fce5c5df8bb9$export$4f1904c03898171b.api;
    }
};

});
parcelRegister("i0cUC", function(module, exports) {

$parcel$export(module.exports, "isBrowser", () => $d1b23e2c2244874a$export$4e09c449d6c407f7);
$parcel$export(module.exports, "target", () => $d1b23e2c2244874a$export$44271b4f0c6a3563);
$parcel$export(module.exports, "isNuxtApp", () => $d1b23e2c2244874a$export$e34a31924fd64105);
$parcel$export(module.exports, "classify", () => $d1b23e2c2244874a$export$b04d9b8d414ba5e8);
$parcel$export(module.exports, "camelize", () => $d1b23e2c2244874a$export$161d051f5dd25de7);
$parcel$export(module.exports, "kebabize", () => $d1b23e2c2244874a$export$3b2e9c066cbbdd4c);
$parcel$export(module.exports, "basename", () => $d1b23e2c2244874a$export$9bf319d8f74f51d1);
$parcel$export(module.exports, "isUrlString", () => $d1b23e2c2244874a$export$8092cb61b2731942);
$parcel$export(module.exports, "deepClone", () => $d1b23e2c2244874a$export$b7d58db314e0ac27);

var $6ZWSX = parcelRequire("6ZWSX");
var $d1b23e2c2244874a$require$Buffer = $6ZWSX.Buffer;
var $d1b23e2c2244874a$var$__create = Object.create;
var $d1b23e2c2244874a$var$__defProp = Object.defineProperty;
var $d1b23e2c2244874a$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $d1b23e2c2244874a$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $d1b23e2c2244874a$var$__getProtoOf = Object.getPrototypeOf;
var $d1b23e2c2244874a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d1b23e2c2244874a$var$__esm = (fn, res)=>function __init() {
        return fn && (res = (0, fn[$d1b23e2c2244874a$var$__getOwnPropNames(fn)[0]])(fn = 0)), res;
    };
var $d1b23e2c2244874a$var$__commonJS = (cb, mod)=>function __require() {
        return mod || (0, cb[$d1b23e2c2244874a$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $d1b23e2c2244874a$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $d1b23e2c2244874a$var$__getOwnPropNames(from))if (!$d1b23e2c2244874a$var$__hasOwnProp.call(to, key) && key !== except) $d1b23e2c2244874a$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $d1b23e2c2244874a$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $d1b23e2c2244874a$var$__toESM = (mod, isNodeMode, target2)=>(target2 = mod != null ? $d1b23e2c2244874a$var$__create($d1b23e2c2244874a$var$__getProtoOf(mod)) : {}, $d1b23e2c2244874a$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $d1b23e2c2244874a$var$__defProp(target2, "default", {
        value: mod,
        enumerable: true
    }) : target2, mod));
// ../../node_modules/.pnpm/tsup@8.3.5_@microsoft+api-extractor@7.48.1_@types+node@22.10.5__jiti@2.4.2_postcss@8.4.49_tsx_s7k37zks4wtn7x2grzma6lrsfa/node_modules/tsup/assets/esm_shims.js
var $d1b23e2c2244874a$var$init_esm_shims = $d1b23e2c2244874a$var$__esm({
    "../../node_modules/.pnpm/tsup@8.3.5_@microsoft+api-extractor@7.48.1_@types+node@22.10.5__jiti@2.4.2_postcss@8.4.49_tsx_s7k37zks4wtn7x2grzma6lrsfa/node_modules/tsup/assets/esm_shims.js" () {
        "use strict";
    }
});
// ../../node_modules/.pnpm/rfdc@1.4.1/node_modules/rfdc/index.js
var $d1b23e2c2244874a$var$require_rfdc = $d1b23e2c2244874a$var$__commonJS({
    "../../node_modules/.pnpm/rfdc@1.4.1/node_modules/rfdc/index.js" (exports, module) {
        "use strict";
        $d1b23e2c2244874a$var$init_esm_shims();
        module.exports = rfdc2;
        function copyBuffer(cur) {
            if (cur instanceof $d1b23e2c2244874a$require$Buffer) return $d1b23e2c2244874a$require$Buffer.from(cur);
            return new cur.constructor(cur.buffer.slice(), cur.byteOffset, cur.length);
        }
        function rfdc2(opts) {
            opts = opts || {};
            if (opts.circles) return rfdcCircles(opts);
            const constructorHandlers = /* @__PURE__ */ new Map();
            constructorHandlers.set(Date, (o)=>new Date(o));
            constructorHandlers.set(Map, (o, fn)=>new Map(cloneArray(Array.from(o), fn)));
            constructorHandlers.set(Set, (o, fn)=>new Set(cloneArray(Array.from(o), fn)));
            if (opts.constructorHandlers) for (const handler2 of opts.constructorHandlers)constructorHandlers.set(handler2[0], handler2[1]);
            let handler = null;
            return opts.proto ? cloneProto : clone;
            function cloneArray(a, fn) {
                const keys = Object.keys(a);
                const a2 = new Array(keys.length);
                for(let i = 0; i < keys.length; i++){
                    const k = keys[i];
                    const cur = a[k];
                    if (typeof cur !== "object" || cur === null) a2[k] = cur;
                    else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) a2[k] = handler(cur, fn);
                    else if (ArrayBuffer.isView(cur)) a2[k] = copyBuffer(cur);
                    else a2[k] = fn(cur);
                }
                return a2;
            }
            function clone(o) {
                if (typeof o !== "object" || o === null) return o;
                if (Array.isArray(o)) return cloneArray(o, clone);
                if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, clone);
                const o2 = {};
                for(const k in o){
                    if (Object.hasOwnProperty.call(o, k) === false) continue;
                    const cur = o[k];
                    if (typeof cur !== "object" || cur === null) o2[k] = cur;
                    else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, clone);
                    else if (ArrayBuffer.isView(cur)) o2[k] = copyBuffer(cur);
                    else o2[k] = clone(cur);
                }
                return o2;
            }
            function cloneProto(o) {
                if (typeof o !== "object" || o === null) return o;
                if (Array.isArray(o)) return cloneArray(o, cloneProto);
                if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, cloneProto);
                const o2 = {};
                for(const k in o){
                    const cur = o[k];
                    if (typeof cur !== "object" || cur === null) o2[k] = cur;
                    else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, cloneProto);
                    else if (ArrayBuffer.isView(cur)) o2[k] = copyBuffer(cur);
                    else o2[k] = cloneProto(cur);
                }
                return o2;
            }
        }
        function rfdcCircles(opts) {
            const refs = [];
            const refsNew = [];
            const constructorHandlers = /* @__PURE__ */ new Map();
            constructorHandlers.set(Date, (o)=>new Date(o));
            constructorHandlers.set(Map, (o, fn)=>new Map(cloneArray(Array.from(o), fn)));
            constructorHandlers.set(Set, (o, fn)=>new Set(cloneArray(Array.from(o), fn)));
            if (opts.constructorHandlers) for (const handler2 of opts.constructorHandlers)constructorHandlers.set(handler2[0], handler2[1]);
            let handler = null;
            return opts.proto ? cloneProto : clone;
            function cloneArray(a, fn) {
                const keys = Object.keys(a);
                const a2 = new Array(keys.length);
                for(let i = 0; i < keys.length; i++){
                    const k = keys[i];
                    const cur = a[k];
                    if (typeof cur !== "object" || cur === null) a2[k] = cur;
                    else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) a2[k] = handler(cur, fn);
                    else if (ArrayBuffer.isView(cur)) a2[k] = copyBuffer(cur);
                    else {
                        const index = refs.indexOf(cur);
                        if (index !== -1) a2[k] = refsNew[index];
                        else a2[k] = fn(cur);
                    }
                }
                return a2;
            }
            function clone(o) {
                if (typeof o !== "object" || o === null) return o;
                if (Array.isArray(o)) return cloneArray(o, clone);
                if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, clone);
                const o2 = {};
                refs.push(o);
                refsNew.push(o2);
                for(const k in o){
                    if (Object.hasOwnProperty.call(o, k) === false) continue;
                    const cur = o[k];
                    if (typeof cur !== "object" || cur === null) o2[k] = cur;
                    else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, clone);
                    else if (ArrayBuffer.isView(cur)) o2[k] = copyBuffer(cur);
                    else {
                        const i = refs.indexOf(cur);
                        if (i !== -1) o2[k] = refsNew[i];
                        else o2[k] = clone(cur);
                    }
                }
                refs.pop();
                refsNew.pop();
                return o2;
            }
            function cloneProto(o) {
                if (typeof o !== "object" || o === null) return o;
                if (Array.isArray(o)) return cloneArray(o, cloneProto);
                if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, cloneProto);
                const o2 = {};
                refs.push(o);
                refsNew.push(o2);
                for(const k in o){
                    const cur = o[k];
                    if (typeof cur !== "object" || cur === null) o2[k] = cur;
                    else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, cloneProto);
                    else if (ArrayBuffer.isView(cur)) o2[k] = copyBuffer(cur);
                    else {
                        const i = refs.indexOf(cur);
                        if (i !== -1) o2[k] = refsNew[i];
                        else o2[k] = cloneProto(cur);
                    }
                }
                refs.pop();
                refsNew.pop();
                return o2;
            }
        }
    }
});
// src/index.ts
$d1b23e2c2244874a$var$init_esm_shims();
// src/constants.ts
$d1b23e2c2244874a$var$init_esm_shims();
var $d1b23e2c2244874a$export$a13f7f627010bccd = "__vue-devtools-view-mode__";
var $d1b23e2c2244874a$export$cb85e77fef76bd8b = "__vue-devtools-vite-plugin-detected__";
var $d1b23e2c2244874a$export$45e7092a470efb27 = "__vue-devtools-vite-plugin-client-url__";
var $d1b23e2c2244874a$export$a7ca7371bc63510e = "__vue-devtools-broadcast-channel__";
// src/env.ts
$d1b23e2c2244874a$var$init_esm_shims();
var $d1b23e2c2244874a$export$4e09c449d6c407f7 = typeof navigator !== "undefined";
var $d1b23e2c2244874a$export$44271b4f0c6a3563 = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : typeof $parcel$global !== "undefined" ? $parcel$global : {};
var $d1b23e2c2244874a$export$2a47bd138bf4827c = typeof $d1b23e2c2244874a$export$44271b4f0c6a3563.chrome !== "undefined" && !!$d1b23e2c2244874a$export$44271b4f0c6a3563.chrome.devtools;
var $d1b23e2c2244874a$export$9f140ed41af5108c = $d1b23e2c2244874a$export$4e09c449d6c407f7 && $d1b23e2c2244874a$export$44271b4f0c6a3563.self !== $d1b23e2c2244874a$export$44271b4f0c6a3563.top;
var $d1b23e2c2244874a$var$_a;
var $d1b23e2c2244874a$export$6272d088ce0bd5ee = typeof navigator !== "undefined" && (($d1b23e2c2244874a$var$_a = navigator.userAgent) == null ? void 0 : $d1b23e2c2244874a$var$_a.toLowerCase().includes("electron"));
var $d1b23e2c2244874a$export$e34a31924fd64105 = typeof window !== "undefined" && !!window.__NUXT__;
var $d1b23e2c2244874a$export$cd24a69e3c9a51c8 = !$d1b23e2c2244874a$export$9f140ed41af5108c && !$d1b23e2c2244874a$export$2a47bd138bf4827c && !$d1b23e2c2244874a$export$6272d088ce0bd5ee;
// src/general.ts
$d1b23e2c2244874a$var$init_esm_shims();
var $d1b23e2c2244874a$var$import_rfdc = $d1b23e2c2244874a$var$__toESM($d1b23e2c2244874a$var$require_rfdc(), 1);
function $d1b23e2c2244874a$export$5702a91a6f42969f() {}
var $d1b23e2c2244874a$export$e90fb89750dba83f = (str)=>`${+str}` === str;
var $d1b23e2c2244874a$export$6159e43e50a41987 = ()=>(navigator == null ? void 0 : navigator.platform) ? navigator == null ? void 0 : navigator.platform.toLowerCase().includes("mac") : /Macintosh/.test(navigator.userAgent);
var $d1b23e2c2244874a$var$classifyRE = /(?:^|[-_/])(\w)/g;
var $d1b23e2c2244874a$var$camelizeRE = /-(\w)/g;
var $d1b23e2c2244874a$var$kebabizeRE = /([a-z0-9])([A-Z])/g;
function $d1b23e2c2244874a$var$toUpper(_, c) {
    return c ? c.toUpperCase() : "";
}
function $d1b23e2c2244874a$export$b04d9b8d414ba5e8(str) {
    return str && `${str}`.replace($d1b23e2c2244874a$var$classifyRE, $d1b23e2c2244874a$var$toUpper);
}
function $d1b23e2c2244874a$export$161d051f5dd25de7(str) {
    return str && str.replace($d1b23e2c2244874a$var$camelizeRE, $d1b23e2c2244874a$var$toUpper);
}
function $d1b23e2c2244874a$export$3b2e9c066cbbdd4c(str) {
    return str && str.replace($d1b23e2c2244874a$var$kebabizeRE, (_, lowerCaseCharacter, upperCaseLetter)=>{
        return `${lowerCaseCharacter}-${upperCaseLetter}`;
    }).toLowerCase();
}
function $d1b23e2c2244874a$export$9bf319d8f74f51d1(filename, ext) {
    let normalizedFilename = filename.replace(/^[a-z]:/i, "").replace(/\\/g, "/");
    if (normalizedFilename.endsWith(`index${ext}`)) normalizedFilename = normalizedFilename.replace(`/index${ext}`, ext);
    const lastSlashIndex = normalizedFilename.lastIndexOf("/");
    const baseNameWithExt = normalizedFilename.substring(lastSlashIndex + 1);
    if (ext) {
        const extIndex = baseNameWithExt.lastIndexOf(ext);
        return baseNameWithExt.substring(0, extIndex);
    }
    return "";
}
function $d1b23e2c2244874a$export$584200199479c807(state) {
    return state && state.slice().sort((a, b)=>{
        if (a.key < b.key) return -1;
        if (a.key > b.key) return 1;
        return 0;
    });
}
var $d1b23e2c2244874a$var$HTTP_URL_RE = /^https?:\/\//;
function $d1b23e2c2244874a$export$8092cb61b2731942(str) {
    return str.startsWith("/") || $d1b23e2c2244874a$var$HTTP_URL_RE.test(str);
}
var $d1b23e2c2244874a$export$b7d58db314e0ac27 = (0, $d1b23e2c2244874a$var$import_rfdc.default)({
    circles: true
});
function $d1b23e2c2244874a$export$e700e91d2b9349e8() {
    return Math.random().toString(36).slice(2);
}
function $d1b23e2c2244874a$export$a6cdc56e425d0d0a(value) {
    return typeof value === "object" && !Array.isArray(value) && value !== null;
}
function $d1b23e2c2244874a$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $d1b23e2c2244874a$export$6750766a7c7ec627(value) {
    return value instanceof Set;
}
function $d1b23e2c2244874a$export$5c90113a285f2241(value) {
    return value instanceof Map;
}

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("dj5lJ", function(module, exports) {

$parcel$export(module.exports, "debounce", () => $6e9f4183630d4f60$export$61fc7d43ac8f84b0);
const $6e9f4183630d4f60$var$DEBOUNCE_DEFAULTS = {
    trailing: true
};
function $6e9f4183630d4f60$export$61fc7d43ac8f84b0(fn, wait = 25, options = {}) {
    options = {
        ...$6e9f4183630d4f60$var$DEBOUNCE_DEFAULTS,
        ...options
    };
    if (!Number.isFinite(wait)) throw new TypeError("Expected `wait` to be a finite number");
    let leadingValue;
    let timeout;
    let resolveList = [];
    let currentPromise;
    let trailingArgs;
    const applyFn = (_this, args)=>{
        currentPromise = $6e9f4183630d4f60$var$_applyPromised(fn, _this, args);
        currentPromise.finally(()=>{
            currentPromise = null;
            if (options.trailing && trailingArgs && !timeout) {
                const promise = applyFn(_this, trailingArgs);
                trailingArgs = null;
                return promise;
            }
        });
        return currentPromise;
    };
    return function(...args) {
        if (currentPromise) {
            if (options.trailing) trailingArgs = args;
            return currentPromise;
        }
        return new Promise((resolve)=>{
            const shouldCallNow = !timeout && options.leading;
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                timeout = null;
                const promise = options.leading ? leadingValue : applyFn(this, args);
                for (const _resolve of resolveList)_resolve(promise);
                resolveList = [];
            }, wait);
            if (shouldCallNow) {
                leadingValue = applyFn(this, args);
                resolve(leadingValue);
            } else resolveList.push(resolve);
        });
    };
}
async function $6e9f4183630d4f60$var$_applyPromised(fn, _this, args) {
    return await fn.apply(_this, args);
}

});

parcelRegister("ptPDd", function(module, exports) {

$parcel$export(module.exports, "createHooks", () => $aad1b324593e83d0$export$39c6a2b4dbabca5d);
function $aad1b324593e83d0$export$9089e2fc8ae509cd(configHooks, hooks = {}, parentName) {
    for(const key in configHooks){
        const subHook = configHooks[key];
        const name = parentName ? `${parentName}:${key}` : key;
        if (typeof subHook === "object" && subHook !== null) $aad1b324593e83d0$export$9089e2fc8ae509cd(subHook, hooks, name);
        else if (typeof subHook === "function") hooks[name] = subHook;
    }
    return hooks;
}
function $aad1b324593e83d0$export$3de1ffbf114b9f2d(...hooks) {
    const finalHooks = {};
    for (const hook of hooks){
        const flatenHook = $aad1b324593e83d0$export$9089e2fc8ae509cd(hook);
        for(const key in flatenHook)if (finalHooks[key]) finalHooks[key].push(flatenHook[key]);
        else finalHooks[key] = [
            flatenHook[key]
        ];
    }
    for(const key in finalHooks)if (finalHooks[key].length > 1) {
        const array = finalHooks[key];
        finalHooks[key] = (...arguments_)=>$aad1b324593e83d0$export$6c2c9a00e27c07e8(array, (function_)=>function_(...arguments_));
    } else finalHooks[key] = finalHooks[key][0];
    return finalHooks;
}
function $aad1b324593e83d0$export$6c2c9a00e27c07e8(tasks, function_) {
    return tasks.reduce((promise, task)=>promise.then(()=>function_(task)), Promise.resolve());
}
const $aad1b324593e83d0$var$defaultTask = {
    run: (function_)=>function_()
};
const $aad1b324593e83d0$var$_createTask = ()=>$aad1b324593e83d0$var$defaultTask;
const $aad1b324593e83d0$var$createTask = typeof console.createTask !== "undefined" ? console.createTask : $aad1b324593e83d0$var$_createTask;
function $aad1b324593e83d0$var$serialTaskCaller(hooks, args) {
    const name = args.shift();
    const task = $aad1b324593e83d0$var$createTask(name);
    return hooks.reduce((promise, hookFunction)=>promise.then(()=>task.run(()=>hookFunction(...args))), Promise.resolve());
}
function $aad1b324593e83d0$var$parallelTaskCaller(hooks, args) {
    const name = args.shift();
    const task = $aad1b324593e83d0$var$createTask(name);
    return Promise.all(hooks.map((hook)=>task.run(()=>hook(...args))));
}
function $aad1b324593e83d0$export$e1dd809e3137c513(hooks, arguments_) {
    return hooks.reduce((promise, hookFunction)=>promise.then(()=>hookFunction(...arguments_ || [])), Promise.resolve());
}
function $aad1b324593e83d0$export$23b1f1c6efb4a44a(hooks, args) {
    return Promise.all(hooks.map((hook)=>hook(...args || [])));
}
function $aad1b324593e83d0$var$callEachWith(callbacks, arg0) {
    for (const callback of [
        ...callbacks
    ])callback(arg0);
}
class $aad1b324593e83d0$export$f26845e0fc859724 {
    constructor(){
        this._hooks = {};
        this._before = void 0;
        this._after = void 0;
        this._deprecatedMessages = void 0;
        this._deprecatedHooks = {};
        this.hook = this.hook.bind(this);
        this.callHook = this.callHook.bind(this);
        this.callHookWith = this.callHookWith.bind(this);
    }
    hook(name, function_, options = {}) {
        if (!name || typeof function_ !== "function") return ()=>{};
        const originalName = name;
        let dep;
        while(this._deprecatedHooks[name]){
            dep = this._deprecatedHooks[name];
            name = dep.to;
        }
        if (dep && !options.allowDeprecated) {
            let message = dep.message;
            if (!message) message = `${originalName} hook has been deprecated` + (dep.to ? `, please use ${dep.to}` : "");
            if (!this._deprecatedMessages) this._deprecatedMessages = /* @__PURE__ */ new Set();
            if (!this._deprecatedMessages.has(message)) {
                console.warn(message);
                this._deprecatedMessages.add(message);
            }
        }
        if (!function_.name) try {
            Object.defineProperty(function_, "name", {
                get: ()=>"_" + name.replace(/\W+/g, "_") + "_hook_cb",
                configurable: true
            });
        } catch  {}
        this._hooks[name] = this._hooks[name] || [];
        this._hooks[name].push(function_);
        return ()=>{
            if (function_) {
                this.removeHook(name, function_);
                function_ = void 0;
            }
        };
    }
    hookOnce(name, function_) {
        let _unreg;
        let _function = (...arguments_)=>{
            if (typeof _unreg === "function") _unreg();
            _unreg = void 0;
            _function = void 0;
            return function_(...arguments_);
        };
        _unreg = this.hook(name, _function);
        return _unreg;
    }
    removeHook(name, function_) {
        if (this._hooks[name]) {
            const index = this._hooks[name].indexOf(function_);
            if (index !== -1) this._hooks[name].splice(index, 1);
            if (this._hooks[name].length === 0) delete this._hooks[name];
        }
    }
    deprecateHook(name, deprecated) {
        this._deprecatedHooks[name] = typeof deprecated === "string" ? {
            to: deprecated
        } : deprecated;
        const _hooks = this._hooks[name] || [];
        delete this._hooks[name];
        for (const hook of _hooks)this.hook(name, hook);
    }
    deprecateHooks(deprecatedHooks) {
        Object.assign(this._deprecatedHooks, deprecatedHooks);
        for(const name in deprecatedHooks)this.deprecateHook(name, deprecatedHooks[name]);
    }
    addHooks(configHooks) {
        const hooks = $aad1b324593e83d0$export$9089e2fc8ae509cd(configHooks);
        const removeFns = Object.keys(hooks).map((key)=>this.hook(key, hooks[key]));
        return ()=>{
            for (const unreg of removeFns.splice(0, removeFns.length))unreg();
        };
    }
    removeHooks(configHooks) {
        const hooks = $aad1b324593e83d0$export$9089e2fc8ae509cd(configHooks);
        for(const key in hooks)this.removeHook(key, hooks[key]);
    }
    removeAllHooks() {
        for(const key in this._hooks)delete this._hooks[key];
    }
    callHook(name, ...arguments_) {
        arguments_.unshift(name);
        return this.callHookWith($aad1b324593e83d0$var$serialTaskCaller, name, ...arguments_);
    }
    callHookParallel(name, ...arguments_) {
        arguments_.unshift(name);
        return this.callHookWith($aad1b324593e83d0$var$parallelTaskCaller, name, ...arguments_);
    }
    callHookWith(caller, name, ...arguments_) {
        const event = this._before || this._after ? {
            name: name,
            args: arguments_,
            context: {}
        } : void 0;
        if (this._before) $aad1b324593e83d0$var$callEachWith(this._before, event);
        const result = caller(name in this._hooks ? [
            ...this._hooks[name]
        ] : [], arguments_);
        if (result instanceof Promise) return result.finally(()=>{
            if (this._after && event) $aad1b324593e83d0$var$callEachWith(this._after, event);
        });
        if (this._after && event) $aad1b324593e83d0$var$callEachWith(this._after, event);
        return result;
    }
    beforeEach(function_) {
        this._before = this._before || [];
        this._before.push(function_);
        return ()=>{
            if (this._before !== void 0) {
                const index = this._before.indexOf(function_);
                if (index !== -1) this._before.splice(index, 1);
            }
        };
    }
    afterEach(function_) {
        this._after = this._after || [];
        this._after.push(function_);
        return ()=>{
            if (this._after !== void 0) {
                const index = this._after.indexOf(function_);
                if (index !== -1) this._after.splice(index, 1);
            }
        };
    }
}
function $aad1b324593e83d0$export$39c6a2b4dbabca5d() {
    return new $aad1b324593e83d0$export$f26845e0fc859724();
}
const $aad1b324593e83d0$var$isBrowser = typeof window !== "undefined";
function $aad1b324593e83d0$export$acfdf6f45fa21f5e(hooks, _options = {}) {
    const options = {
        inspect: $aad1b324593e83d0$var$isBrowser,
        group: $aad1b324593e83d0$var$isBrowser,
        filter: ()=>true,
        ..._options
    };
    const _filter = options.filter;
    const filter = typeof _filter === "string" ? (name)=>name.startsWith(_filter) : _filter;
    const _tag = options.tag ? `[${options.tag}] ` : "";
    const logPrefix = (event)=>_tag + event.name + "".padEnd(event._id, "\0");
    const _idCtr = {};
    const unsubscribeBefore = hooks.beforeEach((event)=>{
        if (filter !== void 0 && !filter(event.name)) return;
        _idCtr[event.name] = _idCtr[event.name] || 0;
        event._id = _idCtr[event.name]++;
        console.time(logPrefix(event));
    });
    const unsubscribeAfter = hooks.afterEach((event)=>{
        if (filter !== void 0 && !filter(event.name)) return;
        if (options.group) console.groupCollapsed(event.name);
        if (options.inspect) console.timeLog(logPrefix(event), event.args);
        else console.timeEnd(logPrefix(event));
        if (options.group) console.groupEnd();
        _idCtr[event.name]--;
    });
    return {
        /** Stop debugging and remove listeners */ close: ()=>{
            unsubscribeBefore();
            unsubscribeAfter();
        }
    };
}

});

parcelRegister("enkGC", function(module, exports) {

$parcel$export(module.exports, "createBirpc", () => $baa9e15afeaf047c$export$8de909a09ac6851a);
$parcel$export(module.exports, "createBirpcGroup", () => $baa9e15afeaf047c$export$ec516731f3c62ae5);
const $baa9e15afeaf047c$export$7bd623b29ec8e1eb = 6e4;
function $baa9e15afeaf047c$var$defaultSerialize(i) {
    return i;
}
const $baa9e15afeaf047c$var$defaultDeserialize = $baa9e15afeaf047c$var$defaultSerialize;
const { clearTimeout: $baa9e15afeaf047c$var$clearTimeout, setTimeout: $baa9e15afeaf047c$var$setTimeout } = globalThis;
const $baa9e15afeaf047c$var$random = Math.random.bind(Math);
function $baa9e15afeaf047c$export$8de909a09ac6851a(functions, options) {
    const { post: post, on: on, off: off = ()=>{}, eventNames: eventNames = [], serialize: serialize = $baa9e15afeaf047c$var$defaultSerialize, deserialize: deserialize = $baa9e15afeaf047c$var$defaultDeserialize, resolver: resolver, bind: bind = "rpc", timeout: timeout = $baa9e15afeaf047c$export$7bd623b29ec8e1eb } = options;
    const rpcPromiseMap = /* @__PURE__ */ new Map();
    let _promise;
    let closed = false;
    const rpc = new Proxy({}, {
        get (_, method) {
            if (method === "$functions") return functions;
            if (method === "$close") return close;
            if (method === "then" && !eventNames.includes("then") && !("then" in functions)) return void 0;
            const sendEvent = (...args)=>{
                post(serialize({
                    m: method,
                    a: args,
                    t: "q"
                }));
            };
            if (eventNames.includes(method)) {
                sendEvent.asEvent = sendEvent;
                return sendEvent;
            }
            const sendCall = async (...args)=>{
                if (closed) throw new Error(`[birpc] rpc is closed, cannot call "${method}"`);
                if (_promise) try {
                    await _promise;
                } finally{
                    _promise = void 0;
                }
                return new Promise((resolve, reject)=>{
                    const id = $baa9e15afeaf047c$var$nanoid();
                    let timeoutId;
                    if (timeout >= 0) {
                        timeoutId = $baa9e15afeaf047c$var$setTimeout(()=>{
                            try {
                                options.onTimeoutError?.(method, args);
                                throw new Error(`[birpc] timeout on calling "${method}"`);
                            } catch (e) {
                                reject(e);
                            }
                            rpcPromiseMap.delete(id);
                        }, timeout);
                        if (typeof timeoutId === "object") timeoutId = timeoutId.unref?.();
                    }
                    rpcPromiseMap.set(id, {
                        resolve: resolve,
                        reject: reject,
                        timeoutId: timeoutId,
                        method: method
                    });
                    post(serialize({
                        m: method,
                        a: args,
                        i: id,
                        t: "q"
                    }));
                });
            };
            sendCall.asEvent = sendEvent;
            return sendCall;
        }
    });
    function close() {
        closed = true;
        rpcPromiseMap.forEach(({ reject: reject, method: method })=>{
            reject(new Error(`[birpc] rpc is closed, cannot call "${method}"`));
        });
        rpcPromiseMap.clear();
        off(onMessage);
    }
    async function onMessage(data, ...extra) {
        const msg = deserialize(data);
        if (msg.t === "q") {
            const { m: method, a: args } = msg;
            let result, error;
            const fn = resolver ? resolver(method, functions[method]) : functions[method];
            if (!fn) error = new Error(`[birpc] function "${method}" not found`);
            else try {
                result = await fn.apply(bind === "rpc" ? rpc : functions, args);
            } catch (e) {
                error = e;
            }
            if (msg.i) {
                if (error && options.onError) options.onError(error, method, args);
                post(serialize({
                    t: "s",
                    i: msg.i,
                    r: result,
                    e: error
                }), ...extra);
            }
        } else {
            const { i: ack, r: result, e: error } = msg;
            const promise = rpcPromiseMap.get(ack);
            if (promise) {
                $baa9e15afeaf047c$var$clearTimeout(promise.timeoutId);
                if (error) promise.reject(error);
                else promise.resolve(result);
            }
            rpcPromiseMap.delete(ack);
        }
    }
    _promise = on(onMessage);
    return rpc;
}
const $baa9e15afeaf047c$var$cacheMap = /* @__PURE__ */ new WeakMap();
function $baa9e15afeaf047c$export$c26b4cbcfe84a428(items, fn) {
    return items.map((i)=>{
        let r = $baa9e15afeaf047c$var$cacheMap.get(i);
        if (!r) {
            r = fn(i);
            $baa9e15afeaf047c$var$cacheMap.set(i, r);
        }
        return r;
    });
}
function $baa9e15afeaf047c$export$ec516731f3c62ae5(functions, channels, options = {}) {
    const getChannels = ()=>typeof channels === "function" ? channels() : channels;
    const getClients = (channels2 = getChannels())=>$baa9e15afeaf047c$export$c26b4cbcfe84a428(channels2, (s)=>$baa9e15afeaf047c$export$8de909a09ac6851a(functions, {
                ...options,
                ...s
            }));
    const broadcastProxy = new Proxy({}, {
        get (_, method) {
            const client = getClients();
            const callbacks = client.map((c)=>c[method]);
            const sendCall = (...args)=>{
                return Promise.all(callbacks.map((i)=>i(...args)));
            };
            sendCall.asEvent = (...args)=>{
                callbacks.map((i)=>i.asEvent(...args));
            };
            return sendCall;
        }
    });
    function updateChannels(fn) {
        const channels2 = getChannels();
        fn?.(channels2);
        return getClients(channels2);
    }
    getClients();
    return {
        get clients () {
            return getClients();
        },
        functions: functions,
        updateChannels: updateChannels,
        broadcast: broadcastProxy,
        /**
     * @deprecated use `broadcast`
     */ // @ts-expect-error deprecated
        boardcast: broadcastProxy
    };
}
const $baa9e15afeaf047c$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
function $baa9e15afeaf047c$var$nanoid(size = 21) {
    let id = "";
    let i = size;
    while(i--)id += $baa9e15afeaf047c$var$urlAlphabet[$baa9e15afeaf047c$var$random() * 64 | 0];
    return id;
}

});



parcelRegister("6VOYw", function(module, exports) {

$parcel$export(module.exports, "CSVParser", () => $50bf9b8bc673648d$export$315737164a83fa6d);
/**
 * A utility class for parsing CSV data with support for:
 * - Quoted fields containing commas
 * - Escaped quotes within quoted fields
 * - Different line endings (Windows/Unix)
 * - Proper whitespace handling
 */ class $50bf9b8bc673648d$export$315737164a83fa6d {
    /**
   * Parses a CSV string into an array of objects using the first row as headers
   * @param {string} csvText - The raw CSV text to parse
   * @param {Object} options - Parsing options
   * @param {boolean} options.hasHeaders - Whether to use first row as headers (default: true)
   * @param {boolean} options.trimHeaders - Whether to trim whitespace from headers (default: true)
   * @param {boolean} options.trimValues - Whether to trim whitespace from values (default: true)
   * @returns {Array<Object>} Array of objects where keys are headers and values are row values
   */ static parse(csvText, options = {}) {
        const { hasHeaders: hasHeaders = true, trimHeaders: trimHeaders = true, trimValues: trimValues = true } = options;
        // Split into rows, handling both Windows and Unix line endings
        const rows = csvText.trim().split(/\r?\n/).map((row)=>this.parseRow(row, {
                trim: trimValues
            }));
        if (!hasHeaders) return rows;
        const headers = rows.shift().map((header)=>{
            const processedHeader = trimHeaders ? header.trim() : header;
            // Downcase first letter while preserving rest of the string
            return processedHeader.charAt(0).toLowerCase() + processedHeader.slice(1);
        });
        return rows.map((row)=>{
            const obj = {};
            row.forEach((value, index)=>{
                if (index < headers.length) obj[headers[index]] = value;
            });
            return obj;
        });
    }
    /**
   * Parses a single CSV row into an array of values
   * @param {string} line - The CSV line to parse
   * @param {Object} options - Parsing options
   * @param {boolean} options.trim - Whether to trim values (default: true)
   * @returns {string[]} Array of parsed values
   */ static parseRow(line, { trim: trim = true } = {}) {
        const result = [];
        let cell = '';
        let inQuotes = false;
        for(let i = 0; i < line.length; i++){
            const char = line[i];
            if (char === '"') {
                if (inQuotes && line[i + 1] === '"') {
                    cell += '"';
                    i++;
                } else inQuotes = !inQuotes;
            } else if (char === ',' && !inQuotes) {
                result.push(trim ? cell.trim() : cell);
                cell = '';
            } else cell += char;
        }
        // Push the last cell
        result.push(trim ? cell.trim() : cell);
        return result;
    }
    /**
   * Parses a CSV file from a Google Sheets URL
   * @param {string} url - The Google Sheets CSV export URL
   * @param {Object} options - Parsing options (same as parse method)
   * @returns {Promise<Array<Object>>} Promise resolving to parsed CSV data
   */ static async parseGoogleSheet(url, options = {}) {
        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const text = await response.text();
            return this.parse(text, options);
        } catch (error) {
            console.error("Error fetching or parsing Google Sheet:", error);
            throw error;
        }
    }
}

});


parcelRegister("hdyeU", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");


module.exports = Promise.all([
    (parcelRequire("fFMZG"))((parcelRequire("27Lyk")).resolve("ehI2k")),
    $Gr8vk("egR1g")
]).then(()=>parcelRequire('fpXBf'));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});

parcelRegister("fFMZG", function(module, exports) {
"use strict";

var $lovBw = parcelRequire("lovBw");
module.exports = $lovBw(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if ([].concat(existingLinks).some(function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("lovBw", function(module, exports) {
"use strict";
var $f9345ad2c034f768$var$cachedBundles = {};
var $f9345ad2c034f768$var$cachedPreloads = {};
var $f9345ad2c034f768$var$cachedPrefetches = {};
function $f9345ad2c034f768$var$getCache(type) {
    switch(type){
        case 'preload':
            return $f9345ad2c034f768$var$cachedPreloads;
        case 'prefetch':
            return $f9345ad2c034f768$var$cachedPrefetches;
        default:
            return $f9345ad2c034f768$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $f9345ad2c034f768$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("2Elws", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");


module.exports = Promise.all([
    (parcelRequire("fFMZG"))((parcelRequire("27Lyk")).resolve("f905o")),
    $Gr8vk("1bBEW")
]).then(()=>parcelRequire('5q5tL'));

});

parcelRegister("h9PHU", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");


module.exports = Promise.all([
    (parcelRequire("fFMZG"))((parcelRequire("27Lyk")).resolve("kL4Ru")),
    $Gr8vk("ZuMMi")
]).then(()=>parcelRequire('eVDBc'));

});

parcelRegister("ipwgW", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");


module.exports = Promise.all([
    (parcelRequire("fFMZG"))((parcelRequire("27Lyk")).resolve("k9F32")),
    $Gr8vk("bljAp")
]).then(()=>parcelRequire('aBrsK'));

});

parcelRegister("69I3W", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");


module.exports = Promise.all([
    (parcelRequire("fFMZG"))((parcelRequire("27Lyk")).resolve("gXvmy")),
    $Gr8vk("gMMqh")
]).then(()=>parcelRequire('8NImY'));

});

parcelRegister("boZNq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $84d1df06ca739753$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

var $8qdaR = parcelRequire("8qdaR");

var $fuaCw = parcelRequire("fuaCw");

var $eyGrO = parcelRequire("eyGrO");
var $84d1df06ca739753$export$2e2bcd8739ae039 = {
    __name: 'App',
    setup (__props, { expose: __expose }) {
        __expose();
        const guestStore = (0, $8qdaR.useGuestStore)();
        const showErrorModal = (0, $01W3b.ref)(false);
        const errorMessage = (0, $01W3b.ref)("");
        const errorSecondaryAction = (0, $01W3b.ref)(null);
        const errorPrimaryActionText = (0, $01W3b.ref)(null);
        // Create methods to handle error modal
        const showError = (message, primaryActionText = "Got it!", secondaryAction = null)=>{
            errorMessage.value = message;
            showErrorModal.value = true;
            errorPrimaryActionText.value = null;
            errorSecondaryAction.value = null;
            if (secondaryAction) errorSecondaryAction.value = secondaryAction;
            if (primaryActionText) errorPrimaryActionText.value = primaryActionText;
        };
        const hideError = ()=>{
            showErrorModal.value = false;
            errorMessage.value = "";
        };
        // Provide the methods to child components
        (0, $TusQn.provide)("errorModal", {
            showError: showError,
            hideError: hideError
        });
        (0, $TusQn.onMounted)(async ()=>{
            await guestStore.loadResponses();
            guestStore.loadGuest();
        });
        const __returned__ = {
            guestStore: guestStore,
            showErrorModal: showErrorModal,
            errorMessage: errorMessage,
            errorSecondaryAction: errorSecondaryAction,
            errorPrimaryActionText: errorPrimaryActionText,
            showError: showError,
            hideError: hideError,
            onMounted: $TusQn.onMounted,
            ref: $01W3b.ref,
            provide: $TusQn.provide,
            get useGuestStore () {
                return 0, $8qdaR.useGuestStore;
            },
            MusicPlayButton: $fuaCw.default,
            ErrorModal: $eyGrO.default
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("fuaCw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b461e54f7d2db2c3$export$2e2bcd8739ae039);
let $b461e54f7d2db2c3$var$script;




let $b461e54f7d2db2c3$var$initialize = ()=>{
    $b461e54f7d2db2c3$var$script = (parcelRequire("7YrBD"));
    if ($b461e54f7d2db2c3$var$script.__esModule) $b461e54f7d2db2c3$var$script = $b461e54f7d2db2c3$var$script.default;
    $b461e54f7d2db2c3$var$script.render = (parcelRequire("leCth")).render;
    $b461e54f7d2db2c3$var$script.__cssModules = {};
    (parcelRequire("hL26k")).default($b461e54f7d2db2c3$var$script);
    $b461e54f7d2db2c3$var$script.__scopeId = 'data-v-6e36ac';
    $b461e54f7d2db2c3$var$script.__file = "MusicPlayButton.vue";
};
$b461e54f7d2db2c3$var$initialize();
var $b461e54f7d2db2c3$export$2e2bcd8739ae039 = $b461e54f7d2db2c3$var$script;

});
parcelRegister("7YrBD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5ce38cf60313ddec$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

var $6QOaN = parcelRequire("6QOaN");

var $8yIr7 = parcelRequire("8yIr7");

var $j6VVY = parcelRequire("j6VVY");
var $5ce38cf60313ddec$export$2e2bcd8739ae039 = {
    __name: 'MusicPlayButton',
    setup (__props, { expose: __expose }) {
        __expose();
        const audioManager = (0, $TusQn.inject)("audioManager");
        const themeSong = audioManager.getAudio("themeSong");
        const isPlaying = (0, $01W3b.ref)(false);
        const toggleMusic = ()=>{
            const initialState = isPlaying.value;
            if (isPlaying.value) {
                themeSong.pause();
                themeSong.currentTime = 0;
            } else themeSong.play();
            (0, $TusQn.nextTick)(()=>{
                if (isPlaying.value === initialState) isPlaying.value = !initialState;
            });
        };
        (0, $TusQn.onMounted)(()=>{
            themeSong.addEventListener("pause", ()=>{
                isPlaying.value = false;
            });
            themeSong.addEventListener("play", ()=>{
                isPlaying.value = true;
            });
            themeSong.addEventListener("ended", ()=>{
                isPlaying.value = false;
            });
        });
        const __returned__ = {
            audioManager: audioManager,
            themeSong: themeSong,
            isPlaying: isPlaying,
            toggleMusic: toggleMusic,
            ref: $01W3b.ref,
            inject: $TusQn.inject,
            nextTick: $TusQn.nextTick,
            onMounted: $TusQn.onMounted,
            OTButton: $6QOaN.default,
            AudioPlayingIcon: $8yIr7.default,
            AudioStoppedIcon: $j6VVY.default
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("6QOaN", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fce84bcb39e4428$export$2e2bcd8739ae039);
let $4fce84bcb39e4428$var$script;




let $4fce84bcb39e4428$var$initialize = ()=>{
    $4fce84bcb39e4428$var$script = (parcelRequire("dVNkU"));
    if ($4fce84bcb39e4428$var$script.__esModule) $4fce84bcb39e4428$var$script = $4fce84bcb39e4428$var$script.default;
    $4fce84bcb39e4428$var$script.render = (parcelRequire("faMNq")).render;
    $4fce84bcb39e4428$var$script.__cssModules = {};
    (parcelRequire("ay0fr")).default($4fce84bcb39e4428$var$script);
    $4fce84bcb39e4428$var$script.__scopeId = 'data-v-5927c3';
    $4fce84bcb39e4428$var$script.__file = "OTButton.vue";
};
$4fce84bcb39e4428$var$initialize();
var $4fce84bcb39e4428$export$2e2bcd8739ae039 = $4fce84bcb39e4428$var$script;

});
parcelRegister("dVNkU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a246de5e7207f732$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $a246de5e7207f732$export$2e2bcd8739ae039 = {
    __name: 'OTButton',
    props: {
        text: {
            type: String,
            default: "OK"
        }
    },
    emits: [
        "click"
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const audioManager = (0, $TusQn.inject)("audioManager");
        const emit = __emit;
        const buttonClicked = (event)=>{
            event.stopPropagation();
            audioManager.play("click").then(()=>{
                emit("click", event);
            });
        };
        const __returned__ = {
            audioManager: audioManager,
            emit: emit,
            buttonClicked: buttonClicked,
            inject: $TusQn.inject
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("faMNq", function(module, exports) {

$parcel$export(module.exports, "render", () => $b0bda419eacbf27c$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $b0bda419eacbf27c$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
        class: "ot-button",
        onClick: $setup.buttonClicked
    }, [
        (0, $TusQn.renderSlot)(_ctx.$slots, "default")
    ]);
}

});

parcelRegister("ay0fr", function(module, exports) {

$parcel$export(module.exports, "default", () => $7add459cb7bcd5f6$export$2e2bcd8739ae039);
let $7add459cb7bcd5f6$var$NOOP = ()=>{};
var $7add459cb7bcd5f6$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("8yIr7", function(module, exports) {

$parcel$export(module.exports, "default", () => $63b3f7d774b1b535$export$2e2bcd8739ae039);
let $63b3f7d774b1b535$var$script;


let $63b3f7d774b1b535$var$initialize = ()=>{
    $63b3f7d774b1b535$var$script = {};
    $63b3f7d774b1b535$var$script.render = (parcelRequire("kH3O6")).render;
    (parcelRequire("cdOI0")).default($63b3f7d774b1b535$var$script);
    $63b3f7d774b1b535$var$script.__scopeId = 'data-v-b93d80';
    $63b3f7d774b1b535$var$script.__file = "AudioPlayingIcon.vue";
};
$63b3f7d774b1b535$var$initialize();
var $63b3f7d774b1b535$export$2e2bcd8739ae039 = $63b3f7d774b1b535$var$script;

});
parcelRegister("kH3O6", function(module, exports) {

$parcel$export(module.exports, "render", () => $f10ac6d14c1ee9ee$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $f10ac6d14c1ee9ee$var$_hoisted_1 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "currentColor",
    class: "bi bi-play-fill",
    viewBox: "0 0 16 16"
};
function $f10ac6d14c1ee9ee$export$b3890eb0ae9dca99(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", $f10ac6d14c1ee9ee$var$_hoisted_1, _cache[0] || (_cache[0] = [
        (0, $TusQn.createElementVNode)("path", {
            d: "m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393"
        }, null, -1)
    ]));
}

});

parcelRegister("cdOI0", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e5e08a780faf46c$export$2e2bcd8739ae039);
let $8e5e08a780faf46c$var$NOOP = ()=>{};
var $8e5e08a780faf46c$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("j6VVY", function(module, exports) {

$parcel$export(module.exports, "default", () => $de9b845f7a21dc78$export$2e2bcd8739ae039);
let $de9b845f7a21dc78$var$script;


let $de9b845f7a21dc78$var$initialize = ()=>{
    $de9b845f7a21dc78$var$script = {};
    $de9b845f7a21dc78$var$script.render = (parcelRequire("7Y2J5")).render;
    (parcelRequire("kWd8k")).default($de9b845f7a21dc78$var$script);
    $de9b845f7a21dc78$var$script.__scopeId = 'data-v-11411c';
    $de9b845f7a21dc78$var$script.__file = "AudioStoppedIcon.vue";
};
$de9b845f7a21dc78$var$initialize();
var $de9b845f7a21dc78$export$2e2bcd8739ae039 = $de9b845f7a21dc78$var$script;

});
parcelRegister("7Y2J5", function(module, exports) {

$parcel$export(module.exports, "render", () => $5cd0405bd85af2dc$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $5cd0405bd85af2dc$var$_hoisted_1 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "currentColor",
    class: "bi bi-pause-fill",
    viewBox: "0 0 16 16"
};
function $5cd0405bd85af2dc$export$b3890eb0ae9dca99(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", $5cd0405bd85af2dc$var$_hoisted_1, _cache[0] || (_cache[0] = [
        (0, $TusQn.createElementVNode)("path", {
            d: "M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5m5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5"
        }, null, -1)
    ]));
}

});

parcelRegister("kWd8k", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3e3696b55ba6ae6$export$2e2bcd8739ae039);
let $f3e3696b55ba6ae6$var$NOOP = ()=>{};
var $f3e3696b55ba6ae6$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("leCth", function(module, exports) {

$parcel$export(module.exports, "render", () => $f758bf612a2f021d$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $f758bf612a2f021d$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["OTButton"], {
        onClick: $setup.toggleMusic
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                $setup.isPlaying ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["AudioStoppedIcon"], {
                    key: 0
                })) : ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["AudioPlayingIcon"], {
                    key: 1
                }))
            ]),
        _: 1
    });
}

});

parcelRegister("hL26k", function(module, exports) {

$parcel$export(module.exports, "default", () => $ced874b4b5dcabf5$export$2e2bcd8739ae039);
let $ced874b4b5dcabf5$var$NOOP = ()=>{};
var $ced874b4b5dcabf5$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("eyGrO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9952ad883d91736$export$2e2bcd8739ae039);
let $a9952ad883d91736$var$script;




let $a9952ad883d91736$var$initialize = ()=>{
    $a9952ad883d91736$var$script = (parcelRequire("j5aO4"));
    if ($a9952ad883d91736$var$script.__esModule) $a9952ad883d91736$var$script = $a9952ad883d91736$var$script.default;
    $a9952ad883d91736$var$script.render = (parcelRequire("j9pVa")).render;
    $a9952ad883d91736$var$script.__cssModules = {};
    (parcelRequire("gfiIj")).default($a9952ad883d91736$var$script);
    $a9952ad883d91736$var$script.__scopeId = 'data-v-dff7f6';
    $a9952ad883d91736$var$script.__file = "ErrorModal.vue";
};
$a9952ad883d91736$var$initialize();
var $a9952ad883d91736$export$2e2bcd8739ae039 = $a9952ad883d91736$var$script;

});
parcelRegister("j5aO4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $de46ddec201d2c25$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

var $m59f4 = parcelRequire("m59f4");

var $6QOaN = parcelRequire("6QOaN");
var $de46ddec201d2c25$export$2e2bcd8739ae039 = {
    __name: 'ErrorModal',
    props: {
        showModal: {
            type: Boolean,
            required: true
        },
        errorMessage: {
            type: String,
            required: true
        },
        secondaryAction: {
            type: Object,
            required: false
        },
        primaryActionText: {
            type: String,
            default: "Got it!"
        }
    },
    emits: [
        "closeModal"
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const audioManager = (0, $TusQn.inject)("audioManager");
        const props = __props;
        (0, $01W3b.watch)(()=>props.showModal, (newVal)=>{
            if (newVal) audioManager.play("howdy");
        });
        const emit = __emit;
        const closeModal = ()=>{
            emit("closeModal");
        };
        const executeSecondaryAction = ()=>{
            props.secondaryAction.action();
            closeModal();
        };
        const __returned__ = {
            audioManager: audioManager,
            props: props,
            emit: emit,
            closeModal: closeModal,
            executeSecondaryAction: executeSecondaryAction,
            inject: $TusQn.inject,
            watch: $01W3b.watch,
            OTModal: $m59f4.default,
            OTButton: $6QOaN.default
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("m59f4", function(module, exports) {

$parcel$export(module.exports, "default", () => $04260c7cc7530e35$export$2e2bcd8739ae039);
let $04260c7cc7530e35$var$script;




let $04260c7cc7530e35$var$initialize = ()=>{
    $04260c7cc7530e35$var$script = (parcelRequire("fYQ68"));
    if ($04260c7cc7530e35$var$script.__esModule) $04260c7cc7530e35$var$script = $04260c7cc7530e35$var$script.default;
    $04260c7cc7530e35$var$script.render = (parcelRequire("jPbF7")).render;
    $04260c7cc7530e35$var$script.__cssModules = {};
    (parcelRequire("3DJuw")).default($04260c7cc7530e35$var$script);
    $04260c7cc7530e35$var$script.__scopeId = 'data-v-2ac99a';
    $04260c7cc7530e35$var$script.__file = "OTModal.vue";
};
$04260c7cc7530e35$var$initialize();
var $04260c7cc7530e35$export$2e2bcd8739ae039 = $04260c7cc7530e35$var$script;

});
parcelRegister("fYQ68", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ba24df2cde33d94c$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $eeJ70 = parcelRequire("eeJ70");
var $01W3b = parcelRequire("01W3b");

var $doE53 = parcelRequire("doE53");

var $lyvle = parcelRequire("lyvle");
var $ba24df2cde33d94c$export$2e2bcd8739ae039 = {
    __name: 'OTModal',
    props: {
        showModal: Boolean,
        contentPadding: {
            type: String,
            default: "40px"
        },
        mobilePadding: {
            type: String,
            default: "20px"
        },
        backButton: {
            type: Boolean,
            default: false
        },
        useClickOutside: {
            type: Boolean,
            default: true
        }
    },
    emits: [
        "backButtonClicked",
        "closeModal"
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        (0, $eeJ70.useCssVars)((_ctx)=>({
                "35dc870a": __props.contentPadding,
                "557b518c": __props.mobilePadding
            }));
        const props = __props;
        const clickOutside = ()=>{
            if (props.useClickOutside) emit("closeModal");
        };
        (0, $01W3b.watch)(()=>props.showModal, (newVal)=>{
            if (newVal) document.body.style.overflow = "hidden";
            else document.body.style.overflow = "auto";
        });
        const emit = __emit;
        const backButtonClicked = ()=>{
            emit("backButtonClicked");
        };
        const __returned__ = {
            props: props,
            clickOutside: clickOutside,
            emit: emit,
            backButtonClicked: backButtonClicked,
            OTOutline: $doE53.default,
            OTBackButton: $lyvle.default,
            watch: $01W3b.watch
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("doE53", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c0c9b69c3c79fd0$export$2e2bcd8739ae039);
let $9c0c9b69c3c79fd0$var$script;



let $9c0c9b69c3c79fd0$var$initialize = ()=>{
    $9c0c9b69c3c79fd0$var$script = {};
    $9c0c9b69c3c79fd0$var$script.render = (parcelRequire("6T6cX")).render;
    $9c0c9b69c3c79fd0$var$script.__cssModules = {};
    (parcelRequire("kxysI")).default($9c0c9b69c3c79fd0$var$script);
    $9c0c9b69c3c79fd0$var$script.__scopeId = 'data-v-52fdc5';
    $9c0c9b69c3c79fd0$var$script.__file = "OTOutline.vue";
};
$9c0c9b69c3c79fd0$var$initialize();
var $9c0c9b69c3c79fd0$export$2e2bcd8739ae039 = $9c0c9b69c3c79fd0$var$script;

});
parcelRegister("6T6cX", function(module, exports) {

$parcel$export(module.exports, "render", () => $503cb1e299af759f$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $503cb1e299af759f$var$_hoisted_1 = {
    class: "ot-outline"
};
function $503cb1e299af759f$export$b3890eb0ae9dca99(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $503cb1e299af759f$var$_hoisted_1, [
        (0, $TusQn.renderSlot)(_ctx.$slots, "default")
    ]);
}

});

parcelRegister("kxysI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef419f307f1e3ed7$export$2e2bcd8739ae039);
let $ef419f307f1e3ed7$var$NOOP = ()=>{};
var $ef419f307f1e3ed7$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("lyvle", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb1515badeefa2a8$export$2e2bcd8739ae039);
let $fb1515badeefa2a8$var$script;




let $fb1515badeefa2a8$var$initialize = ()=>{
    $fb1515badeefa2a8$var$script = (parcelRequire("87rQi"));
    if ($fb1515badeefa2a8$var$script.__esModule) $fb1515badeefa2a8$var$script = $fb1515badeefa2a8$var$script.default;
    $fb1515badeefa2a8$var$script.render = (parcelRequire("97Nvz")).render;
    $fb1515badeefa2a8$var$script.__cssModules = {};
    (parcelRequire("99yoz")).default($fb1515badeefa2a8$var$script);
    $fb1515badeefa2a8$var$script.__scopeId = 'data-v-35b454';
    $fb1515badeefa2a8$var$script.__file = "OTBackButton.vue";
};
$fb1515badeefa2a8$var$initialize();
var $fb1515badeefa2a8$export$2e2bcd8739ae039 = $fb1515badeefa2a8$var$script;

});
parcelRegister("87rQi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5e949317151ad946$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $5e949317151ad946$export$2e2bcd8739ae039 = {
    __name: 'OTBackButton',
    props: {
        forward: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        "click"
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const audioManager = (0, $TusQn.inject)("audioManager");
        const emit = __emit;
        const props = __props;
        const buttonClicked = (event)=>{
            event.stopPropagation();
            audioManager.play("click").then(()=>{
                emit("click", event);
            });
        };
        const __returned__ = {
            audioManager: audioManager,
            emit: emit,
            props: props,
            buttonClicked: buttonClicked,
            inject: $TusQn.inject
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("97Nvz", function(module, exports) {

$parcel$export(module.exports, "render", () => $6a4b2bcfbddd22c3$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $6ijcT = parcelRequire("6ijcT");

var $j1J2A = parcelRequire("j1J2A");
const $6a4b2bcfbddd22c3$var$_hoisted_1 = {
    key: 0,
    src: (0, (/*@__PURE__*/$parcel$interopDefault($6ijcT))),
    alt: "Forward"
};
const $6a4b2bcfbddd22c3$var$_hoisted_2 = {
    key: 1,
    src: (0, (/*@__PURE__*/$parcel$interopDefault($j1J2A))),
    alt: "Back"
};
function $6a4b2bcfbddd22c3$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
        class: "ot-back-button",
        onClick: $setup.buttonClicked
    }, [
        $props.forward ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("img", $6a4b2bcfbddd22c3$var$_hoisted_1)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("img", $6a4b2bcfbddd22c3$var$_hoisted_2))
    ]);
}

});
parcelRegister("6ijcT", function(module, exports) {
module.exports = new URL("forward-button.927f453d.png", import.meta.url).toString();

});

parcelRegister("j1J2A", function(module, exports) {
module.exports = new URL("back-button.57ce7f0c.png", import.meta.url).toString();

});


parcelRegister("99yoz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a9fa284e487f323$export$2e2bcd8739ae039);
let $6a9fa284e487f323$var$NOOP = ()=>{};
var $6a9fa284e487f323$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("jPbF7", function(module, exports) {

$parcel$export(module.exports, "render", () => $e6ebd39dd8049341$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $e6ebd39dd8049341$var$_hoisted_1 = {
    key: 0,
    class: "ot-actions-container"
};
function $e6ebd39dd8049341$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "fade",
        mode: "out-in"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                $props.showModal ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                    key: 0,
                    class: "ot-modal",
                    onClick: $setup.clickOutside
                }, [
                    (0, $TusQn.createVNode)($setup["OTOutline"], {
                        class: "ot-modal-content",
                        onClick: _cache[0] || (_cache[0] = (0, $eeJ70.withModifiers)(()=>{}, [
                            "stop"
                        ]))
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.renderSlot)(_ctx.$slots, "title"),
                                (0, $TusQn.renderSlot)(_ctx.$slots, "content"),
                                $props.backButton || _ctx.$slots.actions ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $e6ebd39dd8049341$var$_hoisted_1, [
                                    $props.backButton ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["OTBackButton"], {
                                        key: 0,
                                        onClick: $setup.backButtonClicked
                                    })) : (0, $TusQn.createCommentVNode)("", true),
                                    (0, $TusQn.createElementVNode)("div", {
                                        class: (0, $8POXm.normalizeClass)([
                                            "ot-modal-actions",
                                            {
                                                'with-back-button': $props.backButton,
                                                'without-back-button': !$props.backButton
                                            }
                                        ])
                                    }, [
                                        (0, $TusQn.renderSlot)(_ctx.$slots, "actions")
                                    ], 2)
                                ])) : (0, $TusQn.createCommentVNode)("", true)
                            ]),
                        _: 3
                    })
                ])) : (0, $TusQn.createCommentVNode)("", true)
            ]),
        _: 3
    });
}

});

parcelRegister("3DJuw", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a684d3923634e0d$export$2e2bcd8739ae039);
let $2a684d3923634e0d$var$NOOP = ()=>{};
var $2a684d3923634e0d$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("j9pVa", function(module, exports) {

$parcel$export(module.exports, "render", () => $df12f6fa9ad5b0f4$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");

var $33AOd = parcelRequire("33AOd");
const $df12f6fa9ad5b0f4$var$_hoisted_1 = {
    class: "error-modal-content"
};
const $df12f6fa9ad5b0f4$var$_hoisted_2 = {
    class: "error-modal-message"
};
const $df12f6fa9ad5b0f4$var$_hoisted_3 = {
    class: "error-modal-actions"
};
function $df12f6fa9ad5b0f4$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["OTModal"], {
        "show-modal": $props.showModal,
        "content-padding": "10px",
        "mobile-padding": "10px"
    }, {
        content: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $df12f6fa9ad5b0f4$var$_hoisted_1, [
                    _cache[0] || (_cache[0] = (0, $TusQn.createElementVNode)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($33AOd))),
                        alt: "Error"
                    }, null, -1)),
                    (0, $TusQn.createElementVNode)("p", $df12f6fa9ad5b0f4$var$_hoisted_2, (0, $8POXm.toDisplayString)($props.errorMessage), 1)
                ])
            ]),
        actions: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $df12f6fa9ad5b0f4$var$_hoisted_3, [
                    (0, $TusQn.createVNode)($setup["OTButton"], {
                        onClick: $setup.closeModal
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($props.primaryActionText), 1)
                            ]),
                        _: 1
                    }),
                    $props.secondaryAction ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["OTButton"], {
                        key: 0,
                        onClick: $setup.executeSecondaryAction
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($props.secondaryAction.text), 1)
                            ]),
                        _: 1
                    })) : (0, $TusQn.createCommentVNode)("", true)
                ])
            ]),
        _: 1
    }, 8, [
        "show-modal"
    ]);
}

});
parcelRegister("33AOd", function(module, exports) {
module.exports = new URL("error-popup.4e07f700.png", import.meta.url).toString();

});


parcelRegister("gfiIj", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd3c90352f772b81$export$2e2bcd8739ae039);
let $bd3c90352f772b81$var$NOOP = ()=>{};
var $bd3c90352f772b81$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("3NNX1", function(module, exports) {

$parcel$export(module.exports, "render", () => $2c4cb1eb429dee56$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $2c4cb1eb429dee56$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterView = (0, $TusQn.resolveComponent)("RouterView");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        _cache[1] || (_cache[1] = (0, $TusQn.createElementVNode)("div", {
            class: "background"
        }, null, -1)),
        (0, $TusQn.createVNode)(_component_RouterView),
        (0, $TusQn.createVNode)($setup["MusicPlayButton"]),
        (0, $TusQn.createVNode)($setup["ErrorModal"], {
            "show-modal": $setup.showErrorModal,
            "error-message": $setup.errorMessage,
            "secondary-action": $setup.errorSecondaryAction,
            "primary-action-text": $setup.errorPrimaryActionText,
            onCloseModal: _cache[0] || (_cache[0] = ($event)=>$setup.showErrorModal = false)
        }, null, 8, [
            "show-modal",
            "error-message",
            "secondary-action",
            "primary-action-text"
        ])
    ], 64);
}

});

parcelRegister("1rrBo", function(module, exports) {

$parcel$export(module.exports, "default", () => $10cdb945e864b702$export$2e2bcd8739ae039);
let $10cdb945e864b702$var$NOOP = ()=>{};
var $10cdb945e864b702$export$2e2bcd8739ae039 = (script)=>{};

});

var $d4c9f67d25be4ab7$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"auyDg\",\"index.e7696e03.js\",\"egR1g\",\"HomeView.a98c8fb4.js\",\"kHNJ8\",\"ot-loading.cd3dc892.gif\",\"khETo\",\"vg-bg-5.d60d5903.webp\",\"ehI2k\",\"HomeView.f5ef05bc.css\",\"2lclt\",\"forward-button.927f453d.png\",\"ijjMX\",\"back-button.57ce7f0c.png\",\"1bBEW\",\"CharacterView.892d76d2.js\",\"1FohY\",\"placeholder.13369cb8.webp\",\"f905o\",\"CharacterView.c5e8ce18.css\",\"ZuMMi\",\"PosseView.ea9a91ce.js\",\"kL4Ru\",\"PosseView.0d7fe421.css\",\"bljAp\",\"ItineraryView.c4410df8.js\",\"k9F32\",\"ItineraryView.659875d7.css\",\"gMMqh\",\"Accomodations.05b89f2d.js\",\"aHkC0\",\"house1.b342449a.jpeg\",\"8a6Q1\",\"house2.dd277afa.jpeg\",\"grnAq\",\"house3.28beb38b.jpeg\",\"2DrlQ\",\"house4.6e71878c.jpeg\",\"848J0\",\"house5.bf72f208.jpeg\",\"emWrb\",\"house6.df3c6b0c.jpeg\",\"83Jgb\",\"house7.52b9c332.jpeg\",\"fPPeu\",\"house8.2e2b216d.jpeg\",\"hG3nT\",\"house9.e495e5a2.jpeg\",\"1ryU2\",\"house10.ce93ea05.jpeg\",\"787dW\",\"house11.462a3e8f.jpeg\",\"18mNr\",\"house12.66f9456c.jpeg\",\"7VQKl\",\"house13.96c0f924.jpeg\",\"j0Dyi\",\"house14.187a4346.jpeg\",\"86bY0\",\"house15.c51bc82b.jpeg\",\"50kxZ\",\"house16.52cd0139.jpeg\",\"4iJfh\",\"house17.6f1b8eeb.jpeg\",\"6917D\",\"house18.6d5242f1.jpeg\",\"DCwBJ\",\"house19.73b6598f.jpeg\",\"aHCk2\",\"house20.d8718990.jpeg\",\"3Cl6a\",\"house21.33922359.jpeg\",\"jcctV\",\"house22.afa2b535.jpeg\",\"85nDc\",\"house23.1012e112.jpeg\",\"bFCM3\",\"house24.9bd5239e.jpeg\",\"7f8Ao\",\"house25.88052f33.jpeg\",\"f8Aze\",\"house26.babd4724.jpeg\",\"2Mvbt\",\"house27.e35c91c4.jpeg\",\"gXvmy\",\"Accomodations.df9aa19e.css\",\"d5pqq\",\"error-popup.4e07f700.png\",\"lvmhz\",\"click.534b4d00.mp3\",\"epB1k\",\"oregon-trail.d21a64db.mp3\",\"6KrPe\",\"howdy.34ee0801.mp3\",\"6aLfr\",\"whip-crack.4cffac82.mp3\",\"eYHbW\",\"game-over.971676d0.mp3\",\"ahsm4\",\"pot-ding.15b4af1e.mp3\",\"jt63b\",\"yeehaw.65e6827d.mp3\",\"8koGT\",\"index.9dda3715.css\"]"));

parcelRequire("ecd4d");
var $eeJ70 = parcelRequire("eeJ70");

var $i0TKe = parcelRequire("i0TKe");

var $73mM4 = parcelRequire("73mM4");

var $8qdaR = parcelRequire("8qdaR");





const $3805e7143c36831c$var$router = (0, $73mM4.createRouter)({
    history: (0, $73mM4.createWebHistory)(),
    routes: [
        {
            path: '/',
            component: ()=>(parcelRequire("hdyeU")),
            name: "home"
        },
        {
            path: "/character",
            component: ()=>(parcelRequire("2Elws")),
            name: "character"
        },
        {
            path: "/posse",
            component: ()=>(parcelRequire("h9PHU")),
            name: "posse"
        },
        {
            path: '/itinerary',
            component: ()=>(parcelRequire("ipwgW")),
            name: 'itinerary'
        },
        {
            path: '/house',
            component: ()=>(parcelRequire("69I3W")),
            name: 'accomodations'
        }
    ]
});
$3805e7143c36831c$var$router.beforeEach((to, from, next)=>{
    if (to.name === "home") {
        next();
        return;
    }
    if (to.name === "accomodations") {
        next();
        return;
    }
    const guestStore = (0, $8qdaR.useGuestStore)();
    if (guestStore.guest.completedSurvey) next();
    else next({
        name: "home"
    });
});
var $3805e7143c36831c$export$2e2bcd8739ae039 = $3805e7143c36831c$var$router;


let $ae3de8900c09c2f9$var$script;




let $ae3de8900c09c2f9$var$initialize = ()=>{
    $ae3de8900c09c2f9$var$script = (parcelRequire("boZNq"));
    if ($ae3de8900c09c2f9$var$script.__esModule) $ae3de8900c09c2f9$var$script = $ae3de8900c09c2f9$var$script.default;
    $ae3de8900c09c2f9$var$script.render = (parcelRequire("3NNX1")).render;
    $ae3de8900c09c2f9$var$script.__cssModules = {};
    (parcelRequire("1rrBo")).default($ae3de8900c09c2f9$var$script);
    $ae3de8900c09c2f9$var$script.__scopeId = 'data-v-d857d4';
    $ae3de8900c09c2f9$var$script.__file = "App.vue";
};
$ae3de8900c09c2f9$var$initialize();
var $ae3de8900c09c2f9$export$2e2bcd8739ae039 = $ae3de8900c09c2f9$var$script;


var $da94be33164af2d0$exports = {};
$da94be33164af2d0$exports = new URL("click.534b4d00.mp3", import.meta.url).toString();


var $e073db660a1934e2$exports = {};
$e073db660a1934e2$exports = new URL("oregon-trail.d21a64db.mp3", import.meta.url).toString();


var $3bc4a35048ca82ce$exports = {};
$3bc4a35048ca82ce$exports = new URL("howdy.34ee0801.mp3", import.meta.url).toString();


var $429a08115ca8e1a1$exports = {};
$429a08115ca8e1a1$exports = new URL("whip-crack.4cffac82.mp3", import.meta.url).toString();


var $67a5c833f68f4a5f$exports = {};
$67a5c833f68f4a5f$exports = new URL("game-over.971676d0.mp3", import.meta.url).toString();


var $e630912630f23313$exports = {};
$e630912630f23313$exports = new URL("pot-ding.15b4af1e.mp3", import.meta.url).toString();


var $ed3e33635aa6f1c0$exports = {};
$ed3e33635aa6f1c0$exports = new URL("yeehaw.65e6827d.mp3", import.meta.url).toString();


const $b2858fd6108d7f1d$var$audioFiles = {
    click: (0, (/*@__PURE__*/$parcel$interopDefault($da94be33164af2d0$exports))),
    themeSong: (0, (/*@__PURE__*/$parcel$interopDefault($e073db660a1934e2$exports))),
    howdy: (0, (/*@__PURE__*/$parcel$interopDefault($3bc4a35048ca82ce$exports))),
    whipCrack: (0, (/*@__PURE__*/$parcel$interopDefault($429a08115ca8e1a1$exports))),
    gameOver: (0, (/*@__PURE__*/$parcel$interopDefault($67a5c833f68f4a5f$exports))),
    potDing: (0, (/*@__PURE__*/$parcel$interopDefault($e630912630f23313$exports))),
    yeehaw: (0, (/*@__PURE__*/$parcel$interopDefault($ed3e33635aa6f1c0$exports)))
};
class $b2858fd6108d7f1d$var$AudioManager {
    constructor(audioFiles){
        this.audioFiles = audioFiles;
        this.audios = new Map();
        this.volume = 1.0;
        this.isMuted = false;
        // Add all audio files from assets/audio
        this.initializeAudioFiles();
    }
    initializeAudioFiles() {
        // Preload all audio files
        for (const [id, path] of Object.entries(this.audioFiles)){
            const audio = new Audio(path);
            audio.preload = true;
            this.audios.set(id, audio);
        }
    }
    // Get audio by ID
    getAudio(id) {
        return this.audios.get(id);
    }
    // Play audio by ID
    play(id) {
        return new Promise((resolve, reject)=>{
            const audio = this.getAudio(id);
            if (this.isMuted) resolve();
            else if (audio) {
                audio.currentTime = 0; // Reset to start
                audio.volume = this.volume;
                audio.addEventListener("ended", resolve);
                audio.play();
            } else reject(new Error(`Audio file ${id} not found`));
        });
    }
    // Set global volume (0.0 to 1.0)
    setVolume(value) {
        this.volume = Math.max(0, Math.min(1, value));
        this.updateAllVolumes();
    }
    // Mute/unmute all audio
    setMute(mute) {
        this.isMuted = mute;
        this.updateAllAudio();
    }
    // Update volumes for all audio files
    updateAllVolumes() {
        for (const audio of this.audios.values())audio.volume = this.isMuted ? 0 : this.volume;
    }
    updateAllAudio() {
        if (this.isMuted) for (const audio of this.audios.values()){
            audio.currentTime = 0;
            audio.pause();
        }
        else for (const audio of this.audios.values())audio.currentTime = 0;
    }
}
// Create a singleton instance
const $b2858fd6108d7f1d$var$audioManager = new $b2858fd6108d7f1d$var$AudioManager($b2858fd6108d7f1d$var$audioFiles);
var $b2858fd6108d7f1d$export$2e2bcd8739ae039 = $b2858fd6108d7f1d$var$audioManager;




const $ac882e78ad3d929e$export$46c2327ad39dd7a4 = {
    mounted (el, binding, vnode) {
        // Add mousedown and mouseup event listeners for the active effect
        el.addEventListener('mousedown', ()=>{
            el.style.transform = 'translate3d(2px, 2px, 0)';
            el.style.filter = 'brightness(0.9)';
        });
        el.addEventListener('mouseup', ()=>{
            el.style.transform = '';
            el.style.filter = '';
        });
        // Also reset on mouse leave to prevent stuck state
        el.addEventListener('mouseleave', ()=>{
            el.style.transform = '';
            el.style.filter = '';
        });
        el.addEventListener('click', async (event)=>{
            // Only play sound if the click wasn't already handled by OTButton
            if (!event._soundPlayed) {
                event._soundPlayed = true;
                await (0, $b2858fd6108d7f1d$export$2e2bcd8739ae039).play('click');
            }
        });
    }
};


document.addEventListener('DOMContentLoaded', ()=>{
    const app = (0, $eeJ70.createApp)((0, $ae3de8900c09c2f9$export$2e2bcd8739ae039));
    app.provide("audioManager", (0, $b2858fd6108d7f1d$export$2e2bcd8739ae039));
    app.directive('clicky', (0, $ac882e78ad3d929e$export$46c2327ad39dd7a4));
    app.use((0, $3805e7143c36831c$export$2e2bcd8739ae039));
    app.use((0, $i0TKe.createPinia)());
    app.mount('#app');
});


//# sourceMappingURL=index.e7696e03.js.map
